module.exports = {
  Cargo_TrunkLine: '干线',
  Cargo_Inquiry_MissingBusinessCannotSubmit: '{0}类型未选择对应商务，不能提交',
  Cargo_100Million: '亿',
  Cargo_10Cents: '角',
  Cargo_1St: '第一张',
  Cargo_1StInvoiceNo: '第一张发票号',
  Cargo_1Year: '1年',
  Cargo_2NdDispatch: '二次送出',
  Cargo_2NdDispatchTime: '二次送出时间',
  Cargo_2NdReleaseTime: '二次放货时间',
  Cargo_2NdTransitAirportAir: '中转二程（空港）',
  Cargo_2StUnit: '第二单位',
  Cargo_2Years: '2年',
  Cargo_30DaysShpt: '30天（票）',
  Cargo_3RdParty: '第三方',
  Cargo_3RdTransitAirportAir: '中转三程（空港）',
  Cargo_3Years: '3年',
  Cargo_60DaysShpt: '60天（票）',
  Cargo_90DaysShpt: '90天（票）',
  Cargo_AAPACRIG: '作为预付款,生成一条相应的记录!',
  Cargo_AbandonThisVoucher: '确认放弃此凭证？',
  Cargo_Abbreviation: '简称',
  Cargo_AbbreviationOfConsignor: '委托单位（简称）',
  Cargo_ABCDC: '正在确认，其中{0}已确认。',
  Cargo_MessageTip1: '您有【',
  Cargo_MessageTip2: '】条未读提醒.',
  Cargo_Abstract: '摘要',
  Cargo_AbstractRuleOfJournalEntry: '分录摘要规则',
  Cargo_ABYBPSTCI23M: 'AA-每年招标,根据情况可以看看,在2-3个月内。',
  Cargo_Accepted: '已接受',
  Cargo_AccordingBillExchangeRate: '按账单汇率',
  Cargo_AccordingForStatementFxRate: '按对账单汇率',
  Cargo_AccountClosedSuccessfully: '结账完成。',
  Cargo_AccountInForeignCurrency: '是否原币核算？',
  Cargo_AccountingMethod: '记账方式',
  Cargo_AccountingOrganizationCode: '核算组织代码',
  Cargo_AccountingQuantity: '数量核算',
  Cargo_AccountingVoucher: '会计凭证',
  Cargo_AccountPeriod: '账期',
  Cargo_AccountPeriodDay: '账期(天)',
  Cargo_AccountQuantityOrNot: '是否按照数量核算？',
  Cargo_AccountsReconciliation: '往来核对账',
  Cargo_AccountsReconciliation2: '往来核对账2',
  Cargo_AccountStatement: '对账单',
  Cargo_AccountStatementNo: '对账单号',
  Cargo_AccountStatementNoP: '对账单号:',
  Cargo_AccountTitle: '科目',
  Cargo_AccountTitle2: '科目2',
  Cargo_AccountTitleCanTBeEmpty: '科目不能为空',
  Cargo_AccountTitleCategory: '科目类别',
  Cargo_AccountTitleClassification: '科目分级',
  Cargo_AccountTitleClassificationRule: '科目分级规则',
  Cargo_AccountTitleCode: '科目编码',
  Cargo_AccountTitleCodeCanTBeEmpty: '科目编码不能为空。',
  Cargo_AccountTitleCodeP: '科目编码:',
  Cargo_AccountTitleGroupingCondition1: '科目分组条件一',
  Cargo_AccountTitleGroupingCondition2: '科目分组条件二',
  Cargo_AccountTitleGroupingCondition3: '科目分组条件三',
  Cargo_AccountTitleGroupingCondition4: '科目分组条件四',
  Cargo_AccountTitleGroupingCondition5: '科目分组条件五',
  Cargo_AccountTitleGroupingCondition6: '科目分组条件六',
  Cargo_AccountTitleLevel: '科目级别',
  Cargo_AccountTitleMapping: '科目映射',
  Cargo_AccountTitleName: '科目名称',
  Cargo_AccountTitleNameCanTBeEmpty: '科目名称不能为空',
  Cargo_AccountTitleNameP: '科目名称:',
  Cargo_AccountTitleOfProfitNotAllocated: '未分配利润科目',
  Cargo_AccountTitleOfProfitNotAllocatedP: '未分配利润科目:',
  Cargo_AccrualDate: '计提日期',
  Cargo_JobAccrualDate: '业务计提日期',
  Cargo_AccrualReview: '计提审核',
  Cargo_AccrualStatus: '计提状态',
  Cargo_Accrue: '计提',
  Cargo_Accrued: '已计提',
  Cargo_UsersAlreadyProvisionedToday: '存在今日已经计提的用户，请检查',
  Cargo_AccumulatedCommissionProfit: '累计提成利润',
  Cargo_AConsiderChangeIfOffersCheap: 'A-只要便宜就考虑。',
  Cargo_ACPCOIM: '系统正在结账，请耐心等候，稍后再试~',
  Cargo_Acquired: '已领用',
  Cargo_AcquireFilteredExpenseList: '获取过滤费用列表',
  Cargo_Acquirer: '领用人',
  Cargo_AcquirerCanTBeEmpty: '领用人不能为空。',
  Cargo_AcquireSelectedItems: '获取选中的对象',
  Cargo_AcquireTotalAROrAPAmount: '获取总的应收应付金额',
  Cargo_Acquisition: '领用',
  Cargo_AcquisitionRecord: '领用记录',
  Cargo_AcquisitionTime: '领用时间',
  Cargo_AcquisitionTimeCanTBeEmpty: '领用时间不能为空。',
  Cargo_ACSWASRATBTSWEAC: '确认后，系统将自动将对账金额设置为与费用金额相同，是否继续？',
  Cargo_ACSWASRATBTSWEANCOWOEWNBPC: '所有对账金额将根据费用金额设置，已确认或者已销账的费用将会忽略，是否继续？',
  Cargo_ThereAreAlreadyExportedVouchers: '存在已导出过的凭证',
  Cargo_ActualChargedWeight: '实际计费重量',
  Cargo_ActualGrossWeight: '实际毛重',
  Cargo_ActualQuantity: '实际件数',
  Cargo_ActualReceiptAmount: '实收金额',
  Cargo_ActualReceiptAndPayment: '实收实付',
  Cargo_ActualVolume: '实际体积',
  Cargo_ActualWeight: '实际重量',
  Cargo_ActualWriteOffAmountRequired: '实际需要销账的金额',
  Cargo_OnlyImportedCurrentBranch: '仅导入操作分公司为当前分公司的费用',
  Cargo_Add: '新增',
  Cargo_AddAdjustBill: '增加调整（账单）',
  Cargo_AddAirBooking: '新增空运订舱',
  Cargo_AddRailwayBooking: '新增铁路订舱',
  Cargo_RailwayBooking: '铁路订舱',
  Cargo_AddAirFreightServiceItems: '新增空运运费服务项目',
  Cargo_AddAssetAccountTitle: '新增资产类科目',
  Cargo_AddAssociatedPort: '新增关联港口',
  Cargo_AddAwbSurcharge: '新增空运运单杂费',
  Cargo_AddBasePort: '添加基础港口',
  Cargo_AddBill: '新增账单',
  Cargo_AddBillCharge: '加入费用',
  Cargo_AddBLType: '新增提单类型',
  Cargo_AddCashFlowItem: '新增现金流量项目',
  Cargo_AddCharges: '新增费用',
  Cargo_AddCostType: '新增费用类型',
  Cargo_EditFeeType: '编辑费用类型',
  Cargo_DeleteFeeType: '删除费用类型',
  Cargo_ImportFeeType: '导入费用类型',
  Cargo_SelectBusinessOperation: '请选择正操作的业务',
  Cargo_SelectSameDelegateUnit: '请选择相同委托单位的业务',
  Cargo_SelectSameBusinessType: '请选择同一个业务类型的业务',
  Cargo_SelectSameFbaStatus: '请选择FBA状态一致的业务',
  Cargo_SelectSameBusinessTypeWithJobNo: '业务类型不一致：{baseJobNo} 与 {currentJobNo}，请选择同一个业务类型的业务',
  Cargo_SelectSameFbaStatusWithJobNo: 'FBA状态不一致：{baseJobNo} 与 {currentJobNo}，请选择FBA状态一致的业务',
  Cargo_SelectFeeType: '请选择费用类型！',
  Cargo_ReceivablePayableLocked: '所选业务存在应收应付已锁定，不能进行此操作！',
  Cargo_ReceivableLocked: '所选业务存在应收已锁定，不能进行此操作！',
  Cargo_PayableLocked: '所选业务存在应付已锁定，不能进行此操作！',
  Cargo_PayableLockedStatusTag: '（应付已锁定）',
  Cargo_PleaseSelectTheManifestYouWishToDelete: '请选择您需要删除的舱单',
  Cargo_TheManifestYouWishToDeleteTips: '*温馨提示：拼箱删单，必须一并删除箱子内所以舱单，不得单独删除！',
  Cargo_ConfirmDelete: '确认删除',
  Cargo_AddCirculationDocumentType: '新增流转文件类型',
  Cargo_AddClientType: '新增客户类型',
  Cargo_AddCollectionRecord: '新增托收登记',
  Cargo_AddCommissionRules: '新增提成规则',
  Cargo_AddContinent: '新增大洲',
  Cargo_AddContract: '新增合同',
  Cargo_AddCustomizedServiceType: '新增自定义业务类型',
  Cargo_AddedAlreadyDoNotRepeat: '{0}已添加，不能重复添加。',
  Cargo_AddedSuccessfully: '新增成功。',
  Cargo_AddFees: '添加费用',
  Cargo_AddHeadquartersToTheList: '将总部加进来',
  Cargo_AddJournalEntry: '增加分录',
  Cargo_AddKeyword: '新增敏感词',
  Cargo_AddMscService: '新增 MSC Service',
  Cargo_AddNewSoaOrNot: '是否新增对账单',
  Cargo_AddRailwayStation: '添加铁路站点',
  Cargo_AddressTelNo: '地址/电话',
  Cargo_AddressTelNoP: '地址、电话:',
  Cargo_AddRoute: '新增航线',
  Cargo_AddSave: '添加保存',
  Cargo_AddSeaBooking: '新增海运订舱',
  Cargo_IntelligentDocumentRecognition: '智能托书识别',
  Cargo_AddSoa: '新增对账单',
  Cargo_AddToBlackList: '加入黑名单',
  Cargo_AdjustBillDate: '调整账单日期',
  Cargo_AdjustDate: '调整日期',
  Cargo_AdjustedItem: '调整项',
  Cargo_AdjustedOrNot: '是否调整',
  Cargo_AdjustedSuccessfully: '调整成功。',
  Cargo_AdjustedValue: '调整值',
  Cargo_AdjustExpenseOrNot: '是否调整费用',
  Cargo_AdjustFxRateEndOfPeriod: '调整汇率（期末）',
  Cargo_AdjustmentDateCanTBeEmpty: '调整日期不能为空。',
  Cargo_AdjustmentExpense: '调整费用',
  Cargo_AdjustmentExpenseState: '调整状态',
  Cargo_Advance: '预收付',
  Cargo_AdvanceAP: '预付应付',
  Cargo_AdvanceAPDifferential: '预付应付差额',
  Cargo_AdvanceChargeInfo: '代收垫付',
  Cargo_AdvancedSearch: '高级查询',
  Cargo_AdvanceMoneyForAnotherOrNot: '是否代垫',
  Cargo_AdvanceOrNot: '是否垫付',
  Cargo_AdvancePayment: '预付',
  Cargo_AdvancePaymentAmount: '预付金额',
  Cargo_AdvancePaymentItem: '垫付项',
  Cargo_AdvanceReceiptOrNot: '是否预收',
  Cargo_AdvanceReceivedAmount: '预收金额',
  Cargo_AdvanceReceivedAmountIs: '预收金额为：',
  Cargo_AEBPWTCW1Y: 'AAA-有固定合作代理内部关系一年内不换',
  Cargo_AEFTSIST: '上海空运出口类似于',
  Cargo_AEIMBOUF: '更新失败，费用已被他人修改。',
  Cargo_AEIMBOUFM: '{0}条更新失败，费用已被他人修改。',
  Cargo_AGEBDAWI: '开票时调整差额自动产生的费用。',
  Cargo_AgentBillNo: '对方账单号',
  Cargo_Aging: '账龄（天）',
  Cargo_AgingOfCurrentBill: '当票账龄',
  Cargo_Agree: '同意',
  Cargo_AILCNETOCERCTS: '本位币金额不等于原币*汇率,是否继续保存?',
  Cargo_Air: '空运',
  Cargo_AirExport: '空运出口',
  Cargo_AirImport: '空运进口',
  Cargo_AirImportExport: '空运进出',
  Cargo_Airline: '航线',
  Cargo_AirlineCode: '航线代码',
  Cargo_AirlineCompany: '航空公司',
  Cargo_ShippingCompanyName: '船公司中/英文名称',
  Cargo_ShippingCompanyCode: '船公司代码',
  Cargo_ShippingCompanyScacCode: '船公司SCAC CODE',
  Cargo_ShippingCompanyChineseName: '船公司中文名称',
  Cargo_ShippingCompanyEnglishName: '船公司英文名称',
  Cargo_DataDuplication: '数据已存在，请勿重复添加',
  Cargo_AdditionFailed: '新增失败',
  Cargo_DeleteShipCompany: '确认要删除选中的信息吗？<br>温馨提示：删除后租户中关联删除的船司默认清空',
  Cargo_AssociatedPlatformShippingCompany: '关联平台船公司',
  Cargo_ShipCompanyThirdPartyCode: '船公司三方代码',
  Cargo_MblCode: '提单代码',
  Cargo_AirlinePerson: '航线负责人',
  Cargo_Airport: '空港',
  Cargo_AirportOfDischarge: '卸货港（空港）',
  Cargo_AirService: '空运运费服务项目',
  Cargo_AlertConfiguration: '提醒配置',
  Cargo_AlertDaysPriorToExpiryDate: '距到期日期剩余*天提醒',
  Cargo_All: '全部',
  Cargo_AllB: '（全部）',
  Cargo_AllP: '【全部】',
  Cargo_AllAmount: '总数',
  Cargo_AllAmountP: '总数:',
  Cargo_AllCurrencies: '所有币种',
  Cargo_AllForeignCurrencies: '所有外币',
  Cargo_AllSelectedBillsWrittenOff: '所选的账单已全部核销。',
  Cargo_AllSelectedRecordsConfirmed: '所选记录已全部确认过。',
  Cargo_AllSelectedSoaWrittenOff: '所选的对账单已全部核销。',
  Cargo_WithoutDiscrepancies: '无差异',
  Cargo_AllWithWithoutDiscrepancies: '全部有差异/无差异',
  Cargo_AllWrittenOff: '全部销完',
  Cargo_AlreadyAddedOrNot: '是否已添加',
  Cargo_AmendmentFee: '改单费',
  Cargo_Amount: '金额',
  Cargo_AmountF: '金额。',
  Cargo_AmountCanTBeEmpty: '金额不能为空',
  Cargo_AmountCanTBeZero: '金额不能为零。',
  Cargo_AmountCNY: '金额（CNY）',
  Cargo_AmountCNYP: 'CNY金额:',
  Cargo_AmountEnteredForReconciliation: '输入的对账金额',
  Cargo_AmountIncurredOfCurrentPeriod: '本期发生额',
  Cargo_AmountInOriginalCurrency: '原币种金额',
  Cargo_AmountNotWrittenOff: '未销金额',
  Cargo_AmountNumber: '数量',
  Cargo_AmountNumberP: '数量:',
  Cargo_AmountOfActualCollectionPayment: '实收付金额',
  Cargo_AmountOfCurrentMonth: '本月金额',
  Cargo_AmountOfPaidInOutOfPocket: '实际收付金额',
  Cargo_AmountOfPaymentApplication: '申请金额',
  Cargo_AmountRange: '金额区间',
  Cargo_AmountRemark: '费用备注',
  Cargo_AmountSum: '总金额',
  Cargo_AmountTo: '合计',
  Cargo_AmountToDetail: '合计详情',
  Cargo_CurrentMonthAmountTo: '本月合计',
  Cargo_CurrentYearAmountTo: '本年合计',
  Cargo_TotalReportingCurrencyOfThisMonth: '本月合计本位币',
  Cargo_TotalReportingCurrencyOfThisYear: '本年合计本位币',
  Cargo_AmountToCNY: '合计（CNY）',
  Cargo_AmountToP: '合计：',
  Cargo_AmountToUSD: '合计（USD）',
  Cargo_AmountUSD: 'USD金额',
  Cargo_AmountUSDP: 'USD金额:',
  Cargo_AmsEnsCyCutOffDate: 'AMS/ENS截关日期',
  Cargo_Annual: '年度',
  Cargo_AolAir: '起运机场',
  Cargo_AOPLVCTBE: '损益凭证摘要不能为空',
  Cargo_APAR: '应付应收',
  Cargo_APBill: '应付账单',
  Cargo_APEOFINNPPARFV: '请核对，以下发票号的应付费用没有完成付款审批：\\n',
  Cargo_APInclusive: '是否包含应付费用',
  Cargo_APInvoice: '应付发票',
  Cargo_Appendix: '附页',
  Cargo_Applicant: '申请人',
  Cargo_ApplicationDateApplicationDate: '申请日期申请日期',
  Cargo_ApplicationDateBusinessDate: '申请日期业务日期',
  Cargo_ApplicationFormSavedSuccessfully: '申请单保存成功!',
  Cargo_ApplicationNo: '申请单号',
  Cargo_ApplicationNoBill: '{0}号申请单的费用没有发票，业务编号为{1}',
  Cargo_ApplicationPermission: '应用权限',
  Cargo_ApplicationStatus: '申请状态',
  Cargo_AppliedForPaymentOrNot: '是否已申请付款',
  Cargo_ApplyForPayment: '申请付款',
  Cargo_Approval: '审批通过',
  Cargo_ApprovalStatus: '审批状态',
  Cargo_Approved: '已审核',
  Cargo_ApprovedBy: '复核人',
  Cargo_ApprovedStatue: '复核状态',
  Cargo_April: '4月',
  Cargo_APWriteOff: '应付销账',
  Cargo_APWriteOffAmount: '应付销账金额',
  Cargo_APWrittenOff: '应付已销',
  Cargo_APWrittenOffP: '应付已销:',
  Cargo_ARAges: '账龄',
  Cargo_ARAmountCanTExceedAPAmount: '应收费用不能大于应付费用。',
  Cargo_ARAP: '应收应付',
  Cargo_ARAPItemsMustBeComplete: '应收应付费用必须录入完整。',
  Cargo_ARBill: '应收账单',
  Cargo_ARegularExportVolume20TeuMonthly: 'A.货物出口稳定每个月固定20TEU。',
  Cargo_ARInvoice: '应收发票',
  Cargo_ARIPFCSC: '思锐应收发票推送失败：',
  Cargo_ARNotWrittenOff: '应收未销',
  Cargo_ARNotWrittenOffP: '应收未销:',
  Cargo_AROrNot: '是否应收',
  Cargo_InvoiceAROrNot: '发票是否应收',
  Cargo_ArrivalDate: '到港日期',
  Cargo_ArrivalTime: '到港时间',
  Cargo_ARWriteOffAmount: '应收销账金额',
  Cargo_ARWrittenOff: '应收已销',
  Cargo_ARWrittenOffP: '应收已销:',
  Cargo_ASRCCTD: '所选记录已全部确认过，不能拒绝',
  Cargo_AssessedClientLevel: '客户评定等级',
  Cargo_AssignedClientsSuccessfully: '分配成功{0}个客户',
  Cargo_AssignmentDate: '分配日期',
  Cargo_AssignToMe: '分配给我',
  Cargo_AssociatedPort: '关联港口',
  Cargo_ATCIJECTBE: '分录科目编码不能为空。',
  Cargo_AttachedDocuments: '附单据',
  Cargo_Attachment: '附件',
  Cargo_AttachmentP: '附件:',
  Cargo_AttachmentInvoice: '发票附件',
  Cargo_AttachmentStorage: '附件存储',
  Cargo_Audit: '审核',
  Cargo_AuditDate: '审核日期',
  Cargo_Auditor: '审核人',
  Cargo_AuditorP: '审核人:',
  Cargo_AuditStatus: '审核状态',
  Cargo_AuditSuccessfully: '审核成功',
  Cargo_AuditSuccessfullyF: '审核成功。',
  Cargo_Guarantee: '保函',
  Cargo_GuaranteeName: '保函名称',
  Cargo_GuaranteeType: '保函类型',
  Cargo_August: '8月',
  Cargo_AuthorizedClient: '委托单位',
  Cargo_AvailableBranch: '可用分公司',
  Cargo_AuthorizedCubage: '委托体积',
  Cargo_AuthorizedQuantity: '委托件数',
  Cargo_AutomaticallyEnterInvoiceNumber: '自动输入发票号',
  Cargo_AutomaticGenerated: '自动生成',
  Cargo_AvailableOrNot: '是否可用',
  Cargo_AverageMonthlyCargoVolume: '月均出货量',
  Cargo_AwaitBusinessApproval: '待业务审批',
  Cargo_AwaitFinancialApproval: '待财务审批',
  Cargo_Back: '返回',
  Cargo_BackgroundParameter: '后台参数',
  Cargo_BackgroundProcessing: '后台处理中',
  Cargo_BackgroundReturnedErrorStatus: '后台返回错误状态',
  Cargo_BackToCancel: '返回取消',
  Cargo_BackToInvoicingStatus: '返回开票状态',
  Cargo_BackToProcessingMethod: '返回处理方法',
  Cargo_BackToSearchResults: '返回查询结果',
  Cargo_BaiwangInvoiceExport: 'InvoiceExport(Baiwang).xml',
  Cargo_Balance: '余额',
  Cargo_BalanceCalculation: '余额计算',
  Cargo_BalanceCNY: '余额（人民币）',
  Cargo_BalanceDirection: '余额方向',
  Cargo_BalanceOfActualCollectionPayment: '实收付余额',
  Cargo_BalanceSheet: '资产负债表',
  Cargo_BalanceSheet2: '资产负债表2',
  Cargo_BalancesOfAccountTitle: '科目余额表',
  Cargo_BalancesOfAccountTitle2: '科目余额表2',
  Cargo_BalanceUSD: '余额（美元）',
  Cargo_BangPic: '进仓照片',
  Cargo_Bank: '银行',
  Cargo_BankAccount: '银行账号',
  Cargo_BankAccountBalance: '银行余额',
  Cargo_BankAccountNo: '银行账号',
  Cargo_BankOfPayment: '付款银行',
  Cargo_BankReceiptDetails: '水单详情',
  Cargo_BankReceiptNo: '银行水单号',
  Cargo_ReceiptNo: '水单号',
  Cargo_BankReceiptRecord: '水单登记',
  Cargo_BankReceiptStatus: '水单状态',
  Cargo_BaseCurrency: '基准货币',
  Cargo_BasePort: '基港',
  Cargo_Basic: '基本',
  Cargo_ExternalInterface: '外部接口',
  Cargo_Blacklisted: '已被加入黑名单!',
  Cargo_BasicInfo: '基本信息',
  Cargo_BasicInformation: '基础信息',
  Cargo_BasisForGrouping: '分组条件',
  Cargo_BatchAudit: '批量审核',
  Cargo_BatchCancelAudit: '批量取消审核',
  Cargo_BatchCancelConfirmation: '批量取消确认',
  Cargo_BatchConfirm: '批量确认',
  Cargo_BatchDelete: '批量删除',
  Cargo_BatchDownload: '批量下载',
  Cargo_BatchEnterModifyBusinessOrderNo: '批量输入修改业务单号',
  Cargo_BatchNo: '批次号',
  Cargo_BatchNoOfCollection: '托收批次号',
  Cargo_BatchNoP: '批次号:',
  Cargo_BatchPrint: '批量打印',
  Cargo_BatchProcessing: '批量操作',
  Cargo_BatchRetrieval: '批量取回',
  Cargo_BatchRetrievalButtonTrigger: '批量取回按钮触发',
  Cargo_BatchRevokeRetrieval: '批量撤销取回',
  Cargo_BatchTransfer: '批量送出',
  Cargo_BelowBillingAmountsIncorrect: '以下账单金额有误：',
  Cargo_Bill: '账单',
  Cargo_BillCanTBeEmpty: '账单不能为空。',
  Cargo_BillConfirmed: '账单已确认。',
  Cargo_BillConfirmedM: '[{0}]账单已确认。',
  Cargo_BillDate: '账单日期',
  Cargo_DueDate: '账单到期日',
  Cargo_BillDeleteAdjustment: '账单-删除调整',
  Cargo_BillDeletedSuccessfully: '成功删除{0}个账单',
  Cargo_BilledOrNot: '是否已开账单',
  Cargo_BillingAmount: '账单金额',
  Cargo_BillingCurrency: '账单币种',
  Cargo_BillingData: '账单数据',
  Cargo_BillingDetails: '账单明细',
  Cargo_BillingExpenditure: '账单支出',
  Cargo_BillingExpenditureDetails: '账单支出费用明细',
  Cargo_BillingExpense: '账单费用',
  Cargo_BillingMethod: '计费方式',
  Cargo_BillingRevenue: '账单收入',
  Cargo_BillingRevenueExpenseDetails: '账单收入费用明细',
  Cargo_BillInvoiced: '[{0}]账单已开票',
  Cargo_BillIssued: '已开账单',
  Cargo_BillList: '账单列表',
  Cargo_BillNo: '账单号',
  Cargo_BillNoP: '账单号：',
  Cargo_BillNotSelected: '未选择账单。',
  Cargo_BillPaidInFullCanTRepeatWriteOff: '账单已经全部付清，不能再次销账。',
  Cargo_BillStatus: '账单状态',
  Cargo_BillTo: '账单对象',
  Cargo_BillType: '账单类型',
  Cargo_BillWrittenOff: '[{0}]账单已核销',
  Cargo_Blacklist: '黑名单',
  Cargo_BLControl: '提单管理',
  Cargo_BLMAEONRS: '提单方式已存在或未选择记录',
  Cargo_BLMethodMaintenance: '提单方式维护',
  Cargo_BLMode: '提单方式',
  Cargo_BLNo: '提单号',
  Cargo_BLReleaseManagement: '放单管理',
  Cargo_MBLReleaseManagement: '主单提单管理',
  Cargo_HBLReleaseManagement: '分单提单管理',
  Cargo_BLReleaseReview: '放单审核',
  Cargo_MBLReleaseReview: '主单放单审核',
  Cargo_HBLReleaseReview: '分单放单审核',
  Cargo_BLReleaseReviewStatus: '放单审核状态',
  Cargo_BlReleasingNo: '放单号',
  Cargo_BlReleasingNoP: '放单号：',
  Cargo_BLRemoteReleaseFee: '异地放单费',
  Cargo_BLRetrieved: '提单是否取回',
  Cargo_BLType: '提单类型',
  Cargo_HBLType: 'HBL提单类型',
  Cargo_BNASPCTBBE: '业务编号和结算对象不能都为空',
  Cargo_BNTTPRS: '批次号{0}转入预付登记成功',
  Cargo_BOECTBCIWBII: '请统一选择国内/国外费用创建账单',
  Cargo_Booking: '订舱',
  Cargo_BookingAgent: '订舱代理',
  Cargo_BookingAgentAbbreviation: '订舱代理(简称)',
  Cargo_BookingAgentCode: '订舱代理(代码)',
  Cargo_BookingNo: '订舱编号',
  Cargo_BookingOrderNotExistCanTBeAdded: '新增失败，订舱单不存在。',
  Cargo_BookingWindow: '订/换单窗口',
  Cargo_BookKeeper: '记账人',
  Cargo_BookKeepingDate: '记账日期',
  Cargo_BookKeepingMethod: '记账方式',
  Cargo_BookKeepingVoucher: '记账凭证',
  Cargo_BOPIOOPCTBLT: '实际收付余额不能小于{0}',
  Cargo_BOPIOOPCTBLTCWOA: '实际收付余额不能小于本次核销金额。',
  Cargo_BPHCCTBWO: '账单{0}正在等待总部核销，当前不能销账。',
  Cargo_BranchBill: '分公司账单',
  Cargo_BranchCMP: '分公司',
  Cargo_BranchCMPP: '分公司：',
  Cargo_BranchCompany: '所属分公司',
  Cargo_BranchConfirmation: '分公司确认',
  Cargo_BranchConfirmed: '分公司已确认',
  Cargo_BranchFilter: '分公司过滤',
  Cargo_BREVB20TM: 'B.出口较稳定在20TEU下',
  Cargo_BRNPNACW: '业务参考号/项目编号/实际计费重量',
  Cargo_BrokenDesc: '货损描述',
  Cargo_BrokenNumberDetection: '检测断号',
  Cargo_Browse: '浏览...',
  Cargo_BRTSIOC: 'B-便宜就考虑给老板推荐',
  Cargo_BSNMIR: '业务状态不符合开票要求',
  Cargo_BSNMPCR: '业务状态不符合付款申请要求。',
  Cargo_BSNMWOR: '业务状态不符合销账要求',
  Cargo_BulkCargo: '散杂货',
  Cargo_BURCNBE: '待审核的业务不能被编辑',
  Cargo_Business: '业务',
  Cargo_BusinessAdjustment: '业务调整',
  Cargo_BusinessAdjustmentLog: '业务调整日志',
  Cargo_BusinessApproval: '业务审批',
  Cargo_BusinessApprovalDate: '业务审批日期',
  Cargo_BusinessApproved: '已业务审批',
  Cargo_OfficeApproved: '已商务审批',
  Cargo_BusinessCategory: '业务种类',
  Cargo_BusinessCharacteristic: '业务特性',
  Cargo_BusinessCommission: '业务提成',
  Cargo_BusinessCreateDate: '业务创建日期',
  Cargo_BusinessCreator: '业务创建人',
  Cargo_BusinessDate: '业务日期',
  Cargo_BusinessDateBusinessDate: '业务日期业务日期',
  Cargo_BusinessDateP: '业务日期:',
  Cargo_BusinessDocNo: '业务单号',
  Cargo_BusinessDocNo2: '业务单号2',
  Cargo_BusinessDocNoP: '业务单号:',
  Cargo_BusinessHappenDate: '业务发生日期',
  Cargo_BusinessHappenDateP: '业务发生日期:',
  Cargo_BusinessInformation: '业务信息',
  Cargo_BusinessModel: '业务模式',
  Cargo_BusinessNo: '业务编号',
  Cargo_BusinessNoInBill: '(账单)业务编号',
  Cargo_BusinessNotSelected: '未选择业务。',
  Cargo_BusinessReferenceNo: '业务参考号',
  Cargo_GenerateNumberOfBusiness: '生成业务份数',
  Cargo_UpdateBusinessAgain: '再次修改生成业务',
  Cargo_Business_CustomerRefNo: '业务/客户参考号',
  Cargo_BusinessStatus: '业务状态',
  Cargo_BusinessStatusChangeLog: '业务状态变更日志',
  Cargo_DataPushResultRecords: '数据推送结果记录',
  Cargo_SendType: '发送类型',
  Cargo_ReissueFees: '重发费用',
  Cargo_ReissueFeesTips: '点击此按钮会将所有发送失败的费用重新发送。',
  Cargo_BusinessType: '业务类型',
  Cargo_BusinessTypeP: '业务类型：',
  Cargo_BusinessTypeCanTBeEmpty: '业务类型不能为空',
  Cargo_BusinessTypeInconsistent: '业务类型不一致',
  Cargo_ButtonPermissionControl: '按钮权限控制',
  Cargo_BuyingPrice: '买价',
  Cargo_BWNBCAED: '合同到期后将不能再创建业务',
  Cargo_ByBill: '按账单',
  Cargo_ByDetail: '按明细',
  Cargo_ByInvoice: '按发票',
  Cargo_ByInvoiceFxRate: '按发票汇率',
  Cargo_ByJob: '按业务',
  Cargo_ByJobNo: '按业务编号',
  Cargo_ByPaymentRequestFxRate: '按付款申请汇率',
  Cargo_BySettlementAgent: '通过结算代理',
  Cargo_CAEONRS: '币种已存在或未选择记录',
  Cargo_CAIFCINFCAUU: '勾选外币核算。若无外币则按美元判断。',
  Cargo_CAIOCPCRY: '本期发生额贷方（人民币）',
  Cargo_CAIOCPUSD: '本期发生额贷方（美元）',
  Cargo_CalculateBalance: '计算余额',
  Cargo_CalculateBalanceTotalToWriteOff: '计算可销余额总值',
  Cargo_CalculateBillingAmount: '账单金额计算',
  Cargo_CalculatedInOriginalCurrency: '使用原始币种计算',
  Cargo_CalculateTaxRate: '计算税率',
  Cargo_CallbackFunction: '回调函数',
  Cargo_CanBeConfirmedOrNot: '是否可以确认',
  Cargo_CanBeDeletedOrNot: '是否可删除',
  Cargo_CanBePrintedOrNot: '是否可以打印',
  Cargo_CanBeVoidedOrNot: '是否可作废',
  Cargo_CANCA: '代收垫付非代收垫付',
  Cargo_Cancel: '取消',
  Cargo_CancelAccrue: '取消计提',
  Cargo_CancelAudit: '取消审核',
  Cargo_NewCustomerApplication: '新增客户申请',
  Cargo_NewSupplierApplication: '新增供应商申请',
  Cargo_RequiredFields: '请填写表单对应必填项',
  Cargo_SelectTradeType: '请选择贸易类型',
  Cargo_CancelCheckOfSelectedRecord: '是否确认取消复核选择的记录？',
  Cargo_CancelClosure: '取消关闭',
  Cargo_CancelConfirm: '取消确认',
  Cargo_CancelCurrentModification: '取消当前修改信息',
  Cargo_CancelDefaultsInBatch: '批量取消默认',
  Cargo_CancelEditing: '取消编辑',
  Cargo_CancelGetBack: '撤销取回',
  Cargo_CancelIgnore: '取消忽略',
  Cargo_CancelMark: '取消标记',
  Cargo_CancelMerging: '取消合并',
  Cargo_CancelModification: '取消当前修改？',
  Cargo_CancelPublishment: '取消发布',
  Cargo_DownloadImportTemplate: '下载导入模版',
  Cargo_CancelReconciliation: '取消对账',
  Cargo_CancelReturn: '取消返回',
  Cargo_CancelSuccessfully: '取消成功。',
  Cargo_CancelTheChargesAudit: '取消费用审核',
  Cargo_CancelWriteOff: '撤销销账',
  Cargo_CanNotProcessUnsavedNewExpense: '不能处理新增未保存的费用。',
  Cargo_CanNotRedoCancellation: '不能重复注销。',
  Cargo_CanNotRemoveAllBills: '不能移除全部账单。',
  Cargo_CanOnlyRetrieveAfterDelivered: '已送出才能取回!',
  Cargo_CanTDeleteItemsWithInvoiceNo: '已经录入发票号，不能删除.',
  Cargo_CanTDeleteWrittenOffItem: '已经核销，不能删除',
  Cargo_CanTEditClosedItem: '已经结账不能编辑。',
  Cargo_CanTRepeatVoiding: '【{0}】已经作废，不能再作废',
  Cargo_CanTSelectInvoiceNoForEInvoice: '电子发票不能选择发票号.',
  Cargo_CanTSplitInvoicedItem: '已经开票，不能拆分!',
  Cargo_CanTVoidInvoiceWithoutInvoiceNo: '没有发票号码, 不能作废发票!',
  Cargo_CanTVoidWrittenOffItem: '【{0}】已经核销，不能作废。',
  Cargo_CAOPWWT: '计算税价不含税价金额',
  Cargo_Cargo: '货物',
  Cargo_Remark: '货物备注',
  Cargo_Remark_Check: '货物备注只能输入3999个大小写数字和特殊字符：!"#%&\'()*+,-./:;<=>?@_0-9a-zA-Z\n\s',
  Cargo_CargoDetention: '扣货',
  Cargo_CargoInfo: '货物信息',
  Cargo_CargoName: '货物名称',
  Cargo_CargoNature: '货物属性',
  Cargo_CargoType: '货物类型',
  Cargo_CAROJE: '分录摘要规则配置',
  Cargo_CarriedOver: '已结转',
  Cargo_Carrier: '承运人',
  Cargo_Carrier_Ship: '承运人(船公司)',
  Cargo_Carrier_Air: '承运人(航空公司)',
  Cargo_Carrier_Railway: '承运人(口岸代理)',
  Cargo_CarrierAgent: '船代',
  Cargo_CarrierShip: '船公司',
  Cargo_CarryOverForeignExchange: '结转汇兑',
  Cargo_CarryOverInitialized: '结转已初始化',
  Cargo_CarryOverProfitLoss: '损益结转',
  Cargo_CarryOverProfitLoss2: '损益结转2',
  Cargo_CarryOverToNextPeriod: '结转到下期',
  Cargo_CartonQuantity: '箱型箱量',
  Cargo_TicketCount: '票数',
  Cargo_Cash: '现金',
  Cargo_CasualClientNonCasualClient: '散客/非散客',
  Cargo_NonCasualClient: '非散客',
  Cargo_CasualClientOrNot: '是否散客',
  Cargo_Category: '类别',
  Cargo_CategoryOfPartner: '合作伙伴类型',
  Cargo_CATISExport: '金税导出',
  Cargo_CATISInvalid: '金税作废',
  Cargo_CATISPrint: '金税打印',
  Cargo_CBEIPCPTSINACSRANMPC: '当前分公司电子发票: 平台编码/密码/纳税人识别号/授权码/服务请求地址有未维护, 请检查。',
  Cargo_CBEIPCTSINACSRANMPC: '当前分公司电子发票: 平台编码/纳税人识别号/授权码/服务请求地址有未维护, 请检查。',
  Cargo_CBFCEBD: '默认创建已确认的费用账单',
  Cargo_CBISAWTSNM: '当前分公司税务系统接口服务地址未维护。',
  Cargo_CBTSINNM: '当前分公司纳税人识别号未维护。',
  Cargo_CCOCM: '确定取消当前修改？',
  Cargo_CCOPLV: '生成结转损益凭证成功：',
  Cargo_CCRAIOC: 'C-便宜就考虑准备换代理',
  Cargo_CCS: '取消确认成功。',
  Cargo_CDOPRI: '确定拒绝付款申请信息',
  Cargo_Cent: '分',
  Cargo_AndTo: '还有{0}到{1}',
  Cargo_AlreadyHere: '已经到了',
  Cargo_IsOver: '{0}已经过去{1}',
  Cargo_CERNM: '币种（{0}）汇率未维护',
  Cargo_CFCNAPM: '科目不核算当前外币:{0}，请修改。',
  Cargo_CGS1RV: '销售抢客户成功！成功审核{0}条记录。',
  Cargo_ChangeContent: '更改内容',
  Cargo_ChangeInvoiceTitle: '更改发票抬头',
  Cargo_ChangeInvoiceTitleP: '更改发票抬头:',
  Cargo_ChangeSob: '改变账套',
  Cargo_ChangeTo: '更改为',
  Cargo_ChangeToP: '更改为：',
  Cargo_Charge: '收取',
  Cargo_Chargeback: '退单',
  Cargo_ChargebackFile: '退单文件',
  Cargo_ChargeDetails: '费用明细',
  Cargo_ChargedWeight: '计费重量',
  Cargo_ChargeName: '费用名称',
  Cargo_ChargeOriginalAmount: '费用原金额',
  Cargo_ChargeOriginalCurrency: '费用原币种',
  Cargo_ChargeOriginalExchangeRate: '费用原汇率',
  Cargo_ChargesAudit: '费用审核',
  Cargo_ChargesContactPerson: '费用联系人',
  Cargo_ChargesReject: '费用驳回',
  Cargo_ChargeStatus: '费用状态',
  Cargo_ChargesTotalAmount: '费用总金额',
  Cargo_ChargeType: '费用类型',
  Cargo_ChargeTypeP: '费用类型:',
  Cargo_CHBRNFOA: '该合同已续签，禁止操作',
  Cargo_CheckAccountInForeignCurrency: '勾选外币核算',
  Cargo_CheckChargeDetailBranch: '正操作的数据所在分公司不属于当前分公司或上一级分公司。',
  Cargo_CheckCreateBillWay: '结算对象或结算代理必须满足一项相同',
  Cargo_CheckInvoiceQueryBranch: '当前正在操作分公司与数据归属分公司不一致，请重新查询数据再处理。',
  Cargo_CheckClientToExtendValidPeriod: '请先勾选需要延长期限的客户。',
  Cargo_CheckIfSoaFullyWrittenOff: '检查对账单是否全部核销',
  Cargo_CheckingStatus: '提单确认状态',
  Cargo_HblCheckingStatus: 'HBL提单确认状态',
  Cargo_CheckingURLStatus: '对单状态',
  Cargo_CheckInvoice: '收票开票',
  Cargo_CheckWriteOffDetails: '查询销账明细',
  Cargo_ChineseCargoName: '中文品名',
  Cargo_StatusUpdateTime: '提单状态变更时间',
  Cargo_StatusUpdateUser: '提单状态变更人',
  Cargo_ChineseFirstVesselName: '船名',
  Cargo_ChineseName: '中文名',
  Cargo_ChineseNameCanTBeEmpty: '中文名不能为空',
  Cargo_ChineseNameOfSettlingParty: '结算对象中文名',
  Cargo_Choose0P: '选中 0:',
  Cargo_ChooseByText: '根据文本选择',
  Cargo_ChooseFee: '选择费用',
  Cargo_ChooseFeeCNY: '选中RMB费用',
  Cargo_ChooseFeeUSD: '选中USD费用',
  Cargo_ChooseInvoicedFee: '选中有发票费用',
  Cargo_ChooseP: '选中 {0}:',
  Cargo_TicketCount: '票数：',
  Cargo_CIIRSBATTB: '确认是否应当添加账单中的开票需求',
  Cargo_CIMJ: '快递信息必录判断',
  Cargo_CIMS: '托收信息修改成功。',
  Cargo_City: '所属城市',
  Cargo_CityCode: '城市编码',
  Cargo_CityMaintenance: '城市维护',
  Cargo_CityName: '城市名称',
  Cargo_CityNotSelected: '城市未选择',
  Cargo_CityP: '城市',
  Cargo_Claim: '认领',
  Cargo_ClaimAdvanceReceipt: '预收款认领',
  Cargo_ClaimAR: '应收款认领',
  Cargo_ClaimBankReceipt: '水单认领',
  Cargo_ClaimDate: '认领日期',
  Cargo_ClaimedBy: '认领人',
  Cargo_ClaimInformation: '认领信息',
  Cargo_ClaimOrNot: '是否认领',
  Cargo_ClaimState: '认领状态',
  Cargo_ClaimStatusOfAdvanceReceipt: '认领状态(预收)',
  Cargo_ClaimStatusOfAR: '认领状态(应收)',
  Cargo_Clear: '清除',
  Cargo_ClearData: '清除数据',
  Cargo_ClearFilter: '清除过滤',
  Cargo_ClickToFilter: '点击过滤',
  Cargo_ClickToLoadParameter: '点击按钮加载查询参数',
  Cargo_ClickToQuery: '点击按钮进行查询操作',
  Cargo_ClientAllocationStatus: '客户分配状态',
  Cargo_CLientCantBeEmpty: '客户不能为空',
  Cargo_ClientContract: '客户合同',
  Cargo_ClientEventNotSelected: '客户事件未选择',
  Cargo_ClientList: '客户列表',
  Cargo_ClientMovedToRecycleBin: '该客户被移入客户回收站',
  Cargo_ClientNo: '客户编号',
  Cargo_ClientOverseasAgent: '客户/海外代理',
  Cargo_ClientStatus: '客户状态',
  Cargo_ClientSVisit: '客户来访',
  Cargo_ClientVendor: '客户/供应商',
  Cargo_Close: '关闭',
  Cargo_Close2: '收起',
  Cargo_CloseAccount: '结账',
  Cargo_CloseAccount2: '结账2',
  Cargo_CloseAccountOrNot: '是否结账',
  Cargo_CloseDateOfContainerReturn: '还柜结束日期',
  Cargo_CloseDetailWindow: '关闭详细窗口',
  Cargo_CloseWindow: '关闭窗口',
  Cargo_ClosureNo: '结束号码',
  Cargo_ClosureTimeSelection: '结束时间选择',
  Cargo_ClosureTitleOfAccount: '结束科目',
  Cargo_CNY: '人民币',
  Cargo_CNYHKD: '人民币/港元',
  Cargo_CNYInvoiceNo: '人民币发票号',
  Cargo_CNYP: '人民币：',
  Cargo_COACP: '实收付币种',
  Cargo_Code: '代码',
  Cargo_CodeCanTBeEmpty: '代码不能为空',
  Cargo_DuplicateCode: '代码重复，请重新输入.',
  Cargo_CodeNotMaintained: '编码没有维护。',
  Cargo_CodeOfExpenseDescription: '费用名称代码',
  Cargo_CodeSearching: '代码检索',
  Cargo_CodeType: '编码类型',
  Cargo_CodeTypeP: '编码类型:',
  Cargo_Coding: '编码',
  Cargo_ApCoding: '应付编码',
  Cargo_ArCoding: '应收编码',
  Cargo_CodingMapping: '编码映射',
  Cargo_CodingP: '编码:',
  Cargo_Collect: '收',
  Cargo_CollectAndPrepaidOrNot: '是否代收垫付',
  Cargo_CollectedExpenseDetails: '已托收费用明细',
  Cargo_CollectedExpenseDetailsP: '已托收费用明细:',
  Cargo_CollectedInFull: '已收齐',
  Cargo_CollectedNotCollectedInFull: '已收齐/未收齐',
  Cargo_CollectFormation: '收款信息',
  Cargo_CollectInvoice: '收票',
  Cargo_Collection: '托收',
  Cargo_CollectionCNY: '托收CNY',
  Cargo_CollectionDetails: '托收费用明细',
  Cargo_CollectionDifference: '托收差异',
  Cargo_CollectionInformation: '托收信息',
  Cargo_CollectionPayment: '收付款',
  Cargo_CollectionPaymentCleared: '收付款已结清',
  Cargo_CollectionPaymentDate: '收付款日期',
  Cargo_CollectionPaymentInformation: '收付款信息',
  Cargo_CollectionPaymentMethod: '收付款方式',
  Cargo_CollectionPaymentTypeFilter: '收付类型过滤',
  Cargo_CollectionRecordByCarrier: '船公司托收记录',
  Cargo_CollectionSituation: '收款情况',
  Cargo_CollectionStatus: '托收状态',
  Cargo_CollectionUSD: '托收USD',
  Cargo_CoLoadConsol: '委托拼箱',
  Cargo_ColorOfControllingRow: '控制行颜色',
  Cargo_CombinedInvoicing: '合并开票',
  Cargo_CombinedListNo: '并票清单号',
  Cargo_Commission: '佣金',
  Cargo_CommissionAmount: '提成金额',
  Cargo_CommissionedGrossWeight: '委托毛重',
  Cargo_CommissionItems: '佣金项',
  Cargo_CommissionOrNot: '是否佣金',
  Cargo_CommissionPercentage: '提成比例',
  Cargo_CommissionRules: '提成规则',
  Cargo_CommodityCode: '商品编码',
  Cargo_CommodityInspection: '商检',
  Cargo_CommonlyUsedTradeTerms: '常用贸易条款',
  Cargo_Company: '公司',
  Cargo_CompanySelfRelease: '公司自出单',
  Cargo_CompanySReceivingAccountNumber: '公司收款账号',
  Cargo_CompanySReceivingBank: '公司收款银行',
  Cargo_Competitor: '竞争公司',
  Cargo_Completed: '完成',
  Cargo_CompleteDate: '结束日期',
  Cargo_CompletedOrNot: '是否已完成',
  Cargo_CompleteWriteOff: '完全核销',
  Cargo_CompletionTime: '完成时间',
  Cargo_ConditionOfSearch: '搜索条件',
  Cargo_ConditionType: '条件类型',
  Cargo_ConfiCNYill: '确认账单',
  Cargo_ConfigureAccountTitle: '科目设置',
  Cargo_Confirm: '确定',
  Cargo_AMSEnsChannel: '反恐舱单ENS识别供应商',
  Cargo_SkipAll: '全部跳过',
  Cargo_SecondFlightSchedule: '二程航班时刻',
  Cargo_TwoWayFreighter: '二程货机',
  Cargo_EmailFormatError: '邮箱格式错误',
  Cargo_CountryOfShipment: '起运国家',
  Cargo_AirFreightRateDetails: '空运运价详情',
  Cargo_ConfirmAndCheckSelectedRecord: '是否确认复核选择的记录？',
  Cargo_ConfirmAP: '确认应付费用',
  Cargo_ConfirmCancellationOfRecord: '确定删除记录？',
  Cargo_ConfirmCombinedInvoice: '确定合并开票',
  Cargo_ConfirmDate: '确认日期',
  Cargo_Confirmed: '已确认',
  Cargo_ConfirmedSuccessfully: '确认成功。',
  Cargo_ConfirmExpenses: '费用确认',
  Cargo_ConfirmNotification: '确认提醒',
  Cargo_ConfirmOffset: '确认对销',
  Cargo_ConfirmOrNot: '是否确认',
  Cargo_ConfirmPartial: '是否部分确认',
  Cargo_ConfirmR: '确认',
  Cargo_ConfirmRQ: '确认？',
  Cargo_ConfirmRemarks: '确认备注',
  Cargo_ConfirmSelectedItem: '确认选中项',
  Cargo_ConfirmStatus: '确认状态',
  Cargo_ConfirmSubmissionOfPaymentOrder: '确定提交付款通知？',
  Cargo_ConfirmWriteOff: '确定销账',
  Cargo_ConfirmWriteOffQ: '确认销账吗？',
  Cargo_ConfirmWrittenOffExpense: '确认销账费用',
  Cargo_ConflictExpenseDetails: '冲突费用明细',
  Cargo_Consignation: '委托',
  Cargo_ConsignationCompanyCannotBeNull: '委托单位不能为空',
  Cargo_Consignee: '收货人',
  Cargo_ConsigneeId: '收货人代码',
  Cargo_ConsigneeInfo: '收货人信息',
  Cargo_ConsigneeSName: '收货人名称',
  Cargo_ConsignorSCode: '委托单位(代码)',
  Cargo_ConsolidatedCNY: '综合（人民币）',
  Cargo_ConsolidatedCurrency: '合并币种',
  Cargo_ConsolidatedLocalCurrency: '综合本位币',
  Cargo_ConsolidatedLocalCurrencyCNY: '综合本位币（人民币）',
  Cargo_ConsolidatedProfitLossIs: '汇兑损益为：',
  Cargo_ConsolidateOrNot: '是否归并',
  Cargo_Contact: '联系人',
  Cargo_ContactNumber: '联系电话',
  Cargo_ContainerAmount: '箱量',
  Cargo_ContainerDescription: '箱量描述',
  Cargo_ContainerInfo: '装箱信息',
  Cargo_ContainerNo: '箱号',
  Cargo_ContainerSize: '箱型',
  Cargo_ContainerType: '箱种',
  Cargo_ContainerRule: '箱尺',
  Cargo_ContainerTypeCanTBeEmpty: '箱型不能为空',
  Cargo_ContainerTypeMaintenance: '箱种维护',
  Cargo_ContainerTypeSea: '整拼类型（海运）',
  Cargo_ContentDescription: '内容描述',
  Cargo_ContentFailedToLoad: '内容加载失败',
  Cargo_ContentFailedToLoadP: '内容加载失败：',
  Cargo_ContentOfAmount: '金额内容',
  Cargo_ContentOfExpenseDescription: '费用名称内容',
  Cargo_ContentPreviewOfPaymentNotice: '入款通知内容预览',
  Cargo_Continent: '大洲',
  Cargo_ContinueToAddData: '继续添加数据',
  Cargo_ContinueToSave: '继续保存',
  Cargo_ContinuousFilter: '连续过滤',
  Cargo_Contra: '对销',
  Cargo_ContraAmount: '对销金额',
  Cargo_ContraAmountP: '对销金额:',
  Cargo_ContraBalance: '对销余额',
  Cargo_ContractAdministrator: '合同管理员',
  Cargo_ContractConfiguration: '合同配置',
  Cargo_Contracted: '已签约',
  Cargo_ContractedClientInformation: '签单客户信息',
  Cargo_ContractExpired: '合约失效',
  Cargo_ContractNumber: '合同编号',
  Cargo_ContractNumberCanTBeEmpty: '合同编号不能为空',
  Cargo_ContractRateProperty: '约价性质',
  Cargo_ContractSignedSuccessfully: '签单成功',
  Cargo_ContractStatus: '合同状态',
  Cargo_RiskReason: '风控原因',
  Cargo_ContractValidStatus: '合约是否有效',
  Cargo_ContractTerms: '合同条款',
  Cargo_CurrentCredit: '当前信控',
  Cargo_ContractCredit: '合同信控',
  Cargo_ContractType: '合同类型',
  Cargo_ConversionAmountContent: '折算金额内容',
  Cargo_ConversionAmountInCNY: '折算人民币金额',
  Cargo_ConversionRMB: '折合RMB',
  Cargo_ConversionAP: '折合应付',
  Cargo_ConversionAPCNY: '折合CNY应付',
  Cargo_ConversionPaidCNY: '折合CNY已付',
  Cargo_ConversionAPCurrency: '折合{0}应付',
  Cargo_ConversionAR: '折合应收',
  Cargo_ConversionARCNY: '折合CNY应收',
  Cargo_ConversionReceivedCNY: '折合CNY已收',
  Cargo_ConversionARCurrency: '折合{0}应收',
  Cargo_ConversionCurrencyAmount: '折算币种金额',
  Cargo_ConversionOutstandingAR: '折合未收',
  Cargo_ConversionOutstandingARCNY: '折合CNY未收',
  Cargo_ConversionOutstandingARCurrency: '折合{0}未收',
  Cargo_ConversionOutstandingReceivedCurrency: '折合{0}已收',
  Cargo_ConversionProfit: '折合利润',
  Cargo_ConversionProfitCNY: '折合CNY利润',
  Cargo_ConversionProfitCNYP: '折合CNY利润:',
  Cargo_ConversionWriteOffAmountInCNY: '销账折算人民币金额',
  Cargo_COPLOCP: '结转本期损益',
  Cargo_Copy: '复制',
  Cargo_CopyAndAddPoItems: '复制新增',
  Cargo_CopyExchangeRate: '复制汇率',
  Cargo_CopyFromExisting: '根据现有账套新建',
  Cargo_InitializeLevelOneSubject: '初始化一级科目',
  Cargo_InitializeReport: '初始化报表',
  Cargo_Cost: '费用',
  Cargo_CostInvoiceNo: '成本发票号',
  Cargo_CounterpartySBankAccount: '对方账号',
  Cargo_CounterpartySBillingNo: '对方账单号',
  Cargo_Country: '国家',
  Cargo_CountryMaintenance: '国家维护',
  Cargo_CountryRegion: '国家(地区)',
  Cargo_CountryRegionCode: '国家(地区)代码',
  Cargo_CourierOrderNo: '快递单号',
  Cargo_CPIOOPRCCTBV: '当前实收实付记录已经复核过,不能作废.',
  Cargo_CPIOOPRVCTBM: '当前实收实付记录已作废，不能被修改!',
  Cargo_CPIOOPRWOCTBV: '当前实收实付记录已有核销记录,不能作废.',
  Cargo_Create: '创建',
  Cargo_uploadErr: '上传失败',
  Cargo_CreateAndExportDirectly: '生成后直接导出',
  Cargo_CreateBill: '创建账单',
  Cargo_BatchCreateBill: '批量生成账单',
  Cargo_BatchCreateBillTitle: '请选择数据范围',
  Cargo_BatchCreateBillBySame: '相同结算对象的费用将生成一张账单',
  Cargo_BatchCreateBillByAll: '查出的全部记录',
  Cargo_BatchCreateBillBySelected: '选中的记录',
  Cargo_BatchCreateBillSuccess: '操作成功: 共生成 {0} 笔账单',
  Cargo_CreateBillQ: '是否创建账单',
  Cargo_CreateCombination: '合并生成',
  Cargo_CreateCostInvoice: '是否生成成本发票',
  Cargo_CreatedBy: '录入人',
  Cargo_CreatedDate: '创建日期',
  Cargo_CreatedSuccessfully: '新建成功!',
  Cargo_CreateInvoice: '生成发票',
  Cargo_CreateListOfCombinedInvoices: '生成并票清单',
  Cargo_CreateOffsetExpense: '生成对冲费用',
  Cargo_CreatePaymentRequest: '创建付款申请单',
  Cargo_CreatePaymentRequestChooseFees: '创建付款申请-选择费用',
  Cargo_CreatePaymentRequestDetails: '创建付款申请-详细信息',
  Cargo_BasicPaymentRequest: '付款申请(基础版)',
  Cargo_PendingSupervisorApproval: '待主管审批',
  Cargo_PaymentRequestSettings: '付款申请设置',
  Cargo_EnableUICustomization: '开启UI自定义显示',
  Cargo_AdditionalApprovalNode: '额外审批节点',
  Cargo_DepartmentApprovalTab: '部门审批（显示待部门审批页签）',
  Cargo_SupervisorApprovalTab: '主管审批（显示待主管审批页签）',
  Cargo_PreApproval: '前置审核',
  Cargo_FinanceApproval: '财务审批',
  Cargo_OperationReview: '业务审批',
  Cargo_DepartmentReview: '部门审批',
  Cargo_SupervisorReview: '主管审批',
  Cargo_RuleBasedApproval: '仅将符合规则的单据，进入该页签进行额外审批',
  Cargo_NonRuleBypass: '允许不符合特定规则的单据，无需主管审核',
  Cargo_Settings: '设置',
  Cargo_PendingDepartmentApproval: '待部门审批',
  Cargo_AllPaymentRequests: '付款申请(所有)',
  Cargo_SupervisorReviewer: '主管审核人',
  Cargo_SupervisorReviewDate: '主管审核日期',
  Cargo_SettlementUnitContractStatus: '供应商合同状态',
  Cargo_ReturnToPreviousApprovalNode: '是否退回到上一审批节点',
  Cargo_CreateSoa: '创建对账单',
  Cargo_CreateVoucher: '生成凭证',
  Cargo_Creator: '创建人',
  Cargo_Credit: '贷',
  Cargo_CreditAmount: 'credit金额',
  Cargo_CreditAmount2: '贷方金额',
  Cargo_CreditAmountCNY: '贷方（人民币）',
  Cargo_CreditAmountOccurred: '贷方发生额',
  Cargo_CreditAmountOccurredCNY: '贷方发生额(人民币)',
  Cargo_CreditAmountOccurredP: '贷方发生额：',
  Cargo_CreditAmountOccurredUSD: '贷方发生额(美元)',
  Cargo_CreditAmountTo: 'Credit合计',
  Cargo_CreditAmountToP: 'Credit合计:',
  Cargo_CreditAmountUSD: '贷方（美元）',
  Cargo_CreditControlDetails: '信用控制明细',
  Cargo_CreditControlSettings: '信控设置',
  Cargo_CreditLimitExceeded: '额度超出',
  Cargo_ETDSettingDays: 'ETD设置天数',
  Cargo_ETDOccupyDays: '占用天数',
  Cargo_ETDExceeded: 'ETD超出',
  Cargo_CreditLimitRange: '额度范围',
  Cargo_CreditLocalCurrency: '贷方本位币',
  Cargo_CreditNotWrittenOff: 'credit未销',
  Cargo_CreditOriginalAmount: 'Credit原金额',
  Cargo_CreditSide: '贷方',
  Cargo_CreditUsed: '已用额度',
  Cargo_CreditWriteOffAmount: 'Credit核销金额',
  Cargo_CREVB5TM: 'C.出口稳定每个月5TEU以内',
  Cargo_CRPI: '确定要做登记预付？',
  Cargo_CSNPM: '收发通信息维护',
  Cargo_CSR: '操作员',
  Cargo_CSRGTIDDDI: '当前查询的结果大于显示条数，数据显示不全。',
  Cargo_CSWTCSTR: '该客户已签订合同，可选择该客户进行续签',
  Cargo_CTMCWOPCCF: '已经复核过的销账无法修改,请先取消复核.',
  Cargo_CTOPR: '确定转入预付登记？',
  Cargo_CTORI: '确定转回对账?',
  Cargo_CTRCWOPCCF: '已经复核过的销账无法撤销,请先取消复核.',
  Cargo_CTRLSPFCC: '是否确认释放客户绑定的销售',
  Cargo_Cubage: '体积',
  Cargo_Currency: '币种',
  Cargo_CurrencyCanTBeEmpty: '币种不能为空',
  Cargo_CurrencyFXRateNoMaintained: '币种【{0}】的汇率没有维护!',
  Cargo_CurrencyInconsistent: '币种不一致。',
  Cargo_CurrencyMaintenance: '币种维护',
  Cargo_CurrencyOfPayment: '付款币种',
  Cargo_CurrencyOfTotal: '合计币种',
  Cargo_CurrencyP: '币种:',
  Cargo_CurrentClientIsContracted: '当前客户已签单',
  Cargo_CurrentExchangeRate: '当前汇率',
  Cargo_CurrentLoginUser: '当前登录人',
  Cargo_CurrentMonth: '当前月份',
  Cargo_CurrentSelected: '当前选中',
  Cargo_Reefer: 'Reefer',
  Cargo_ShowCharacteristics: '显示货物特性',
  Cargo_ShowCharacteristicsTip: '选择当前货物类型时，在基本页面额外显示“带电”“带磁”液体”“粉末”勾选框',
  Electric: '带电',
  Magnetic: '带磁',
  Powder: '粉末',
  Liquid: '液体',
  Cargo_CurrentSelectedExpense: '当前选中的费用{0}',
  Cargo_CurrentSelectedSobIs: '当前选择的账套是：{0}',
  Cargo_CurrentSettlingParty: '当前结算对象',
  Cargo_CurrentWriteOffSerialNoCompleted: '本次销账流水号为{0}，销账成功。',
  Cargo_CurrentYearAccumulatedAmount: '本年累计金额',
  Cargo_CurrentYearProfitAccount: '本年利润科目',
  Cargo_CurrentYearProfitAccountP: '本年利润科目:',
  Cargo_CurrentYearTotal: '本年累计',
  Cargo_CurrentYearTotalAmout: '本年累计发生额',
  Cargo_CurrentYearTotalAmoutCreditCNY: '本年累计发生额贷方（人民币）',
  Cargo_CurrentYearTotalAmoutCreditUSD: '本年累计发生额贷方（美元）',
  Cargo_CurrentYearTotalAmoutDebitCNY: '本年累计发生额借方（人民币）',
  Cargo_CurrentYearTotalAmoutDebitUSD: '本年累计发生额借方（美元）',
  Cargo_CursorPointedInvoiceNo: '光标定位发票号',
  Cargo_Customer: '客户',
  Cargo_CustomerAddress: '客户地址',
  Cargo_CustomerHasConfirm: '{0}号，客户已经确认。',
  Cargo_CustomerLevel: '客户级别',
  Cargo_CustomerName: '客户名称',
  Cargo_CustomerP: '客户:',
  Cargo_CustomerProperty: '客户属性',
  Cargo_CustomerReferenceNumber: '客户参考号',
  Cargo_CustomerSelfRelease: '客户自出单',
  Cargo_CustomerService: '客服',
  Cargo_CustomerSpace2: '指定货',
  Cargo_CustomerSpace3: '自揽货',
  Cargo_CustomerType: '客户类型',
  Cargo_Customized: '自定义',
  Cargo_CustomizedField1: '自定义字段1',
  Cargo_CustomizedField2: '自定义字段2',
  Cargo_CustomizedField3: '自定义字段3',
  Cargo_CustomizedField4: '自定义字段4',
  Cargo_CustomJobType: '自定义业务类型',
  Cargo_CustomJobTypeP: '自定义业务类型',
  Cargo_CustomsApproval: '海关审批',
  Cargo_CustomsBroker: '报关行',
  Cargo_CustomsBrokerFilter: '报关行过滤',
  Cargo_CustomsDeclaration: '报关',
  Cargo_CustomsDeclarationSearchFailed: '查询报关信息失败：',
  Cargo_CustomsNo: '海关编号',
  Cargo_CWOIFCTTTEPRCOEA: '托收已经全部核销,不能再转入费用,请另做托收或费用申请。',
  Cargo_CYCutOffDate: '截关日期',
  Cargo_CYSPATIPLVCTBE: '损益凭证本年利润科目不能为空',
  Cargo_CYWRYTTPPATDWBMTRS: '单击"是"将跳转到打印页面并修改单证为"已退还"状态',
  Cargo_CYWRYTTPPATRDWBCTRS: '单击"是"将跳转到打印页面,已取回的单证改为"已退还"状态',
  Cargo_DAIIUCTBD: '【差额调整】已被业务使用，不能删除',
  Cargo_DAIOCPCNY: '本期发生额借方（人民币）',
  Cargo_DAIOCPUSD: '本期发生额借方（美元）',
  Cargo_DataExport: '导出',
  Cargo_DataExportPDF: '导出PDF',
  Cargo_DataSent: '已发资料',
  Cargo_DataTransmissionStatus: '资料发送状态',
  Cargo_DataType: '数据类型',
  Cargo_DataTypeP: '数据类型:',
  Cargo_Date: '日期',
  Cargo_DateCanTBeEmpty: '日期不能为空',
  Cargo_DateFrom: '开始日期',
  Cargo_DateFunction: '日期函数',
  Cargo_DateNotInPeriod: '日期不在期间内',
  Cargo_DateOfApplication: '申请日期',
  Cargo_DateOfCollectionCanTBeEmpty: '收款日期不能为空。',
  Cargo_DateOfDeclaration: '申报日期',
  Cargo_DateOfDepartureCannotBeNull: '开航日期不能为空',
  Cargo_DateOfDocument: '制单日期',
  Cargo_DateOfInvoicingList: '开票清单日期',
  Cargo_DateP: '日期:',
  Cargo_DateType: '日期类型',
  Cargo_DateType2: '日期类型2',
  Cargo_Days: '天',
  Cargo_DaysFromContractSigned: '签单天数',
  Cargo_DaysOfSleep: '沉睡天数',
  Cargo_DaysOverdue: '逾期天数',
  Cargo_DaysToContractExpiry: '即将到期天数',
  Cargo_DBASBEICS: '选择现金时银行账号需要默认为空',
  Cargo_Deadline: '截止日',
  Cargo_TempCredit: '临时信控',
  Cargo_EtdDays: 'ETD天数',
  Cargo_EtdExceedsDays: '当前客户已经超出了最大ETD天数，无法放号',
  Cargo_EtdExceedsDaysOrder: '当前客户已经超出了最大ETD天数，无法放单',
  Cargo_ShippingDocumentsNotBeReleased: '应收未结清，不允许放单',
  Cargo_SpecialFeePaymentLimit: '专项费用付款申请限制',
  Cargo_PaymentOnlySpecificCosts: '专项费用付款申请只能申请专项费用，不能含有其他费用',
  Cargo_ThePaymentNotSettled: '{0}月份款项没有结清',
  Cargo_UnconfirmedSum: '{0}+{1}+{2}+{3} 未确认，请先确认！',
  Cargo_SpecialApproval2: '特殊审批',
  Application_Item: '申请事项',
  Application_Content: '申请内容',
  Application_Reason: '申请原因',
  Cargo_DomesticOverseas: '国内/境外',
  Cargo_IncludeOverseasWarehouse: '含海外仓',
  Cargo_SignContract2: '签订合同',
  Cargo_LatestContractDate: '最迟签订合同日期',
  Cargo_CreditControlSelfAssessment: '信控额度自测表',
  Cargo_CustomerFile: '客户档案',
  Cargo_CustomerConsignmentNote: '客户托书',
  Cargo_HasContract: '有合同',
  Cargo_NoContract: '无合同',
  Cargo_ContractStatus2: '有无合同',
  Cargo_SupplierFile: '供应商档案',
  Cargo_ApprovalSummary: '审批内容简述',
  Cargo_AlreadyExistsCannotSubmit: '{0}已存在，无法提交申请！',
  Action_AddAttachment: '添加附件',
  Validation_ApplicationContentRequired: '申请内容不能为空',
  Validation_ApplicationReasonRequired: '申请原因不能为空',
  Cargo_AutoReceivablesWriteOff: '应收自动核销',
  Cargo_WhetherIgnore: '是否忽略',
  Cargo_TempCreditNotBeCross: '临时信控有效期不能有交集',
  Cargo_TempCreditNotice: '注：临时信控的额度/账期 单位同合同的单位（次日生效）',
  Cargo_CurrentCreditNotice: '注：当前时间下满足条件的账期/额度，当天所维护的临时信控会在次日同步至合作伙伴中',
  Cargo_CurrentAvailableNotEntered: '当前可用数未输入',
  Cargo_Debit: '借',
  Cargo_DebitAmount: 'debit金额',
  Cargo_DebitAmount2: '借方金额',
  Cargo_DebitAmountCNY: '借方金额（人民币）',
  Cargo_DebitAmountOccurred: '借方发生额',
  Cargo_DebitAmountOccurredCNY: '借方发生额（人民币）',
  Cargo_DebitAmountOccurredP: '借方发生额：',
  Cargo_DebitAmountOccurredUSD: '借方发生额（美元）',
  Cargo_DebitAmountTo: 'Debit合计',
  Cargo_DebitAmountToP: 'Debit合计:',
  Cargo_DebitAmountUSD: '借方金额（美元）',
  Cargo_DebitLocalCurrency: '借方本位币',
  Cargo_DebitNotWrittenOff: 'debit未销',
  Cargo_DebitOriginalAmount: 'Debit原金额',
  Cargo_DebitSide: '借方',
  Cargo_DebitSideCNY: '借方（人民币）',
  Cargo_DebitSideCreditSide: '借方/贷方',
  Cargo_DebitSideCreditSideP: '借方/贷方:',
  Cargo_DebitSideUSD: '借方（美元）',
  Cargo_DebitWriteOffAmount: 'Debit核销金额',
  Cargo_December: '12月',
  Cargo_DeclareWarehouseLoadingContainer: '是否报关内装箱仓储',
  Cargo_DeemedPrinted: '视同打印',
  Cargo_VGMLog: 'VGM日志',
  Cargo_SendVGM: '发送VGM',
  Cargo_VGMChannel: 'VGM通道',
  Cargo_VGMBasicInfo: 'VGM基本信息',
  Cargo_FriendlyReminder: '温馨提示：加拼请填写主单号',
  Cargo_VGMCutOffDate: '截VGM日期',
  Cargo_ContainerHolder: '持箱人',
  Cargo_NotFilledIn: '未填写，请填写完成后发送。',
  Cargo_NotSelected: '未选择，请填写完成后发送。',
  Cargo_PleaseMaintainCargoInfo: '请维护箱货信息',
  Cargo_IfYouHaveSentPreStowageManifest: '如您已通过海管家通道发送预配舱单，则会从预配信息页签同步信息；',
  Cargo_IfYouHaveNotSentPreStowageManifest: '如没有通过海管家通道发送预配舱单，则会从基本，订舱页签同步信息。',
  Cargo_FriendlyReminderWithPort: '温馨提示：上海口岸，建议您在预录入完成之后再发送VGM信息，驳船接大船，以驳船时间为准',
  Cargo_TerminalInfoForReferenceOnly: '码头信息仅供参考，具体请以订舱口为准！',
  Cargo_TerminalInfoForReferenceWse: '若订舱口码头信息与我们参考码头信息不符，请联系客服，谢谢！',
  Cargo_IfBookingPortTerminalInfoDoesNotMatchPleaseContactCustomerService: '若订舱口码头信息与我们参考码头信息不符，请联系客服。',
  Cargo_FriendlyReminderWithCutOffTime: '温馨提示：请填写正确的截单时间，我们会根据此日期多次发送，若由于信息错误而产生的晚载费，平台不予承担。',
  Cargo_TheShipperDeclares: '本托运人声明：该文件资料所含载货集装箱重量信息系按照《1974年国际海上人命安全公约》所述方法获得，称重点的衡量器已取得计量技术机构颁发的计量检定证书，且获得重量的日期在证书的有效范围内。 ',
  Cargo_RepeatedlySendingVGMWithTheSameContainerTips: '相同箱号重复发送VGM将会多次收费，如需再次发送请{0}S后发送。',
  Cargo_Send_VGM_Reminder: '每个箱号发送VGM会扣费一次，相同箱号多次发送会重复扣费。如修改VGM信息，只需发送修改的箱子的VGM信息。<//br>请确认是否继续发送?',
  Cargo_ContinueSending: '继续发送',
  Cargo_ResendAfterS: 's后重新发送',
  Cargo_ExternalAssociationCode: '外部关联代码',
  Cargo_ExternalAssociationCodeValidMessage: '外部关联代码只能是字母或者是数字',
  Cargo_ShippingCompanyReceiptStatus: '船公司回执状态',
  Cargo_DeparturePortFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: '起运港字段未找到与海管家匹配的信息，请勾选。',
  Cargo_ShippingCompanyFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: '船公司字段未找到与海管家匹配的信息，请勾选。',
  Cargo_CharLengthWithRange: '长度在{0}到{1}个字符',
  Cargo_TheBoxNumberMustBe: '箱号必须为4位字母+7位数字',
  Cargo_LoadWharfTips: '码头信息仅供参考，具体请以订舱口为准！若订舱口码头信息与我们参考码头信息不符，请联系客服，谢谢！',
  Cargo_WhetherToContinueSendingVGM: '是否继续发送VGM？',
  Cargo_Default: '默认',
  Cargo_DefaultAPUnitPrice: '默认应付单价',
  Cargo_DefaultARCurrency: '默认应收币种',
  Cargo_DefaultAPCurrency: '默认应付币种',
  Cargo_DefaultARUnitPrice: '默认应收单价',
  Cargo_DefaultDecimalPlaces: '默认小数位数',
  Cargo_DefaultLine: '默认行',
  Cargo_DefaultMenuItems: '默认的菜单项',
  Cargo_DefaultOrNot: '是否默认',
  Cargo_DefaultPayee: '默认应付对象',
  Cargo_DefaultPayer: '默认应收对象',
  Cargo_DefaultSearchCondition: '默认查询条件',
  Cargo_DefaultValue: '默认值',
  Cargo_SeDefaultValue: '海出默认值',
  Cargo_SiDefaultValue: '海进默认值',
  Cargo_AeDfaultValue: '空出默认值',
  Cargo_AiDfaultValue: '空进默认值',
  Cargo_ReDfaultValue: '铁出默认值',
  Cargo_RiDfaultValue: '铁进默认值',
  Cargo_EditDefaultValue: '编辑默认值',
  Cargo_EditJobDefaultValueTip: `如每个业务类型的默认值不同，请在对应的业务类型文本框内维护；
如业务类型文本框和默认值都维护的有值，优先根据业务类型来取对应业务类型文本框值；`,
  Cargo_DefaultWriteOffCurrency: '默认销账币种',
  Cargo_DelayedTaxRefund: '是滞退税',
  Cargo_DelegationTypeRailway: '委托类型(铁路)',
  Cargo_Delete: '删除',
  Cargo_DeleteConfirmation: '确定要删除选中的记录吗？',
  Cargo_DeleteBill: '移除账单',
  Cargo_DisplayRules: '显示规则',
  Cargo_ViewAttachments: '查看附件',
  Cargo_DeleteCollectionRecord: '删除托收登记',
  Cargo_DeletedBillList: '已删除账单列表',
  Cargo_DeletedSuccessfully: '删除成功。',
  Cargo_WithdrawSuccessfully: '撤回成功。',
  Cargo_DeletedNotHavePermission: '您没有权限删除本条报价单。',
  Cargo_DeletedNotIntoBusiness: '报价单已带入到业务的费用中，不能删除！',
  Cargo_DeleteEntry: '删除分录',
  Cargo_DeleteFailed: '删除失败。',
  Cargo_DeleteFee: '删除费用',
  Cargo_DeleteFeeConfirmedListSync: '同时删除费用确认单',
  Cargo_DeleteInvoice: '删除发票',
  Cargo_DeleteNotification: '删除提示',
  Cargo_DeleteOrNot: '是否删除？',
  Cargo_DeleteVoucher: '删除凭证',
  Cargo_Delivered: '已送出',
  Cargo_DeliveredButNotRetrieved: '已送出(未取回)',
  Cargo_DeliveredSuccessfully: '送出成功。',
  Cargo_DeliveredToBranch: '是否发送过分公司',
  Cargo_DeliverPartial: '是否部分发送',
  Cargo_DeliverySigned: '已签收',
  Cargo_DenialReason: '拒绝理由',
  Cargo_DenialReasonP: '拒绝理由:',
  Cargo_Denied: '已拒绝',
  Cargo_DeniedSuccessfully: '拒绝成功。',
  Cargo_DenyApplication: '拒绝申请',
  Cargo_DenyPaymentApplication: '拒绝付款申请',
  Cargo_Department: '部门',
  Cargo_DepartmentApproval: '部门审批',
  Cargo_DepartmentP: '部门:',
  Cargo_DepartureTime: '开船时间',
  Cargo_DepositBank: '开户银行',
  Cargo_DepositBankAccountNo: '开户银行账号',
  Cargo_DepositBankAndAccountNo: '开户行及账号',
  Cargo_DepositBankAndAccountNoP: '开户行及账号:',
  Cargo_DesCharge: '目的地费用',
  Cargo_DescriptionCanTBeEmpty: '内容描述不能为空',
  Cargo_DescriptionOfCharge: '收费内容',
  Cargo_DescriptionOfExpenseItem: '费用项目名称',
  Cargo_DescriptionOfExpenseItemCNY: 'CNY费用项目名称',
  Cargo_DescriptionOfExpenseItemUSD: 'USD费用项目名称',
  Cargo_DescriptionOfExpenseItemJPY: 'JPY费用项目名称',
  Cargo_DescriptionOfExpenseItemEUR: 'EUR费用项目名称',
  Cargo_DescriptionOfPlan: '方案说明',
  Cargo_DescriptionOfQuantity: '数量内容',
  Cargo_DescriptionOfVoucherType: '凭证类型说明',
  Cargo_DesignatedDepartment: '指定部门',
  Cargo_DesignSubTitlesOfAccount: '设计子科目',
  Cargo_Destination: '目的地',
  Cargo_ChargeItemMaintenance: '收费项目维护',
  Cargo_ZeroTaxRate: '是否零税率',
  Cargo_DestinationAgent: '目的港代理',
  Cargo_DestinationAgent1: '海外代理',
  Cargo_DestinationChargeOrNot: '是否目的地费用',
  Cargo_DestinationPort: '目的港',
  Cargo_DestinationPortSea: '目的港（海运）',
  Cargo_DestinationPortAir: '目的港（空运）',
  Cargo_OverseaWarehouse: '海外仓',
  Cargo_NoRestriction: '不限制',
  Cargo_Details: '明细',
  Cargo_DetailsOfOutOfPocketRecord: '实付登记明细',
  Cargo_DetailsOfSingleWriteOff: '单笔销账明细',
  Cargo_DetailsOfSingleWriteOffPDF: '单笔销账明细.pdf',
  Cargo_DetailsOfSingleWriteOffXLS: '单笔销账明细.xls',
  Cargo_DevelopedAtExhibitions: '展会开发',
  Cargo_Difference: '差额',
  Cargo_DifferenceAdjustment: '差额调整',
  Cargo_DifferenceCNYCNY: '差额CNY',
  Cargo_DifferenceUSD: '差额USD',
  Cargo_DifferentialAdjustedSuccessfully: '差额调整成功',
  Cargo_DifferentialIs: '差额为：{0}',
  Cargo_DifferentialProcessing: '差额处理',
  Cargo_DifficultyIndex: '攻克难度指数',
  Cargo_DIITRLNLTSIT: '右边列表展示与选择的发票类型没有关联',
  Cargo_DirectAssign: '直接分配',
  Cargo_DirectBusiness: '直单',
  Cargo_DirectConsol: '自拼箱',
  Cargo_DirectConsolContainerNo: '自拼箱箱号',
  Cargo_Direction: '方向',
  Cargo_DirectServiceOrNot: '是否直达',
  Cargo_DiscrepancyExist: '有差异',
  Cargo_DiscrepancyFound: '有不相同的',
  Cargo_DisplayAmountOfDifferential: '是否显示差额金额',
  Cargo_DisplayAmountOfReconciliation: '是否显示对账金额',
  Cargo_DisplayBatchOperation: '是否显示批量操作',
  Cargo_DisplayCashFlowItems: '是否现金流量项目',
  Cargo_DisplayExpenseDetails: '是否显示费用明细',
  Cargo_DisplayMonthSelector: '是否显示月份选择器',
  Cargo_DisplayOrder: '显示顺序',
  Cargo_DisplayTotalCost: '是否显示总成本',
  Cargo_DisplayTotalIncome: '是否显示总收入',
  Cargo_DisplayUnCodedRecordsOnly: '只看编码为空',
  Cargo_DisplayUnInvoicedAmount: '是否显示未开票金额',
  Cargo_DistributedReconciliationAmount: '分摊对账金额',
  Cargo_DistributionCostOrNot: '是否分摊费用',
  Cargo_District: '区',
  Cargo_DLCCLCCTBE: '借方本位币/贷方本位币不能为空。',
  Cargo_DMROITE: '发票类型{0}有重复维护的记录',
  Cargo_DNBTCBOHC: '正操作的数据所在分公司不属于当前分公司或上一级分公司，您确定要继续吗？',
  Cargo_DORMBGTTDOR: '退还日期必须大于取回日期。',
  Cargo_InvoiceNature: '税率标识',
  Cargo_InvoiceNatureTip: '税率标识为正常时才可调整税率',
  Cargo_DOCOTS: '货物或应税劳务名称',
  Cargo_DocReleaseAgainstPayment: '是否付款买单',
  Cargo_DocumentationType: '出单类型',
  Cargo_DocumentCirculation: '单证流转',
  Cargo_Documents: '单证',
  Cargo_DOEICTBE: '费用项目名称不可以为空',
  Cargo_Domestic: '国内',
  Cargo_DomesticBill: '国内账单',
  Cargo_DomesticChargeInformation: '国内收费情况',
  Cargo_DomesticCollection: '国内收款',
  Cargo_DomesticDirectClient: '国内直客',
  Cargo_DomesticDirectClientOrNot: '是否国内直客',
  Cargo_DomesticOrInternational: '国内/国外',
  Cargo_DomesticPayment: '国内付款',
  Cargo_DomesticTrade: '内贸',
  Cargo_DoNotSelectMultipleItems: '请勿选择多项',
  Cargo_Door: '门点',
  Cargo_DoorAddress: '门点地址',
  Cargo_DoorLoadingDelivery: '门点装箱/提货',
  Cargo_DoorPickup: '门点提货',
  Cargo_DOPNCTBLTAC: '正数差额不能小于1分钱。',
  Cargo_DoubleClickToView: '双击查看',
  Cargo_DownloadCompleted: '下载成功!',
  Cargo_DownloadFailed: '下载失败!',
  // Cargo_DrawABillOrNot: '是否全部开票',
  Cargo_DrawABillOrNot: '是否需要开票',
  Cargo_DRIRORIOCA: '应收股利应收利息其他应收款存货其他流动资产',
  Cargo_DSAIM: '是否显示结算方式和开票方式',
  Cargo_DSCSDSCS: '借方贷方借方贷方',
  Cargo_Dues: '应付',
  Cargo_DuesB: '（应付）',
  Cargo_DuesToCNY: '折合CNY应付：',
  Cargo_EquivalentCNY: '折合CNY抵扣金额：',
  Cargo_DuesCNY: 'CNY应付',
  Cargo_DuesEUR: 'EUR应付',
  Cargo_DuesGBP: 'GBP应付',
  Cargo_DuesHKD: 'HKD应付',
  Cargo_DuesJPY: 'JPY应付',
  Cargo_DuesNGN: 'NGN应付',
  Cargo_DuesP: '应付:',
  Cargo_DuesUSD: 'USD应付',
  Cargo_DuplicateCodePleaseTryItAgain: '代码重复，请重新输入。',
  Cargo_DuplicateContent: '复制内容',
  Cargo_DutyFree: '免税',
  Cargo_Uncertain: '不确定',
  Cargo_DynamicCurrencyDisplayColumn: '动态显示币种列',
  Cargo_ECDICA: '清空中间区域显示的内容',
  Cargo_ECNETSFS: '请输入代码名称等回车模糊查询',
  Cargo_ECSNMIR: '费用确认状态不符合开票要求',
  Cargo_ECSNMPAR: '费用确认状态不符合申请付款要求',
  Cargo_ECSNMWOR: '费用确认状态不符合销账要求',
  Cargo_EdiCode: 'EDI编码',
  Cargo_EdiInterfaceTypeOfEInvocing: '外部电子开票接口类型',
  Cargo_EdiInterfaceTypeOfInvoicing: '外部开票接口类型',
  Cargo_Edit: '编辑',
  Cargo_EditAdjustment: '修改调整',
  Cargo_EditAirFreightServiceItems: '编辑空运运费服务项目',
  Cargo_EditAssociatedPort: '编辑关联港口',
  Cargo_EditAwbSurcharge: '编辑空运运单杂费',
  Cargo_EditBill: '编辑账单',
  Cargo_EditBLType: '编辑提单类型',
  Cargo_EditChargeFinancialDate: '修改费用财务日期',
  Cargo_EditCirculationDocumentType: '编辑流转文件类型',
  Cargo_CirculationDocumentType: '流转文件类型',
  Cargo_EditClientType: '编辑客户类型',
  Cargo_EditCommissionRules: '编辑提成规则',
  Cargo_EditContract: '编辑合同',
  Cargo_EditCustomizedServiceType: '编辑自定义业务类型',
  Cargo_EditedSuccessfully: '修改成功。',
  Cargo_EditField: '编辑字段',
  Cargo_EditFinancialDate: '修改财务日期',
  Cargo_EditFormula: '编辑公式-',
  Cargo_EditKeyWord: '编辑敏感词',
  Cargo_EditMscService: '编辑MSC Service',
  Cargo_EditOppositeVoucherNo: '修改对方凭证号',
  Cargo_EditOrNot: '是否编辑',
  Cargo_EditRemarks: '修改备注',
  Cargo_EditRoute: '编辑航线',
  Cargo_EDTTTC: '可转入托收费用明细',
  Cargo_EDTTTCP: '可转入托收费用明细:',
  Cargo_EffectiveDate: '生效日期',
  Cargo_EffectiveMonth: '有效月份',
  Cargo_EICCMBU: '\'列Column \'CURRENCY的输入值CURRENCY违反唯一性约束',
  Cargo_EINDWI: '开票是否直接录入发票号',
  Cargo_EInvoiceCanTBePrinted: '电子发票不能打印。',
  Cargo_EInvoiceCanTBeVoided: '电子发票不能作废。',
  Cargo_EInvoicePaperInvoice: '电子发票纸质发票',
  Cargo_EmailAddress: '电子邮件',
  Cargo_EMailAlertForTestOnly: '邮件提醒（测试专用）',
  Cargo_EmailSent: '邮件已发送。',
  Cargo_Empty: '清空',
  Cargo_EmptyData: '清空数据',
  Cargo_EmptyEntries: '清空输入',
  Cargo_EmptyOriginalCurrency: '清空原币',
  Cargo_EMSSCM: '邮件发送成功，请注意查收',
  Cargo_EndDate: '截止日期',
  Cargo_EnglishCargoName: '英文品名',
  Cargo_EnglishCommodityNameMsc: '英文品名（MSC）',
  Cargo_EnglishName: '英文名',
  Cargo_EnglishNameCanTBeEmpty: '英文名不能为空',
  Cargo_Enter: '录入',
  Cargo_CannotDeleteUsedCustomerType: '不允许删除已使用的客户类型',
  Cargo_CannotDeleteUsedCustomerContactChannel: '不允许删除已使用的客户接触渠道',
  Cargo_CannotDeleteUsedCustomerRating: '不允许删除已使用的客户评定等级',
  Cargo_EnterBusinessTypeToStartSearch: '请输入业务类型查询',
  Cargo_EnterExpenseName: '输入费用名称',
  Cargo_EnterInvoiceNo: '录入发票号',
  Cargo_EnterInvoiceNoDirectly: '是否直接录入发票号',
  Cargo_EnterKeyWordsToStartFuzzySearch: '请输入敏感词进行模糊查询',
  Cargo_EnterManually: '手动输入',
  Cargo_EnterSpecialInvoiceNo: '专用发票号码输入',
  Cargo_EnterVoucherInformation: '输入凭证信息',
  Cargo_Entity: '实体',
  Cargo_EntryDate: '录入日期',
  Cargo_EntryOfNumber: '号码输入',
  Cargo_EqualTo: '等于',
  Cargo_Error: '出错了。',
  Cargo_ErrorNoDataFound: '出错了，没有数据。',
  Cargo_ESNMIR: '费用状态不符合开票要求',
  Cargo_ESNMPAR: '费用状态不符合申请付款要求',
  Cargo_ESNMWOR: '费用状态不符合销账要求',
  Cargo_EstTimeOfWarehouseIn: '预计进仓时间',
  Cargo_EventOfSettlingParty: '结算对象事件',
  Cargo_EventRecord: '事件记录',
  Cargo_EventTime: '事件时间',
  Cargo_EverCancelledWriteOff: '是否做过取消核销操作',
  Cargo_ExcelExport: '导出Excel',
  Cargo_ExcessiveOrNot: '是否超额',
  Cargo_ExchangeCode: '交换码',
  Cargo_ExchangeCodeCanTBeEmpty: '交换代码不能为空',
  Cargo_ExchangeCurrency: '兑换币种',
  Cargo_ExchangeGainsAndLosses: '汇兑损益',
  Cargo_ExchangeRate: '兑换率',
  Cargo_ExchangeRateAdjustmentTable: '汇率调整表',
  Cargo_ExchangeRateAdjustmentTableP: '汇率调整表：',
  Cargo_ExchangeRateCanTBeEmpty: '汇率不能为空',
  Cargo_ExchangeRateDifference: '汇差',
  Cargo_ExchangeRateHKD: 'HKD汇率',
  Cargo_ExchangeRateList: '汇率列表',
  Cargo_ExchangeRateOfHKD: '港币汇率',
  Cargo_ExchangeRateP: '汇率:',
  Cargo_ExchangeRateUSD: 'USD汇率',
  Cargo_ExclusionFilter: '排斥过滤',
  Cargo_ExecutionMethodOfWindowClosure: '关闭窗口执行方法',
  Cargo_Existed: '已经存在。',
  Cargo_ExpectedReviewDate: '预计审核日期',
  Cargo_Expenditure: '支出',
  Cargo_ExpenseAdjustment: '费用调整',
  Cargo_ExpenseAdjustmentOfCollection: '托收调整费用',
  Cargo_ExpenseApprovalProcedure: '费用审批流程',
  Cargo_ExpenseDescriptionCanTBeEmpty: '费用名称不能为空。',
  Cargo_ExpenseItemsCanTBeEmpty: '账单内费用不能为空。',
  Cargo_ExpenseListNonEntity: '费用列表非实体',
  Cargo_ExpenseNotSelected: '未选择费用。',
  Cargo_ExpenseRejectedSuccessfully: '费用驳回成功',
  Cargo_ExpenseRelated: '费用所对应的',
  Cargo_ExpenseReviewedBy: '费用审核人',
  Cargo_ExpenseSearch: '费用查询',
  Cargo_ExpenseSelection: '费用选择',
  Cargo_ExpenseSettlingParty: '费用结算对象',
  Cargo_ExpenseWriteOffCanTBeEmpty: '销账费用不能为空。',
  Cargo_ExpenseWrittenOffCanTBeSplit: '费用已经销账,不能拆分!',
  Cargo_ExpiryDateCanTBeEmpty: '失效日期不能为空',
  Cargo_Export: '出口',
  Cargo_ExportBaiwangInvoice: '百旺发票导出',
  Cargo_ExportClientSuccessfully: '导出客户成功',
  Cargo_ExportedSuccessfully: '导出成功。',
  Cargo_ExportExcel: 'EXCLE导出',
  Cargo_ExportExpenses: '费用导出',
  Cargo_ExportFailed: '导出失败。',
  Cargo_ExportOrNot: '是否导出',
  Cargo_ExportRecordsSuccessfully: '导出记录成功',
  Cargo_ExportRequired: '需要导出',
  Cargo_ExportResult: '导出结果',
  Cargo_ExportSuccessfully: '导出完成，成功',
  Cargo_ExportVatInvoice: '增值税发票导出',
  Cargo_ExportVatInvoiceXLS: '增值税发票导出.xls',
  Cargo_ExportVoucher: '导出凭证',
  Cargo_ExportWriteOffDetails: '导出销账明细',
  Cargo_ExpressAddress: '快递地址',
  Cargo_ExpressInfo: '快递信息',
  Cargo_Extend: '是否顺延',
  Cargo_ExtendPeriod: '延长期限',
  Cargo_ExtensionAfterExpiration: '到期后顺延',
  Cargo_ExtensionCycle: '顺延周期',
  Cargo_External: '外部',
  Cargo_Fax: '传真',
  Cargo_FCAEFAIIVWBIWBCCTV: '有{0}个发票已经导出过财务凭证，如果作废系统将生成红冲发票，确认作废吗？',
  Cargo_FCAOCAE: '有外币核算计算原币金额',
  Cargo_FCASPSCT: '已勾选外币核算,请勾选需要核算的币种',
  Cargo_FCL: '整箱',
  Cargo_SpecialSize: '特殊尺寸',
  Cargo_SpecialSizeTip: '勾选后，装箱信息列表可额外显示“尺寸规格(长*宽*高 单位M)”字段。',
  Cargo_FclLclTypeSeaExport: '整拼类型（海出）',
  Cargo_FclLclTypeSeaImport: '整拼类型（海进）',
  Cargo_EstimatedArrivalTimeSeaExport: '预计到港时间（海出）',
  Cargo_EstimatedArrivalTimeSeaImport: '预计到港时间（海进）',
  Cargo_EstimatedArrivalTimeAirExport: '预计抵达时间（空出）',
  Cargo_FDMOPPE0: '每月指定日期，或账期大于0',
  Cargo_February: '2月',
  Cargo_FeederOrNot: '是否驳船',
  Cargo_FIAICTR: '以下开票申请单已经开票,不能撤销!',
  Cargo_FIDSEC: '您选择了不同结算单位的费用，是否确定继续合并销账？',
  Cargo_FileApplication: '提出申请',
  Cargo_FileDocumentation: '文件资料',
  Cargo_FileFormat: '文件格式',
  Cargo_FileHistory: '文件历史',
  Cargo_FileLoadingFailed: '文件加载失败',
  Cargo_FileName: '文件名称',
  Cargo_FileNo: '文件编号',
  Cargo_FileNotFoundInCloud: '云存储找不到该文件',
  Cargo_FileRetrievedSuccessfully: '文件取回成功。',
  Cargo_FileSize: '文件大小',
  Cargo_FileStatus: '文件状态',
  Cargo_FileType: '文件类型',
  Cargo_FileTypeDescription: '文件类型名称',
  Cargo_Filter: '过滤',
  Cargo_FilterP: '过滤:',
  Cargo_FinalDestination: '最终目的地',
  Cargo_FinancialApprovalDate: '财务审批日期',
  Cargo_FinancialApproved: '已财务审批',
  Cargo_FinancialAudit: '财务审核',
  Cargo_FinancialAuditDetail: '财务审核-详情',
  Cargo_FinancialChangeReview: '财务改单审核',
  Cargo_FinancialCharges: '财务费用',
  Cargo_FinancialCode: '财务编码',
  Cargo_FinancialDate: '财务日期',
  Cargo_FinancialExpenseIs: '财务费用为：',
  Cargo_FinancialPeriod: '财务期间',
  Cargo_FinancialReceived: '实收',
  Cargo_FinancialRemarks: '财务备注',
  Cargo_FinancialSoftware: '财务软件',
  Cargo_FinasialCheck: '财务审批',
  Cargo_FindExistingCurrencies: '找出已有的币种',
  Cargo_FirstAccruedProfit: '首次提成利润',
  Cargo_FirstAccruedTime: '首次计提时间',
  Cargo_FirstContactDate: '初次接触日期',
  Cargo_FiscalPeriod: '会计期间',
  Cargo_Fit: '散客',
  Cargo_FixedAccountingCode: '固定核算编码',
  Cargo_FixedDateMonthly: '每月指定日期',
  Cargo_FJTLCTW: '以下工作单已被锁定,不能退单:',
  Cargo_FLCLType: '整拼类型',
  Cargo_FlightVoyage: '航班航次',
  Cargo_FollowingBillsInTheTextNotFound: '文本中的以下账单没有找到：',
  Cargo_ForAirBusiness: '空运使用',
  Cargo_ForAirExportBusiness: '空运出口使用',
  Cargo_ForAirImportBusiness: '空运进口使用',
  Cargo_ForRailwayBusiness: '铁路业务使用',
  Cargo_ForIntegratedJob: '综合物流使用',
  Cargo_ForFbaSeaBusiness: 'FBA海运使用',
  Cargo_ForFbaAirBusiness: 'FBA空运使用',
  Cargo_ForFbaRailwayBusiness: 'FBA铁路使用',
  Cargo_ForceDelete: '强制删除',
  Cargo_ForeignCurrency: '外币',
  Cargo_ForeignCurrencyAccounting: '外币核算',
  Cargo_ForeignCurrencyAccountingExist: '有外币核算',
  Cargo_ForeignTrade: '外贸',
  Cargo_Format: '格式化',
  Cargo_FormLayout: '表单布局',
  Cargo_FormVerification: '表单验证',
  Cargo_ForOceanBusiness: '海运使用',
  Cargo_ForOtherBusiness: '其他业务使用',
  Cargo_ForRailwayExportBusiness: '铁路出口使用',
  Cargo_ForSeaExportBusiness: '海运出口使用',
  Cargo_ForSeaImportBusiness: '海运进口使用',
  Cargo_FreeDetension: '免柜租期',
  Cargo_FreightForwardingFee: '货运代理费',
  Cargo_FristApprovalDate: '申请时间',
  Cargo_From: '从',
  Cargo_Frozen: '已冻结',
  Cargo_FrozenSuccessfully: '冻结成功。',
  Cargo_FullPayment: '全部付款',
  Cargo_FullScreenDisplay: '是否满屏显示',
  Cargo_Fumigation: '熏蒸',
  Cargo_FunctionOfSuccessfulAcquisition: '获取成功函数',
  Cargo_FVOCPIOOPRECTBV: '当前实收实付记录已经导出过财务凭证，不能作废',
  Cargo_FVOVNP: '凭证【{0}】以下验证未通过：',
  Cargo_GeneralInvoice: '普通发票',
  Cargo_GeneralLedger: '总账',
  Cargo_GeneralLedger2: '总账2',
  Cargo_GeneralRate: '普通价',
  Cargo_GeneratedAccountStatement: '是否已生成对账单',
  Cargo_GeneratedBillsOrNot: '是否已生成账单',
  Cargo_GetBack: '取回',
  Cargo_GoldenTaxationExportPrint: '金税导出打印',
  Cargo_GoOn: '继续',
  Cargo_ARAP_Locked: '所选业务存在应收应付已锁定，不可新增费用',
  Cargo_AR_Locked: '所选业务存在应收锁定，不可新增应收费用',
  Cargo_AP_Locked: '所选业务存在应付锁定，不可新增应付费用',
  Cargo_Only_AR: '当前用户仅可新增应收费用',
  Cargo_Only_AP: '当前用户仅可新增应付费用',
  Cargo_Cannot_Add_Charge: '当前用户不能新增费用',
  Cargo_ChargeLockStatusChanged: '业务应收应付锁定状态已更新，请重新查询后再次提交新增费用',
  Cargo_GrandTotal: '总计',
  Cargo_GrandTotalP: '总计:',
  Cargo_GreaterThan: '大于',
  Cargo_GroupCompany: '集团公司',
  Cargo_GroupExchangeRate: '集团汇率',
  Cargo_GroupingConditions: '分组条件',
  Cargo_GroupingConditions1: '分组条件1',
  Cargo_GroupingConditions2: '分组条件2',
  Cargo_GroupingConditions3: '分组条件3',
  Cargo_GroupingConditions4: '分组条件4',
  Cargo_GroupingConditions5: '分组条件5',
  Cargo_GroupingConditions6: '分组条件6',
  Cargo_GroupingMethod: '分组方式',
  Cargo_GroupingRulesOfJournalEntries: '分录分组规则',
  Cargo_GroupingType: '分组类型',
  Cargo_GroupingTypesOfJournalEntries: '分录分组类型',
  Cargo_GroupingTypesOfJournalEntriesP: '分录分组类型:',
  Cargo_HalfMonthly: '半月结',
  Cargo_Harbour: '海港',
  Cargo_HaulageCompany: '运输公司',
  Cargo_HaveHas: '有',
  Cargo_HaveOrNot: '是否有',
  Cargo_HazmatContained: '是否含危化品',
  Cargo_HBLFreightTerm: '分单运费条款',
  Cargo_HBLMode: 'HB/L提单方式',
  Cargo_MBLMode: 'MB/L提单方式',
  Cargo_HBLTransitTerm: '分单运输条款',
  Cargo_HedgingInvoice: '对冲开票',
  Cargo_HideQuantity: '隐藏数量',
  Cargo_HoldCargoOrNot: '是否扣货',
  Cargo_HoldDoc: '扣单',
  Cargo_SpecialApprovalOrder: '特批放单',
  Cargo_HoldSubmission: '暂不提交',
  Cargo_HqSWriteOffPendingConfirmation: '总部核销待确认',
  Cargo_HsCode: 'HS编号',
  Cargo_IADBD: '开票申请日期业务日期',
  Cargo_IARS: '撤销开票申请成功。',
  Cargo_IBOCR: '收款记录余额不足：',
  Cargo_ICDOOAABBD: '默认初始化海空运汇总数据',
  Cargo_IDVOCVDCCIATTC: '定制化凭证接口显示版本的界面根据配置显示相应定制化的接口',
  Cargo_Ignore: '忽略',
  Cargo_IgnoreP: '是否忽略',
  Cargo_IICS: '发票信息成功。',
  Cargo_IINMCTBE: '发票项目名称维护不能为空。',
  Cargo_Import: '导入',
  Cargo_ImportBankSlip: '导入水单',
  Cargo_ImportExcel: 'Excel导入',
  Cargo_INABNCTBBE: '发票号或业务编号不能都为空',
  Cargo_INCBMDON: '是否可直接修改发票号',
  Cargo_IncludedToBusinessNo: '计入业务编号',
  Cargo_IncludedToBusinessNoP: '计入业务编号:',
  Cargo_InclusiveExpense: '含有费用',
  Cargo_InclusiveExpenseP: '含有费用:',
  Cargo_InclusiveOfAR: '是否含应收费用',
  Cargo_Income: '收收',
  Cargo_IncorrectWriteOffRecord: '销账记录不正确',
  Cargo_IncoTerm: '贸易条款',
  Cargo_IncreaseAdjustment: '增加调整',
  Cargo_IncrementValueDuty: '增值税',
  Cargo_ProductNameEn: '产品名称（英）',
  Cargo_ContainerNumber: '集装箱号',
  Cargo_TotalDataCount: '共计{0}条数据',
  Cargo_PalletDetails: '托盘明细',
  Cargo_PalletDimensions: '托盘尺寸',
  Cargo_ShippingCompanyWebsite: '船公司网址',
  Cargo_OverseasWarehouseAddress: '海外仓地址',
  Cargo_Index: '索引',
  Cargo_IndexCanTBeEmpty: '摘要不能为空',
  Cargo_IndexName: '摘要名称',
  Cargo_IndustrialTradingCompany: '工贸一体化公司',
  Cargo_INEPREIN: '发票号已存在,请重新填写发票号',
  Cargo_Infomation: '信息',
  Cargo_InformationSentDate: '已发资料日期',
  Cargo_InformationSentTime: '已发资料时间',
  Cargo_InitialBalance: '科目初始余额',
  Cargo_InitialBalanceImport: '初始余额导入',
  Cargo_InitializePageSwitching: '初始化页面切换',
  Cargo_InitializingPleaseWait: '正在初始化，请稍后.....',
  Cargo_InitialPeriod: '初始期间',
  Cargo_InitialPeriodCannotBeEmpty: '初始期间期不能为空.',
  Cargo_InitialPeriodCanTBeEmpty: '初始期间年不能为空.',
  Cargo_InitialPeriodOrNot: '是否初始期间',
  Cargo_InitialPeriodP: '初始期间:',
  Cargo_InitiateContainerPickupRequest: '发起提箱业务请求',
  Cargo_INNECTCW: '发票号未录入，确认关闭窗口吗？',
  Cargo_INNECTP: '发票号未录入，是否继续打印?',
  Cargo_INNECTS: '发票号未录入，是否继续保存?',
  Cargo_InputBusinessNumber: '请输入业务编号',
  Cargo_InputTime: '录入时间',
  Cargo_InsertJournalEntry: '插入分录',
  Cargo_InsidePacking: '小件包装',
  Cargo_InsideQuantity: '小件数',
  Cargo_InstantMessengerQqWechatEtc: '即时通信（QQ微信等）',
  Cargo_InsufficientRecordBalance: '记录余额不足：',
  Cargo_IntentionStage: '意向阶段',
  Cargo_InterfaceScheme: '接口方案',
  Cargo_Internal: '内部',
  Cargo_InternalCode: '内部编码',
  Cargo_InternalInvoice: '内部发票',
  Cargo_International: '国外',
  Cargo_InternationalBill: '国外账单',
  Cargo_IntLFreight: '国际代理运费',
  Cargo_IntLFreightForwardingServiceFee: '国际货代服务费',
  Cargo_IntLOceanFreight: '国际代理海运费',
  Cargo_InUseByBusinessCanTBeDeleted: '已被业务使用，不能删除',
  Cargo_Invalid: '作废',
  Cargo_InvalidDate: '失效日期',
  Cargo_InvalidNavigation: '导航无效',
  Cargo_InvalidOrNot: '是否作废',
  Cargo_InvalidParameter: '无效参数',
  Cargo_InverseSelect: '反选',
  Cargo_Invoice: '发票',
  Cargo_Invoiceable: '可开发票',
  Cargo_InvoiceAcquisition: '发票领用',
  Cargo_InvoiceAfterARAPOffset: '应收付对冲发票',
  Cargo_InvoiceAmount: '发票金额',
  Cargo_InvoiceAmountP: '发票金额:',
  Cargo_InvoiceConfirmation: '确定开票',
  Cargo_InvoiceContent: '发票内容',
  Cargo_InvoiceCurrency: '发票币种',
  Cargo_InvoiceCurrencyP: '发票币种:',
  Cargo_Invoiced: '已开票',
  Cargo_InvoiceDate: '开票日期',
  Cargo_InvoiceDateP: '开票日期：',
  Cargo_InvoicedBy: '开票人',
  Cargo_InvoicedByP: '开票人:',
  Cargo_InvoiceDeleted: '发票已删除',
  Cargo_InvoicedOrNot: '是否已开发票',
  Cargo_InvoiceHasBeenWrittenOff: '发票已销账',
  Cargo_InvoiceHeader: '发票抬头',
  Cargo_InvoiceInformation: '发票信息',
  Cargo_InvoiceIssued: '已开发票',
  Cargo_InvoiceItemName: '发票项目名称',
  Cargo_InvoiceItemNameSetup: '发票项目名称设置',
  Cargo_InvoiceNo: '发票号',
  Cargo_InvoiceNoCanTBeEmpty: '发票号不能为空。',
  Cargo_InvoiceNoEntry: '发票号录入',
  Cargo_InvoiceNoExist: '有发票号',
  Cargo_InvoiceNoExistedContinue: '发票号码已存在，是否继续？',
  Cargo_InvoiceNoExistedContinueToSave: '发票号码已存在，是否保存？',
  Cargo_InvoiceNoExistedRewrite: '发票号[{0}]已存在,请重新填写发票号.',
  Cargo_InvoiceNoIsEmpty: '发票号为空。',
  Cargo_InvoiceNoIsEmptyContinue: '发票号为空是否继续？',
  Cargo_InvoiceNoMandatory: '是否必填发票号',
  Cargo_InvoiceNoNotEntered: '发票号未输入。',
  Cargo_InvoiceNoP: '发票编号：',
  Cargo_InvoiceNoSegment: '发票号段',
  Cargo_InvoiceNoStatus: '发票号状态',
  Cargo_InvoicePrintedCanTBeDeleted: '发票已经打印，不能删除。',
  Cargo_InvoicePrinting: '发票打印',
  Cargo_InvoiceRecord: '发票记录',
  Cargo_InvoiceReIssued: '已重开发票',
  Cargo_InvoiceRemark: '开票备注',
  Cargo_InvoiceSavedSuccessfully: '发票保存成功',
  Cargo_InvoiceSaveFailed: '发票保存失败',
  Cargo_InvoiceStatus: '发票状态',
  Cargo_InvoiceTitle: '开票抬头',
  Cargo_ChargeInvoiceTitle: '费用开票抬头',
  Cargo_InvoiceTitleInvoiceNo: '开票抬头发票号',
  Cargo_InvoiceTitleNotMatched: '发票抬头不统一。',
  Cargo_InvoiceTitleP: '开票抬头:',
  Cargo_InvoiceType: '发票类型',
  Cargo_InvoiceTypeIncompatible: '发票类型不统一。',
  Cargo_InvoiceTypeP: '发票类型:',
  Cargo_InvoiceTypeSelection: '发票类型选择',
  Cargo_InvoiceUse: '发票使用',
  Cargo_InvoiceVoided: '发票已作废。',
  Cargo_InvoiceVoidedCanTBeDeleted: '发票已经作废，不能删除。',
  Cargo_InvoiceVoucherAfterARAPOffset: '应收付对冲发票凭证',
  Cargo_InvoiceWrittenOffCanTBeDeleted: '发票已销账不能删除',
  Cargo_InvoiceWrittenOffCanTBeVoided: '发票已销账不能作废',
  Cargo_Invoicing: '开票',
  Cargo_InvoicingAccordingToCurrency: '分币种开票',
  Cargo_InvoicingAddress: '开票地址',
  Cargo_InvoicingAmount: '开票金额',
  Cargo_InvoicingApplicationDate: '开票申请日期',
  Cargo_InvoicingApplicationReview: '开票申请审核',
  Cargo_InvoicingCompleted: '开票完成',
  Cargo_InvoicingCurrency: '开票币种',
  Cargo_InvoicingDateBusinessDate: '开票日期业务日期',
  Cargo_InvoicingHeadCannotBeEmpty: '开票抬头不能为空。',
  Cargo_InvoicingInformation: '开票信息',
  Cargo_InvoicingListNo: '开票清单号',
  Cargo_InvoicingMachineNo: '开票机号',
  Cargo_InvoicingMethod: '开票方式',
  Cargo_InvoicingMethodP: '开票方式:',
  Cargo_InvoicingMode: '开票模式',
  Cargo_InvoicingPerBill: '单票开票',
  Cargo_InvoicingPerMonth: '月结开票',
  Cargo_InvoicingRequirements: '开票要求',
  Cargo_InvoicingSearch: '开票查询',
  Cargo_InvoicingStatus: '开票状态',
  Cargo_InvoicingType: '开票类型',
  Cargo_InvoicingVerification: '开票验证',
  Cargo_IOSPIM: '结算对象必须输入信息',
  Cargo_IPCTFATROJE: '无效参数找不到分录科目规则',
  Cargo_IsBroken: '为断号',
  Cargo_IsExtended: '是否超期',
  Cargo_IsItAR: '是否是应收',
  Cargo_IsItCollection: '是否是收款',
  Cargo_IsItDefaultExpense: '是否默认费用',
  Cargo_IsCharterFlightCosts: '是否包机费用',
  Cargo_IsCharterVesselCosts: '是否包板费用',
  Cargo_IsCharterFlight: '是否包机',
  Cargo_IsCharterVessel: '是否包板',
  Cargo_Number_Of_Charter_Containers: '包机集装器数',
  Cargo_Charter_weight_Restrictions: '包机重量限制',
  Cargo_Charter_Volume_Restrictions: '包机体积限制',
  Cargo_Description_of_the_package_Information: '包板信息描述',
  Cargo_Pallets_can_be_loaded_in_Weight: '包板可装货重量',
  Cargo_Packing_Plates_Can_Be_Loaded_In_Volume: '包板可装货体积',
  Cargo_The_Total_Cost_Amount: '总成本金额',
  Cargo_Unit_Load_Device: '集装器',
  Cargo_MountingInformation: '装板信息',
  Cargo_Please_Load_The_Main_Ticket: '请在主票进行装板操作',
  Cargo_Please_Empty_And_Load_The_Main_Ticket_For_The_Operation: '请在主票进行清空装板操作',
  Cargo_OtherBusinessUse: '其它业务使用',
  Cargo_DefaultArSettlementObject: '默认应收固定结算对象',
  Cargo_DefaultArSettlementObjectNull: '默认应收对象是否为空',
  Cargo_DefaultApSettlementObject: '默认应付固定结算对象',
  Cargo_DefaultApSettlementObjectNull: '默认应付对象是否为空',
  Cargo_IsItWriteOff: '是否是对冲',
  Cargo_IsoCode: 'ISO代码',
  Cargo_IsShutOut: '是否退关',
  Cargo_IssuanceReceiptOfInvoice: '开票收票',
  Cargo_Issued: '已发布',
  Cargo_IssueHbl: '是否签HBL',
  Cargo_IssueInvoiceDirectly: '直接生成发票',
  Cargo_IssueInvoiceDirectlyOrNot: '是否直接开票',
  Cargo_IssueOfTheYear: '{0}年第{1}期',
  Cargo_ISWBDC: '确定要删除这{0}条数据吗？',
  Cargo_Item: '项目',
  Cargo_Item1: '项目一',
  Cargo_Item2: '项目二',
  Cargo_ItemNo: '项目编号',
  Cargo_ItemNo2P: '项目号2:',
  Cargo_ItemNoP: '项目编号：',
  Cargo_ItemsAdded: '已添加{0}条',
  Cargo_ItemsNBR: '件数',
  Cargo_ReturnContainerAddress: '还柜地址',
  Cargo_LoadingAddress: '提柜地址',
  Cargo_ITIOCBNMPCBITIITBCPOTS: '当前分公司开票终端标识未维护，请配置基本配置中的百旺开票终端标识',
  Cargo_ITPIEI: '开票种类纸质发票电子发票',
  Cargo_IYDTRIAACWTACYIYWTKTAABFFIACNCTCIA: '如果您已经同开票申请人确定过,决定撤销该开票申请,请点击"是";如果保留开票申请单作为将来开票的依据请点击"否",确认要取消开票申请吗？',
  Cargo_January: '1月',
  Cargo_JEODTD: '数据类型为({0})的分录已经被删除!',
  Cargo_JEOOSC: '是否海外结算中心分录',
  Cargo_JFOCP: '收付字判别字段',
  Cargo_JobListSearched: '已经查询过的工作列表',
  Cargo_JobNo: '工作号',
  Cargo_JobNoP: '工作号：',
  Cargo_JobTypeImport: '进口',
  Cargo_JournalEntryCategory: '分录类型',
  Cargo_JournalEntryRule: '分录规则',
  Cargo_July: '7月',
  Cargo_June: '6月',
  Cargo_KeyWord: '敏感词',
  Cargo_KeyWordCanTBeEmpty: '敏感词不能为空',
  Cargo_KingdeeCloudApprove: '金蝶Cloud审核',
  Cargo_KingdeeCloudReview: '金蝶云审核',
  Cargo_LastAccrualTime: '最新计提时间',
  Cargo_LastDate: '上次日期',
  Cargo_LastInvoiceNo: '最后一张发票号',
  Cargo_LastModificationTime: '最后修改时间：',
  Cargo_LastReceiveDate: '最后收款日期',
  Cargo_LastReceivingDate: '上次收款日期',
  Cargo_LastTimeBalance: '上次余额',
  Cargo_LBNRYSTW: '所关联业务还没有被审核，确认要退单吗？',
  Cargo_LegalUnit: '法定单位',
  Cargo_Lender: '借贷方',
  Cargo_LessThan: '小于',
  Cargo_Letter: '字',
  Cargo_Level: '级别',
  Cargo_Level1AccountTitle: '一级科目',
  Cargo_Level2AccountTitle: '二级科目',
  Cargo_Level3AccountTitle: '三级科目',
  Cargo_Level4AccountTitle: '四级科目',
  Cargo_Level5AccountTitle: '五级科目',
  Cargo_Level6AccountTitle: '六级科目',
  Cargo_Limit: '额度',
  Cargo_LinkBills: '是否关联账单',
  Cargo_LinkOffsetExpenseDifferentials: '是否关联差异对冲费用',
  Cargo_LinkPaymentRequests: '是否关联付款申请',
  Cargo_LinkToInvoice: '关联到发票',
  Cargo_Load: '加载',
  Cargo_LoadCache: '加载缓存',
  Cargo_Loaded: '加载完成',
  Cargo_LoadedAndSave: '加载完成，点击保存。',
  Cargo_LoadingAtDoor: '门点装箱',
  Cargo_LoadingAtFactory: '产装',
  Cargo_LoadOrNot: '是否加载',
  Cargo_Loan: '借贷',
  Cargo_LoanSwap: '借贷互换',
  Cargo_LocalAgent: '本地代理',
  Cargo_LocalCharge: '本地费用',
  Cargo_LocalChargeOrNot: '是否本地费用',
  Cargo_LocalCurrency: '本位币',
  Cargo_LocalizedName: '本地化名称',
  Cargo_Location: '地点',
  Cargo_LocationOfCurrentVoucher: '当前凭证的位置',
  Cargo_LockCancellationDate: '取消日期锁定',
  Cargo_LockTheBill: '锁单',
  Cargo_Log: '日志',
  Cargo_LogisticsCompany: '物流公司',
  Cargo_LogRecord: '日志记录',
  Cargo_LOTFINMBGT3D: '第一张发票号长度必须大于三位。',
  Cargo_LowerCase: '小写',
  Cargo_MainLineTransport: '干线运输',
  Cargo_MaintenanceOfShippingTerms: '运输条款维护',
  Cargo_ManagementOfWithdrawal: '退单管理',
  Cargo_ManageParameters: '管理查询参数',
  Cargo_MANMWCSAISCTD: '快递地址与系统维护数据中的客户地址不同,确定要送出吗?',
  Cargo_March: '3月',
  Cargo_Mark: '标记',
  Cargo_MarkTime: '标记时间',
  Cargo_Marker: '标记人',
  Cargo_MarkStatus: '标记状态',
  Cargo_MarkCancelledSuccessfully: '取消标记成功',
  Cargo_MarkDate: '标注日期',
  Cargo_Marked: '标记成功',
  Cargo_MarkedBy: '标注人',
  Cargo_MarkOfConfirmation: '确认标记',
  Cargo_Marks: '唛头',
  Cargo_MarkSymbols: '标记标识',
  Cargo_MasterBillNotSearched: '主票不查询',
  Cargo_May: '5月',
  Cargo_MBACM: '修改账单金额计算方式',
  Cargo_MBEIRPSUB: '记录中存在已标记的账单，请选择未标记的账单。',
  Cargo_MBLAudit: 'MBL审核',
  Cargo_MBLCargoDetention: 'MBL扣货',
  Cargo_MBLFreightTerm: '主单运费条款',
  Cargo_MblNo: '主单号',
  Cargo_MBLPayable: 'MBL可付款',
  Cargo_MBLPaymentTime: 'MBL付款时间',
  Cargo_MBLReviewTime: 'MBL审核时间',
  Cargo_MBLTimeOfCargoHolding: 'MBL扣货时间',
  Cargo_MBLTransitTerm: '主单运输条款',
  Cargo_MDEPSBP: '有数据修改过，请保存后再打印。',
  Cargo_MDEPSBPIN: '有数据修改过，请保存后再打印[发票号:{0}]',
  Cargo_Merge: '开始合并',
  Cargo_MergeOrNot: '是否合并',
  Cargo_MethodOfClaim: '认领模式',
  Cargo_MethodOfClaimP: '认领模式:',
  Cargo_Metrics: '衡量标准',
  Cargo_MfnTaxRate: '最惠国税率',
  Cargo_Mode: '模式',
  Cargo_ModelSpecification: '规格型号',
  Cargo_ModificationOfCollection: '托收修改',
  Cargo_ModificationTime: '修改时间',
  Cargo_ModifiedDataNotSavedCancel: '修改的数据未保存，确认取消吗？',
  Cargo_Modifier: '修改人',
  Cargo_Modify: '修改',
  Cargo_ModifyAccountTitle: '修改科目',
  Cargo_ModifyAccountTitleName: '科目名称修改',
  Cargo_ModifyAdjustBill: '账单-修改调整',
  Cargo_ModifyBillingInformation: '账单信息修改',
  Cargo_ModifyCollectionInformation: '托收信息修改',
  Cargo_ModifyInvoice: '修改发票',
  Cargo_ModifyPort: '港口修改',
  Cargo_ModifyRailwayStation: '铁路站点修改',
  Cargo_ModifyOverseaWarehouse: '编辑海外仓',
  Cargo_AddOverseaWarehouse: '添加亚马逊仓',
  Cargo_NewOverseaWarehouse: '新增海外仓',
  Cargo_CannotDeleteWarehouse: '{0}仓库代码已被使用，不能删除！',
  Cargo_ModifyRateWithTax: '修改含税价',
  Cargo_ModifySelectedInvoiceStatus: '修改选择的发票状态',
  Cargo_ModifyWriteOffRecord: '修改核销记录',
  Cargo_MOMAOB: '客商辅助期初余额维护',
  Cargo_MonetaryEquivalent: '折算金额',
  Cargo_MonetaryEquivalentCNY: '折算CNY金额',
  Cargo_Month: '月',
  Cargo_FinanceMonthUnitTip: '按自然月计：以本月1号为基准往前推N个月作为边界日，仅锁定边界日之前的数据（不含边界日当天）。例：9月配置2个月，锁定7月1日之前（不含7月1日）',
  Cargo_Monthly: '月结',
  Cargo_MonthlyReconciliation: '月结对账',
  Cargo_Months: '月份',
  Cargo_MoreConditions: '更多条件',
  Cargo_MoreSearch: '更多查询',
  Cargo_Motorcade: '车队',
  Cargo_MscServiceCode: '服务代码',
  Cargo_MultipleChoiceBox: '【多选框】',
  Cargo_MultipleCurrenciesExit: '存在多个币种。',
  Cargo_MultipleSettlingPartiesExist: '存在多个结算对象。',
  Cargo_MUPIOOPFWO: '是否必须使用实收付销账',
  Cargo_MustSelectTheSameClient: '必须选择相同的客户。',
  Cargo_MVOACP: '是否维护预收付凭证',
  Cargo_MVOARAPOI: '是否维护应收付对冲发票凭证',
  Cargo_Name: '名称',
  Cargo_NameCanTBeEmpty: '名称不能为空。',
  Cargo_EnglishNameCheck: '英文名称不能为空.',
  Cargo_ExistDoorSite: '已存在同一个门点信息',
  Cargo_PleaseSelectCommissioningUnit: '请选择合作伙伴中的委托单位',
  Cargo_PleaseInputOneDoorInfoAtLeast: '请输入至少一个门点信息',
  Cargo_LandTransportationDetails: '陆运详细信息编辑',
  Cargo_NameP: '名称:',
  Cargo_NAMISANOSNBCWBRS2DPTED: '注：提醒方式为‘系统提醒’，系统会在到期前2日再次提醒禁止创建业务配置',
  Cargo_NatureOfSales: '销售属性',
  Cargo_NBCTBGTC: '负数差额不能大于-1分钱。',
  Cargo_NECDFTIC: '不能超过{0}个与开票币种不同的币种',
  Cargo_BillPaymentCurrencyBeyond: '不能超过{0}个与付款币种不同的币种！',
  Cargo_PayByBillingRate: '按账单汇率付款',
  Cargo_NeedAccountingPeriod: '抱歉,您现在使用的套账的软件版本"沃特财务软件"需要设置会计期间才能编辑科目',
  Cargo_NeedAccrue: '是否计提',
  Cargo_NeedCustomsDeclare: '是否报关',
  Cargo_NeedHqToWriteOffOrNot: '是否需要通过总部核销',
  Cargo_NeedInvoiceOrNot: '是否需要开票',
  Cargo_NeedMandatoryAccrue: '是否强制计提',
  Cargo_NeedToBillCNYToCNY: '需要向{0}收取{1}RMB',
  Cargo_NeedToConfiCNYankAccountOrNot: '是否需要确认银行账号',
  Cargo_NeedToCreateBillOrNot: '是否要创建账单？',
  Cargo_NeedToExportOrNot: '是否需要导出',
  Cargo_NeedToPayTo: '需要向{0}支付{1}RMB',
  Cargo_NEFEIDE: '默认导出时有非空过滤',
  Cargo_NegotiationStage: '商务阶段',
  Cargo_NEIAFPRPOCA: '申请单没有费用，请刷新网页或联系系统管理员',
  Cargo_NEICTBD: '非电子发票不能下载。',
  Cargo_NetWork: '网络',
  Cargo_NetworkName: '网络名',
  Cargo_NetworkNameCanTBeEmpty: '网络名不能为空',
  Cargo_New: '新建',
  Cargo_NewAccountStatement: '新建对账单',
  Cargo_NewAccountTitle: '新建科目',
  Cargo_NewFiscalPeriod: '新的会计期间',
  Cargo_NewInvoiceNo: '新的发票号',
  Cargo_NewInvoiceNoP: '新发票号码：',
  Cargo_NewPaymentRequest: '创建付款申请',
  Cargo_NewValue: '新值',
  Cargo_Next: '下一步',
  Cargo_NextItem: '下一个',
  Cargo_NextStep: '下一步任务',
  Cargo_NextStepToSave: '下一步保存',
  Cargo_NFFICSPRE: '没有找到云存储文件请重新导出',
  Cargo_NFMKWPEAW: '注：多个敏感词请回车换行',
  Cargo_NFPAFTS: '此账套没有可用的财务期间。',
  Cargo_NFPSCATWBSACYCTS: '由于不存在会计期间,当前科目年份将会设置今年, 确认将会继续保存.',
  Cargo_NMT2MCTAIEAWO: '费用中不能出现与销账币种不同的超过二种以上的币种。',
  Cargo_NNTCVFCOPL: '无需生成结转损益凭证',
  Cargo_NNTEIBOPLBFSOATBOTY: '年初启用的账套，不需要录入损益初始余额哦。',
  Cargo_No: '否',
  Cargo_NOATGCAAIODMBETTGMO: '科目分组条件按顺序排列个数，数据必须等于科目分组减一!',
  Cargo_NoBillToConfirm: '没有可确认的账单。',
  Cargo_NoBillToCreateSoa: '没有账单可做对账单。',
  Cargo_NoBillToWriteOff: '没有需要销账的账单。',
  Cargo_NoBusinessNeedFinancialReview: '没有业务可财务审核。',
  Cargo_NoBusinessTypeSelected: '业务类型未选择',
  Cargo_NoCitySelectedToEdit: '未选择要编辑的城市',
  Cargo_NoConfirmedBillToCancel: '没有可取消确认的账单。',
  Cargo_NoData: '没有数据。',
  Cargo_NoDataModifiedNoNeedToSave: '没有数据被修改，无需保存。',
  Cargo_NoDataSelected: '未选择数据。',
  Cargo_NoDataSelectedToDelete: '未选择要删除的数据',
  Cargo_NoDataToExport: '没有数据可导出。',
  Cargo_NoDataToModify: '没有可修改的数据',
  Cargo_NoDataToPreview: '没有可预览的数据。',
  Cargo_NoDataToTransfer: '没有可发送的数据。',
  Cargo_NoDoNotLink: '否我不要关联',
  Cargo_NOEGT1ICTSTNWBST1C: '费用的数量大于1,如果继续拆分费用将会把数量设置为1,确定要继续吗?',
  Cargo_NoElectronicInvoiceNoToCreate: '没有生成电子发票号。',
  Cargo_NoEligibleExpenseToPrint: '没有符合条件的费用可以打印。',
  Cargo_NoEligibleRecord: '没有符合条件的记录。',
  Cargo_NoEligibleRecordsFound: '没有查询到符合要求的记录',
  Cargo_NoExpenseDifferentialsToProcess: '没有差额费用要处理。',
  Cargo_NoExpenseToBill: '没有费用可做账单。',
  Cargo_NoExpenseToInvoice: '没有费用可开发票。',
  Cargo_NoExpenseToReject: '没有可驳回的费用',
  Cargo_NoExpenseToReview: '没有可审核的费用',
  Cargo_NoExpenseToWriteOff: '没有可销账的费用。',
  Cargo_NoFileToRetrieve: '没有文件可取回。',
  Cargo_NoFileToRevoke: '没有文件可撤销',
  Cargo_NoForeignCurrencyAccounting: '无外币核算',
  Cargo_NoInvoiceNo: '没有发票号',
  Cargo_NoInvoiceNoForInvoiceAmounted: '金额为{0}的发票没有发票号!',
  Cargo_NoInvoiceNoToCheck: '没有需要检查的发票号',
  Cargo_NoMaintainedBankForClient: '客户没有维护银行',
  Cargo_NoMatchedRecordFound: '没有查到符合要求的记录',
  Cargo_NominatedAgent: '指定货代理',
  Cargo_NonAccrual: '非计提',
  Cargo_None: '无',
  Cargo_NoneAnyBillable: '没有可开票的费用。',
  Cargo_NoNeedToRepeatConfirmation: '已确认，无需再次确认。',
  Cargo_NoNeedToSplitThisKeyWord: '此敏感词无需拆分',
  Cargo_NonElectronicInvoice: '非电子发票',
  Cargo_NonSplitWriteOffExpense: '不能拆分核销的费用。',
  Cargo_NoNumberBreak: '没有断号',
  Cargo_NoOfPages: '页数',
  Cargo_NoParentAccountTitles: '无上级科目',
  Cargo_NoPortSelected: '港口未选择',
  Cargo_NoRecordChecked: '未勾选记录。',
  Cargo_NoRecordSelected: '未选择记录。',
  Cargo_NoRecordToSave: '没有可保存的记录。',
  Cargo_NoRelease: '不可放单',
  Cargo_NoReviewedExpenseToCancel: '没有可取消审核的费用',
  Cargo_NoServiceTicketToDelete: '没有可以删除的费用确认单。',
  Cargo_NoSiteSelected: '站点未选择',
  Cargo_NoSobSetUpCurrently: '当前没有设置任何账套。',
  Cargo_NotAcquired: '未领用',
  Cargo_NotAdjustedExpense: '非调整费用',
  Cargo_NotAFinalAccountTitle: '【{0}}】不是末级科目。',
  Cargo_NotCarriedOver: '未结转',
  Cargo_NotCollectAdvance: '非代收垫付',
  Cargo_NotCollected: '未收',
  Cargo_NotCollectedCNY: 'CNY未收',
  Cargo_NotCollectedEUR: 'EUR未收',
  Cargo_NotCollectedGBP: 'GBP未收',
  Cargo_NotCollectedHKD: 'HKD未收',
  Cargo_NotCollectedInFull: '未收齐',
  Cargo_NotCollectedJPY: 'JPY未收',
  Cargo_NotCollectedNGN: 'NGN未收',
  Cargo_NotCollectedP: '未收:',
  Cargo_NotCollectedUSD: 'USD未收',
  Cargo_Collected: '已收',
  Cargo_NotContracted: '未签约',
  Cargo_NotDisplayedIfMultipleItemsExist: '有多条时不显示',
  Cargo_NOTDIST: '查询页签中显示模板个数',
  Cargo_NotificationOfPaymentFreeze: '冻结付款通知',
  Cargo_NotificationOfUnfrozenPayment: '解冻付款通知',
  Cargo_NotifyHq: '通知总部',
  Cargo_NotifyId: '通知人代码',
  Cargo_NotifyInfo: '通知人信息',
  Cargo_NotifyParty: '通知人',
  Cargo_NotifyPartySName: '通知人名称',
  Cargo_NotifyUser: '提醒用户',
  Cargo_NotifyMethod: '通知方式',
  Cargo_NotInvoicedMoney: '未开票金额',
  Cargo_NoTotal: '第{0}张,共{1}张',
  Cargo_NotReviewed: '未审核',
  Cargo_NotSent: '未发送',
  Cargo_NotSet: '未设置',
  Cargo_NotSubmittedCanTWithdraw: '未提交不能退单',
  Cargo_NotTaxFree: '非免税',
  Cargo_NotWrittenBack: '未红冲',
  Cargo_NotWrittenOff: '未核销',
  Cargo_NotWrittenOff2: '未销折合RMB',
  Cargo_NotWrittenOffCurrency: '未销({0})',
  Cargo_NotWrittenOffHKD: '未销(HKD)',
  Cargo_NotWrittenOffUSD: '未销(USD)',
  Cargo_NoUnInvoicedExpense: '没有未开票的费用。',
  Cargo_November: '11月',
  Cargo_NPDOSB: '没有辅助余额初期数据。',
  Cargo_NRFTAL: '自拉自送',
  Cargo_NSEFPCA: '未找到拆分费用,请联系管理员!',
  Cargo_NTWBWRLION: '是否要开红字发票?',
  Cargo_Number: '号码',
  Cargo_NumberS: '号',
  Cargo_NumberOfAttachedDocuments: '附单据数量',
  Cargo_NumberOfCopies: '份数',
  Cargo_NumberOfCopiesCanTBe0: '份数不能为0.',
  Cargo_NumberOfExpenseWriteOffs: '销账费用数量',
  Cargo_NumberOfNominatedAgents: '指定代理数',
  Cargo_OBCILC: '期初余额（综合本位币）',
  Cargo_OBIMICMAWTCSCCPBR: '当收款方式为支票银行转账本票代收代付水单时我方银行必填',
  Cargo_OceanExport: '海运出口',
  Cargo_OceanFreight: '海运',
  Cargo_OceanImport: '海运进口',
  Cargo_OceanImportExport: '海运进出',
  Cargo_OCLWSPCBS: '只能选择销售所关联的客户',
  Cargo_October: '10月',
  Cargo_Oddment: '零头短账',
  Cargo_ODWSSCBP: '只能打印相同状态的单证。',
  Cargo_OEOSET: '所有者权益或股东权益合计',
  Cargo_OEVCBWB: '只能红冲已导出的凭证。',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC: '操作失败，全部或部分费用正在付款审批流程中，请在流程完成后再操作。',
  Cargo_OFCIIFPRNRN: '包含已开票的费用，请重新选择\\n付款申请单号：',
  Cargo_OFCTCMT2: '操作失败，币种不能超过2个。',
  Cargo_OffsetDataSource: '对冲数据源',
  Cargo_OffsetEntity: '对冲实体',
  Cargo_OffsetOrNot: '是否对冲',
  Cargo_MustInvoiceNoAndTitle: '必须填写发票号和开票抬头',
  Cargo_OFGTECOBUFEIIC: '操作失败，“金税导出”只能作用于币种为人民币的电子发票。',
  Cargo_OFNBFSWWF: '无法开票，没有可开票费用。',
  Cargo_OFTAPFSDNMTIR: '应付费用状态不符合开票要求',
  Cargo_OFTARFSDNMTIR: '应收费用状态不符合开票要求',
  Cargo_OFTCBDNMTTINSIIITIEI: '操作失败，当前分公司未维护纳税人识别号，所以无法开具电子发票。',
  Cargo_OFTFRCWNM: '操作失败，不满足财务审核条件。',
  Cargo_OFTFRCWNMCSRT: '不能直接财务审核，更改配置后再试。',
  Cargo_OFTIISCBD: '已开发票，无法删除.',
  Cargo_OFTIRCBDTNIAF: '以下开票申请单已经开票,不能删除!',
  Cargo_OFTIRCBETNIAF: '以下开票申请单已经开票,不能编辑!',
  Cargo_OFTRFOTARFCBIITB: '账单内费用包含红冲费用或者被红冲费用',
  Cargo_OFTUFSCBS: '操作失败，还未保存的费用不能进行拆分操作.',
  Cargo_OFTWOANTBETTSOREGALFE: '操作失败，本次核销金额需要等于收款金额+汇兑损益+财务费用+零头账的总合。',
  Cargo_OFWTIARTARMBGTTAP: '操作失败，当收支类型为应收时，应收总额必须大于应付总额.',
  Cargo_OIRWPSCBCAC: '只有状态为 待开票 的开票申请可以生成并票清单!',
  Cargo_OIWWBCBP: '只能打印未红冲过的发票。',
  Cargo_OnAccountHedge: '（挂账对冲）',
  Cargo_OneClickRenewal: '一键续签',
  Cargo_OnlyCheckedRecordsCanBeCancelled: '只能取消已经被复核的记录。',
  Cargo_OnlyReviewedVouchersCanBeDeleted: '只能删除未审核的凭证。',
  Cargo_OnlyUnCheckedRecordsCanBeChecked: '只能复核未被复核的记录。',
  Cargo_OOAPIICCTTTEPRCOEA: '托收只有未付费用,不能再转入费用,请另做托收或费用申请!',
  Cargo_OORCBSFASBI: '单票开票只能选择一条记录。',
  Cargo_OpeningAmountOfTheYear: '年初数',
  Cargo_OpeningBalance: '期初余额',
  Cargo_OpeningBalanceCreditCNY: '期初余额贷方（人民币）',
  Cargo_OpeningBalanceCreditUSD: '期初余额贷方（美元）',
  Cargo_OpeningBalanceDebitCNY: '期初余额借方（人民币）',
  Cargo_OpeningBalanceDebitUSD: '期初余额借方（美元）',
  Cargo_OperateBy: '操作人',
  Cargo_OperatedSuccessfullyRefreshPage: '操作成功重新刷新页面',
  Cargo_OperatingCompany: '经营单位',
  Cargo_Operation: '操作',
  Cargo_OperationCompany: '操作公司',
  Cargo_OperationComplete: '操作成功',
  Cargo_OperationDate: '操作日期',
  Cargo_OperationDepartment: '操作部门',
  Cargo_OperationOffice: '操作分公司',
  Cargo_OperationFailed: '操作失败',
  Cargo_OperationHistory: '操作历史',
  Cargo_OperationModeAir: '操作模式（空运）',
  Cargo_OperationModeAirExport: '操作模式（空出）',
  Cargo_OperationModeAirImport: '操作模式（空进）',
  Cargo_OperationRequirementType: '操作要求类型',
  Cargo_OperationSuccessfully: '操作成功。',
  Cargo_HblTeleReleaseGuarantee: 'HBL电放打印校验保函',
  Cargo_TeleReleaseBillType: '电放提单种类',
  Cargo_OperationSymbol: '运算符号',
  Cargo_OperationType: '操作类型',
  Cargo_OperationTypeCanTBeEmpty: '操作要求类型不能为空',
  Cargo_Operator: '操作者',
  Cargo_OperatorOfWithdrawal: '退单经手人',
  Cargo_OppositeVoucherNo: '对方凭证号',
  Cargo_OppositeVoucherNoP: '对方凭证号:',
  Cargo_OPVWES: '只能对状态为已审查的凭证进行此项操作。',
  Cargo_Order: '级次',
  Cargo_OrdinaryTaxRate: '普通税率',
  Cargo_ORDM: '操作要求描述信息维护',
  Cargo_Original: '原始',
  Cargo_OriginalAmount: '原金额',
  Cargo_OriginalAmountCNY: 'CNY原始金额',
  Cargo_OriginalAmountInBill: '账单原金额',
  Cargo_OriginalAmountUSD: 'USD原始金额',
  Cargo_OriginalContent: '原始内容',
  Cargo_OriginalCurrency: '原币',
  Cargo_OriginalCurrencyInBill: '账单原币种',
  Cargo_OriginalCurrencyNotWrittenOff: '未销原币种',
  Cargo_OriginalCurrencyP: '原币：',
  Cargo_OriginalExchangeRateInBill: '账单原汇率',
  Cargo_OriginalExpense: '原始费用',
  Cargo_OriginalExpenseAmount: '原费用金额',
  Cargo_OriginalExpenseP: '原始费用:',
  Cargo_OriginalInvoiceNo: '原发票号码',
  Cargo_OriginalInvoiceNoP: '原发票号码：',
  Cargo_OriginalInvoiceTitle: '原发票抬头',
  Cargo_OriginalInvoiceTitleP: '原发票抬头：',
  Cargo_OriginalValue: '原值',
  Cargo_ChargeItemView: '收费项目查看',
  Cargo_ORORDCBO: '只能操作已取回或者已退还的单证。',
  Cargo_ORVCBE: '只能导出已经审核过的凭证。',
  Cargo_OSVBMP: '仅查找机制凭证',
  Cargo_Other: '其他',
  Cargo_OtherChargeItem: '空运运单杂费',
  Cargo_OtherContact: '其他合同',
  Cargo_OtherConversionAP: '其他折算应付',
  Cargo_OtherConversionAPCNY: '其他折算CNY应付',
  Cargo_OtherConversionAPEUR: '其他折算EUR应付',
  Cargo_OtherConversionAPGBP: '其他折算GBP应付',
  Cargo_OtherConversionAPHKD: '其他折算HKD应付',
  Cargo_OtherConversionAPJPY: '其他折算JPY应付',
  Cargo_OtherConversionAPNGN: '其他折算NGN应付',
  Cargo_OtherConversionAR: '其他折算应收',
  Cargo_OtherConversionARCNY: '其他折算CNY应收',
  Cargo_OtherConversionAREUR: '其他折算EUR应收',
  Cargo_OtherConversionARGBP: '其他折算GBP应收',
  Cargo_OtherConversionARHKD: '其他折算HKD应收',
  Cargo_OtherConversionARJPY: '其他折算JPY应收',
  Cargo_OtherConversionARNGN: '其他折算NGN应收',
  Cargo_OtherCurrencies: '其它币种',
  Cargo_OtherCurrencyExchangeRates: '其它币种汇率',
  Cargo_OtherExchangeRates: '其它汇率',
  Cargo_OtherOutstandingConversionAP: '其他折算未付',
  Cargo_OtherOutstandingConversionAPCNY: '其他折算CNY未付',
  Cargo_OtherOutstandingConversionAPEUR: '其他折算EUR未付',
  Cargo_OtherOutstandingConversionAPGBP: '其他折算GBP未付',
  Cargo_OtherOutstandingConversionAPHKD: '其他折算HKD未付',
  Cargo_OtherOutstandingConversionAPJPY: '其他折算JPY未付',
  Cargo_OtherOutstandingConversionAPNGN: '其他折算NGN未付',
  Cargo_OtherOutstandingConversionAR: '其他折算未收',
  Cargo_OtherOutstandingConversionARCNY: '其他折算CNY未收',
  Cargo_OtherOutstandingConversionAREUR: '其他折算EUR未收',
  Cargo_OtherOutstandingConversionARGBP: '其他折算GBP未收',
  Cargo_OtherOutstandingConversionARHKD: '其他折算HKD未收',
  Cargo_OtherOutstandingConversionARJPY: '其他折算JPY未收',
  Cargo_OtherOutstandingConversionARNGN: '其他折算NGN未收',
  Cargo_OTNSOSICBD: '未送出和已送出才可以删除。',
  Cargo_OTWOOCCI: '只有销账人本人可以撤销销账。',
  Cargo_OTWOOCMI: '只有销账人本人可以修改销账。',
  Cargo_OurAccount: '我方账号',
  Cargo_OurBank: '我方银行',
  Cargo_OurBankIsEmptySaveBankReceipt: '我方银行为空，是否保存水单？',
  Cargo_Outcomes: '成果',
  Cargo_OutstandingAP: '应付未销',
  Cargo_OutstandingAPP: '应付未销:',
  Cargo_OutstandingConversionAPInCNY: '折合CNY未付',
  Cargo_OutstandingConversionAPInCurrency: '折合{0}未付',
  Cargo_OutstandingConversionPaidInCurrency: '折合{0}已付',
  Cargo_OutstandingPaymentParties: '未结清结算单位',
  Cargo_OutstandingWrittenOffItemsExist: '有未销账',
  Cargo_OVDCBUFPLAT: '损益类科目，只能选择虚拟部门。',
  Cargo_Virtual: '虚拟',
  Cargo_Over90DaysShpt: '大于90天（票）',
  Cargo_OverdueExpenses: '超期费用',
  Cargo_Overseas: '海外',
  Cargo_OverseasAgencyContract: '海外代理合同',
  Cargo_OverseasAgent: '国外代理',
  Cargo_OverseasAgentOrNot: '是否国外代理',
  Cargo_OverseasCollection: '国外收款',
  Cargo_OverseasDirectClient: '国外直客',
  Cargo_OverseasDirectClientOrNot: '是否国外直客',
  Cargo_OverseasDomestic: '海外国内',
  Cargo_OverseasOrNot: '是否国外',
  Cargo_OverseasPayment: '国外付款',
  Cargo_OverseasWriteOff: '海外销账',
  Cargo_OverseasWriteOffOrNot: '是否海外销账',
  Cargo_OverseasWriteOffSearch: '海外销账查询',
  Cargo_OVICBETGTEI: '增值税发票才可以金税导出电子发票。',
  Cargo_OVWCSNCBE: '只能导出连续凭证号的凭证。',
  Cargo_OVWUSCBE: '只能审查状态为未审查的凭证。',
  Cargo_OWCICGTSEEI: '开票币种是{0}才可以金税导出电子发票',
  Cargo_OwningDept: '所属部门',
  Cargo_Package: '包装',
  Cargo_PackageExistsOrSelectNull: '包装已存在或未选择记录',
  Cargo_PackageMaintenance: '包装维护',
  Cargo_PackingInformationNotSelected: '未选中装箱信息。',
  Cargo_PADS: '拒绝付款申请成功。',
  Cargo_Page: '张',
  Cargo_Paid: '已付款',
  Cargo_PaidInFull: '已付清',
  Cargo_PaidInOutOfPocket: '实际收付',
  Cargo_ReceiptPaymentpVoucher: '实收付凭证',
  Cargo_PANMWEAPCAOCA: '费用申请单与费用金额不符,请检查金额或者联系管理员!',
  Cargo_ParentAccountTitle: '上级科目',
  Cargo_PARGMSA: '付款申请单是否需要总经理审批',
  Cargo_Parter: '合作伙伴',
  Cargo_CreditAccountingPeriod: '信用账期',
  Cargo_CreditLine: '信用额度',
  Cargo_ExceededAmount: '已超出,{0}元',
  Cargo_Exceeded: '已超出',
  Cargo_PartialConfirmation: '部分确认',
  Cargo_PartialExpense: '部分费用',
  Cargo_PartialPayment: '部分付款',
  Cargo_PartialReversalCompleted: '部分转回成功。',
  Cargo_PartialWriteOff: '部分核销',
  Cargo_Participant: '参与人',
  Cargo_PartnerCanTBeEmpty: '合作伙伴不能为空',
  Cargo_PartnerSCreditLimitExceeded: '合作伙伴额度账期已超出',
  Cargo_Password: '密码',
  Cargo_PasswordField: '密码区',
  Cargo_PAWOCTBD: '付款申请单已核销无法删除',
  Cargo_Pay: '付',
  Cargo_Payable: '可付款',
  Cargo_PayableNeedPay: '可付款(应付)',
  Cargo_PayableOrNot: '是否可付款',
  Cargo_PayablesWriteOfStatus: '应付核销状态',
  Cargo_Payee: '收款人',
  Cargo_PayeeP: '收款人:',
  Cargo_Payment: '付款',
  Cargo_PaymentAccount: '付款账号',
  Cargo_PaymentAgainstMonthlySoa: '月结/票结',
  Cargo_PaymentAmount: '付款金额',
  Cargo_PaymentApplicationDirectlySent: '付款申请直达',
  Cargo_PaymentApplicationInformation: '付款申请信息',
  Cargo_PaymentApplicationNo: '付款申请号',
  Cargo_PaymentAppliedSuccessfully: '付款申请成功。',
  Cargo_PaymentApprovalSlipDetails: '付款审批单明细',
  Cargo_PaymentApprovalSlipNo: '付款审批单号',
  Cargo_PaymentCompany: '来款单位',
  Cargo_PaymentCompanyName: '来款公司名称',
  Cargo_PaymentCycle: '账期周期',
  Cargo_PaymentDate: '付款日期',
  Cargo_PaymentDateCanTBeEmpty: '付款日期不能为空。',
  Cargo_PaymentMethod: '付款方式',
  Cargo_PaymentNotApplied: '未申请付款',
  Cargo_PaymentNotificationNo: '付款通知号',
  Cargo_PaymentPeriod: '付款期限',
  Cargo_PaymentPeriodExceeded: '账期超出',
  Cargo_PaymentPeriodRange: '账期范围',
  Cargo_PaymentReceiveMethod: '收付方式',
  Cargo_PaymentReceiveMethodP: '收付方式:',
  Cargo_PaymentReceiveType: '收付类型',
  Cargo_PaymentReceiveTypeP: '收付类型:',
  Cargo_PaymentRequest: '付款申请',
  Cargo_PaymentRequestBusiness: '付款申请-业务',
  Cargo_PaymentRequestDetail: '付款申请-详情',
  Cargo_PaymentRequested: '已申请付款',
  Cargo_PaymentRequestedNotRequested: '已申请付款/未申请付款',
  Cargo_PaymentRequestsCreatedOrNot: '是否已开付款申请单',
  Cargo_PaymentTime: '付款时间',
  Cargo_PaymentToBeChecked: '待查款项',
  Cargo_CarryForwardList: '结转列表',
  Cargo_PaymentType: '支付类型',
  Cargo_PaymentVerification: '付款审核',
  Cargo_PayReceive: '收付',
  Cargo_PayReceiveDate: '收付日期',
  Cargo_PayUnit: '付款单位',
  Cargo_PCAOCO: '请确认，本次{0}金额为：',
  Cargo_PCHIUV: '待审核客户公海',
  Cargo_PCITIHBI: '请检查是否已开票.',
  Cargo_INVOICE_NO_FILE: '该发票下没有找到对应的电子发票文件.',
  Cargo_Pcs: '个',
  Cargo_PCSALOA: '请点选一条以上的申请单。',
  Cargo_PCSALOI: '请点选一条以上的发票。',
  Cargo_Pcst: '条',
  Cargo_PCTAOTCPI: '请确认:\\n本次实际收付金额为：',
  Cargo_PCTOOPAIWOADSA: '请确认:\\n本次实付金额为:{0},\\n销账金额为:{1},\\n差额为:{2}作为零头短账!',
  Cargo_PDDPAF: '只显示了部分数据，请增加检索条件过滤。',
  Cargo_PeakSeason: '业务旺季',
  Cargo_PEALTVJE: '请至少输入两条有效分录',
  Cargo_PEATGR: '请输入科目分组规则。',
  Cargo_PECCI: '请输入完整快递信息。',
  Cargo_PECINSWACONIO: '请输入正确的发票号码,系统会自动依次输入其他号码!',
  Cargo_PEERAVC: '已经生成期末调汇凭证：',
  Cargo_PEFEA: '期末调汇',
  Cargo_PEFEA2: '期末调汇2',
  Cargo_PEFEAS: '期末调汇成功',
  Cargo_PendingBusinessApplication: '待申请业务',
  Cargo_PendingPrice: '待审核',
  Cargo_People: '人',
  Cargo_PerformLetterFiltering: '进行字符过滤',
  Cargo_PERFROIRF: '请在备注中输入重开原因。',
  Cargo_Period: '期',
  Cargo_PeriodEndAmount: '期末数',
  Cargo_PeriodEndBalance: '期末余额',
  Cargo_PeriodEndBalanceCreditCNY: '期末余额贷方（人民币）',
  Cargo_PeriodEndBalanceCreditUSD: '期末余额贷方（美元）',
  Cargo_PeriodEndBalanceDebitCNY: '期末余额借方（人民币）',
  Cargo_PeriodEndBalanceDebitUSD: '期末余额借方（美元）',
  Cargo_PeriodEndExchangeRateAdjustment: '是否期末调汇',
  Cargo_PeriodRange: '期间范围',
  Cargo_Periods: '期间',
  Cargo_PermissionCheck: '权限检查',
  Cargo_PermissionControl: '权限控制',
  Cargo_PermissionToSubmitExpense: '提交费用权限',
  Cargo_PESAI: '请输入【{0}】的辅助核算{1}信息。',
  Cargo_PESAIN: '请输入【{0}】的辅助核算项目号信息',
  Cargo_PESCSBA: '请输入销货单位银行账号。',
  Cargo_PETSAINO: '请输入【{0}】的辅助核算项目号信息.',
  Cargo_PETSFIIB: '请在下方输入拆分出来的费用信息',
  Cargo_PEWOIPETS: '请输入销账信息回车查询',
  Cargo_PFAEFTS: '上海空运付款',
  Cargo_PICNENCTSFS: '请输入中文名、英文名、代码、简称模糊查询',
  Cargo_PlaceOfDelivery: '交货地',
  Cargo_PlaceOfMblPayment: '主单付款地点',
  Cargo_PlaceOfReceipt: '收货地',
  Cargo_PlanDescription: '方案描述',
  Cargo_PlatformCode: '平台编码',
  Cargo_PlatformCustomerService: '平台客服',
  Cargo_CustomerServiceOverSea: '海外客服',
  Cargo_PLCOS: '结转损益成功',
  Cargo_PleaseAddAtLeastOneContactPerson: '客户联系人至少填一个',
  Cargo_PleaseAddContactPerson: '请填写联系人',
  Cargo_PleaseAddExpense: '请添加费用。',
  Cargo_PleaseAddNominationCargoAgent: '请填写指定货代理',
  Cargo_PleaseAddNominationCargoAgentP: '请填写指定货代理：',
  Cargo_PleaseAddTelNumbers: '请填写电话',
  Cargo_PleaseBatchSelectInvoiceNo: '请批量选择{0}个发票号',
  Cargo_PleaseCheckClient: '请勾选客户',
  Cargo_PleaseCheckInvoice: '请勾选发票。',
  Cargo_PleaseChooseData: '请选择数据.',
  Cargo_PleaseChooseFeeName: '请选择费用名称.',
  Cargo_PleaseChooseSettlementEntity: '请选择结算单位.',
  Cargo_PleaseClickSelectAnInvoice: '请点选一条发票。',
  Cargo_PleaseClickSelectARecord: '请点选一条记录。',
  Cargo_PleaseConfirmPaymentMade: '请确认，已向 {0} 支付了{1} {2}!',
  Cargo_PleaseConfirmReviewDate: '请确认审核日期：',
  Cargo_PleaseConfirmFinancialDate: '请确认财务日期：',
  Cargo_PleaseConfirmTheDueAmount: '请确认:\\n本次应当{0}金额:',
  Cargo_PleaseConfirmThePaidInAmountIs: '请确认，本次实收金额为：',
  Cargo_PleaseConfirmThisTime: '请确认，本次{0}金额为:',
  Cargo_PleaseDeleteAfterVoid: '请先作废再删除。',
  Cargo_PleaseEnterAccountTitle: '请输入科目名称。',
  Cargo_PleaseEnterAmount: '请输入金额',
  Cargo_PleaseEnterClientName: '请输入客户名称。',
  Cargo_PleaseEnterCode: '请输入代码。',
  Cargo_PleaseEnterCorrectAmount: '请输入正确的金额。',
  Cargo_PleaseEnterCorrectBillingParty: '请输入正确的结算对象。',
  Cargo_PleaseEnterCorrectExchangeRate: '请输入正确的汇率。',
  Cargo_PleaseEnterCorrectNumber: '请输入正确的数字。',
  Cargo_PleaseEnterCurrencyExchangeRate: '请输入币种【{0}】的汇率。',
  Cargo_PleaseEnterDate: '请输入日期',
  Cargo_PleaseEnterDateOfReceipt: '请输入收款日期。',
  Cargo_PleaseEnterDifferential: '请输入差额',
  Cargo_PleaseEnterExpenseDescription: '请输入费用名称。',
  Cargo_PleaseEnterExpenseDetails: '请输入费用明细',
  Cargo_PleaseEnterFinancialCode: '请输入财务编码。',
  Cargo_ApAndArCodeIsEmpty: '当前【应收编码】/【应付编码】均为空，请完善数据后重试。',
  Cargo_PleaseEnterFinancialDate: '请输入财务日期',
  Cargo_PleaseEnterHsCode: '请输入HSCode',
  Cargo_PleaseEnterInformationOf: '请输入【{0}】的辅助核算{1}信息.',
  Cargo_PleaseEnterInvoiceInformation: '请输入发票信息',
  Cargo_PleaseEnterInvoiceNo: '请输入发票号。',
  Cargo_PleaseEnterInvoiceNoP: '请输入发票号：',
  Cargo_PleaseEnterMailingAddress: '请输入快递地址。',
  Cargo_PleaseEnterName: '请输入名称。',
  Cargo_PleaseEnterNewInvoiceNo: '请输入新发票号码。',
  Cargo_PleaseEnterNewInvoiceTitle: '请输入新发票抬头。',
  Cargo_PleaseEnterOperationCode: '请输入操作符。',
  Cargo_PleaseEnterOurBankAccountNo: '请输入我方银行账号。',
  Cargo_PleaseEnterPaidInAmount: '请输入实收金额。',
  Cargo_PleaseEnterPaidInDate: '请输入实收日期。',
  Cargo_PleaseEnterPaymentParty: '请输入付款单位',
  Cargo_PleaseEnterPaymentTerm: '请输入付款期限。',
  Cargo_PleaseEnterPlanName: '请输入方案名称',
  Cargo_PleaseEnterGuarantrrName: '请输入保函名称',
  Cargo_PleaseEnterRecipientSName: '请输入收件人名称。',
  Cargo_PleaseEnterReturnedCourierNo: '请输入退还快递号。',
  Cargo_PleaseEnterSalesCompanySBank: '请输入销货单位开户行。',
  Cargo_PleaseEnterScarletLetterNumber: '请输入红字通知单号',
  Cargo_PleaseEnterSearchInformation: '请输入查询信息。',
  Cargo_PleaseEnterSettlingParty: '请输入结算对象',
  Cargo_PleaseEnterSobCode: '请输入账套代码。',
  Cargo_PleaseEnterSobName: '请输入账套名称。',
  Cargo_PleaseEnterSplitAmount: '请输入拆分金额。',
  Cargo_PleaseEnterTableName: '请输入表名',
  Cargo_PleaseEnterTelNo: '请输入联系电话。',
  Cargo_PleaseEnterUserName: '请输入用户',
  Cargo_PleaseEnterValueOfCondition: '请输入条件值。',
  Cargo_PleaseEnterVoucherLetter: '请输入凭证字。',
  Cargo_PleaseEnterVoucherNo: '请输入凭证号',
  Cargo_PleaseEnterVoucherType: '请输入凭证类型。',
  Cargo_PleaseInputJobNo: '请输入工作号',
  Cargo_PleaseReselectTheVoucherToExport: '请重新选择要导出的凭证。',
  Cargo_PleaseSelect: '请选择',
  Cargo_PleaseSelectP: '-请选择-',
  Cargo_PleaseSelect2OrMoreApplications: '请点选两条以上的申请单。',
  Cargo_PleaseSelectAccountTitle: '请选择科目。',
  Cargo_PleaseSelectAnAdvanceReceipt: '请选择一项预收款。',
  Cargo_PleaseSelectAnExpenseItem: '请选择一条费用。',
  Cargo_PleaseSelectAnInvoice: '请选择一张发票。',
  Cargo_PleaseSelectAPAndARExpense: '请选择应付及应收费用。',
  Cargo_PleaseSelectApplication: '请选择申请单。',
  Cargo_PleaseSelectARecord: '请选择一条记录。',
  Cargo_PleaseSelectBill: '请选择账单。',
  Cargo_PleaseSelectBillToMark: '请选择需要标记的账单。',
  Cargo_PleaseSelectBillToPrint: '请选择账单进行打印。',
  Cargo_PleaseSelectBillToRemove: '请选择要移除的账单。',
  noRowsToShow: '无查询结果',
  Cargo_PleaseSelectBranch: '请选择分公司。',
  Cargo_SelectBranch: '选择分公司',
  Cargo_ApplicationBranch: '应用操作分公司',
  Cargo_ApplicationDepartment: '应用操作部门',
  Cargo_MoreBusinessConditions: '更多业务条件',
  Cargo_MoreConditionsOptions: '更多条件选项',
  Cargo_BusinessConditionsOptions: '业务条件选项',
  Cargo_PleaseSelectBusiness: '请选择业务。',
  Cargo_PleaseSelectBusinessDate: '请选择业务日期。',
  Cargo_PleaseSelectBusinessOrderRecord: '请选择业务单记录。',
  Cargo_PleaseSelectBusinessType: '请选择业务类型',
  Cargo_PleaseSelectGuaranteeType: '请选择保函类型',
  Cargo_PleaseSelectClosureTime: '请选择结束时间。',
  Cargo_PleaseSelectContentToModify: '请选择需要修改的内容。',
  Cargo_PleaseSelectCurrency: '请选择币种。',
  Cargo_PleaseSelectData: '请勾选数据。',
  Cargo_PleaseSelectContainerGroup: '请勾选指定一个集装器组进行添加操作。',
  Cargo_AutomaticReleaseTips: '存在可放单状态的提单，无需特批放单。',
  Cargo_PleaseSelectDataToDelete: '请选择要删除的数据。',
  Cargo_PleaseSelectDataToRevoke: '请选择要作废的数据。',
  Cargo_SuredRevokeJob: '确定作废选中的业务吗？',
  Cargo_PleaseSelectDataToExport: '请选择需要导出的数据。',
  Cargo_PleaseSelectDataType: '请选择数据类型。',
  Cargo_PleaseSelectDataTypeToCreate: '请选择要生成的数据类型。',
  Cargo_PleaseSelectDate: '请选择日期',
  Cargo_PleaseSelectExpense: '请选择费用。',
  Cargo_PleaseSelectTemplate: '请选择模版。',
  Cargo_PleaseSelectExpenseToConfirm: '请选择要确认的费用。',
  Cargo_PleaseSelectExpenseToSplit: '请选择要拆分的费用。',
  Cargo_PleaseSelectExpenseToWriteOff: '请选择需要销账的费用。',
  Cargo_PleaseSelectFile: '请选择文件',
  Cargo_OwnFileDelete: '权限不足：无法删除其他用户上传的文件',
  Cargo_PleaseSelectFileType: '请选择文件类型',
  Cargo_PleaseSelectGroupingCondition: '请选择分组条件',
  Cargo_PleaseSelectGroupingCondition2: '请选择分组条件1。',
  Cargo_PleaseSelectIncludedBizNo: '请选择计入业务编号',
  Cargo_PleaseSelectInvoice: '请选择发票。',
  Cargo_PleaseSelectInvoiceNo: '请选择发票号。',
  Cargo_PleaseSelectOurBank: '请选择我方银行。',
  Cargo_PleaseSelectPaymentApplication: '请选择付款申请。',
  Cargo_PleaseSelectTheRecord: '请选择需要修改的记录',
  Cargo_batchChangePaymentSuccess: '批量修改付款申请成功',
  Cargo_batchChangePaymentFailed: '批量修改付款申请失败',
  Cargo_NotEmptyChangePaymentTime: '申请付款时间不能为空',
  Cargo_ApprovedSuccess: '审批成功。',
  Cargo_ApprovedFaild: '审批失败。',
  Cargo_Rejected: '已驳回',
  Cargo_Cancelled: '已撤销',
  Cargo_ReturnedSuccess: '退回成功。',
  Cargo_ReturnedFaild: '退回失败。',
  Cargo_NoBusinessApproval: '没有需要业务审批的数据。',
  Cargo_NoDeptApproval: '没有需要部门审批的数据。',
  Cargo_NoFinanceApprovalData: '没有需要财务审批的数据',
  Cargo_NoSupervisorApprovalData: '没有需要主管审批的数据',
  Cargo_PleaseSelectPeriodRange: '请选择期间范围',
  Cargo_PleaseSelectRecord: '请选择记录。',
  Cargo_PleaseSelectRecordToInvoice: '请选择要开票的记录。',
  Cargo_PleaseSelectRecordToReview: '请选择要复核的记录。',
  Cargo_PleaseSelectRecordToCancelReview: '请选择要取消复核的记录。',
  Cargo_PleaseSelectRecordToWriteOff: '请选择要销账的记录。',
  Cargo_PleaseSelectReviewDate: '请选择审核日期。',
  Cargo_PleaseSelectSameInvoiceType: '请选择相同的发票类型。',
  Cargo_PleaseSelectServiceTicket: '请选择费用确认单。',
  Cargo_PleaseSelectSettlingParty: '请选择结算对象。',
  Cargo_AddTag: '新增标记',
  Cargo_NotFoundNeedSaveCharges: '列表中没有需要新增的费用。',
  Cargo_SureSaveBilling: '是否确定保存并生成账单？',
  Cargo_SureSaveChargeOnly: '是否确定仅保存费用？',
  Cargo_SureCancelEdit: '是否确定取消编辑？',
  Cargo_JobBillingChargeNotEqual: '业务【{0}】的【{1}】【{2}】 与账单的不一致，请移除不一致费用后，才可修改！',
  Cargo_SaveGenerateBills: '保存并生成账单',
  Cargo_GenerateExpensesOnly: '仅生成费用',
  Cargo_PleaseSelectSoa: '请选择对账单。',
  Cargo_PleaseSelectSob: '请选择账套。',
  Cargo_PleaseSelectStartTime: '请选择开始时间。',
  Cargo_PleaseSelectThePurchaser: '请选择购买人。',
  Cargo_PleaseSelectTypeOfJournalEntries: '请选择分录类型。',
  Cargo_PleaseSelectVatInvoice: '请选择增值税发票。',
  Cargo_PleaseSelectVatEiInvoice: '请选择增值税电票。',
  Cargo_PleaseSelectVoucher: '请选择凭证。',
  Cargo_PleaseSelectVoucherGroupingRule: '请选择凭证分组规则',
  Cargo_PleaseSelectVoucherToCancel: '请选择需要取消的凭证。',
  Cargo_PleaseSelectVoucherToReview: '请选择需要审核的凭证。',
  Cargo_PleaseSelectWriteOffDetails: '请选择销账明细。',
  Cargo_PleaseSelectWriteOffRecord: '请选择销账记录。',
  Cargo_PleaseSpecifyPaymentPeriodRange: '请指定账期范围',
  Cargo_PleaseUseComponent: '请用组件',
  Cargo_PlsInput: '请输入',
  Cargo_PLVDCTBE: '损益凭证日期不能为空',
  Cargo_PLVDNITP: '损益凭证日期不在期间内',
  Cargo_PLVFCTBE: '损益凭证字不能为空',
  Cargo_PLVNAPATCTBE: '损益凭证未分配利润科目不能为空',
  Cargo_PoaCustomsDeclaration: '委托报关',
  Cargo_PODcode: '港口代码',
  Cargo_FileFromQuotation: '包含从报价管理中带入的文件，不允许删除',
  Cargo_FileFromInquiry: '包含从询价管理中带入的文件，不允许删除',
  Cargo_PodSea: '卸货 港（海港）',
  Cargo_Unloading: '卸货',
  Cargo_ArrivalNotice: '到货通知',
  Cargo_PickUp: '提货',
  Cargo_AircraftGISPositioning: '飞机GIS定位',
  Cargo_PointOfPermission: '权限点',
  Cargo_PointsToNote: '有无特殊性',
  Cargo_Pol: '装船港',
  Cargo_PolAgent: '起运港代理',
  Cargo_POLCannotBeNull: '起运港不能为空',
  Cargo_PolSea: '起运港（海港）',
  Cargo_Port: '港口',
  Cargo_PortCodeCanTBeEmpty: '港口代码不能为空',
  Cargo_PortGroup: '港口群',
  Cargo_PortGroupCanTBeEmpty: '港口群不能为空',
  Cargo_PortOfDestinationCode: '目的港代码',
  Cargo_PortOfDischarge: '卸货港',
  Cargo_PortOfDischargeCannotBeNull: '卸货港不能为空',
  Cargo_PortOfLoading: '起运港',
  Cargo_PortOfLoadingSea: '起运港（海运）',
  Cargo_PortOfLoadingAir: '起运港（空运）',
  Cargo_PortPrompt: '请输入港口',
  Cargo_PortRequirement: '港口要求',
  Cargo_PositiveOperation: '正操作',
  Cargo_Post: '岗位',
  Cargo_PotentialStage: '潜在阶段',
  Cargo_PPNCASA: '作为零头短账，不生成预付款。',
  Cargo_PRCTBCFWOE: '已核销的费用/业务不能创建付款申请。',
  Cargo_PreCollection: '预收款',
  Cargo_PreferredAgentAtDestination: '偏好目的港代理',
  Cargo_PreferredAirline: '偏好航空公司',
  Cargo_PreferredAirport: '偏好空港',
  Cargo_PreferredAirportAir: '偏好港口（空港）',
  Cargo_PreferredCustomsBroker: '偏好报关服务',
  Cargo_PreferredOceanCarrier: '偏好船公司',
  Cargo_PreferredPort: '偏好海港',
  Cargo_PreferredPortSea: '偏好港口（海港）',
  Cargo_PreferredShippingMethod: '偏好走货类型',
  Cargo_PreferredShippingRoute: '偏好航线',
  Cargo_PreferredShippingTerms: '偏好运输条款',
  Cargo_PreferredTrucker: '偏好拖车行',
  Cargo_PreferredTruckingService: '偏好拖车服务',
  Cargo_PrepaidOrNot: '是否预付',
  Cargo_PreparedBy: '制单人',
  Cargo_PreparedByP: '制单人：',
  Cargo_PrepareServiceTicket: '制作费用确认单',
  Cargo_PrePayment: '是否预收款',
  Cargo_PrepaymentRecordedSuccessfully: '登记预付成功。',
  Cargo_PreReviewStatus: '预审状态',
  Cargo_PreReviewAllStatus: '预审状态（复核）',
  Cargo_PreSubmission: '预提交',
  Cargo_PreviewEmailContent: '预览邮件内容',
  Cargo_Previous: '上一个',
  Cargo_PrimeCost: '成本',
  Cargo_Print: '打印',
  Cargo_PrintAll: '全部打印',
  Cargo_PrintBill: '打印账单',
  Cargo_PrintedSuccessfully: '打印成功。',
  Cargo_PrintInvoice: '开票打印',
  Cargo_PrintList: '清单打印',
  Cargo_PrintOrNot: '是否打印',
  Cargo_LACKINVOICE: '是否缺票',
  Cargo_Printout: '打印结果',
  Cargo_PrintPaymentList: '打印付款清单',
  Cargo_PrintSoa: '打印对账单',
  Cargo_PrintStatusSaved: '保存打印状态成功。',
  Cargo_PrintTheProfit: '利润打印',
  Cargo_PrintVerification: '打印验证',
  Cargo_PrintWithdrawalList: '打印（退单清单）',
  Cargo_ProcessedAsShortAccount: '作为零头短账处理',
  Cargo_ProcessedBy: '处理人',
  Cargo_ProcessingChangeRemarks: '处理调整备注',
  Cargo_ProcessingPleaseWait: '请稍候，正在处理……',
  Cargo_ProcessingRemarks: '处理备注',
  Cargo_ProcessingTime: '处理时间',
  Cargo_ProductName: '方案名称',
  Cargo_Profit: '利润',
  Cargo_ProfitLossAccount: '损益类科目',
  Cargo_ProfitLoss: '利润表',
  Cargo_ProfitLoss2: '利润表2',
  Cargo_ProfitLossVoucherNoCanTBeEmpty: '损益凭证号不能为空',
  Cargo_ProfitLossVoucherNotInThePeriod: '损益凭证不在期间内',
  Cargo_Prompt: '提醒',
  Cargo_Proof: '凭证',
  Cargo_ProofDate: '凭证日期',
  Cargo_ProofDateP: '凭证日期：',
  Cargo_ProofOrNot: '是否生成凭证',
  Cargo_Property: '属性',
  Cargo_Province: '省',
  Cargo_PRSCSCRICP: '船公司托收记录，请到托收页签撤销。',
  Cargo_PSALOAPAARE: '请选择至少一条应付及应收费用。',
  Cargo_PSALOER: '请选择至少一条费用记录。',
  Cargo_PSALOGODC: '请至少选择一组日期条件。',
  Cargo_PSALOGODC2: '请至少选择一种过滤条件。',
  Cargo_SelectLockOrderCondition: '选择锁单条件',
  Cargo_PSBOTSSP: '请选择相同结算单位的账单',
  Cargo_PSCI: '请选择托收信息',
  Cargo_PSDTOVG: '请选择凭证分组数据类型。',
  Cargo_PSEDTRWO: '请选中要撤销销账的费用明细。',
  Cargo_PSFDD: '报关单证录入分页查询',
  Cargo_PSFPOTSY: '会计期间请选择同一年。',
  Cargo_PleaseSelectVoucherRange: '请选择凭证区间',
  Cargo_PSGROJE: '请选择分录分组规则',
  Cargo_PSOR: '请选择操作要求',
  Cargo_PSPAF: '请选择付款申请单。',
  Cargo_PSPATD: '请选择要删除的付款申请。',
  Cargo_PSPATW: '请选择要撤回的付款申请。',
  Cargo_PSPATR: '请选择要退回的付款申请。',
  Cargo_PSPATS: '请选择要提交的付款申请。',
  Cargo_PSROACP: '请选择实际收付款记录。',
  Cargo_PSRTCPA: '请选择要做付款申请的记录。',
  Cargo_PSRTCV: '请选择所要生成凭证的记录。',
  Cargo_PSSDOCD: '请选择开始日期或结束日期。',
  Cargo_PSUSPAF: '请选择未提交的付款申请单。',
  Cargo_PSSPAF: '只能撤回未被审批的付款申请',
  Cargo_PSVOFS: '请选择财务软件版本。',
  Cargo_CurrencyMismatch: '{0}的币种与银行账号不符，请修改销账',
  Cargo_PublicClientHub: '客户公海',
  Cargo_Publish: '发布',
  Cargo_PublishStatus: '发布状态',
  Cargo_PurchasedBy: '购买人',
  Cargo_PurchaseRecord: '购买记录',
  Cargo_PurchaseRegisteredSuccessfully: '购买登记成功。',
  Cargo_PurchaseRegistration: '购买登记',
  Cargo_PurchasingParty: '购货方',
  Cargo_PurchasingUnit: '购货单位',
  Cargo_PUSBAANMRIDSS: '购货单位开户行及账号不是{0}所属的银行账户，是否要保存？',
  Cargo_PutARItemsOnTop: '应收的放上面',
  Cargo_PYPALAA: '以前年度损益调整科目',
  Cargo_PYPALAAP: '以前年度损益调整科目:',
  Cargo_Query: '查询',
  Cargo_QueryFailed: '查询失败。',
  Cargo_QueryInvoice: '发票查询',
  Cargo_QuickSearch: '简单查询',
  Cargo_QuotaCurrency: '额度币种',
  Cargo_QuotaRange: '额度区间',
  Cargo_RAIAV: '取绝对值后的对账金额',
  Cargo_Railway: '铁路',
  Cargo_RailwayExport: '铁路出口',
  Cargo_RailwayImport: '铁路进口',
  Cargo_RailwayBusiness: '铁路业务',
  Cargo_IntegratedJob: '综合物流',
  Cargo_FbaOrder: 'FBA下单',
  Cargo_FbaSea: 'FBA海运',
  Cargo_FbaAir: 'FBA空运',
  Cargo_FbaRailway: 'FBA铁路',
  Cargo_RailwayRoute: '铁路航线',
  Cargo_Settlement: '结算',
  Cargo_ReconciliationTab: '对账页签',
  Cargo_BillTab: ' 账单页签 ',
  Cargo_CancelApprovalCheck: ' 选择的数据中包含已发送过 BO 的业务，不允许取消审核，请检查！',
  Cargo_BusinessPushStatus: '业务推送状态 ',
  Cargo_CostPushStatus: '费用推送状态 ',
  Cargo_AutoGenerateEnabled: '是否自动生成',
  Cargo_BusinessQuotationAmount: '商务报价',
  Cargo_BusinessQuotationConfirmed: '报价确认',
  Cargo_BusinessQuotationConfirmedCancel: '取消报价确认',
  Cargo_OperationAllowedOnlyForUnconfirmedQuotation: '只有报价确认为“否”的费用才能进行此操作！',
  Cargo_OperationAllowedOnlyForConfirmedNonZeroQuotation: '只有商务报价不为0，且报价确认为“是”的费用才能进行此操作！',
  Cargo_RCAFTPOY: '反结账{0}年第{1}期',
  Cargo_RCBDIDL: '刷新当前下拉分公司数据',
  Cargo_RealPaid: '实付',
  Cargo_RealPaidP: '实付:',
  Cargo_ReasonNotEntered: '理由未填写',
  Cargo_ReasonOfCargoDetention: '扣单原因',
  Cargo_ReasonOfCargoDetentionP: '扣单原因:',
  Cargo_ReCalculateBillingAmount: '重新计算账单金额',
  Cargo_Receipt: '收款',
  Cargo_ReceiptAmount: '收款金额',
  Cargo_Receivable: '应收',
  Cargo_ReceivableToCNY: '折合CNY应收：',
  Cargo_ReceivableB: '（应收）',
  Cargo_ReceivedCNY: 'CNY已收',
  Cargo_PayPaidCNY: 'CNY已付',
  Cargo_ReceivedUSD: 'USD已收',
  Cargo_ReceivedEUR: 'EUR已收',
  Cargo_ReceivedGBP: 'GBP已收',
  Cargo_ReceivedHKD: 'HKD已收',
  Cargo_ReceivedJPY: 'JPY已收',
  Cargo_ReceivedNGN: 'NGN已收',
  Cargo_PayPaidUSD: 'USD已付',
  Cargo_PayPaidEUR: 'EUR已付',
  Cargo_PayPaidGBP: 'GBP已付',
  Cargo_PayPaidHKD: 'HKD已付',
  Cargo_PayPaidJPY: 'JPY已付',
  Cargo_PayPaidNGN: 'NGN已付',
  Cargo_OtherConversionReceivedUSD: '其他折算USD已收',
  Cargo_OtherConversionReceivedEUR: '其他折算EUR已收',
  Cargo_OtherConversionReceivedGBP: '其他折算GBP已收',
  Cargo_OtherConversionReceivedHKD: '其他折算HKD已收',
  Cargo_OtherConversionReceivedJPY: '其他折算JPY已收',
  Cargo_OtherConversionReceivedNGN: '其他折算NGN已收',
  Cargo_OtherConversionPayPaidUSD: '其他折算USD已付',
  Cargo_OtherConversionPayPaidEUR: '其他折算EUR已付',
  Cargo_OtherConversionPayPaidGBP: '其他折算GBP已付',
  Cargo_OtherConversionPayPaidHKD: '其他折算HKD已付',
  Cargo_OtherConversionPayPaidJPY: '其他折算JPY已付',
  Cargo_OtherConversionPayPaidNGN: '其他折算NGN已付',
  Cargo_OtherConversionReceivedCNY: '其他折算CNY已收',
  Cargo_OtherConversionPayPaidCNY: '其他折算CNY已付',
  Cargo_ReceivableCNY: 'CNY应收',
  Cargo_ReceivableEUR: 'EUR应收',
  Cargo_ReceivableGBP: 'GBP应收',
  Cargo_ReceivableHKD: 'HKD应收',
  Cargo_ReceivableJPY: 'JPY应收',
  Cargo_ReceivableNGN: 'NGN应收',
  Cargo_ReceivableP: '应收:',
  Cargo_ReceivablesInvoicingDate: '应收开票日期',
  Cargo_ReceivablesInvoicingStatus: '应收开票状态',
  Cargo_ReceivablesWriteOfStatus: '应收核销状态',
  Cargo_ReceivableUSD: 'USD应收',
  Cargo_Receive: '接收',
  Cargo_RevocationOfReceipt: '撤销接收',
  Cargo_Received: '已接收',
  Cargo_ReceivedDate: '收款日期',
  Cargo_ReceiveMethod: '收款方式',
  Cargo_Receiver: '取回人',
  Cargo_Receiver2: '收件人',
  Cargo_ReceiverCompanyName: '收件单位',
  Cargo_ReceivingBank: '收款银行',
  Cargo_ReceivingBankAccount: '收款账号',
  Cargo_ReceivingDate: '取回日期',
  Cargo_Recheck: '复核',
  Cargo_RecheckDate: '复核日期',
  Cargo_ReCheckedSuccessfully: '复核成功。',
  Cargo_ReCheckedFailed: '复核失败。',
  Cargo_CancelReCheckedSuccessfully: '取消复核成功。',
  Cargo_RecheckOrNot: '是否复核',
  Cargo_RecheckP: '复核:',
  Cargo_ReCheckPermission: '复核权限',
  Cargo_RecipientOfWithdrawal: '退单收件人',
  Cargo_RecipientSCompanyOfWithdrawal: '退单收件单位',
  Cargo_ReconcileOrNot: '是否对账',
  Cargo_Reconciliation: '对账',
  Cargo_ReconciliationAmount: '对账金额',
  Cargo_ReconciliationConfirmation: '对账确认',
  Cargo_ReconciliationDate: '对账日期',
  Cargo_ReconciliationOfAR: '应收对账',
  Cargo_ReconciliationStatus: '对账状态',
  Cargo_ReconciliationStatusControl: '对账状态控制',
  Cargo_ReconciliationType: '对账类型',
  Cargo_SendEmailByReconciliationDiff: '保存时是否同步邮件通知费用创建人员对账金额不一致',
  Cargo_ReconciliationDiffConfirm: '对账差异处理',
  Cargo_ReconciliationDiffReason: '差异原因',
  Cargo_ReconciliationDiffConfirmTip: '请重新勾选对账状态为【对账不一致】的费用进行确认处理',
  Cargo_Record: '登记记录',
  Cargo_RecordCount: '记录数',
  Cargo_Recorder: '记录人',
  Cargo_RecordLabel: '记录标签',
  Cargo_RecordNoOfPaidIn: '实收登记号',
  Cargo_RecordOrNot: '是否登记',
  Cargo_RecordOutOfPocket: '实付登记',
  Cargo_RecordPrepayment: '登记预付',
  Cargo_RecordsFound: '查询到{0}条记录',
  Cargo_RecordsWithEmptyInvoiceTypeExist: '有发票类型为空的记录',
  Cargo_RecordTime: '记录时间',
  Cargo_RedChargesOrNot: '是否红冲有国外费用没有有效账单号',
  Cargo_ReDeliveryOrNot: '是否二次送出？',
  Cargo_ReferralFromExistingClient: '熟客介绍',
  Cargo_Reflush: '更新',
  Cargo_RefNbr: '关单号',
  Cargo_Refresh: '刷新',
  Cargo_RefreshCompleteStatus: '更新完成。',
  Cargo_RefreshSearch: '查询刷新',
  Cargo_RefundAdvanceReceipt: '预收款退回',
  Cargo_RefundOfLclBusiness: '是否拼箱退费？',
  Cargo_Refuse: '拒绝',
  Cargo_Region: '区域',
  Cargo_RegisteredCapital: '公司注册金',
  Cargo_RegisteredCapitalIn10Thousand: '公司注册金/万',
  Cargo_RegistrationNumber: '纳税人识别号',
  Cargo_RegistrationNumberP: '纳税人识别号:',
  Cargo_ReIssuedInvoiceNo: '重开新发票号码',
  Cargo_ReIssuedInvoiceNoP: '重开新发票号码:',
  Cargo_ReIssueInvoice: '重开发票',
  Cargo_ReIssueVoidedInvoice: '作废后重新开票',
  Cargo_RelatedBLNo: '关联提单号',
  Cargo_Release: '释放',
  Cargo_ReleaseHbl: '分单放单',
  Cargo_Releasing: '放单',
  Cargo_ReleasingStatus: '放单状态',
  Cargo_IF_ReleasingStatus: '是否可放单状态',
  Cargo_RemainingAmount: '剩余金额',
  Cargo_RemainingPledgedAmount: '剩余认领金额',
  Cargo_Remarks: '备注',
  Cargo_SupervisorComments: '主管评论区',
  Cargo_RemarksCannotBeEmptyWhenWipeOut: '忽略零头时备注不能为空。',
  Cargo_RemarksOnAROrAPItems: '收付费科目备注',
  Cargo_RemarksOnPayment: '付款备注',
  Cargo_RemarksP: '备注：',
  Cargo_ArOriginalCurrency: '应收(原币种)',
  Cargo_ApOriginalCurrency: '应付(原币种)',
  Cargo_RemarkTheLengthCannotExceedP: '备注长度不能超过',
  Cargo_RemarkTheLengthCannotExceedP256: '备注长度不能超过256。',
  Cargo_RemittanceFee: '汇费',
  Cargo_Remove: '移除',
  Cargo_RemoveConfig: '移除配置',
  Cargo_AddConfig: '添加配置',
  Cargo_RemoveBillCharge: '移除费用',
  Cargo_RemoveDetails: '移除明细',
  Cargo_RemoveExpenseRemoveAll: '移除费用/移除全部',
  Cargo_RemoveParameterFunction: '去除参数功能',
  Cargo_RemovePartial: '移除部分',
  Cargo_OrderType: '订单类型',
  Cargo_TruckTrailer: '集卡拖车',
  Cargo_WholeVehicleAndLessThanCarload: '整车/零担',
  Cargo_RemovePermissionToSubmitExpense: '取消提交费用权限',
  Cargo_RemoveSelectedData: '移除选中数据',
  Cargo_RemoveSelectedExpense: '移除选中费用',
  Cargo_RenderStyle: '样式渲染',
  Cargo_Renew: '续签',
  Cargo_RenewContract: '续签合同',
  Cargo_ReOpen: '重开',
  Cargo_ReOpenedSuccessfully: '重开成功。',
  Cargo_RepeatedMaintenance: '重复维护',
  Cargo_ReplaceBill: '更换账单',
  Cargo_ReportTo: '汇报对象',
  Cargo_Reset: '重置',
  Cargo_ResetFilter: '重置条件',
  Cargo_Restore: '恢复',
  Cargo_RestoreSelectedClient: '是否确认恢复选择的客户',
  Cargo_RetreatASingle: '退单列表',
  Cargo_RetrievalFailureReturnFunction: '检索失败返回函数',
  Cargo_RetrievalFunction: '检索函数',
  Cargo_RetrievalType: '检索类型',
  Cargo_RetrievalTypeP: '检索类型:',
  Cargo_Retrieved: '已取回',
  Cargo_RetrievedButNotReturned: '已取回（未退还）',
  Cargo_RetrieveMark: '标记取回',
  Cargo_Return: '退回',
  Cargo_ReturnDate: '退还日期',
  Cargo_Returned: '已退还',
  Cargo_ReturnedSuccessfully: '退还成功。',
  Cargo_ReturnExpressNumber: '退还快递号',
  Cargo_ReturnOrderExpressNumber: '退单快递号',
  Cargo_ReturnQuery: '返回查询',
  Cargo_ReturnToSearch: '是否返回查询',
  Cargo_Revenue: '收入',
  Cargo_RevenueAndExpenditureType: '收支类型',
  Cargo_RevenueOrExpenditure: '收支',
  Cargo_Reverse: '确认红冲',
  Cargo_ReversedCloseAccountSuccessfully: '反结账成功',
  Cargo_CloseAccountSuccessfully: '结账成功',
  Cargo_ReverseReview: '反审核',
  Cargo_ReverseReviewedSuccessfully: '反审核成功',
  Cargo_ReviewCancelledSuccessfully: '取消审核成功。',
  Cargo_ReviewedOrNot: '是否已审核',
  Cargo_ReviewOverallSearch: '审核全局查询',
  Cargo_ReviewTime: '审核时间',
  Cargo_ReviewVoucher: '审核凭证',
  Cargo_Revoke: '撤销',
  Cargo_RevokeClaim: '撤销认领',
  Cargo_RevokedSuccessfully: '撤销成功。',
  Cargo_RevokeInvoicingApplication: '撤销开票申请',
  Cargo_RevokeOrNot: '是否撤销',
  Cargo_PushFailByCBMS: '推送失败,请联系工作人员排查',
  Cargo_PushSuccessByCBMS: '推送业务成功',
  Cargo_RevokeReview: '撤销审核',
  Cargo_RevokeSelection: '撤销选中',
  Cargo_RevokeWithdrawal: '撤销退单',
  Cargo_RevokeWithdrawalList: '撤销退单列表',
  Cargo_RevokingRetrievalFailed: '撤销取回失败。',
  Cargo_RFPNMIS: '账套中没有维护相应的财务期间。',
  Cargo_RITSS: '记录成功导入系统。',
  Cargo_RTGTEOMCACC: '重复操作金税导出可能会造成额外费用，是否确定要再次金税导出？',
  Cargo_RTIAFRODI: '如果不选择“同时删除费用确认单”，则将发票返回至开票申请审核中，否则删除发票和费用确认单',
  Cargo_RTPIRS: '已重置为开票申请审核中',
  Cargo_Rule: '规则',
  Cargo_SABID: '是否直接跳过填写基本信息',
  Cargo_SADNSUICAT: '当前科目没有设置辅助核算项。',
  Cargo_SailingDate: '开航日期',
  Cargo_SailingDay: '开船日期',
  Cargo_ETD: 'ETD',
  Cargo_ETA: 'ETA',
  Cargo_ATD: 'ATD',
  Cargo_ATA: 'ATA',
  Cargo_LookDetail: '查看详情',
  Cargo_Sales: '销售',
  Cargo_SalesP: '销售：',
  Cargo_SalesBranchCompany: '销售分公司',
  Cargo_SalesCommission: '销售提成',
  Cargo_SalesCompany: '销售公司',
  Cargo_SalesDepartment: '销售部门',
  Cargo_SalesFreeHand: '销售自拓',
  Cargo_Salesman: '业务员',
  Cargo_SalesmanP: '业务员:',
  Cargo_SalesParty: '销货方',
  Cargo_SalesPerson: '销售员',
  Cargo_SALOGROEI: '至少需要选择一个分组条件或者输入摘要名称。',
  Cargo_SameYear: '相同年',
  Cargo_SAPPMBI: '选择的实收/实付结算单位必须相同。',
  Cargo_Save: '保存',
  Cargo_SaveAll: '保存所有',
  Cargo_SaveAndAdd: '保存并新增',
  Cargo_SaveAndCalculateTotalAmount: '保存并且计算总金额',
  Cargo_SaveBill: '账单保存',
  Cargo_SaveCurrentSelection: '保存当前选中项',
  Cargo_CurrentSelection: '当前选中项',
  Cargo_Saved: '保存完成。',
  Cargo_SaveEditing: '保存编辑',
  Cargo_SaveEntity: '保存实体',
  Cargo_SaveExchangeRateToCache: '保存汇率到缓存',
  Cargo_SaveFailed: '保存失败。',
  Cargo_SaveGroupInfo: '保存分组信息',
  Cargo_SaveInvoice: '保存发票',
  Cargo_SaveInvoiceNo: '保存发票号',
  Cargo_SaveOrNot: '是否正大保存',
  Cargo_SaveQueryP: '保存查询参数',
  Cargo_SaveReconciliation: '保存对账',
  Cargo_SaveSucceed: '保存成功。',
  Cargo_Saving: '保存中',
  Cargo_SBRASPATFRD: '付款申请无需业务审核，直接提交至财务审核',
  Cargo_SBSPISB: '相同分公司按照结算对象进行汇总',
  Cargo_ScaleOfCompany: '公司规模',
  Cargo_ScaleOfCompanyEmployees: '公司规模/人',
  Cargo_SCNEIPMSL: '合作伙伴模块已存在名称相似的企业是否需要关联',
  Cargo_SCOCCSC: '销售提成操作提成客服提成',
  Cargo_SDNCCNTFL: '有对账单数据未加载完成，请点击下一步加载。',
  Cargo_SDNMBR: '账单状态不符合开票要求',
  Cargo_SDNMWOR: '账单状态不符合销账要求',
  Cargo_SeaportOfDischarge: '卸货港（海港）',
  Cargo_Search: '检索',
  Cargo_SearchAlreadyExisted: '查询已经存在',
  Cargo_SearchAPWriteOffs: '应付销账查询',
  Cargo_SearchARWriteOff: '应收销账查询',
  Cargo_SearchCompleted: '查询成功。',
  Cargo_SearchConditions: '查询条件',
  Cargo_SearchCreated: '已生成查询',
  Cargo_SearchDisplayColumn: '查询显示列',
  Cargo_SearchError: '查询出错。',
  Cargo_SearchForBill: '查询账单',
  Cargo_SearchForBusinessDeptApproved: '查询业务审批和部门审批的',
  Cargo_SearchForBusinessOfSameGroup: '查询同组人业务',
  Cargo_SearchForData: '查询数据',
  Cargo_SearchForDataAsPerPermission: '是否根据权限查询数据',
  Cargo_SearchForExpenses: '查询费用',
  Cargo_SearchForMore: '是否更多查询',
  Cargo_SearchForOverseasExpense: '是否查询海外费用',
  Cargo_SearchForParameterTemplateList: '查询参数模板列表',
  Cargo_SearchInformation: '查询信息',
  Cargo_SearchMark: '查询标记',
  Cargo_SearchOperation: '查询操作',
  Cargo_SecondNotifyParty: '第二通知人',
  Cargo_SecondVoyage: '船次',
  Cargo_SecureBusiness: '锁定业务',
  Cargo_SEFInput: '报关单证录入',
  Cargo_Select: '选择',
  Cargo_SelectAddPlatfoCNYLMethod: '平台提单方式选择添加',
  Cargo_SelectAddPlatformContainerType: '平台箱种选择添加',
  Cargo_SelectAddPlatformCurrency: '平台币种选择添加',
  Cargo_ShippingAddress: '配送地址',
  Cargo_AddModel: '机型维护',
  Cargo_maintenance: '集装器维护',
  cargo_container_type: '集装器类型',
  cargo_container_code: '集装器代码',
  cargo_container_number: '集装器编号',
  cargo_pallet: '包板',
  cargo_container_max_weight: '集装器可装货物重量',
  cargo_container_max_capacity: '集装器可装货物容量',
  cargo_loading_rate: '装载率',
  Cargo_Container_Type_Not_Configured: '您未维护集装器，可前往【基础数据-集装器】维护对应数据',
  cargo_please_enter_the_container: '请录入集装器',
  cargo_please_enter_the_container_code: '请录入集装器代码',
  cargo_Please_select_a_container: '请选择集装器',
  cargo_Charter_package_board_statistics: '包机包板统计',
  cargo_please_enter_the_cost: '请录入费用',
  Cargo_please_enter_flight_costs: '包机/包板航班，请录入航班成本。',
  Cargo_Please_enter_charter_details_or_flight_costs: '包板航班，请录入包板信息或航班成本。',
  cargo_can_only_be_dragged_under_a_container: '只能拖拽到集装器下',
  cargo_requires_dragging_across_containers: '需跨集装器拖动',
  cargo_not_allowed_reconfiguration: '正操作状态外其他业务不允许重新改配',
  Cargo_cross_flight_tips: '跨航班会关联新的集装器，并删除原有业务关联的所有集装器信息，请确认是否继续？',
  Cargo_CheckUldWeightOrCubage: '集装器代码：{0}货物{1}超出可装货物{2},请确认是否保存？',
  Cargo_master_reconfiguration_tips: '改配后，主票下所有的小票都关联到该集装器下，是否继续？',
  cargo_no_flight_information: '当前业务无航班，且目标位置也无航班信息，无需处理',
  cargo_unloaded_container_business: '未配载集装器业务',
  Cargo_SelectAddPlatformPackages: '平台包装选择添加',
  Cargo_SelectAddPlatformShippingTerms: '平台运输条款选择添加',
  Cargo_SelectAddPlatformTradeMethod: '平台贸易方式选择添加',
  Cargo_SelectAddPlatformTradeTerms: '平台贸易条款选择添加',
  Cargo_SelectAll: '全选',
  Cargo_SelectBusinessDateRange: '选择业务日期范围',
  Cargo_SelectCopyContent: '选择复制内容',
  Cargo_SelectCurrency: '选择币种',
  Cargo_Selected: '已选',
  Cargo_SelectedByDefault: '默认选中',
  Cargo_SelectedData: '选中的数据',
  Cargo_SelectedEntity: '已经选中的实体',
  Cargo_SelectedExpenseConfirmedExpense: '选择的费用确认过的费用',
  Cargo_SelectedInvoice: '选中的发票',
  Cargo_SelectedItems: '已选：{0}',
  Cargo_SelectedP: '已选:',
  Cargo_SelectedVoucher: '已选凭证',
  Cargo_SelectedVoucherCantOver100: '已选凭证{0}条，不能超过100条。',
  Cargo_SelectEventStatus: '请选择事件状态',
  Cargo_SelectEventToApprove: '请选择审批事项',
  Cargo_SelectFilesToDownload: '请选择需要下载的文件',
  Cargo_SelectInvoiceNo: '选择发票号',
  Cargo_SelectNewInvoiceNo: '选择新的发票号',
  Cargo_SelectOrAddInvoiceNo: '选择或填写发票号',
  Cargo_SelectPaperInvoiceByDefault: '默认选择纸质发票',
  CargoMsg_Information_Supplement: '信息补充',
  Cargo_SelectRecordsToExport: '请选择需要导出的记录',
  Cargo_SelectSalesPerson: '请选择销售',
  Cargo_SelectSalesPersonDep: '请选择销售部门',
  Cargo_SelectCsr: '请选择客服',
  Cargo_SelectCsrDep: '请选择客服部门',
  Cargo_SelectDoc: '请选择单证',
  Cargo_SelectDocDep: '请选择单证部门',
  Cargo_SoldSlots: '已售舱位',
  Cargo_RemainingSlots: '舱位余量',
  Cargo_SoldVolume: '已售体积',
  Cargo_RemainingVolume: '体积余量',
  Cargo_FlightDateError: '航班日期不在航线产品的有效期范围内，或者航班日期对应的航次不在航线产品维护的航次中，是否继续？',
  Cargo_SelectOverseaOp: '请选择海外客服',
  Cargo_SelectOverseaOpDep: '请选择海外客服部门',
  Cargo_SelectCargoSales: '请选择揽货销售',
  Cargo_SelectPlanner: '请选择航线负责人',
  Cargo_SelectPlannerDep: '请选择航线负责人部门',
  Cargo_invalidBatchModifyBusiness: '未找到操作分公司和销售分公司相同的业务，请重新选择后再试',
  Cargo_SelectSob: '选择账套',
  Cargo_SelectSubject: '请选择主题',
  Cargo_SelectToCopyInFutureDoNotAsk: '以后按本次选择复制无需再问',
  Cargo_SelectVoucherDate: '选择凭证日期',
  Cargo_SelfDeclaration: '自报关',
  Cargo_SelfDeclareToCustoms: '是否自己报关',
  Cargo_SelfDelivery: '自送',
  Cargo_SpecialApprovalIssuance: '特批放号',
  Cargo_CurrentAvailableQuantity: '当前可用数',
  Cargo_OccupiedBusinessNumber: '占用业务编号',
  Cargo_BlacklistedWithRemainingAllocation: '合作伙伴已拉黑，特批放号剩余可用额度：{0}个。',
  Cargo_SpecialApprovalCreateBusiness: '当结算对象超信控且配置了【不可保存】时，创建业务时可在放号数量中进行特批创建业务。',
  Cargo_CopyResult: '成功复制{0}条，失败复制{1}条',
  Cargo_SellingPrice: '卖价',
  Cargo_SellTitle: '销货单位',
  Cargo_Send2: '送出',
  Cargo_SendAll: '全部发送',
  Cargo_SendAllP: '是否全部发送',
  Cargo_SendBack: '退还',
  Cargo_SendConfirmationStatus: '发送确认状态',
  Cargo_SendFailed: '发送失败。',
  Cargo_SendingDate: '送出日期',
  Cargo_SendMessage: '发送消息',
  Cargo_SendPartial: '部分发送',
  Cargo_SendToBranchCompany: '发送分公司',
  Cargo_Sent: '已发送',
  Cargo_SentDate: '发送日期',
  Cargo_SeparateNumber: '分单号',
  Cargo_September: '9月',
  Cargo_SequenceNumber: '序号',
  Cargo_UNNumber: '联合国编号',
  Cargo_ChargeUnit: '计费单位/单位',
  Cargo_DangerousGoods: '危险品',
  Cargo_IndicatesRequired: '*号表示必填',
  Cargo_NewTo: '新增',
  Cargo_EditTo: '编辑',
  Cargo_AccountingPeriodRange: '请指定账期范围.',
  Cargo_SerialNoOfBankReceipt: '水单流水号',
  Cargo_AutoUpdateNote: '是否自动更新备注',
  Cargo_ConfirmBeforeEnable: '开启前请与技术团队确认，请勿随意开启',
  Cargo_MultiHeaderBankMode: '多抬头银行模式',
  Cargo_ServiceCodeCannotBeNull: '服务代码不能为空',
  Cargo_ServiceItems: '服务项目',
  Cargo_ServiceName: '服务名称',
  Cargo_AutoGenerateFeeName: '自动生成费用名称',
  Cargo_AutoGenerateTaxRate: '自动生成费用税率',
  Cargo_TaxNameRateConsistency: '税率费用名称和税率必须同时存在或同时为空',
  Cargo_AutoGenerateOrDefaultTaxExclusive: '自动生成费用税率和默认税率只能同时维护一个',
  Cargo_ServiceNameCanTBeEmpty: '服务名称不能为空',
  Cargo_ServiceRequestAddressForEInvoice: '电子发票服务请求地址',
  Cargo_ServiceTicket: '费用确认单',
  Cargo_ServiceTicketState: '确认单状态',
  Cargo_ServiceTicketCreatedOrNot: '是否已开费用确认单',
  Cargo_ServiceTicketIssued: '已开确认单',
  Cargo_SetAging: '设置账龄',
  Cargo_SetDefault: '设置默认',
  Cargo_SetDefaultItemDescription: '设置默认项目名称',
  Cargo_SetDefaultItemName: '是否默认项目名称',
  Cargo_SetFocusToFileNoTextTable: '设置焦点到文件编号文本框',
  Cargo_SetName: '设置名称',
  Cargo_SetsOfBooks: '账套',
  Cargo_SetsOfBooksP: '账套:',
  Cargo_SetText: '设置文本',
  Cargo_SettleAccountsTo: '结算对象',
  Cargo_SettleByMonthly: '按月结算',
  Cargo_SettleByWeekly: '按周结算',
  Cargo_SettlementAgent: '结算代理',
  Cargo_SettlementAgentError: '结算代理错误，请重新选择！',
  Cargo_SettlementByBill: '票结',
  Cargo_SettlementCompany: '结算单位',
  Cargo_SettlementMethod: '结算方式',
  Cargo_SettlementMethodP: '结算方式',
  Cargo_SettlementNotByBill: '非票结',
  Cargo_SettlementNotice: '结款通知',
  Cargo_SettlementPartyDoesNotExist: '结算对象不存在。',
  Cargo_SettlementStatus: '结款状态',
  Cargo_SettlementType: '结算类型',
  Cargo_DoNotSpecify: '不指定',
  Cargo_DomesticAndForeign: '国内/外',
  Cargo_CurrencyRequirements: '币种要求',
  Cargo_NotSpecified: '未指定',
  Cargo_Appoint: '指定',
  Cargo_PaymentInOriginalCurrency: '原币支付',
  Cargo_SettlingAgentInconsistent: '结算代理不一致。',
  Cargo_SettlingCompanyMustBeIdentical: '结算单位必须相同。',
  Cargo_SettlingCompanySAbbreviation: '结算单位(简称)',
  Cargo_SettlingCompanySCode: '结算单位(代码)',
  Cargo_SettlingPartyCanTBeEmpty: '结算对象不能为空。',
  Cargo_SettlingPartyIncompatible: '结算对象不统一。',
  Cargo_SettlingPartyInconsistent: '结算对象不一致。',
  Cargo_SettlingPartyOrSettlementAgentInconsistent: '结算对象或结算代理不一致',
  Cargo_SettlingPartyIsMandatory: '结算对象必须输入。',
  Cargo_SettlingPartyMustBeConsistent: '结算对象必须一致。',
  Cargo_ProjectNumberNotNull: '业务单号不能为空',
  Cargo_SettlingPartyOfPayables: '可付款结算单位',
  Cargo_SetToCurrentSob: '设为当前账套',
  Cargo_SetUpDefaultsInBatch: '批量设置默认',
  Cargo_SetUpServiceTypesInBatch: '批量设置服务类型',
  Cargo_SFEDOCSP: '查询当前结算对象费用明细',
  Cargo_CollectFeeType: '收费类型',
  Cargo_Shipper: '发货人',
  Cargo_ShipperId: '发货人代码',
  Cargo_ShipperInfo: '发货人信息',
  Cargo_ShipperSName: '发货人名称',
  Cargo_ShippingCompanyContractNo: '船公司约号',
  Cargo_ShippingCompanySAbbreviation: '船公司（简称）',
  Cargo_ShippingCompanySCode: '船公司（代码）',
  Cargo_ShippingInformation: '发运信息',
  Cargo_ShippingRouteArea: '航线/区域',
  Cargo_ShortAccountIs: '零头短账为：',
  Cargo_ShowDetailedTitles: '显示明细科目',
  Cargo_ShowAdjustRateEntry: '含期末调汇分录',
  Cargo_ShowDetails: '显示明细',
  Cargo_ShowedByVessel: '按船名显示',
  Cargo_ShowFromTo2: '到',
  Cargo_ShowInvoiceDetails: '显示发票明细',
  Cargo_ShowOpeningBalance: '显示期初余额',
  Cargo_ShowRows: '显示条数',
  Cargo_ShowStatementInformation: '显示对账单信息',
  Cargo_ShutOut: '已退关',
  Cargo_SIATEPIISOTT: '模板的的初始段每个人分配一个空间',
  Cargo_SignContract: '签单',
  Cargo_SingleBillPrinting: '单票打印',
  Cargo_SITCINCOSDHBFLBS: '共：{0}个对账单，当前是第：{1}个(保存时确保其他对账单数据加载完成)',
  Cargo_SiteVisit: '实地拜访',
  Cargo_Size: '尺寸',
  Cargo_SkipPreviousStep: '是否路过前面步骤',
  Cargo_SLNECTS: '红字通知单号未录入，是否继续保存？',
  Cargo_SoaConfirmed: '[{0}]对账单已确认。',
  Cargo_SoaCreated: '账单已做对账单',
  Cargo_SoaCreatedM: '[{0}]账单已做对账单',
  Cargo_SoaCreatedAlready: '账单已做过对账单。',
  Cargo_SoaNoAlreadyCreated: '已经创建过对账单号。',
  Cargo_SobCode: '账套代码',
  Cargo_SobCodeAlreadyExists: '账套代码已经存在。',
  Cargo_SobDataLoadingFailed: '账套数据加载失败。',
  Cargo_SobList: '账套列表',
  Cargo_SobName: '账套名称',
  Cargo_SobNameP: '账套名:',
  Cargo_SobSetup: '账套设置',
  Cargo_Soc: '货主箱',
  Cargo_IsSoc: '是否货主箱',
  Cargo_SoftwareVersion: '软件版本',
  Cargo_SolicitationType: '揽货类型',
  Cargo_SOSINTU: '更新选择发票号状态',
  Cargo_SOSINTUIU: '更新选择的发票号状态为已使用',
  Cargo_SourceOfClient: '客户来源',
  Cargo_SOWLC: '内装箱仓储',
  Cargo_Sp1: '发票联',
  Cargo_Sp17: '展开明细',
  Cargo_Sp18: '合并明细',
  Cargo_Sp24: '财务说明',
  Cargo_Sp27: '企业签章',
  Cargo_Sp31: '费用拆分',
  Cargo_SPABNCTBBE: '结算对象和业务编号不能都为空。',
  Cargo_Space2: '发票日期',
  Cargo_SPBNMNAL1SCR: '结算对象、业务编号、主单号、日期查询条件必须填写一个。',
  Cargo_SpecialApproval: '特批',
  Cargo_SpecialApprovalValidUntil: '特批有效期至',
  Cargo_BusinessExpirationDate: '业务到期日',
  Cargo_SpecialApprovalTip: '注：有效期为空时，特批长期有效。',
  Cargo_SpecialGoods: '产品有无特殊性',
  Cargo_SpecialInvoice: '专用发票',
  Cargo_SpecialInvoiceGeneralInvoice: '专用发票/普通发票',
  Cargo_SpecialInvoiceInternalInvoice: '专用发票/内部发票',
  Cargo_SpecialPrice: '特价',
  Cargo_SpecialPriceInstructions: '特价说明',
  Cargo_SpecifyCollectionPayment: '区别收付',
  Cargo_SPIANA: '结算对象不一致且没有归并关系。',
  Cargo_SPIANA_DiffSettlementAgent: '结算对象不一致且没有归并关系，结算代理也不一致。',
  Cargo_Split: '拆分',
  Cargo_SplitBillingFees: '拆分账单费用',
  Cargo_SplitBL: '拆单',
  Cargo_SplitExpense: '拆分费用',
  Cargo_SplitExpenseP: '拆分费用:',
  Cargo_SplitHBL: 'HBL拆单',
  Cargo_SplitMBL: 'MBL拆单',
  Cargo_SplitOldDataToNew: '拆分（老数据变新数据）',
  Cargo_SplitSuccessfully: '拆分成功',
  Cargo_SPNETRSC: '结算对象不存在，请重置缓存试试。',
  Cargo_SPWPWO: '待销账结算对象',
  Cargo_SSNMIR: '对账单状态不符合开票要求',
  Cargo_SSNMWOR: '对账单状态不符合销账要求',
  Cargo_SSSFPR: '保存成功是否提交预审状态',
  Cargo_STAEONRS: '运输条款已存在或未选择记录',
  Cargo_Staff: '职员',
  Cargo_StaffP: '职员:',
  Cargo_StampOfSalesUnit: '销货单位:(章)',
  Cargo_StartDateOfContainerReturn: '还柜起始日期',
  Cargo_StartDateOfFinancialPeriod: '财务期间起始日期',
  Cargo_StartingAccountTitle: '起始科目',
  Cargo_StartNo: '开始号码',
  Cargo_StartReconciliation: '手工对账',
  Cargo_StatementOfBalance: '往来余额表',
  Cargo_StatementOfBalance2: '往来余额表2',
  Cargo_Statistics: '统计',
  Cargo_StatisticsWithoutMblExpenses: '不统计主票费用',
  Cargo_Status: '状态',
  Cargo_StatusChanged: '状态改变',
  Cargo_StatusOfAdvanceReceipt: '预收款状态',
  Cargo_STCCOTB: '确定要取消确认这{0}个账单吗？',
  Cargo_STDTATM: '确认要删除此条科目映射吗？',
  Cargo_STDTATNRAD: '您确定要删除该科目吗？删除后不可恢复！',
  Cargo_STDTPA: '确认要删除这些付款申请吗？',
  Cargo_STWTPA: '确认要撤回这些付款申请吗？',
  Cargo_STDTSPT: '你确定要删除此查询参数模板吗',
  Cargo_STDTSRRAVWBDT: '确定要删除账套吗？账套所关联的规则和凭证也会被删除。',
  Cargo_STDTSVRJEWBDT: '确定要删除选中的这条凭证吗？其所关联的凭证分录也被会被删除。',
  Cargo_STDTSVRJEWBDTM: '确定要删除选中的这{0}条凭证吗？其所关联的凭证分录也被会被删除。',
  Cargo_STDTVGR: '确认要删除此凭证分组规则吗？',
  Cargo_STOAOWO: '显示未销金额总计',
  Cargo_Storage: '仓储',
  Cargo_SendToEachRecipientSeparately: '单独发送到每个收件人',
  Cargo_SyncSendCCAddress: '同步发送抄送地址',
  Cargo_SearchForTheDataYouWantToInsert: '搜索您要插入的数据',
  Cargo_StorageRequired: '是否仓储',
  Cargo_STRAEAAWORWBRC: '确定要撤销吗？所有的调整费用和销账记录会被重置。',
  Cargo_StreetAddress: '详细街道地址',
  Cargo_StreetAddressCanTBeEmpty: '详细街道地址不能为空',
  Cargo_STRTWOREAIIWBR: '确定要撤销这次销账操作吗？相应的费用和发票信息会重置。',
  Cargo_Stuff: '填充',
  Cargo_STWBTSV: '确定要红冲选中的这{0}条凭证吗？',
  Cargo_SubCategoryOfAccountTitle: '科目子类',
  Cargo_Submit: '提交',
  Cargo_SubmitExpenseForReviewDirectly: '是否直接提交审核费用',
  Cargo_SubmitPaymentNotice: '提交付款通知',
  Cargo_SubmitStatusSelection: '提交状态选择',
  Cargo_Submitted: '已提交',
  Cargo_SubmittedForPreReviewStatus: '是否提交预审状态',
  Cargo_SubmittedSuccessfully: '提交成功。',
  Cargo_SpecialFeeLimitReleaseApply: '专项费用限制解除申请',
  Cargo_SpecialFeeLimitReleaseApplyContent: '{0}申请解除专项费用限制',
  Cargo_SpecialFeeLimitReleaseApplyContentPlain: '申请解除专项费用限制',
  Cargo_ReleaseDocumentNumberApplication: '放单/放号申请',
  Cargo_ReleaseNumberDocument: '放号/放单',
  Cargo_IsPaymentReceived: '是否收款',
  Cargo_PaymentTime2: '收款时间',
  Cargo_ReleaseNumberQuantity: '放号数量',
  Cargo_RelatedAttachments: '相关附件',
  Cargo_ReleaseNumber: '放号',
  Cargo_ReleaseDocument: '放单',
  Cargo_RemainingTemporaryReleaseQuantity: '剩余临时放号数量',
  Cargo_TemporaryDocumentReleaseApplication: '临时放单申请',
  Cargo_TemporaryNumberReleaseApplication: '临时放号申请',
  Cargo_SubscribePOL: '起运地',
  Cargo_SubsidiaryAccounting: '辅助核算',
  Cargo_SubsidiaryAccountingClient: '辅助核算客户',
  Cargo_SubsidiaryAccountingCondition1: '辅助核算条件一',
  Cargo_SubsidiaryAccountingCondition2: '辅助核算条件二',
  Cargo_SubsidiaryAccountingCondition3: '辅助核算条件三',
  Cargo_SubsidiaryAccountingCondition4: '辅助核算条件四',
  Cargo_SubsidiaryAccountingCondition5: '辅助核算条件五',
  Cargo_SubsidiaryAccountingCondition6: '辅助核算条件六',
  Cargo_SubsidiaryAccountingItems: '辅助核算项目',
  Cargo_SubsidiaryAccountingStaff: '辅助核算职员',
  Cargo_SubsidiaryLedger: '明细账',
  Cargo_SubsidiaryLedger2: '明细账2',
  Cargo_SubtitlesOfAccount: '子科目',
  Cargo_SubTotal: '小计',
  Cargo_SubTotalOfOpeningBalance: '期初余额小计',
  Cargo_Success: '成功',
  Cargo_SummarizeDistributionExpense: '是否统计分摊费用',
  Cargo_SummarizeMblExpense: '是否统计主票费用',
  Cargo_SupervisionMethod: '监管方式',
  Cargo_SupplierContract: '供应商合同',
  Cargo_Surcharge: '附加费',
  Cargo_Controlled: '受控项',
  Cargo_NeedInvoice: '需要开票项',
  Cargo_SurchargeOrNot: '是否附加费',
  Cargo_SureToAddToBlackList: '确定要加入黑名单吗',
  Cargo_SureToBatchConfirmTheBill: '确定要批量确认这{0}个账单吗？',
  Cargo_SureToBatchReviewTheExpense: '确定要批量审核这{0}条费用吗？',
  Cargo_SureToCancel: '确定要取消吗？',
  Cargo_SureToCancelConfirmation: '确定要取消确认吗？',
  Cargo_SureToCancelConfirmationYes: '确定要取消确认吗确认',
  Cargo_SureToCancelReviewOfTheExpense: '确定要取消审核这{0}条费用吗？',
  Cargo_SureToCancelReviewOfTheVoucher: '确认要取消审核这{0}条凭证吗',
  Cargo_SureToCancelReviewOfTheExpenseCheck: '所选费用存在{0} <br/>',
  Cargo_Billinged: '已生成账单',
  Cargo_WriteOffed: '已核销',
  Cargo_SureToCancelVerification: '确定取消审核吗？',
  Cargo_SureToCarryOver: '您确认进行结转操作吗？',
  Cargo_SureToConfirmWriteOffRecord: '确定要确认核销记录吗？',
  Cargo_SureToCreateInvoice: '确定生成发票吗？',
  Cargo_SureToCreateListOfCombinedBills: '确定生成并票清单吗？',
  Cargo_SureToDelete: '你确认要删除吗？',
  Cargo_SureToDeleteWarehouse: '删除后将清除所有进仓信息，是否继续？',
  Cargo_SureToDeleteInvoice: '确定删除发票吗？',
  Cargo_SureToDeleteSelectedRecord: '确定删除选中的记录吗',
  Cargo_SureToDeleteTheAbstractRule: '确定要删除这条摘要规则吗？',
  Cargo_SureToDeleteTheAdvanceReceipt: '确定要删除这条预收款吗？',
  Cargo_SureToDeleteTheBill: '确定删除这{0}条账单吗？',
  Cargo_SureToDeleteTheExchangeRate: '确认要删除此条汇率吗？',
  Cargo_SureToDeleteTheInvoice: '确定要删除这{0}张发票吗',
  Cargo_SureToDeleteTheMapping: '确认要删除这条映射吗？',
  Cargo_SureToDeleteTheRecord: '确定要删除这条记录吗？',
  Cargo_SureToDeleteTheRule: '确认要删除这个规则吗？',
  Cargo_SureToDeleteThisSoaItem: '确定删除这{0}条对账单吗？',
  Cargo_SureToDeliverToBranch: '确认要发送分公司吗？',
  Cargo_SureToDeny: '确定要拒绝吗？',
  Cargo_SureToFreezeApplication: '确定要冻结申请吗？',
  Cargo_SureToHoldSubmission: '确定暂不提交吗',
  Cargo_SureToIssueCombinedInvoice: '确定合并开票吗？',
  Cargo_SureToModifyBillingDate: '确定要修改账单日期吗？',
  Cargo_SureToPrint: '你确定要打印吗？',
  Cargo_SureToPrintDetailList: '确定打印明细清单吗？',
  Cargo_SureToReIssueInvoice: '确定要重新开票吗？',
  Cargo_SureToRejectIt: '确定拒绝吗？',
  Cargo_SureToRejectTheExpenseItem: '确定要驳回这{0}条费用吗？',
  Cargo_SureToRemoveTheBill: '确认要移除这{0}个账单吗？',
  Cargo_SureToRemoveTheExpenseItem: '确认要移除这{0}条费用吗？',
  Cargo_SureToReturnApplication: '确定要退还申请吗？',
  Cargo_SureToReviewTheBills: '确定审核这些单子吗？',
  Cargo_SureToReviewTheVoucher: '确认要审核这{0}条凭证吗？',
  Cargo_SureToRevokeContractWith: '是否确认撤销与****的***该笔合同',
  Cargo_SureToRevokeRetrieval: '确定撤销取回吗？',
  Cargo_SureToRevokeWithdrawal: '确定撤销退单吗？',
  Cargo_SureToVoid: '确定要作废吗？',
  Cargo_SureToVoidInvoice: '确定要作废发票吗？',
  Cargo_SureToVoidTheInvoice: '确定要作废这张发票吗？',
  Cargo_SureToVoidTheInvoiceM: '确定要作废这{0}张发票吗？',
  Cargo_SUSBODNMWBACTS: '销货单位开户行与银行账号不匹配，确认要保存吗？',
  Cargo_SUSBODNMWRISCTS: '销货单位银行账号与系统中维护的不匹配，确认要保存吗？',
  Cargo_SUTCPALVIBC: '结账前先设置结转损益凭证信息',
  Cargo_SVSFPHBC: '当前选择的凭证日期所属财务期间已结账。',
  Cargo_SVSMHBC: '当前选择的凭证，所属月份已结账。',
  Cargo_SWDE: '不统计分摊费用',
  Cargo_Switch: '切换',
  Cargo_SwitchBasisToAcquireDocument: '切换根据获取单证',
  Cargo_SwitchCurrency: '切换币种',
  Cargo_SwitchFile: '切换文件',
  Cargo_SwitchInvoice: '切换发票',
  Cargo_SwitchMethodOfClaim: '切换认领模式',
  Cargo_SwitchSob: '切换账套',
  Cargo_Symbol: '符号',
  Cargo_SynchronousCodingPartners: '同步客商编码',
  Cargo_SystemAlertForPayment: '系统催账',
  Cargo_SystemBusy: '系统繁忙',
  Cargo_SystemBusyPRL: '系统繁忙，请稍后重试。',
  Cargo_TableFilter: '表格过滤',
  Cargo_TakeByCustomsBroker: '报关行自取',
  Cargo_TAOPLFESAMBETCWOA: '金额+汇总损益+财务费用+零头短账必须等于本次核销金额。',
  Cargo_TAOPLFESAMBETCWOANoFinance: '金额+汇总损益+零头短账必须等于本次核销金额。',
  Cargo_TAOPLFESAMBETCWOAPC: '金额+汇总损益+财务费用+零头短账必须等于本次核销金额，请检查。',
  Cargo_TAPBACTBLTARAWIETIAP: '收支类型为应付时，应付账单总金额不能小于应收账单总金额。',
  Cargo_Tax: '税金',
  Cargo_TaxAmount: '税额',
  Cargo_TaxAmountP: '税额:',
  Cargo_TaxationNbr: '税务登记号',
  Cargo_TaxExcludedPrice: '不含税价',
  Cargo_TaxExcludedPriceP: '不含税价:',
  Cargo_TaxFreeAmount: '不含税金额',
  Cargo_TaxIncludedPrice: '含税价',
  Cargo_TaxIncludedPriceP: '含税价:',
  Cargo_TaxpayerAuthorizationCode: '纳税人授权码',
  Cargo_TaxRate: '税率',
  Cargo_TaxRateNotNull: '请填写税率',
  Cargo_TaxRateP: '税率:',
  Cargo_TaxRatePct: '税率(%)',
  Cargo_TBTRS: '转回对账成功。',
  Cargo_TDCBODNBTTCBOTULBC: '正操作的数据所在分公司不属于当前分公司或上一级分公司。您确定要继续吗',
  Cargo_TeamLeader: '组长',
  Cargo_TeamLeaderAssignment: '组长分配',
  Cargo_Tel: '电话',
  Cargo_TelexReleaseApplicant: '电放申请人',
  Cargo_TelexReleaseApplicationDate: '电放申请时间',
  Cargo_TelexReleaseFee: '电放费',
  Cargo_TelexReleaseMaterial: '电放资料',
  Cargo_TelexReleaseNo: '电放号',
  Cargo_ExpenseBoxNo: '费用箱号',
  Cargo_TemplateDownload: '模板下载',
  Cargo_TemplateDownloadFailed: '模块加载失败。',
  Cargo_TenDigitCode: '十位码',
  Cargo_TenThousandYuan: '万元',
  Cargo_TEYAPHBMBSEC: '您所操作的费用已经被其它人修改，是否要继续操作？',
  Cargo_TFCFDTECNIPSDOACS: '因在合作伙伴中已经存在以下编号的客户未成功签单而其余客户成功签单',
  Cargo_TFOTPCTBCWOP: '期间的时间范围不能与其它期间时间范围交叉。',
  Cargo_TFSIIUDNA: '以下站点已被业务使用，不允许删除',
  Cargo_The1StInvoiceNoCanTBeEmpty: '第一张发票号不能为空。',
  Cargo_TheAmountOfWrittenOff: '已销金额',
  Cargo_TheExpenseNotBoundToInvoice: '该费用没有绑定发票。',
  Cargo_TheLast: '最后一张',
  Cargo_TheLastPage: '上一张',
  Cargo_TheNextPage: '下一张',
  Cargo_TheOppositeSideAccount: '对方账号',
  Cargo_TheOppositeSideBank: '对方银行',
  Cargo_TheOppositeSideCompany: '对方单位',
  Cargo_TheOppositeSideInvoiceNo: '对方发票号',
  Cargo_ThisFeeHasBeenInvoiced: '该费用已经开票不能拆分！',
  Cargo_ThisFeeHasBeenWrittenOff: '该费用已经核销不能拆分！',
  Cargo_ThisTimeBalance: '本次余额',
  Cargo_ThisTimeWriteOff: '本次核销',
  Cargo_ThisTimeWriteOffEq: '本次核销=收款金额+汇总损益+财务费用+零头短账',
  Cargo_ThisWriteOffNoIs: '本次销账流水号为:',
  Cargo_TIBYEIB: '您录入的初始余额平衡',
  Cargo_TIBYEIUPDCTBSAIS: '您录入的初始余额不平衡，请仔细核对「资产负债表」与「利润表」',
  Cargo_Time: '时间',
  Cargo_TimeFrame: '时间范围',
  Cargo_TimeOfCargoHolding: '扣货时间',
  Cargo_TimeOfDocHolding: '扣单时间',
  Cargo_TimeOfPurchase: '购买时间',
  Cargo_TimeOfPurchaseCanTBeEmpty: '购买时间不能为空',
  Cargo_TimeOfUse: '使用时间',
  Cargo_TimeOfUseCanTBeEmpty: '使用时间不能为空。',
  Cargo_Tips: '提示',
  Cargo_PleaseSelectTheSailingScheduleBelow: '请选择如下的船期',
  Cargo_ChooseShippingSchedulesTips1: '1.请选择对应的船期信息。若是不做选择，会存在无法获取船期相关的计划离靠泊时间、开截港时间、实际离靠泊时间',
  Cargo_ChooseShippingSchedulesTips2: '2.若是您时还无法确认船期，可以点击[暂不选择] 按钮，等确认后点击[选择船期]按钮来选择船期',
  Cargo_MoreShippingSchedulesTips: '港区返回多个码头的船期,会影响船期信息显示以及推送,请选择您想要的船期信息',
  Cargo_ChooseShippingSchedules: '选择船期',
  Cargo_NoSelectYet: '暂不选择',
  Cargo_ChangePayment: '修改付款申请',
  Cargo_PaymentTimeLimit: '付款期限',
  Cargo_Title: '标题',
  Cargo_TitleOfAccount: '会计科目',
  Cargo_TLOOSE: '负债和所有者权益或股东权益总计',
  Cargo_TMAEONRS: '贸易方式已存在或未选择记录',
  Cargo_To: '至',
  Cargo_FROM: '起',
  Cargo_ToDetermineIfEditableWhenViewing: '为了判断查看时是否可编辑',
  Cargo_TOEIAADFIA: '费用项目金额总和与发票金额不相同。',
  Cargo_ChargeAmountCannotExceedInvoiceAmount: '费用项目金额不能大于发票金额',
  Cargo_ChargeAlreadyAssociatedInvoice: '{0}费用已关联发票',
  Cargo_TORFRS: '共查询到{0}条记录，选择了{1}条记录',
  Cargo_Total0: '总数:{0}',
  Cargo_TotalAmount: '合计金额',
  Cargo_TotalAmountNotWrittenOff: '未销金额合计',
  Cargo_TotalAmountOfCurrentPeriod: '本期合计',
  Cargo_TotalAmountPJ: '合计金额-',
  Cargo_TotalAmountP: '金额合计：',
  Cargo_TotalAmountToWriteOff: '可销金额总计',
  Cargo_TotalAPAmount: '应付费用合计',
  Cargo_TotalARAmount: '应收费用合计',
  Cargo_TotalBalance: '总余额',
  Cargo_TotalCommissionAmount: '提成金额合计',
  Cargo_TotalCommissionAmountP: '提成金额合计：',
  Cargo_TotalCost: '总成本',
  Cargo_TotalCurrency: '分币种合计',
  Cargo_TotalCurrentLiabilities: '流动负债合计',
  Cargo_TotalIncome: '总收入',
  Cargo_TotalLiabilities: '负债合计',
  Cargo_TotalNonCurrentAssets: '非流动资产合计',
  Cargo_TotalNonCurrentLiabilities: '非流动负债合计',
  Cargo_TotalOfVouchersEntered: '共录入凭证{0}张',
  Cargo_TotalOutstandingAmountByCurrency: '未销分币种合计',
  Cargo_TotalPriceWithTaxInWords: '价税合计(大写)',
  Cargo_TotalProfit: '利润总计',
  Cargo_TotalRevenue: '收入总计',
  Cargo_TotalWriteOffAmount: '核销总金额',
  Cargo_Choose: '选中',
  Cargo_TotalWriteOffs: '核销总计',
  Cargo_TotalWriteOffsP: '核销总计  Credit:',
  Cargo_TPOPNOINOE: '利润总额营业利润营业外收入营业外支出',
  Cargo_TPTODIDDYCTMAGV: '支付类型或收付方式不同，是否要合并生成凭证？',
  Cargo_TradeTerm: '贸易方式',
  Cargo_TradeTerms: '成交条款',
  Cargo_TradeTermsMaintenance: '贸易条款维护',
  Cargo_TradeType: '贸易类型',
  Cargo_TradingCompany: '贸易公司',
  Cargo_Transfer: '转',
  Cargo_TransferAllToReconciliation: '全部转回对账',
  Cargo_TransferBackAmount: '转回金额',
  Cargo_TransferBackGrandTotal: '转回合计金额',
  Cargo_TransferBackToReconciliation: '转回对账',
  Cargo_TransferCash: '转账现金',
  Cargo_TransferExpense: '转移费用',
  Cargo_TransferIntoCollection: '转入托收',
  Cargo_TransferOutToCollection: '转出托收',
  Cargo_TransferPort: '中转港',
  Cargo_TransferToCNY: '转CNY',
  Cargo_TransitPortSea: '中转港（海港）',
  Cargo_TransitTerm: '运输条款',
  Cargo_Transportation: '运输',
  Cargo_TRAYEINR: '您输入的对账金额不合理！',
  Cargo_TRFRBLFDAF: '电放费异地放单费改单费',
  Cargo_TrialBalance: '试算平衡',
  Cargo_TrialBalanceCheck: '试算平衡检查',
  Cargo_TRNAPUCWOFISI: '不能全部撤销，请使用查询界面中的取消销账功能。',
  Cargo_TruckCompany: '卡车公司',
  Cargo_TruckingCompany: '运输公司',
  Cargo_TSASOBMBTS: '账单的结算代理必须相同！',
  Cargo_TSBADNCTCC: '所选银行账号不包含此币种，继续?',
  Cargo_TTAEONRS: '贸易条款已存在或未选择记录',
  Cargo_TTOAFNTCCPM: '科目只核算:{0}，不核算当前币别:{1}，请修改',
  Cargo_TUPAOTPALVCBE: '损益凭证未分配利润科目不能为空',
  Cargo_TWORHBRCC: '此销账记录已红冲，不允许撤销。',
  Cargo_Type: '类型',
  Cargo_MaximumTakeOffWeight: '最大起飞重量',
  Cargo_Charter_Flights_Tips: '如为包机/包板‘如为包机包板航班，可在此维护航班成本',
  Cargo_Charter_package_board: '包机/包板',
  Cargo_Board_Tips: '包板业务用于后续的容载率及利润分析',
  Cargo_Flight_costs: '航班成本',
  Cargo_NumberOfCartridges: '集装器数',
  Cargo_Please_Select_The_Model_You_Want_To_Edit: '请选中需要编辑的机型',
  Cargo_Please_Select_The_Model_To_Be_Deleted: '请勾选需要删除的机型',
  Cargo_Please_Select_The_Uld_You_Want_To_Edit: '请选中需要编辑的集装器',
  Cargo_Please_Select_The_Uld_To_Be_Deleted: '请勾选需要删除的集装器',
  Cargo_WeightRestrictions: '重量限制',
  Cargo_VolumeLimit: '体积限制',
  Cargo_LoadableCapacity: '可装货容量',
  Cargo_LoadableWeight: '可装货重量',
  Cargo_DeadWeight: '自重',
  Cargo_LSize: '尺寸（长）',
  Cargo_WSize: '尺寸（宽）',
  Cargo_HSize: '尺寸（高）',
  Cargo_ApplicableModels: '适用机型',
  Cargo_ApplicableContainerType: '集装器类型',
  Cargo_ApplicableContainerCode: '集装器代码',
  Cargo_ApplicableContainerNumber: '集装器编号',
  Cargo_CharterPack: '包机/包板',
  Cargo_TypeOfBill: '票据类型',
  Cargo_TypeOfGoods: '货物种类',
  Cargo_TypeOfPort: '港口类型',
  Cargo_UBEIRPSMB: '记录中存在未标记的账单，请选择已标记的账单',
  Cargo_UCOVEIIDPCTD: '当前导入的数据存在客户或者供应商在系统中未维护，请点击下载。',
  Cargo_Unbilled: '未开账单',
  Cargo_Uncommitted: '未提交',
  Cargo_Unconfirmed: '未确认',
  Cargo_UnderConfirmation: '确认中',
  Cargo_UnfrozenSuccessfully: '解冻成功。',
  Cargo_UnInvoiced: '未开发票',
  Cargo_Unissued: '未发布',
  Cargo_UnissuedServiceTicket: '未开确认单',
  Cargo_Unit: '单位',
  Cargo_UnitOfMeasurement: '计量单位',
  Cargo_UnitOfPaymentPeriod: '账期单位',
  Cargo_UnitPrice: '单价',
  Cargo_UnitPriceP: '单价:',
  Cargo_Unknown: '未知',
  Cargo_UnKnownStatus: '状态未知',
  Cargo_Unlimited: '不限',
  Cargo_Unpaid: '未付款',
  Cargo_UnpaidClear: '未付清',
  Cargo_UnpaidCNY: 'CNY未付',
  Cargo_UnpaidEUR: 'EUR未付',
  Cargo_UnpaidGBP: 'GBP未付',
  Cargo_UnpaidHKD: 'HKD未付',
  Cargo_UnpaidJPY: 'JPY未付',
  Cargo_UnpaidNGN: 'NGN未付',
  Cargo_UnpaidP: '未付:',
  Cargo_SimpleUnpaidP: '未付',
  Cargo_UnpaidUSD: 'USD未付',
  Cargo_ReceivedP: '已收',
  Cargo_PaidP: '已付',
  Cargo_EmptyValue: '空',
  Cargo_UnsavedNewExpenseCanTBeSplit: '不能拆分新增未保存的费用！',
  Cargo_UpdateBar: '更新条',
  Cargo_UpdateBusinessDate: '修改业务日期',
  Cargo_UpdatedSuccessfully: '更新成功。',
  Cargo_UpdateFailed: '更新失败。',
  Cargo_UpdatePageDisplay: '更新页面显示',
  Cargo_UpdatePrintButtonStatus: '更新打印按钮状态',
  Cargo_Upload: '上传',
  Cargo_UploadAttachment: '上传附件',
  Cargo_DeleteAttachment: '删除附件',
  Cargo_UploadContract: '合同上传',
  Cargo_UploadContractAttachments: '上传合同附件',
  Cargo_UploadData: '数据上传',
  Cargo_URVUTSWBRIKC: '该账套下未审核的凭证将通过金蝶Cloud审核，确定要继续吗？',
  Cargo_USD: '美金',
  Cargo_USDAmount: '美元',
  Cargo_USDExchangeRate: '美元汇率',
  Cargo_USDInvoiceNo: '美元发票号',
  Cargo_USDP: '美元:',
  Cargo_Use: '使用',
  Cargo_Used: '已使用',
  Cargo_UseGroupExchangeRate: '使用集团汇率',
  Cargo_UseOriginalTemporarily: '临时用本来',
  Cargo_User: '用户',
  Cargo_UserCanTBeEmpty: '使用人不能为空。',
  Cargo_UseShouldBeTemporarily: '这里暂时用应该是',
  Cargo_ValidityOfInvoice: '发票是否有效',
  Cargo_Value: '值',
  Cargo_VatGeneralInvoice: '增值税普通发票',
  Cargo_VatInvoice: '增值税发票',
  Cargo_VatInvoiceIssuingMachineNo: '增值税发票开票机号',
  Cargo_VatSpecialInvoice: '增值税专用发票',
  Cargo_Vendor: '供应商',
  Cargo_VendorCantBeEmpty: '供应商不能为空',
  Cargo_VendorClient: '供应商客户',
  Cargo_VendorModification: '供应商修改',
  Cargo_VendorP: '供应商:',
  Cargo_VendorSInvoiceNo: '供应商发票号',
  Cargo_VerificationCancelled: '已取消审核',
  Cargo_VerificationPassed: '是否通过审核',
  Cargo_VerificationRejected: '审核拒绝',
  Cargo_VerifiedSuccessfullyClickToSave: '验证成功，点击保存。',
  Cargo_VerifiedSuccessfullyClickToExport: '验证成功，点击导出。',
  Cargo_Verify: '验证',
  Cargo_VerifyARAPExpense: '应收应付费用验证',
  Cargo_VerifyInvoiceNo: '验证发票号',
  Cargo_VerifyJournalEntry: '验证分录',
  Cargo_VesselAndVoyage: '船名/航次',
  Cargo_VesselVoyageFlight: '船名航次航班',
  Cargo_VGIVSI: '增值税普通发票增值税专用发票',
  Cargo_VHBCFSACCTBC: '辅助核算【客户】已生成凭证，不能取消。',
  Cargo_VHBCFSADCTBC: '辅助核算【部门】已生成凭证，不能取消。',
  Cargo_VHBCFSAICTBC: '辅助核算【项目】已生成凭证，不能取消。',
  Cargo_VHBCFSASCTBC: '辅助核算【职员】已生成凭证，不能取消。',
  Cargo_VHBCFSAVCTBC: '辅助核算【供应商】已生成凭证，不能取消。',
  Cargo_ASCCCTBC: '已发公司确认，不能取消。',
  Cargo_VHBEFCWOWBRWBCITWORSTWB: '此核销记录已经导出过财务凭证，如果撤销核销系统将生成红冲记录，确认红冲吗？',
  Cargo_View: '查看',
  Cargo_ViewAllBusiness: '查看所有业务',
  Cargo_ViewAllExpenses: '查看全部的费用',
  Cargo_ViewBill: '查看账单',
  Cargo_ViewBusinessOfSameGroup: '查看同组业务',
  Cargo_ViewDetail: '查看明细',
  Cargo_ViewDetails: '查看详细',
  Cargo_ViewDetailsOfRemovals: '查看移除明细',
  Cargo_ViewedByFee: '按费用查看',
  Cargo_ViewedByJob: '按业务查看',
  Cargo_ViewExpensesOfSameGroup: '查看同组的费用',
  Cargo_ViewFile: '查看文件',
  Cargo_ViewInvoice: '查看发票',
  Cargo_ViewSelfBusiness: '查看自己业务',
  Cargo_ViewSoa: '查看对账单',
  Cargo_ViewUploadedDeclarationDocInfo: '查看上传报关文件信息',
  Cargo_ViewVoucher: '查看凭证',
  Cargo_ViolationOfUniquenessConstraint: '违反唯一性约束',
  Cargo_VOCMEICSR: '当前选择的记录包含了已结账月份的凭证。',
  Cargo_VoidCompleted: '完成作废。',
  Cargo_Voided: '已作废',
  Cargo_VoidedBy: '作废人',
  Cargo_VoidedInvoice: '作废发票',
  Cargo_VoidedInvoiceNo: '作废发票号',
  Cargo_VoidedInvoiceNoP: '已作废发票号码:',
  Cargo_VoidedSuccessfully: '作废成功。',
  Cargo_VoidStatus: '作废状态',
  Cargo_VoidTime: '作废时间',
  Cargo_AssociatedExpenseID: '关联费用ID',
  Cargo_ChargeID: '费用ID',
  Cargo_VOPLCOCTBD: '结转损益凭证无法删除。',
  Cargo_StateDeleteError: '已成功导入凭证系统，不可删除',
  Cargo_VoucherAbstract: '凭证摘要',
  Cargo_VoucherCannotBeEmpty: '凭证不能为空！',
  Cargo_VoucherCreatedOrNot: '是否已经生成过凭证',
  Cargo_VoucherCreatedSuccessfully: '成功生成{0}条凭证',
  Cargo_VoucherDateCanTBeEmpty: '凭证日期不能为空',
  Cargo_VoucherEntryCanTBeEmpty: '凭证分录不能为空。',
  Cargo_VoucherGroupingRule: '凭证分组规则',
  Cargo_VoucherGroupingType: '凭证分组类型',
  Cargo_VoucherGroupingTypeP: '凭证分组类型:',
  Cargo_VoucherLetter: '凭证字',
  Cargo_VoucherLetterCanTBeEmpty: '凭证字不能为空',
  Cargo_VoucherLetterNo: '凭证字号',
  Cargo_VoucherLetterP: '凭证字:',
  Cargo_VoucherList: '凭证列表',
  Cargo_VoucherMonth: '凭证月',
  Cargo_VoucherNo: '凭证号',
  Cargo_VoucherNoCanTBeEmpty: '凭证号不能为空',
  Cargo_VoucherNoP: '凭证号:',
  Cargo_VoucherNotCreatedCreateItNow: '未生成凭证，是否生成凭证？',
  Cargo_VoucherOfAdvance: '预收付凭证',
  Cargo_VoucherPeriod: '凭证期间',
  Cargo_VoucherPeriodCanTBeEmpty: '凭证期间不能为空',
  Cargo_VoucherRule: '凭证规则',
  Cargo_VoucherSearch: '凭证查询',
  Cargo_VoucherStatus: '凭证状态',
  Cargo_VoucherType: '凭证类型',
  Cargo_VoyageFlight: '航次/航班',
  Cargo_VoyageNo: '航次',
  Cargo_VRDBR: '查看移除明细按对账',
  Cargo_VSRAOGTEPAEIADPERAPIT: '金税导出纸质发票、电子发票的校验及服务请求地址不同，请根据发票种类分别导出。',
  Cargo_Warehouse: '仓库',
  Cargo_WarehouseDoor: '仓储/门点',
  Cargo_WarehouseLoading: '仓库内装',
  Cargo_WarehouseLoadingStorage: '内装箱/仓储',
  Cargo_WarehouseNo: '进仓编号',
  Cargo_WBOWBVCTBD: '红冲凭证或被红冲凭证不能删除。',
  Cargo_WBOWBVCTBWB: '红冲凭证或被红冲凭证不能红冲。',
  Cargo_REVERSE: '红冲凭证成功。',
  Cargo_WCDCOVCWBDBOSRCCWBIDDRWNOPC: '勾选后，本次查询将按照查到的结果显示不同币种的详细列，忽略自定义的设置。 动态显示的结果不会覆盖原有的配置。',
  Cargo_WDPCCS: '数据有误，请联系客服。',
  Cargo_Wechat: '微信',
  Cargo_Week: '周',
  Cargo_Weight: '重量',
  Cargo_WHCode: '进舱编号',
  Cargo_WhetherOrNotBroken: '是否破损',
  Cargo_WipeOut: '忽略零头',
  Cargo_WithdrawalAddress: '退单地址',
  Cargo_WithdrawalListOfLinkedConsignors: '关联委托单位退单列表',
  Cargo_WithdrawExpense: '抽取费用',
  Cargo_WONCPPC: '销账号确认付款流程已经走完',
  Cargo_WORIPCPARO: '销账记录不正确，请关闭页面重新打开',
  Cargo_WorkSetAfterSearch: '查询后的工作集',
  Cargo_WriteBack: '红冲',
  Cargo_WriteBackVoucher: '红冲凭证',
  Cargo_WriteOff: '销账',
  Cargo_WriteOffAll: '全部核销',
  Cargo_WriteOffAllP: '是否全部核销',
  Cargo_WriteOffAmount: '销账金额',
  Cargo_WriteOffAmountCNY: 'CNY销账金额',
  Cargo_WriteOffAmountIs: '销账金额为：',
  Cargo_WriteOffAmountUSD: 'USD销账金额',
  Cargo_WriteOffAR: '应收销账',
  Cargo_WriteOffBalance: '销账余额',
  Cargo_WriteOffBalanceIs: '销账余额为：',
  Cargo_WriteOffCurrency: '核销币种',
  Cargo_WriteOffDate: '销账日期',
  Cargo_WriteOffDetails: '销账明细',
  Cargo_WriteOffEntry: '销账输入',
  Cargo_WriteOffFailed: '销账失败',
  Cargo_WriteOffInputError: '被选中的待核销费用中包含加入付款申请单费用，请在付款申请单审核流程完毕后进行核销。',
  Cargo_WriteOffList: '销账明细',
  Cargo_WriteOffListPDF: '销账明细.pdf',
  Cargo_WriteOffListXLS: '销账明细.xls',
  Cargo_WriteOffNo: '销账编号',
  Cargo_WriteOffOfAdvance: '预收付核销',
  Cargo_WriteOffOrNot: '是否销账',
  Cargo_WriteOffP: '销账 -',
  Cargo_WriteOffPerson: '销账人',
  Cargo_WriteOffRate: '核销汇率',
  Cargo_WriteOffRecordsNotSelected: '未选择销账记录。',
  Cargo_WriteOffRemarks: '销账备注',
  Cargo_WriteOffReverseWriteOff: '核销/反核销',
  Cargo_WriteOffRevokedSuccessfully: '撤销销账成功。',
  Cargo_WriteOffSerialNumber: '销账流水号',
  Cargo_WriteOffStartingPeriod: '核销期初',
  Cargo_WriteOffStartingPeriodP: '核销期初:',
  Cargo_WriteOffStatus: '销账状态',
  Cargo_WriteOffType: '销',
  Cargo_WriteOffTypeP: '销账类型:',
  Cargo_WrittenOff: '已销账',
  Cargo_WrittenOff2: '已销折合RMB',
  Cargo_WrittenOffItemsCanTBeModified: '已经被核销，不能被修改。',
  Cargo_WrittenOffItemsExist: '有已销账',
  Cargo_WrittenOffNotWrittenOff: '已销账未销账',
  Cargo_WrittenOffSuccessfully: '销账成功',
  Cargo_WrongInvoicingMachineNoEntered: '开票机号输入有误。',
  Cargo_WroteOff: '是否核销',
  Cargo_WroteOffOrNot: '是否已核销',
  Cargo_X10: '十',
  Cargo_X100: '百',
  Cargo_X1000: '千',
  Cargo_X10000: '万',
  Cargo_YadongKingdee: '亚东金蝶',
  Cargo_Year: '年',
  Cargo_Years: '年份',
  Cargo_Yes: '是',
  Cargo_YesControlled: '受控',
  Cargo_NotControlled: '不受控',
  Cargo_YesLink: '是我要关联',
  Cargo_YesNo: '是否',
  Cargo_Yuan: '元',
  Cargo_ContentIsEmpty: '内容为空。',
  Cargo_PleaseSelectExpenseToProcess: '请选择要处理的费用。',
  Cargo_EditSoa: '编辑对账单',
  Cargo_InvalidParameterCFR: '无效参数，找不到分录科目规则。',
  Cargo_SuccessItemsFailedItems: '成功{0}条，第{1}条失败。',
  Cargo_BADNMOPRTB: '账单{0}的结算代理与对账单的结算对象不一致，请移除该账单再保存。',
  Cargo_IVCNBVPDTORTI: '有{0}个发票已生成凭证不可作废，请删除凭证，或者红冲。',
  Cargo_Temp: '-空-',
  Cargo_OperationCommission: '操作提成',
  Cargo_CSCommission: '客服提成',
  Cargo_ViewPaymentRequest: '查看付款申请单',
  Cargo_WantToAddThemToTheBill: '选择的费用包含已核销费用，是否继续加入账单？',
  Cargo_AddAllToTheBill: '全部加入账单',
  Cargo_OnlyTheUnwrittenOffExpenses: '只加入未核销费用',
  Cargo_ImportAndQueryOfBillNumber: '账单号导入查询',
  Cargo_DebitAmountCN: '借方金额',
  Cargo_CreditAmountCN: '贷方金额',
  Cargo_PushMiddleTable: '推送中间表',
  Cargo_IfError: '是否报错',
  Cargo_ErrorInfo: '报错信息',

  Cargo_AIOCER: '汇率原币金额',
  Cargo_BalanceInRmb: '余额人民币',
  Cargo_BalanceInUsd: '余额美元',
  Cargo_CanTDeleteInvoicedItems: '已开票无法删除',
  Cargo_CanTDeleteIssuedInvoice: '已开发票无法删除！',
  Cargo_CardAccessControl: '卡片权限控制',
  Cargo_CCTBEVCTBE: '客户不能为空，供应商不能为空',
  Cargo_ConfirmAPP: '是否确认应付费用',
  Cargo_ConfirmBill: '确认账单',
  Cargo_CreditSideRmb: '贷方(人民币)',
  Cargo_CreditSideUsd: '贷方(美元)',
  Cargo_CurrencyIncompatible: '币种不统一',
  Cargo_CustomizedField: '自定义字段',
  Cargo_IssuedUnissued: '已发布未发布',
  Cargo_NoExpensesToBeInvoiced: '无法开票,没有可开票费用',
  Cargo_OVICBETGTEI_2: '增值税发票才可以金税作废电子发票',
  Cargo_OWCICGTSEEI_2: '开票币种是RMB才可以金税作废电子发票',
  Cargo_PleaseSelectAnBillPayment: '请选择一条付款申请',
  Cargo_PleaseSelectPurchaser: '请选择购买人。',
  Cargo_SelectAddPlatformBLMethod: '平台提单方式选择添加',
  Cargo_SettlingPartyMustBeIdentical: '结算对象必须相同',
  Cargo_Space5: '半月结',
  Cargo_TARBACTBLTAPAWIETIAR: '收支类型为应收时应收账单总金额不能小于应付账单总金额',
  Cargo_CanNotRemovedAllCharge: '不能移除全部费用！',
  Cargo_BillNotAllowEditEtowerOne: 'EtowerOne过来的账单不允许操作！',
  Cargo_NoSubmit_SR: '未提交',
  Cargo_AwaitApproval_SR: '审批中',
  Cargo_Approved_SR: '审批完成',
  Cargo_ModifyFilter: '增减条件',
  Cargo_SaveChanges: '保存修改',
  Cargo_SaveAsScheme: '另存为方案',
  Cargo_QueryScheme: '查询方案',
  Cargo_QuerySchemeManagement: '查询方案管理',
  Cargo_SelectQueryCriteria: '选择查询条件',
  Cargo_ApplicationForm: '申请单',
  Cargo_ApprovalHistory: '审批历史',
  Cargo_AllQueryCriteria: '所有查询条件',
  Cargo_MyQueryCriteria: '我的查询条件',
  Cargo_DisplayName: '显示名',
  Cargo_ConditionalExpression: '条件表达式',
  Cargo_ProcessingDifference: '处理差额',
  Cargo_NotFoundTemplate: '没有找到对应的打印模板！',
  Cargo_NoPaymentMethodPermissionOfReconciliation: '权限不足，请联系管理员配置对账页签收付方式权限！',
  Cargo_NoFeeTypePermissionOfReconciliation: '权限不足，请联系管理员配置对账页签费用类型权限！',
  Cargo_SearchDataForReconciliation: '请先查询数据，再进行开始对账！',
  Cargo_ChargeUpdateFailed: '有{0}个费用被其他人修改，没有更新成功！',
  Cargo_SaveReconciliationSuccess: '保存对账成功！',
  Cargo_RemoveAll: '删除全部',
  Cargo_ViewDeleteChargeDetail: '查看/移除明细',
  Cargo_DeleteAdjustment: '删除调整',
  Cargo_PleaseSelectedCancelConfirmCharge: '请选择需要取消确认的费用',
  Cargo_PleaseSelectedConfirmCharge: '请选择需要确认的费用',
  Cargo_PleaseSelectedBillingDate: '请选择账单日期！',
  PleaseSelectSplitCharge: '请选择需要拆分的费用！',
  OnlySelectOneChargeToSplit: '只能选择一条费用进行拆分！',
  ChargeHasInvoicedOrWriteOff: '该费用已开发票或已销账，请重新选择！',
  NoChargeForSplit: '无实际可拆分的费用，请重新选择！',
  Cargo_exportExcelAll: '导出全部',
  Cargo_PleaseInputKeyWordsForQuery: '请输入关键字查询',
  Cargo_AccountNumber: '账号',
  Cargo_OwnerBankOfDeposit: '我司银行',
  Cargo_JoinBill: '加入账单',
  Cargo_SelectedUnConfirmedCharge: '请选择要取消确认的费用！',
  Cargo_NoChargeForSplit: '无实际可拆分费用，请重新选择！',
  Cargo_InputTaxAmount: '请输入含税价！',
  Cargo_ReconciliationTypeP: '对账类型:',
  Cargo_ByFee: '按费用',
  Cargo_SelectBill: '选择账单',
  Cargo_BillOfType: '账单类型：',
  Cargo_BillDateP: '账单日期：',
  Cargo_StatementDateP: '对账单日期：',
  Cargo_RegistrationAddress: '纳税人地址',
  Cargo_OriginalCurrency2: '原币种',
  Cargo_ExchangeRate2: '汇率',
  Cargo_BillRateEmpty: '账单原币种汇率不能为空！',
  Cargo_BillCurrencyMore: '账单费用币种不能超过三种！',
  Cargo_BillCurrencyEmpty: '账单币种不能为空！',
  Cargo_SettlementAgentEmpty: '结算代理不能为空！',
  Cargo_IncludingTaxAmountZero: '含税价不能为零！',
  RequiredAccrueDate: '请输入计提日期',
  RequiredCancelDate: '请输入取消日期',
  Cargo_NoChargeForBillPayment: '没有费用可创建付款申请！',
  Cargo_CancelSpecialApproval: '取消特批',
  Cargo_LockTheBillTime: '锁单时间',
  Cargo_CreditControlObject: '信控对象',
  Cargo_SpecialApprovalTime: '特批时间',
  Cargo_SpecialApprovalUser: '特批人',
  Cargo_AmountExceeded: '超额',
  Cargo_DateExceeded: '超期',
  Cargo_CreditControlInfo: '信控情况',
  Cargo_OperateTime: '操作时间',
  Cargo_DownloadLog: '下载日志',
  Cargo_Times: '次',
  Cargo_LockTheBillDate: '锁单日期',
  Cargo_SpecialApprovalDate: '特批日期',
  Cargo_OperateDate: '操作日期',
  Cargo_LockTheBillUser: '锁单人',
  Cargo_sono: 'SoNo',
  Cargo_pono: 'PO.No.',
  Cargo_PolAir: '起运港（空港）',
  Cargo_keyWordsTip: '请输入关键词',
  Cargo_sopDoubleClickTip: '双击文本框选择节点状态查询。',
  Cargo_SchemeName: '方案名称',
  Cargo_NewQueryScheme: '新增查询方案',
  Cargo_TheQueryItemSelected: '该查询项【{0}】已经被选择了',
  Cargo_SchemeSaveSuccess: '方案保存成功',
  Cargo_BillLogManagement: '提单日志管理',
  Cargo_ModifyContent: '修改内容',
  Cargo_CheckPermission: '你没有查看业务的权限！',
  Cargo_CheckBusinessType: '请选择同一业务类型！',
  Cargo_MasterChargeWhetherShareOrNot: '主票费用是否分摊',
  Cargo_DepartmentPrefixNotSelected: '未选择结算部门。',
  Cargo_SalesIsEmpty: '当前客户销售为空，不能签单!',
  Cargo_Distribution: '分配',
  Cargo_SalesNotSelected: '未选中销售!',
  Cargo_ReviewedByLeader: '已分配，此客户待原组长审核：',
  Cargo_AllocationSucceeded: '分配成功！',
  Cargo_FormerGroupLeader: '原组长',
  Cargo_ChineseNameIsEmpty: '客户中文名为空！',
  Cargo_OriginalTeamLeaderIsEmpty: '原组长名称为空！',
  Cargo_DoNotOperate: '禁止对当前客户进行操作，请联系销售经理解决！',
  Cargo_RestoreCurrentCustomer: '确认要恢复当前客户吗？',
  Cargo_CustomerInformationIsEmpty: '客户信息为空！',
  Cargo_CannotBeDeleted: '该客户已被业务使用，无法删除！',
  Cargo_DeleteSuccessfully: '删除成功，该客户被移入客户回收站！',
  Cargo_AreYouSureDelete: '你确定要删除吗？',
  Cargo_PleaseSelectForDelete: '请选择您要删除的客户!',
  Cargo_ChineseNameAlreadyExists: '中文名称已存在',
  Cargo_EnglishNameAlreadyExists: '英文名称已存在',
  Cargo_ChineseOrEnglishAlreadyExists: '中文名称或英文名称已存在',
  Cargo_ContactPersonToFillInA: '客户的联系人至少填一个！',
  Cargo_PleaseInvoicingRequirementsTab: '请填写开票要求页签的币种要求！',
  Cargo_SignOrNot: '是否签单',
  Cargo_DangerousChemicals: '是否危化品',
  Cargo_DaysNotFollowedUp: '未跟进天数',
  Cargo_CustomerNotSelected: '客户未选择！',
  Cargo_AssignedClientsSuccessfully2: '已分配{0}个客户',
  Cargo_examine: '个客户待原组长审核',
  Cargo_DistributionSales: '个客户成功分配销售',
  Cargo_MoreThan1Year: '超过1年',
  Cargo_list: '列表',
  Cargo_MyClients: '我的客户',
  Cargo_CustomersInThisGroup: '本组客户',
  Cargo_CustomerRecycleBin: '客户回收站',
  Cargo_PleaseSelectTheCustomerToExport: '请选择需要导出的客户!',
  Cargo_city: '市',
  Cargo_email: '邮箱',
  Cargo_add: '添加',
  Cargo_Append: '追加',
  Cargo_PSCF: '请先选择联系人!',
  Cargo_NCS: '未选择联系人!',
  Cargo_CNATCBE: '联系人姓名和电话不能为空!',
  Cargo_ERF: '删除文件出错!',
  Cargo_FDS: '文件删除成功!',
  Cargo_AYSDF: '确定要删除文件吗?',
  Cargo_PSAEF: '请先选择事件',
  Cargo_theme: '主题',
  Cargo_FTMFT: '修改文件类型失败',
  Cargo_EventStatus: '事件状态',
  Cargo_TaskTime: '任务时间',
  Cargo_CustomerChineseName: '客户中文名称',
  Cargo_CustomerEnglishName: '客户英文名称',
  Cargo_NextTask: '下步任务',
  Cargo_RWSR: '成功拒绝{0}条记录',
  Cargo_isActive: '是否有效',
  Cargo_OverdueLimit: '超期额度',
  Cargo_OverdueDays: '超期天数',
  Cargo_Enable: '启用',
  Cargo_Disable: '停用',
  Cargo_EnableStatus: '启用状态',
  Cargo_Enabled: '已启用',
  Cargo_Disabled: '已禁用',
  Cargo_amount: '条数',
  Cargo_HasChosen: '已选择',
  Cargo_RemoveToBlackList: '移出黑名单',
  Cargo_SureToRemoveToBlackList: '确定要移出黑名单吗?',
  Cargo_Flight: '航班',
  Cargo_OutstandingAmount: '未销金额（费用）',
  Cargo_WriteOffAmountCharge: '核销金额（费用）',
  Cargo_ReceivableExcludingTax: '应收不含税（发票）',
  Cargo_TaxIncludedReceivable: '应收含税（发票）',
  Cargo_PayableExcludingTax: '应付不含税（发票）',
  Cargo_TaxPayable: '应付含税（发票）',
  Cargo_TotalExcludingTax: '合计不含税（发票）',
  Cargo_TotalTaxIncluded: '合计含税（发票）',
  Cargo_PleaseEnterBoxTypeOrBoxType: '请输入箱型或箱种!',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate: '生效日期必须小于失效日期',
  Cargo_MaintenanceOfExpenseDetails: '费用明细维护',
  Cargo_CustomerQuickSearch: '快捷检索:客户中文名/英文名',
  Cargo_WechatAccount: '微信号',
  Cargo_Download: '下载',
  Cargo_ChineseNamed: '中文名称',
  Cargo_EnglishNamed: '英文名称',
  Cargo_SignContractTip: '合作伙伴模块已存在名称相似的企业,是否需要关联？',
  Cargo_SignContractTipYes: '是，我要关联',
  Cargo_SignContractTipNo: '否，我不要关联',
  Cargo_CooperationStage: '合作阶段',
  Cargo_Financial_Year: '财务年度',
  Cargo_ConfirmCloseWindow: '确认关闭窗口吗？',
  Cargo_NoteUpdatedSuccessfully: '备注更新成功',
  Cargo_PleaseSelectAPieceOfData: '请选中一条数据.',
  Cargo_SelectDataIsNotAuditState: '仅支持暂不提交预审状态为待审核的业务，请重新勾选。',
  Cargo_SelectDataIsNotSubmittedTemporarilyOrRejectState: '仅支持提交预审状态为 暂不提交 或 已拒绝 的业务，请重新勾选。',
  Cargo_SelectAtLeastOneRecord: '请至少选择一条记录',
  Cargo_FieldDisplay: '字段展示',
  Cargo_ControlSelection: '控件选择',
  Cargo_EnumValue: '枚举值',
  Cargo_StatusIsNotPending: '状态不是待审核.',
  Cargo_NotSubmittedAndRejectedStatusTips: '只能选择暂不提交和已拒绝状态.',
  Cargo_subimitPreStatusTips: '确定提交预审状态吗？',
  Cargo_TransitCannotBeNull: '中转港不能为空',
  Cargo_TheClientDoesNotBelongToYourCustomerTips: '该委托单位不属于您的客户，请从新选择',
  Cargo_ThereAreBargesTips: '有驳船请输入驳船截关日期',
  Cargo_ClosingDateCannotBeGreaterThanTheSailingDate: '截关日期不能大于开航日期',
  Cargo_ClosingDateOfBargeTips: '驳船截关日期不能大于截关日期',
  Cargo_CurrentAccount: '往来科目',
  Cargo_BusinessNoAndChargeName: '业务编号/费用名称',
  Cargo_BusinessNum: '业务条数',
  Cargo_VoucherLineNumberSetting: '凭证行数设置',
  Cargo_VoucherLine: '凭证行数',
  Cargo_UseRmbEntrytypeByInvoice: '发票凭证分录是否[原币金额]直接取[本位币金额] 、汇率1',
  Cargo_UseRmbEntrytypeByInvoiceTip: '（用“,”隔开:1=应收账款 3=应付账款 5=营业收入 7=营业成本）',
  Cargo_UseRmbEntrytypeByFact: '收付凭证分录是否[原币金额]直接取[本位币金额] 、汇率1',
  Cargo_UseRmbEntrytypeByFactTip: '（用“,”隔开:1=应收账款 3=应付账款 73=应付账款(个人) 40=应收账款(合并) 41=应付账款(合并) 42=营业收入(合并) 43=营业成本(合并)）',
  Cargo_UseRmbEntrytypeByPre: '预收付凭证分录是否[原币金额]直接取[本位币金额] 、汇率1',
  Cargo_UseRmbEntrytypeByPreTip: '（用“,”隔开:1=应收账款 3=应付账款 26=预收账款 44=预付账款）',
  Cargo_UploadTime: '上传时间',
  Cargo_Finished: '是否完成',
  Cargo_OperationRequirement: '操作要求',
  Cargo_measurements: '尺寸CM(长*宽*高*件数)',
  Cargo_Note: '说明',
  Cargo_ChooseEdiTemplate: '选择EDI模板',
  Cargo_OperatedFailed: '操作失败',
  Cargo_SelectPurchaseRecord: '请选择购买记录.',
  Cargo_SelectAcquiredRecord: '请选择领用记录.',
  Cargo_CheckInvoiceInvalidState: '当前选择包含了已作废或已使用的发票号。',
  Cargo_CheckInvoiceUsedState: '未选择发票或不是选择已领用状态。',
  Cargo_InvoiceRestoreSuccessfully: '发票恢复成功。',
  Cargo_CheckInvoiceRestoreState: '当前选择包含了不是作废的发票号。',
  Cargo_ConfirmRestoreInvoice: '确定要恢复作废的发票吗？',
  Cargo_InvoiceInvalidSuccessfully: '发票作废成功。',
  Cargo_CheckInvoiceType: '发票类型不一致。',
  Cargo_CheckInvoiceRecipientState: '当前选择包含了已领用记录。',
  Cargo_LocalAmount: '本位币',
  Cargo_SourceAmount: '原币',
  Cargo_DebitAmountOccurredLocal: '借方发生额（本位币）',
  Cargo_DebitAmountOccurredSource: '借方发生额（原币）',
  Cargo_CreditAmountOccurredLocal: '贷方发生额（本位币）',
  Cargo_CreditAmountOccurredSource: '贷方发生额（原币）',
  Cargo_dispPop: '点击展开统计',
  Cargo_hidePop: '点击收起统计',
  Cargo_SchemeUserTips: '注：维护了用户的费用方案，仅适用以下列表内用户',
  Cargo_NoDataCanBeModified: '没有数据可修改.',
  Cargo_BalanceLocal: '余额（本位币）',
  Cargo_BalanceSource: '余额（原币）',
  Cargo_DebitAmountLocal: '借方金额（本位币）',
  Cargo_DebitAmountSource: '借方金额（原币）',
  Cargo_DebitSideLocal: '借方（本位币）',
  Cargo_DebitSideSource: '借方（原币）',
  Cargo_CreditAmountLocal: '贷方（本位币）',
  Cargo_CreditAmountSource: '贷方（原币）',
  Cargo_BatchUpload: '批量上传',
  Cargo_PleaseSelectBusinessData: '请选择文件名要匹配的业务数据',
  Cargo_DocumentsBack: '单证取回',
  Cargo_CanNotWriteOffForDifferentExpenseTypes: '国内国外费用不允许同时核销！',
  Cargo_VehicleRequestForm: '用车申请单',
  Cargo_VehicleOrder: '车单',
  Cargo_BatchGenerateVehicleOrder: '批量生成车单',
  Cargo_VehicleRequestFormNo: '用车申请单号',
  Cargo_PickUpDelivery: '提货/送货',
  Cargo_EstimatedPickUpDate: '预计提货日期',
  Cargo_Port2: '口岸',
  Cargo_VehicleOrderNo: '车单编号',
  Cargo_VehicleTime: '出车时间',
  Cargo_CancelVehicleOrder: '取消车单',
  Cargo_VehicleDispatched: '已出车',
  Cargo_CancelVehicleStatus: '撤销出车状态',
  Cargo_CancelCompletedStatus: '撤销完成状态',
  Cargo_StatusUpdateRecord: '状态更新记录',
  Cargo_UpdateVehicleOrderStatus: '更新车单状态',
  Cargo_CancelCondition: '车单状态仅为“未出车”时，可取消',
  Cargo_ConfirmCancelVehicleOrder: '确认取消出车？',
  Cargo_SelectNotDispatched: '请选择“未出车”状态的车单，进行操作。',
  Cargo_SelectDispatched: '请选择“已出车”状态的车单，进行操作。',
  Cargo_SelectStatusConsistent: '选择车单的状态需要一致。',
  Cargo_VehicleOrderCompleted: '车单状态已完成。',
  Cargo_SelectCompleted: '请选择“已完成”状态的车单，进行操作。',
  Cargo_CompletionTimeNotEarlierThanDispatchTime: '“完成时间”不可早于“出车时间”',
  Cargo_ActualPickupDate: '实际提货日期',
  Cargo_DispatchTaskLinkedToVehicle: '派车任务单已关联车单，不可删除。需先解绑后再可修改。',
  Cargo_DispatchTaskLinkedToVehicle_ArrivalMethod: '派车任务单已关联车单，不可修改“到货方式”。需先解绑后再可修改。',
  Cargo_DispatchTaskLinkedToVehicle_DestinationPort: '派车任务单已关联车单，不可取消“目的港派车”。需先解绑后再可修改。',
  Cargo_Port_Airport: '口岸(空港)',
  Cargo_VehicleRequestDifferentPorts: '用车申请单属于不同口岸，是否合并生成？',
  Cargo_VehicleOrderGeneratedSuccess: '出车单生成成功',
  Cargo_VehicleOrderSerialNumber: '出车单流水号为',
  Cargo_BusinessCreationTime: '业务创建时间',

  Cargo_CurrencyMustBeTheSame: '币种必须相同！',
  Cargo_AccountContacts: '结算单位联系人',
  Cargo_AccountAddr: '结算单位地址',
  Cargo_AccountContactsTel: '联系人电话',
  Cargo_CustomsDeclarationInformationOujian: '报关信息 （当前不支持特殊监管区域的通关模式）',
  Cargo_ChargeSubmit: '费用是否提交',
  Cargo_ContractRatePropertySE: '约价性质(海出)',
  Cargo_ContractRatePropertySI: '约价性质(海进)',
  Cargo_TaxRevenueShortName: '编码',
  Cargo_TaxRevenueName: '税收编码名称',
  Cargo_TaxRevenueToolTip: '注：编码为国家税收统一编码，例：3040802010200000000；税收编码名称为税收分类编码简称，例：经纪代理服务',
  Cargo_CargoSourceTip: '是否切换揽货类型为[{0}]?',
  Cargo_AccountingMonthMaintain: '财务月维护',
  Cargo_FclApproximatePrice: '整箱约号价格',
  Cargo_LclApproximatePrice: '拼箱约号价格',
  Cargo_AddContractNo: '添加约号',
  Cargo_Income20: '20\'调整',
  Cargo_Income40: '40\'调整',
  Cargo_Income40HC: '40HC\'调整',
  Cargo_Income45: '45\'调整',
  Cargo_WeightPriceAdjust: '重量价调整',
  Cargo_CubagePriceAdjust: '体积价调整',
  Cargo_MinimumPriceAdjust: '最低价调整',
  Cargo_GrossMargin: '毛利率',
  Cargo_IncorrectExpenseStatus: '费用状态不正确！',
  Cargo_ExpenseStatusModifiedSuccessfully: '费用状态修改成功！',
  Cargo_DestinationSelection: '目的地选择',
  Cargo_AciPortCode: 'aci端口代码',
  Cargo_InlandLocation: '内陆位置',
  Cargo_SubLocationCode: '子位置代码',
  Cargo_DeleteBillTips: '只能删除未生成账单号且账单状态为未确认的账单！',
  Cargo_ForceDeleteBillTips: '只能删除账单状态为未确认、已确认、已打印、已作废的的账单！',
  Cargo_ConfirmDeleteCategoryAndType: '确定要删除选中的归类及类型吗？',
  Cargo_RangeAndGE: '数值下限（含）',
  Cargo_RangeAndLT: '数值上限（不含）',
  Cargo_FinancialDateCheckNull: '财务日期不能为空！',
  Cargo_CurrencyCheckNull: '币种不允许为空！',
  Cargo_FinancialDateCheckBefore: '选择日期不能晚于当前日期',
  Cargo_OperatingCompanyCannotBeEmpty: '操作公司不能为空',
  Cargo_DeliveryCannotBeNull: '交货地不能为空',
  Cargo_DesignatedCannotBeNull: '指定货代理不能为空!',
  Cargo_SalesCannotBeEmpty: '销售不能为空',
  Cargo_ItemNumberCannotBeEmpty: '项目编号不能为空!',
  Cargo_PleaseSelectLoadingPort: '请选择装货港!',
  Cargo_PleaseChooseTheDestinationPort: '请选择目的港!',

  Cargo_UserManagement: '用户管理',
  Cargo_Search2: '搜索',
  Cargo_RecordAmount: '记录数',
  Cargo_RoleUserSettings: '角色用户设置',
  Cargo_SystemAdministrator: '系统管理员',
  Cargo_UserCode: '用户代码',
  Cargo_UserDepartment: '用户所属部门',
  Cargo_UserCompany: '用户所属公司',
  Cargo_IncludingElectricitySupplierAccount: '包含电商账户',
  Cargo_ValidOrNot: '是否有效',
  Cargo_Valid: '有效',
  Cargo_Invalid2: '失效',
  Cargo_LoginName: '登录名',
  Cargo_MobilePhoneNo: '手机',
  Cargo_PasswordExpirationDate: '密码失效日期',
  Cargo_NetworkManagementCode: '网管代码',
  Cargo_Superior: '上级主管',
  Cargo_OfficeAndDep: '所属分公司/部门',
  Cargo_ConfirmBatchModifyUser: '批量替换勾选数据对应【{0}】',
  Cargo_BatchModifyUserSucceed: '成功修改{0}条数据【{1}】为【{2}】',
  Cargo_Activation: '激活',
  Cargo_ElectricitySupplierAccountOrNot: '是否电商账户',
  Cargo_SystemAdministratorOrNot: '是否系统管理员',
  Cargo_BatchModify: '批量修改',
  Cargo_TheCompanyToWhichTheAccountBelongs: '账户所属公司',
  Cargo_EditPermission: '编辑权限',
  Cargo_AddUser: '添加用户',
  Cargo_DeleteUser: '删除用户',
  Cargo_RemoveUser: '移除用户',
  Cargo_Filter2: '过滤条件',
  Cargo_Import2: '批量导入',
  GOODS_INFO_IMPORT: '货物信息导入',
  Cargo_ContinueToCreate: '在{0}下已维护此合作伙伴，是否继续创建？',
  Cargo_AssignRolesToUsers: '待分配角色用户',
  Cargo_SelectARangeOfUsers: '选择用户范围',
  Cargo_NotSubmittedOrRejectedTips: '只允许删除暂不提交或已拒绝的业务，请重新选择',
  Cargo_SelectedMoreThenNPieces: '您选择的数据已超过限制条数{0}条，请重新选择',
  Cargo_SmallTicketCannotBeRemoved: '小票中含有分摊费用，不可移除。',
  Cargo_invoiceNotInconsistent: '发票类型、发票种类不一致，是否继续操作？',
  Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted: '只能提交有账单号的账单',
  Cargo_SureDoThis: '确定执行此操作吗?',
  Cargo_BillHasBeenSubmitted: '账单[{0}]已提交过了',
  Cargo_BillWasNotSubmitted: '账单[{0}]不是已提交状态',
  Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff: '只能对有账单号的账单进行销账',
  Cargo_BillsHasBeenPaidInFull: '账单{0} 已经全部付款,不能再次销账.',
  Cargo_NotAllowWriteOffFee: '待核销费用中，有应付费用未做付款申请或付款申请流程没有完成，不允许核销.',
  Cargo_BillsAlreadyWriteOffFee: '账单{0}已经做过销账，不能退回',
  Cargo_RevokeAll: '全部撤销',
  Cargo_ConfirmAndNotityHQ: '确定通知总部吗?',
  Cargo_AllBillingHasBeenSentToBranches: '当前选中的结算对象已全部发送过分公司',
  Cargo_Sender: '发送人',
  Cargo_SendDate: 'EDI时间',
  Cargo_VersionNo: '版本号',
  Cargo_BookingLog: '订舱日志',
  Cargo_BookingSubscribe: '订阅',
  Cargo_BookingSubscribeSync: '更新数据',
  Cargo_BookingSubscriptionStatus: '订阅详情',
  Cargo_SubscribeDataType: '数据类型',
  Cargo_SubscribeStatus: '订阅状态',
  Cargo_BatchUpdateExchangeRate: '批量更新汇率',
  Cargo_UpdateExchangeRate: '更新汇率',
  Cargo_SelectAccountAndCurrency: '请选择结算对象和币种修改汇率：',
  Cargo_InputRate: '输入汇率：',
  Cargo_ConfirmUpdateExchangeRate: '是否确认更新汇率？',
  Cargo_PleaseInputRate: '请输入需要更改的汇率！',
  Cargo_PleaseSelectAccountAndCurrency: '请选择需要更改汇率的结算对象/币种！',
  Cargo_ValidateUpdateRateTips: '操作失败，此次更新汇率的结算单位/币种不在本次勾选业务内！',
  Cargo_UpdateRateConfirmTipsHead: '批量更新汇率包含生成',
  Cargo_UpdateRateConfirmTipsTail: '的费用，本次仅更新原费用汇率，修改后数据不可恢复，是否继续？',
  Cargo_BillVoidTipForState: '账单仅可在“未确认”状态下才能作废！',
  Cargo_BillVoidTipForReview: '账单仅可在“未复核”状态下才能作废！',
  Cargo_DuplicatedCode: '此代码重复，请重新输入。',
  Cargo_PlatformCertifiedPartner: '选择平台认证合作伙伴',
  Cargo_Examine: '是否审核',
  Cargo_NameOfApplicant: '申请企业名称',
  Cargo_CreateSource: '来源',
  Cargo_Tenant: '租户',
  Cargo_Platform: '平台',
  Cargo_AdvertisingManagement: '广告管理',
  Cargo_AdvertisingNo: '广告编号',
  Cargo_AdvertisingContent: '广告内容',
  Cargo_System: '所属系统',
  Cargo_Module: '所属模块',
  Cargo_PageIndex: '所属页面',
  Cargo_AdvertisingSpace: '广告位',
  Cargo_AdvertisingSubject: '广告主体',
  Cargo_PromotionCycle: '推广周期',
  Cargo_DataTime: '数据日期',
  Cargo_AdvertisingSpaceNo: '广告编位号',
  Cargo_billPaymentNo: '付款申请单号',
  Cargo_RangeSmaller: '推荐使用小范围',
  Cargo_SyncFinanceCode: '此举会将合作伙伴代码写入客商编码，是否继续？',
  Cargo_SyncFinanceCodeSuccess: '客商编码同步成功',
  Carge_ConfirmDate: '确认时间',
  Carge_ConfirmUser: '确认人',
  Carge_BillingConfirmDate: '账单确认时间',
  Carge_BillingConfirmUser: '账单确认人',
  Carge_BillingGroupConfirmDate: '对账单确认时间',
  Carge_BillingGroupConfirmUser: '对账单确认人',
  Carge_ChinessNameExist: '中文名称已存在，请修改',
  Carge_EnglishNameExist: '英文名称已存在，请修改',
  Cargo_Dep: '录入部门',
  Cargo_contactInformationCopy: '联系人信息-单号抄录',
  Cargo_contactInformationCode: '联系人信息-代码检索',
  Cargo_auditResult: '审核结果',
  Cargo_number: '编号',
  Cargo_PlatformCode2: '平台代码',
  Cargo_InterchaneeCode: '交换码',
  Cargo_abbreviation: '简称',
  Cargo_TemplateDescribe: '模板说明',
  Cargo_Describe: '描述',
  Cargo_BillingHeaderName: '开票抬头名称',
  Cargo_EnglishNameOfBank: '银行英文名称',
  Cargo_ContactName: '联系人名称',
  Cargo_TenantID: '租户ID',
  Cargo_AppendQuery: '追加查询',
  Cargo_CollapseList: '收起列表',
  Cargo_SetAsDefault: '设为默认',
  Cargo_MultipleWorkNoEnter: '请使用回车进行多个工作号的输入',
  Cargo_DeleteConfirm: '删除后数据将不可恢复，是否继续？',
  Cargo_EachPage: '每页',
  Cargo_DataBar: '条数据',
  Cargo_ClientNumberMaintenance: '税控盘编号维护',
  Cargo_BillingPointCode: '开票点代码',
  Cargo_UseDepartment: '使用部门',
  Cargo_CanNotEmpty: '不能为空！',
  Cargo_CanNotRepeat: '不能重复！',
  Cargo_BeforeCurrentDisplay: '当前展示前',
  Cargo_ReceivableChargeInput: '应收费用是否录入',
  Cargo_CostChargeInput: '应付费用是否录入',
  Cargo_ConvertToCnyAr: '应收：折算RMB',
  Cargo_ConvertToCnyAp: '应付：折算RMB',
  Cargo_FeeModifier: '费用修改人',
  Cargo_FeeModifyDate: '费用修改时间',
  Cargo_SoNoChangeTips: '关单号数量发生更改，是否刷新原有按关单号为单位的费用?',
  Cargo_EditSaleInfo: '销售信息调整',
  Cargo_PleaseSelectChargeApplyData: '请选择费用审核数据。',
  Cargo_PleaseSelectExportChargeDetailData: '请勾选申请记录后再试',
  Cargo_BeyondMaxExportChargeDetailData: '导出申请记录不能超过5000条，请重新选择',
  Cargo_ExportChargeDetailDataSucceed: '导出明细成功',
  Cargo_NotSameEtd: '勾选业务的开航日期月份不一致！',
  Cargo_BatchModifyJobNoMore: '单次批量修改业务编号不能超过100条。',
  Cargo_BatchModifyJobNoSuccess: '批量修改成功：{0}',
  Cargo_VolumeIsChanged: '实际体积发生更改，是否刷新原有按体积价为单位的费用?',
  Cargo_DealingsCustomer: '往来余额是否根据业务单号',
  Cargo_AllowsExceptionProofExport: '允许跳过异常凭证导出',
  Cargo_ChargeChanger: '费用变更人',
  Cargo_ChargeCreadBy: '费用创建人',
  Cargo_DeleteData: '数据已被删除，请联系管理员',
  Cargo_MasterTicketShareCharge: '主票的费用已分摊，新加入小票请重新分摊费用。',
  Cargo_CreateBillNo: '是否生成账单号',
  Cargo_CalcShareAmount: '计算分摊金额',
  Cargo_CalcShareAmountTip: '请点击计算分摊金额按钮重新计算后确认。',
  Cargo_CancelOrder: '已成功取消{0}条订单，未能取消{1}条订单。仅支持取消正操作状态下的订单。',
  Cargo_CancelOrderTip1: '以下订单不可取消，是否继续？',
  Cargo_CancelOrderTip2: '此订单已离港且已有干线业务编号，不可取消',
  Cargo_CancelOrderTip3: '此订单已离港，不可取消',
  Cargo_CancelOrderTip4: '此订单已有干线业务编号，不可取消',
  Cargo_CancelOrderTip5: '是否要批量取消这{0}笔订单？',
  Cargo_CancelOrderTip6: '取消订单',
  Cargo_CancelOrderTip7: '本次供提交{0}笔订单。以下订单不可进行取消，是否要继续？',
  Cargo_CancelOrderTip8: '订单状态为{0}，不可取消',
  Cargo_Reason: '原因',
  Cargo_PushResultLog: '数据推送结果记录',
  Cargo_SendContent: '发送内容',
  Cargo_ResultSuccess: '发送状态',
  Cargo_ResultMessage: '失败原因',
  Cargo_DesignatedCargoWarehouseNo: '指定货时,进仓编号等于业务参考号',
  Cargo_SelfCargoWarehouseNo: '自揽货时,进仓编号等于业务参考号',
  Cargo_BusinessMark: '业务标记',
  Cargo_ModifyBusiness: '修改再次生成业务',
  Cargo_SelectJobNo: '请选择一个业务编号',
  Cargo_ClosingRecord: '关帐记录',
  Cargo_ClosingAudit: '关帐审核',
  Cargo_AccountKeeper: '关帐人',
  Cargo_ClosingMonth: '关帐月份',
  Cargo_ClosingBranch: '关帐分公司',
  Cargo_AccountClosingType: '关账类型',
  Cargo_ClosingDate: '关账日期',
  Cargo_FinancialClosing: '财务关账',
  Cargo_BusinessClosing: '业务关账',
  Cargo_SelectClosingDate: '选择关账日期',
  Cargo_SelectDeleteTip: '请选择您需要删除的模版信息',
  Cargo_SelectDeleteTip2: '{0}被使用了，无法删除',
  Cargo_SelectDeleteTip3: '确定要删除选中的配置吗？删除后调用接口将不再返回数据',
  Cargo_SameCurrencyForMultipleRecord: '请勾选相同币种的实收付记录进行销账！',
  Cargo_SamePayReceiveDateForMultipleRecord: '请选择相同实收付日期的实收付记录进行销账！',
  Cargo_DefaultTaxRete: '默认税率',
  Cargo_TaxRateRange: '可用税率范围',
  Cargo_TaxRateRangeLimit: '{0}，当前税率不可用，请核实，如有必要请联系主管维护该费用的【可用税率】',
  Cargo_BargeETD: '驳船ETD',
  Cargo_DataModifyDate: '数据变更时间',
  Cargo_sendOcOrder: '重发订单信息',
  Cargo_sendOcTracking: '重发轨迹信息',
  Cargo_sendOcFile: '重发文件信息',
  Cargo_sendOcBilling: '重发账单信息',
  Cargo_chargeUpdater: '费用更新人',
  Cargo_WriteOffForMultipleRemainTipAr: '本次选择实收金额不足，建议修改本次销账金额!',
  Cargo_SharedChargeRecord: '费用分摊记录',
  Cargo_ExcludingTaxAmount: '未税金额',
  Cargo_IncludedTaxAmount: '含税金额',
  Cargo_ShareScheme: '分摊方式',
  Cargo_ChargeSyncStatus: '费用同步状态',
  Cargo_ChargeSyncConfirmStatus: '同步确认状态',
  Cargo_WriteOffForMultipleRemainTipAp: '本次选择实付金额不足，建议修改本次销账金额!',
  Cargo_ConsolidatedProfitLossIs2: '汇兑损益为：',
  Cargo_GroupScene: '群组场景',
  Cargo_GroupName: '群组名称',
  Cargo_GroupType: '群组类型',
  Cargo_CcPerson: '抄送人',
  Cargo_UpdatePerson: '更新人',
  Cargo_Common: '公共',
  Cargo_Personal: '私人',
  Cargo_ReleasePerson: '放单人',
  Cargo_MailGroupType: '请至少选择一种类型。',
  Cargo_MailGroupName: '请输入群组名称。',
  Cargo_MailGroupEmail: '请输入至少1个邮件地址。',
  Cargo_MailGroupCheckEmail: '请检查输入的邮件格式。',
  Cargo_MailGroupDelete: '删除操作不可恢复，请确认是否删除数据？',
  Cargo_ChargeRate: '费用汇率',
  Cargo_BillingRate: '账单汇率',
  Cargo_GroupChargeRate: '集团费用汇率',
  Cargo_BranchRate: '分公司汇率',
  Cargo_EnabledChildOffice: '当前汇率对下级子公司生效',
  Cargo_ShowParentRateOffice: '应用：{0}汇率',
  Cargo_SetEnabledChild: '设置子公司生效',
  Cargo_SetEnabledChildDialog: '设置对下级子公司生效',
  Cargo_SetEnabledChildCheckbox: '对下级子公司生效',
  Cargo_CopyOfficeRate: '复制分公司汇率',
  Cargo_CopyHqRate: '复制集团汇率',
  Cargo_ConfirmCopyBillingRateTip: '是否覆盖现有数据？',
  Cargo_Cover: '覆盖',
  Cargo_NotCover: '不覆盖',
  Cargo_PleaseSelectExportData: '请选择您要导出的数据！',
  Cargo_UploadRateTip: '上传文件只能是 xls、xlsx格式！',
  Cargo_UploadDataSizeMore: '文件大小不能大于2MB！',
  Cargo_UploadDataFailed: '导入失败，请联系管理员！',
  Cargo_UploadFailedCheckExcel: '导入失败，请检查模板内容！',
  Cargo_ValidateUploadRateTip1: '原货币 值为{0},基准货币 值为{1} 与Excel中其他数据重复！',
  Cargo_ValidateUploadRateTip2: '原货币 值为{0},基准货币 值为{1} 与表中已有数据重复！',
  Cargo_ValidateUploadRateTip3: '数据与表中已有数据重复！',
  Cargo_DefaultReceivableMode: '默认应收模式',
  Cargo_DefaultReceivableRate: '应收默认费率',
  Cargo_SecondReceivableRate: '应收第二费率',
  Cargo_ChargeableAmountInterval: '应收费额区间',
  Cargo_ReceivableIntervalType: '应收区间类型',
  Cargo_DefaultUnitPrice: '默认单价',
  Cargo_DefaultRate: '默认费率',
  Cargo_Suit: '适用',
  Cargo_DefaultPayableMode: '默认应付模式',
  Cargo_DefaultPayableRate: '应付默认费率',
  Cargo_SecondRatePayable: '应付第二费率',
  Cargo_PayableAmountInterval: '应付费额区间',
  Cargo_PayableIntervalType: '应付区间类型',
  Cargo_EDIFileType: '发送时EDI文件类型(UploadFileSuffix)',
  Cargo_MarkOrCargoEnglishNameChangeTip: '基本页签{0}已变更，是否刷新提单页签数据？',
  Cargo_ShareChargeCheckCurrency: '费用分摊的币种和收付方向应一致。',
  Cargo_ShareChargeCheck: '小票分摊费用总和与原始费用不相等!',
  Cargo_PleaseSelectedSalesForCustomer: '请维护客户对应销售！',
  Cargo_PleaseSelectServicePersonnel: '请维护对应服务人员！',
  Cargo_PleaseSelectedLevelForCustomer: '请维护客户对应客户级别！',
  AutomaticReconciliation: '自动对账',
  AutomaticReconciliationHistory: '自动对账历史',
  CheckHistory: '对账历史',
  ReconciliationResult: '对账结果',
  ImportReconciliationExcel: '导入对账Excel表格',
  Cargo_BatchUpdateChargeConfirmSerialNumber: '批量修改批次',
  Cargo_BatchUpdateChargeConfirmSerialNumberTip: '已选择中的费用将会被修改成以下批次号',
  Cargo_InputChargeConfirmSerialNumber: '请输入批次号',
  Cargo_ChargeConfirmSerialNumber: '费用确认批次号',
  Cargo_ChargeConfirmSerialNumberLengthMore: '批次号不能超过20位数！',
  Cargo_PleaseSelectSolicitationType: '请选择揽货类型！',
  Cargo_WriteoffSeqNo: '销账批次号',
  Cargo_CustomerContactChannel: '客户接触渠道',
  Cargo_AgentBilling: '代理分成账单',
  Cargo_AgentBillingCanNotEdit: '代理分成账单不能进行编辑！',
  Cargo_RecheckBillingCanNotEdit: '已复核账单不能进行编辑！',
  Cargo_ContainsAgentBilling: '含有代理分成账单，请选择其他对账单进行操作！',
  Cargo_HasAgentBilling: '含有代理分成账单，请选择其他账单进行操作！',
  Cargo_ForeignBillStatusError: '国外账单状态不符合打印的要求。',
  Cargo_ExportBillVoucherStatus: '导出账单凭证状态',
  Cargo_BillGeneratedNoCancel: '已生成账单号，不可取消复核',
  Cargo_OverseasBillReverseRule1: '海外账单需要有账单号，才能红冲',
  Cargo_WriteOffStatusReverseRule: '已核销状态不可红冲',
  Cargo_VoidStatusReverseRule: '已作废状态的账单，不可被红冲',
  Cargo_AlreadyReversedRule: '已红冲过的账单，不能再红冲',
  Cargo_NoBillToReverse: '没有可红冲的账单',
  Cargo_ConfirmReverseBills: '确定要红冲这{0}个账单吗？',
  Cargo_ReversedBillNoInvoice: '红冲账单不能再开票',
  Cargo_BillInvoicedNoReverse: '账单已被开票，不可被红冲',
  Cargo_BillPaymentAppliedNoReverse: '账单已被做付款申请，不可被红冲',
  Cargo_BillStatementMadeNoReverse: '账单已被做对账单，不可被红冲',
  Cargo_BillWrittenOffNoReverse: '账单已被做核销，不可被红冲',
  Cargo_Config: '配置',
  Cargo_OrderTemplateName: '导入订单模板名称',
  Cargo_TemplateTips: '小贴士：',
  Cargo_Blue: '蓝色',
  Cargo_MusetSelectd: '必填项，不能删除，必须配置模板的表头名称，如果模板没有值请配置订单默认值',
  Cargo_StartLine: '导入起始行 (含标题)',
  Cargo_TemplateDefault: '如模板中没有必填字段，可在这里维护导入生成订单的默认值',
  Cargo_TemplateDefaultValue: '模板值',
  CargoFieldDescription: '字段描述',
  Cargo_FieldDropdownValue: '字段下拉框值',
  Cargo_ActualFieldName: '实际业务字段名',
  Cargo_TemplateHeaderName: '模板表头名称',
  Cargo_TemplateImportValue: '模板导入值',
  Cargo_OrderDefaultValue: '订单默认值',
  Cargo_OrderOperation: '操作',
  Cargo_OrderDelete: '删除',
  Cargo_CloseAccountTips1: '当前调整日期已关账，请重新选择。',
  Cargo_CloseAccountTips2: '当前财务日期已关账，请重新选择。',
  Cargo_PayableOrderCreationDate: '应付单创建日期',
  Cargo_InvoiceHistoryEmail: '发票历史邮件',
  Cargo_SendCc: '同步发送抄送地址',
  Cargo_DoInvoiceTip: '仅有{0}权限，不可操作收票',
  Cargo_DoInvoiceTip2: '仅有{0}权限，不可操作应收应付的混合开票',
  Cargo_CallBackTip: '【已提交，已出单】的投保记录不能返回上一步',
  Cargo_CabinSpaceSerialNo: '舱位流水号',
  Cargo_CabinSpaceStatus: '舱位状态',
  Cargo_CabinSpaceNote: '舱位备注',
  Cargo_AllocationStatus: '分配状态',
  Cargo_QuantityInconsistency: 'S/O或MBL数量与舱位数量不一致',
  Cargo_VesselCallSign: '船舶呼号',
  Cargo_SORecognitionNewAdd: 'SO识别新增',
  Cargo_ShutOut2: '退关回收',
  Cargo_CabinSpaceBackFill: '舱位回填',
  Cargo_RevokeAllocation: '撤销分配',
  Cargo_CancelCabinReservation: '退舱',
  Cargo_AllocateCabinSpace: '分配舱位',
  Cargo_Allocate1: '分配-关联业务',
  Cargo_Allocate2: '分配-创建业务',
  Cargo_SelectBusinessTip: '请选择一个修改复制的业务',
  Cargo_GuidedSellingPrice: '指导卖价',
  Cargo_CabinCancellationNote: '退舱备注',
  Cargo_CutOffDate: '截单日期',
  Cargo_DeclarationCutOffDate: '截申报日期',
  Cargo_CutOffDate2: '客户截关日期',
  Cargo_ReturnDateForCustoms: '客户退关日期',
  Cargo_CutOffTime: '客户截单时间',
  Cargo_FreeStorageDays: '免堆天数',
  Cargo_TotalPiecesMismatchContinue: '总件数不符，是否继续操作？',
  Cargo_BasicData: '基础资料',
  Cargo_CustomerVendorRating: '客商评分',
  Cargo_DeliveryOperator: '交货操作人',
  Cargo_DeliveryOperationTime: '交货操作时间',
  Cargo_DeliveryOperationMethod: '交货操作方式',
  Cargo_PartnerApprovalRequired: '勾选的合作伙伴需先发起审批流程，流程通过后此合作伙伴方可生效，审批过程中此合作伙伴不可用。您现在要发起审批吗？',
  Cargo_ContractApprovalRequired: '此合同需先发起审批流程，流程通过后此合同方可生效，审批过程中此合同不可编辑/续签/文件管理操作。您现在要发起审批吗？',
  Cargo_ViewPartnerDetails: '查看合作伙伴详情',
  Cargo_PartnerApplicationForm: '合作伙伴申请单',
  Cargo_ContractApplicationForm: '合同申请单',
  Cargo_PartnerApplicationApprovalProcess: '合作伙伴申请审批流程',
  Cargo_ContractApplicationApprovalProcess: '合同申请审批流程',
  Cargo_UnderReview: '审核中',
  Cargo_CanSubmitOnlyUnreviewedPartner: '仅可对未审核状态下的合作伙伴进行提交操作，请重新勾选后重试',
  Cargo_DataUnderReviewCheckRetry: '存在审批中数据，请检查后重试',
  Cargo_ViewContractDetails: '查看合同详情',
  Cargo_WeightOutOperator: '出重操作人',
  Cargo_WeightOutOperationTime: '出重操作时间',
  Cargo_WeightOutOperationMethod: '出重操作方式',
  Cargo_ConfirmBatchOperation: '是否确认批量操作？',
  Cargo_AutomationConfig: '自动化配置',
  Cargo_TaskScenario: '任务场景',
  Cargo_TimingMethod: '定时方式',
  Cargo_LastExecutionTime: '最后执行时间',
  Cargo_ExecutionFrequency: '执行频率',
  Cargo_PerHour: '按小时',
  Cargo_Daily: '每天',
  Cargo_Weekly: '每周',
  Cargo_Monthly2: '每月',
  Cargo_VesselEnglishName: '船舶英文名',
  Cargo_ActualSailingTime: '实际开船时间',
  Cargo_EstimatedSailingTime: '预计开船时间',
  Cargo_ShippingCompanyName2: '船公司名称',
  Cargo_ActualAmount: '实际金额(费用的最终金额)',
  Cargo_FeeCreationTime: '费用创建时间',
  Cargo_StartExecutionTime: '开始执行时间',
  Cargo_Every: '每隔',
  Cargo_Hour: '小时',
  Cargo_EffectiveTime: '生效时间',
  Cargo_TaskResult: '任务结果',
  Cargo_TaskResultReminder: '任务结果提醒(邮件方式，EXCEL附件结果)',
  Cargo_ScenarioName: '场景名称',
  Cargo_AutomationTask: '自动化任务',
  Cargo_SpecifiedWeekday: '指定星期',
  Cargo_SpecifiedDay: '指定天',
  Cargo_LastDayOfMonth: '本月最后一天',
  Cargo_Day29to31Fallback: '当选择天数为29,30,31时，如当月没有该天数，自动按当月最后一天执行',
  Cargo_ExecuteCommand: '执行指令',
  Cargo_AutoInvoicing: '自动开票',
  Cargo_TaskName: '任务名称',
  Cargo_MultiLegVoyageManagement: '航程多程管理',
  Cargo_ScheduleSelection: '船期选择',
  Cargo_Leg1: '一程',
  Cargo_Leg2: '二程',
  Cargo_Leg3: '三程',
  Cargo_Leg4: '四程',
  Cargo_Leg5: '五程',
  Cargo_OnlyOneVoucherForCopy: '只允许勾选一条凭证进行复制！',
  Cargo_VoyageInfoCannotBeEmpty: '航程信息中的{0}不能为空',
  Cargo_AutoExecute: '自动执行',
  Cargo_TaskNameCannotBeEmpty: '任务名称不可以为空！',
  Cargo_TaskNameAlreadyExists: '任务名称【{0}】已存在，不可重复！',
  Cargo_TaskScenarioAutoExecuteCannotDelete: '该任务场景已配置自动执行，不可以删除！',
  Cargo_EnabledStatusCannotDelete: '【{0}】是已启用状态，请禁用后再进行删除。',
  Cargo_ConfirmDeleteTaskScenario: '确定是否删除该任务场景？',
  Cargo_ScenarioSettings: '场景设置',
  Cargo_TransmissionRule: '传输规则',
  Cargo_Script: '脚本',
  Cargo_AccountPassword: '账号密码',
  Cargo_GetTokenUrl: '获取token地址',
  Cargo_InterfaceUrl: '接口地址',
  Cargo_TransmissionSample: '传输格式示例',
  Cargo_RuleSettings: '规则设置',
  Cargo_CommandSettings: '指令设置',
  Cargo_DataScript: '数据脚本',
  Cargo_DataDisplay: '数据展示',
  Cargo_DeleteFromLastLeg: '请从最后一个行程删除',
  Cargo_PreviewData: '预览数据',
  Cargo_NotificationPersonnel: '通知人员',
  Cargo_DebugExecute: '调试执行',
  Cargo_ConditionName: '条件名称',
  Cargo_SendToExchangeTime: '发送航交所时间',
  Cargo_EnterYourRequirement: '请输入你的需求',
  Cargo_ConfigExecuteCommands: '配置执行指令(按序号依次执行)',
  Cargo_CommandName: '指令名称',
  Cargo_SelectCommand: '选择指令',
  Cargo_ConfirmRuleSettings: '请确认规则设置',
  Cargo_ScenarioDescription: '场景描述',
  Cargo_Command: '指令',
  Cargo_ExecutionTime: '执行时间',
  Cargo_HistoryDetails: '历史详情',
  Cargo_ExecutionScenario: '执行场景',
  Cargo_DataID: '数据ID',
  Cargo_ExecuteCommandName: '执行指令名称',
  Cargo_ManualRun: '手动运行',
  Cargo_AsyncExecutingCheckLogLater: '异步执行中，请稍后查看执行日志',
  Cargo_ExecutionLog: '执行日志',
  Cargo_Execute: '执行',
  Cargo_NoOutboundCommandConfirmPickList: '{0},没有下达出库指令，是否确认生成拣货单？',
  Cargo_CabinSpaceAllocationDate: '舱位分配日期',
  Cargo_AssociatedBusinessNo: '关联业务编号',
  Cargo_AssociatedBusinessStatus: '关联业务状态',
  Cargo_FirstTimeSalesAllocation: '首次分配销售',
  Cargo_FirstTimeAllocationEntrustingUnit: '首次分配委托单位',
  Cargo_CabinCancellationExplanation: '退舱说明',
  Cargo_CabinSpaceRecord: '舱位记录',
  Cargo_VoyageInformation: '航次信息',
  Cargo_AssociatedBusinessStatus2: '关联业务业务状态',
  Cargo_UploadFileOver50: '由于数据量过大，上传速度可能较慢，请稍后查看。',
  Cargo_UserSecurityPolicy: '用户安全策略',
  Cargo_RoleGroupManagement: '角色组管理',
  Cargo_RoleGroupName: '角色组名称',
  Cargo_UnmaintainedRoleGroupPermissions: '未维护对应角色组权限',
  Cargo_RoleGroup: '角色组',
  Cargo_RoleGroupCountLessThanTwo: '角色组数量<2',
  Cargo_PolicySettings: '策略设置：',
  Cargo_EnableUserSecurityPolicy: '启用用户安全策略',
  Cargo_PasswordLengthRange: '密码长度范围：',
  Cargo_MaxLengthRange8to20: '可设最大长度范围8-20位',
  Cargo_CompositionRule: '组合规则：',
  Cargo_RequireNumUpperLower: '需包含数字、大写字母和小写字母',
  Cargo_MustIncludeSpecialChars: '必须包含特殊字符：!、$、%、&、_、|、-、@、#、*、=',
  Cargo_PasswordHistoryCheck: '密码重复性验证：',
  Cargo_HistoryLength0to10: '可设置长度0-10，0表示不验证密码重复性，输入3表示与前3次不重复',
  Cargo_PasswordErrorLock: '密码错误锁定：',
  Cargo_LockLength0to10: '可设置长度0-10，0表示不锁定，锁定后，账户将被禁用',
  Cargo_AdminApplication: '管理员应用：',
  Cargo_AdminPwdFollowPolicy: '管理员输入密码按用户安全策略',
  Cargo_NoRepeatLastNPasswords: '不可与前 {0} 次密码一致',
  Cargo_PasswordRulePrompt: '请按密码规则设置：密码长度 {0}-{1},需包含数字、大写字母和小写字母',
  Cargo_DimensionsExceedRouteProductLimits: '尺寸超过航线产品-航次中限制，是否继续?',
  Cargo_FlightReassignment: '航班改配',
  Cargo_InformationMaintenance: '信息维护',
  Cargo_VehicleInformation: '车辆信息',
  Cargo_CountyDistrict: '县/区',
  Cargo_TownStreet: '镇/街道',
  Cargo_VillageCommunity: '村/社区',
  Cargo_FleetPhoneNumber: '车队电话',
  Cargo_DoorPointName: '门点名称',
  Cargo_DeliveryArea: '派送区域',
  Cargo_EstimatedLoadingTime: '预计装货时间',
  Cargo_ActualLoadingTime1: '实际装货时间',
  Cargo_DeliverySequenceNumber: '派送序号',
  Cargo_DispatchVehicleNoteFields: '派车操作过程中请注意完善以下字段:',
  Cargo_TTDEG: '运输公司、拖车费、门点名称、预计装货时间、毛重',
  Cargo_RouteMarking: '航线标记',
  Cargo_SecondaryConfirmation: '二次确认',
  Cargo_BookingCompleted: '已经订舱完成，请检查:',
  Cargo_DataNotPendingConfirmation: '存在非待确认数据，请检查:',
  Cargo_PortMismatch: '始发港、目的港不完全一致，确定继续吗？',
  Cargo_DataNotConfirmed: '存在非已确认数据，请检查:',
  Cargo_RouteNotConfirmedOrDoubleConfirmed: '存在未航线确认或已经二次确认数据，请检查:',
  Cargo_SelectOneMasterBill: '最多勾选一条主票',
  Cargo_DataNotRouteDoubleConfirmed: '存在非航线二次确认数据，请检查:',
  Cargo_GrossProfitAmount: '毛利金额',
  Cargo_SpecialExpenseIndicator: '销售特殊费用标识',
  Cargo_BusinessSpecialExpenseIndicator: '商务特殊费用标识',
  Cargo_IsNoInvoiceExpense: '是否无票费用',
  Cargo_SpecialExpensePayableTotal: '特殊费用应付合计',
  Cargo_SpecialExpensePayableCurrency: '特殊费用应付币种',
  Cargo_SpecialExpenseReceivableTotal: '特殊费用应收合计',
  Cargo_SpecialExpenseReceivableCurrency: '特殊费用应收币种',
  Cargo_SpecialExpenseApplication: '专项费用申请',
  Cargo_BookingCompletion: '订舱完成',
  Cargo_RouteConfirmation: '航线确认',
  Cargo_RouteConfirmationStatus: '航线确认状态',
  Cargo_FlightDateRange: '航班日期',
  Cargo_RouteConfirmationPerson: '航线确认人',
  Cargo_RouteConfirmationTimeRange: '航线确认时间',
  Cargo_IsBookingCompleted: '是否订舱完成',
  Cargo_OrderNumber: '订单号',
  Cargo_FlightNumber: '航班号',
  Cargo_SecondLegFlight: '二程航班',
  Cargo_SecondLegAirline: '二程航司',
  Cargo_SecondLegDocumentNumber: '二程单号',
  Cargo_SecondLegETD: '二程ETD',
  Cargo_SecondLegETA: '二程ETA',
  Cargo_ThirdLegFlight: '三程航班',
  Cargo_ThirdLegAirline: '三程航司',
  Cargo_ThirdLegDocumentNumber: '三程单号',
  Cargo_ThirdLegETD: '三程ETD',
  Cargo_ThirdLegETA: '三程ETA',
  Cargo_FreightUnitPrice: '运费单价',
  Cargo_SignatureWeight: '签单计重',
  Cargo_SignatureDimensions: '签单尺寸',
  Cargo_SignatureRemarks: '签单备注',
  Cargo_FoldedWeightRemarks: '折重备注',
  Cargo_TotalPrice: '总价',
  Cargo_TransshipmentFee: '转运费',
  Cargo_HumanResourcePerformance: '人事绩效',
  Cargo_AIEngine: 'AI引擎',
  Cargo_ProvisionRuleConfig: '计提规则配置',
  Cargo_ProvisionReport: '计提报表',
  Cargo_ScriptName: '脚本名称',
  Cargo_ScriptDescription: '脚本描述',
  Cargo_GenerateScript: '生成脚本',
  Cargo_RuleDescription: '规则描述',
  Cargo_ScriptPreview: '脚本预览',
  Cargo_CommissionRole: '提成角色',
  Cargo_CommissionPersonnel: '提成人员',
  Cargo_ApplicableScript: '适用脚本',
  Cargo_RuleApplication: '规则应用',
  Cargo_ApplicablePersonnel: '适用人员',
  Cargo_BusinessVolume: '业务数',
  Cargo_ApplicableRule: '适用规则',
  Cargo_CustomsProvision: '报关计提',
  Cargo_OperationProvision: '操作计提',
  Cargo_CustomerServiceProvision: '客服计提',
  Cargo_BusinessProvision: '商务计提',
  Cargo_SalesProvision: '销售计提',
  Cargo_OperationTicketProvision: '操作票数计提',
  Cargo_SalesSupervisorProvision: '销售主管计提',
  Cargo_OperationSupervisorProvision: '操作主管计提',
  Cargo_ConfirmCancelProvision: '确认取消计提吗?',
  Cargo_LockLimit: '锁定限制',
  Cargo_ReceivableFullWriteOffTime: '应收全部核销时间',
  Cargo_LockAccountsReceivableAndPayableEntry: '锁定应收应付录入',
  Cargo_ViewDetailedBusiness: '查看详细业务',
  Cargo_TestRun: '试运行',
  Cargo_ProvisionLimit: '计提限制',
  Cargo_ViewProvisionDetails: '查看计提详情',
  Cargo_ProvisionBatchNumber: '计提批次号',
  Cargo_ProvisionPerson: '计提人',
  Cargo_ProvisionTime: '计提时间',
  Cargo_ProvisionRole: '计提角色',
  Cargo_PendingProvision: '待计提',
  Cargo_ProvisionHistory: '计提历史',
  Cargo_ResponsibleCustomerService: '责任客服',
  Cargo_ResponsibleOperator: '责任操作',
  Cargo_ConfirmAndBookingCompleted: '确认并订舱完成',
  Cargo_OrderQuantity: '订单数量',
  Cargo_FinancialStatus: '财务状态',
  Cargo_FinancialColorTip: '表格颜色控制配置范围：\n空运订舱-列表\n空运操作-列表\n综合物流-列表\n铁路操作-列表\n远程订舱-列表\n销售查询-列表\n海运出口-列表\n海运操作-列表\n海运进口-预报-列表\n销售查询-海外部-列表\n销售查询-销售部-列表\n海运出口-提单制作-列表\n海运出口-EDI-列表\n财务审核-列表\n财务审核-结转-列表\n空运出口-报关清单-列表\n空运出口-前置仓-列表\n空运出口-仓储-列表\n海运进口- 仓库操作-列表',
  Cargo_CurrentInvoiceDifferentRates: '当前开票存在不同税率的费用，将按税率拆分出多张发票进行开具，将统一取默认税收编码进行维护，是否继续本次操作？',
  Cargo_CurrentSelectionContains9TaxPointsAndOthers: '当前勾选项中包含9税点和其它税点，因货物运输发票特殊请单独申请开具，不支持一并提交开票。',
  Cargo_Allocated: '已分配',
  Cargo_NotAllocated: '未分配',
  Cargo_PriceAuditEventFclTitle: '运价审核更新提醒',
  Cargo_FillSO: '填充S/O',
  Cargo_FillMBL: '填充MBL',
  Cargo_FillALL: '同时填充MBL和S/O',
  Cargo_CustomsReturnAndRecovery: '从退关业务回收舱位',
  Cargo_CheckDTip: 'MBL NO.或SO NO.已存在，确认要继续创建？',
  Cargo_BatchUpdateTitle1: '批量修改-舱位回填',
  Cargo_WindowTip1: '*批量更新提运单号信息。',
  Cargo_WindowTip2: '**如果批量勾选的订单中箱型箱量有差异，请单条填写舱位回填。',
  Cargo_CheckDTip2: '“已退舱”或“已分配”的状态下不可进行操作',
  Cargo_CheckDTip3: '请选择箱型箱量一致的舱位进行操作',
  Cargo_NoItems_NoAudit: '没有{0}，无需审核',
  Cargo_Audited_NoNeedAudit: '已审核，无需审核',
  Cargo_AvailableCabinSpace: '现舱',
  Cargo_QueryTip: '快捷检索:舱位流水号',
  Cargo_PriceUpdateUser: '运价修改人',
  Cargo_BookingPreAudit: '订舱预审',
  Cargo_UniversalIntelligentRecognition: '通用智能识别',
  Cargo_PromptWords: '提示词',
  Cargo_PleaseUploadFile: '请上传文件',
  Cargo_BatchImportAr1: '批量导入收款销账',
  Cargo_BatchImportAp1: '批量导入付款销账',
  Cargo_BatchImportAr2: '下载收款导入模版',
  Cargo_BatchImportAp2: '下载付款导入模版',
  Cargo_ImportingDataSuccess1: '此操作为异步操作，您可在',
  Cargo_ImportingDataSuccess2: '文件存储->上传日志',
  Cargo_ImportingDataSuccess3: '查看导入结果',
  Cargo_RecordsWrittenOff: '已核销{0}条记录。',
  Cargo_lockLabel1: '锁定买价',
  Cargo_lockLabel2: '锁定卖价',
  Cargo_lockLabel3: '解锁买价',
  Cargo_lockLabel4: '解锁卖价',
  Cargo_UnLockLabel: '解锁',
  Cargo_LockLabel: '锁定',
  Cargo_LockSuccess: '{0}{1}成功',
  Cargo_DisplayByBillOfLading: '按提单展示',
  Cargo_DisplayByDateAndVoyageNo: '按日期航次展示',
  Cargo_ShowSeaExportJob: '合并查看海出订舱数据',
  Cargo_OperatingSpaceOnly: '仅可操作舱位，不可操作订单',
  Cargo_IsCabinSpace: '是否使用现舱',
  Cargo_CheckBoxTip: '箱型箱量与舱位不一致，请核实',
  Cargo_CheckBoxTip2: '订单的船名、航次、船公司、ETD与舱位不一致, 请确认是否继续?',
  Cargo_CheckBoxTip3: '待关联业务已有MBL NO,或 SO NO,无法关联',
  Cargo_AllocationSuccess: '分配成功！',
  Cargo_AllocationCancel: '确认撤销分配?',
  Cargo_CabinReturn: '同时退舱',
  Cargo_CabinReturnTip: '请填写退舱说明',
  Cargo_CancelCabinTip1: '撤销完成',
  Cargo_CancelCabinTip2: '退舱完成',
  Cargo_CancelCabinTip3: '舱位有关联的业务，请先取消关联',
  Cargo_CancelCabinTip4: '舱位关联的业务尚在订舱预审，如需撤销分配，请在订舱预审进行拒绝',
  Cargo_CancelCabinTip5: '舱位关联的业务尚未退关，请先退关',
  Cargo_CancelCabinTip6: '存在未分配舱位，请检查',
  Cargo_BusinessProcessStage: '业务流转阶段',
  Cargo_PleaseSelectDataAndUpload: '请勾选数据后，批量上传文件。',
  Cargo_PleaseSelectDataAndUpload2: '请选择相同业务类型后，批量上传文件。',
  Cargo_BatchUploadFile: '批量上传文件',
  Cargo_BatchUploadFile2: '上传失败不支持此格式',
  Cargo_Allocate3: '分配-创建业务',
  Cargo_CabinCreate1: '创建到订舱预审',
  Cargo_CabinCreate2: '创建到海运订舱',
  Cargo_CabinCreate3: '已生成业务单号：',
  Cargo_CloseAndCopyNumber: '关闭并复制单号',
  Cargo_AllocateCheck1: '存在已分配的数据，请检查',
  Cargo_AllocateCheck2: '存在非已放舱数据，请检查',
  Cargo_OnlyReturnTheCabin: '仅可以删除已退舱状态的数据',
  Cargo_CabinManagement: '舱位管理',
  Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement: '红色字体字段，将以舱位管理的值覆盖海运出口',
  Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten: '蓝色字体字段，将保留海运出口原值，不会被覆盖',
  Cargo_ImportedMultipleBusiness: '已导入匹配多票业务',
  Cargo_UploadedRepeatedly: '重复上传',
  Cargo_BoxType2: '对应箱型箱种',
  Cargo_BoxTypeAndCategory: '箱型箱种',
  Cargo_CheckBoxSize: '请填写箱型',
  Cargo_UsedQuota: '已用额度（对冲）',
  Cargo_PleaseSelectTheConsignee: '请选择收货人',
  Cargo_ViewingMessage: '查看原始报文',
  Cargo_ChangeSettlement: '修改结算对象',
  Cargo_CanNotEditTips: '包含不可编辑的费用，请核对！',
  Cargo_PleaseSelectExpenseToModify: '请选择要修改的费用',
  Cargo_ArChargeSettlementCannotModify: '应收费用结算对象无法修改',
  Cargo_ChargeSettledCannotModify: '费用已生成账单/开票/付款/核销，无法修改',
  Cargo_ArChargeSettlementCannotModifyDetail: '费用{0}为应收费用，结算对象无法修改',
  Cargo_ChargeSettledCannotModifyDetail: '费用{0}已生成账单/开票/付款/核销，无法修改',
  Cargo_CanNotEditChargeDetail: '费用{0}无编辑权限，无法修改',
  Cargo_CheckChargeDetailBranchDetail: '费用{0}所在分公司无操作权限',
  Cargo_BeforeAdjustment: '调整前',
  Cargo_AfterAdjustment: '调整后',
  Cargo_EstimateListQuery: '暂估单查询',
  Cargo_MappingConfiguration: '映射配置',
  Cargo_CreateEstimate: '创建暂估单',
  Cargo_SendSharingCenter: '发送共享中心',
  Cargo_GenerateExpenseAmount: '生成费用金额',
  Cargo_GenerateExpenseMode: '生成费用模式',
  Cargo_GenerateInReceivables: '生成在应收',
  Cargo_GenerateInPay: '生成在应付',
  Cargo_GenerateAll: '分别生成在应收应付',
  Cargo_ChargeAmount: '请填写生成费用金额',
  Cargo_PushDate: '推送日期',
  Cargo_GetSendResult: '获取发送结果',
  Cargo_ALittleSend: '作为零星客户推送',
  Cargo_MappingEditor: '编辑映射',
  Cargo_NewMapping: '新建映射',
  Cargo_Recipient: '发送对象',
  Cargo_DataRepetition: '存在重复数据',
  Cargo_checkTip2: '{0}或者{1}',
  Cargo_ErrorExcel: '模板错误',
  Cargo_ImportException: '导入异常',
  Cargo_SelectiveFinanceMonth: '选择财务月',
  Cargo_FinancialMonth: '财务月份',
  Cargo_PushLog: '推送记录',
  Cargo_ConfirmImport: '是否导入',
  Cargo_NumberOfOriginalCopies: '正本份数',
  Cargo_DisplayDllInformation: '显示全部信息',
  Cargo_DisplayDifferenceInformation: '显示差异信息',
  Cargo_OverrideSystemBillOfLading: '覆盖系统提单',
  Cargo_ContainerIdTip: '装箱信息（勾选则添加到提单中或者覆盖提单数据）',
  Cargo_ContainerInfo2: '装箱信息（勾选后添加到业务中，可编辑）',
  Cargo_ContainerTypeQuantityMismatch: '箱型箱量与勾选的装箱信息不一致，请确认；',
  Cargo_SystemData: '系统数据',
  Cargo_RecognitionData: '识别数据',
  Cargo_SETitle: '计划离泊时间/预计到港时间',
  Cargo_CurentSETitle: '当前计划离泊时间(Current ETD)/当前计划到港时间(Current ETA)',
  Cargo_OriginalSETitle: '原始计划离泊时间(Original ETD)/原始计划到港时间(Original ETA)',
  Cargo_AETitle: '预计起飞时间/预计抵达时间',
  Cargo_SEAtdAtaTitle: '实际离泊时间(ATD)/实际到港时间(ATA)',
  Cargo_AEAtdAtaTitle: '实际起飞时间(ATD)/实际抵达时间(ATA)',
  Cargo_UpdateAtdAtaDateTip: '请输入需要修改的实际离泊时间、实际到港时间',
  Cargo_UpdateAtdAtaDateTip2: '请输入需要修改的实际起飞时间、实际抵达时间',
  Cargo_UpdateDateTip: '请输入需要修改的计划离开时间、预计到港时间',
  Cargo_UpdateDateTip2: '请输入需要修改的预计起飞时间、预计抵达时间',
  Cargo_BusinessNotPositiveOperation: '{0}不是正操作状态，无法修改时间',
  Cargo_SuccessTip: '成功{0}条，失败0条',
  Cargo_SuccessTip1: '成功{0}条，失败{1}条，<br/>失败说明: <br/> {2} 不是正操作状态，无法修改时间',
  Cargo_SuccessTip2: '成功{0}条，失败{1}条，<br/>失败说明: <br/> {2} 不是正操作状态，无法修改 <br/> {3}只勾选了小票未勾选主票信息，无法修改',
  Cargo_ErrorCause: '异常原因',
  Cargo_PushMessage: '推送报文',
  Cargo_PushMessageRsp: '接收报文',
  Cargo_ViewMessage: '查看报文',
  Cargo_Message: '报文',
  Cargo_BusinessApplicationContext: '应用业务场景',
  Cargo_ConfigureEmailTemplate: '配置邮件模版',
  Cargo_SendingPosition: '发送岗位',
  Cargo_DeleteEmailTip: '是否确认删除已勾选的邮件模版？',
  Cargo_UpdateEmailTip: '邮件模版名称不能为空!',
  Cargo_UpdateEmailTip2: '推送环节:{0},发送对象:{1},已有相关设置,请勿重复！',
  Cargo_UpdateEmailTip3: '模板名称【{0}】已存在，邮件模板名称不可重复！',
  Cargo_EmailTemplate: '邮件模版',
  Cargo_OrganizeClearing: '结算组织',
  Cargo_DocumentCode: '单据编号',
  Cargo_BillDate2: '单据日期',
  Cargo_EndDate2: '到期日',
  Cargo_doTip: '后台正在进行异步处理，请稍后重新查询！',
  Cargo_TypeOfExchange: '往来类型',
  Cargo_CurrentAccountCode: '往来户编码',
  Cargo_PE: '暂估/预估',
  Cargo_ENo: '预估单号',
  Cargo_OrderChannel: '适用订单渠道',
  Cargo_MonthlyFinancial: '财务月',
  Cargo_DocumentId: '业务系统单据ID',
  Cargo_NotInWarehouse: '货物没有入仓，是否提前下达出仓指令？下达指令请点击"确认"。',
  Cargo_NotInWarehouse2: '货物没有入仓，是否撤回提前出仓指令？如需撤回请点击"确认"。',
  Cargo_OutboundInstructionIssued: '已下达出库指令',
  Cargo_AlreadyOutbound: '货物已出仓，不可取消出仓指令。',
  Cargo_SourceSystemCoding: '来源系统编码',
  Cargo_businessShipAgency: '业务类型(船代)',
  Cargo_CoinsReceivable: '应收币别',
  Cargo_ArApAmount: '应收/应付金额',
  Cargo_CostItem: '费用项目.编码',
  Cargo_TaxNumber: '税号',
  Cargo_IsDefaultTitle: '是否默认抬头',
  Cargo_SingleTitleMode: '单抬头模式',
  Cargo_MultipleTitleMode: '多抬头模式',
  Cargo_UnitPrice2: '含税单价',
  Cargo_TaxRateCode: '税率.编码',
  Cargo_Discount: '折扣方式',
  Cargo_CanNotChargeTips: '已经存在不可编辑费用，请及时处理!',
  Cargo_RefreshChargeTips: '已经存在费用,是否刷新费用？',
  Cargo_ArAmount: '应收金额',
  Cargo_MonthCode: '月份编码',
  Cargo_BeforeChange1: '更改前整票预估利润',
  Cargo_BeforeChange2: '更改后整票预估利润',
  Cargo_TaxPolicyCoding: '税收政策编码',
  Cargo_SendingSharingCenter: '发送共享中心',
  Cargo_SendingResult: '推送成功:{0}条,失败:{1}条',
  Cargo_System2: '系统',
  Cargo_FileDelete: '文件删除: 删除',
  Cargo_BillsPayable: '应付单',
  Cargo_PaymentSlipDataNo: '付款单单据号',
  Cargo_Payer: '付款对象',
  Cargo_Prepaid: '已预付',
  Cargo_TypeOfInvoice: '发票种类',
  Cargo_UploadInvoiceCloudStatus: '上传发票云状态',
  Cargo_AccountToBeCredited: '收款账户',
  Cargo_BankConnectionNo: '银行联行号/SWIFT CODE',
  Cargo_BankConnectionNo2: '联行号/SWIFT',
  Cargo_OriginalPaymentSlipNo: '原始付款单号',
  Cargo_ProcessNumber: '流程编号',
  Cargo_FinancialPayStatus: '财务应付单状态',
  Cargo_PaymentRequisitionStatus: '付款申请单状态',
  Cargo_DefaultDetailItems: '明细默认项',
  Cargo_GeneratePay: '生成应付单',
  Cargo_MergeGeneratePay: '合并生成应付单',
  Cargo_PrintChannel: '打印渠道',
  Cargo_BookingConfirmed: '已订舱',
  Cargo_OrderRecorded: '已录单',
  Cargo_CreateBillsPayable: '创建应付单',
  Cargo_FinancialPayAreSent: '财务应付单发送',
  Cargo_PaymentRequestSent: '付款申请单发送',
  Cargo_DetailEntryID: '明细分录ID',
  Cargo_PayableSingleAttribute: '应付单属性',
  Cargo_SelectAp2: '请选择开票抬头一致的付款申请',
  Cargo_SelectAp: '请选择应付单',
  Cargo_LookAp: '查看应付单',
  Cargo_IdentifyTheCustomsTips: '存在正在解析或者已经解析过的文件',
  Cargo_IdentifyTheCustomsDeclaration: '识别报关单',
  Cargo_RefreshCustomsDeclaration: '刷新报关单',
  Cargo_ContactMultiple: '一个合同包含多种合同协议',
  Cargo_CustomsActivatedTip: '未开通识别报关服务功能',
  Cargo_CustomsActivatedTip2: '余额不足，请联系客服充值',
  Cargo_CustomsDeclarationNo: '报关单号',
  Cargo_AnalysisStatus: '解析状态',
  Cargo_SystemFee: '系统费',
  Cargo_InsurancePremium: '安保费',
  Cargo_ProcessingFee: '加工费',
  Cargo_FOBValue: 'FOB货值',
  Cargo_ExportCustomsDeclaration: '导出报关单',
  Cargo_Nonstop: '只看直航',
  Cargo_InternationalRoute: '只看国际线路',
  Cargo_SelectNoDeleteAp: '【应付单】已推送,不可删除',
  Cargo_SelectInvoiceAR: '请选择应收发票',
  Cargo_SelectInvoiceAR2: '请选择已经推送的数据，进行状态获取.',
  Cargo_SelectNoPushData: '请选择未推送的数据',
  Cargo_SelectNoDelete: '【暂估单】已推送,不可删除',
  Cargo_SendSharedCenter: '发送共享中心状态',
  Cargo_SelectInvoiceType: '请选择发票类型',
  Cargo_EditAp: '编辑应付单',
  Cargo_NotPushAP: '托收情况，无需推送【财务应付单】',
  Cargo_NotPushAP2: '联行号/SWIFT为空,不可发送',
  Cargo_AttachmentName: '附件名称',
  Cargo_AccessoriesAddress: '附件地址',
  Cargo_canNotEdit: '已经推送，不能编辑',
  Cargo_GetTheWriteOffResult: '获取核销结果',
  Cargo_RemarkMax200: '备注请勿超过 200 字符',
  Cargo_RemarkAutoTruncated: '备注内容超过200字符，系统自动截断',
  Cargo_RemarkTip1: '发票备注总字数超过230字符',
  Cargo_RemarkTip2: '票开场景，“非明细开票”时，需要开票抬头、开票项目名称填写',
  Cargo_PortOfTransferCheck: '请选择“中转港”',
  Cargo_BatchServiceLocking: '批量业务锁定',
  Cargo_UnlockServicesInBatches: '批量解除锁定业务',
  Cargo_SetAMarginAlert2: '设置提醒',
  Cargo_SetAMarginAlert: '设置余量提醒',
  Cargo_ApplicableBranch: '适用分公司',
  Cargo_AdditionalRemark: '附加说明',
  Cargo_FixedLastNumber: '尾号固定00',
  Cargo_GenerativeRule: '生成规则',
  Cargo_StartNumber: '起始单号',
  Cargo_EndNumber: '结束单号',
  Cargo_MarginTip1: '公司单号余量不足提醒',
  Cargo_MarginTip2: '领用人余量不足提醒',
  Cargo_MarginTip3: '如需提醒，请在对应栏位输入单号余量不足数量。',
  Cargo_useTip: '单号必须尚未被使用过',
  Cargo_useTip2: '已作废的单号不可分配',
  Cargo_DeleteTip: '仅可删除已作废的单号',
  Cargo_PrefixTip: '主单号前缀不正确',
  Cargo_StarTip: '起始单号，结束单号不符合规则',
  Cargo_StarNoTip: '起始单号异常',
  Cargo_MarginTip4: '请填写领用人',
  Cargo_NumberErrTip: '*单号数字位数不足',
  Cargo_NumberErrTip2: '单号不符合生成规则',
  Cargo_AlreadyExistTip: '导入失败，导入的单号已存在。<br/>{0}',
  Cargo_ImportStarTip: '导入失败，导入的单号前缀不正确。<br/>{0}',
  Cargo_ImportNoTip: '导入失败，导入的单号异常。<br/>{0}',
  Cargo_EmptyNoTip: '导入的Excel文件没有MBL号码',
  Cargo_CarrierCheck: '请先录入船公司',
  Cargo_NumberMarginUse: '当前用户单号余量低于{0}',
  Cargo_NumberMarginCompany: '当前公司单号余量低于{0}',
  Cargo_receiveTip: '你输入的单号已经被领用，请确认是否继续?',
  Cargo_receiveTip2: '主单号与“主单号管理”维护的数据不一致，确定要继续使用该单号吗？',
  Cargo_ImperialUnits: '英制单位',
  Cargo_Metric: '公制',
  Cargo_Imperial: '英制',
  Cargo_AirExportEnableImperialUnits: '空运出口开启英制单位输入',
  Cargo_Inch: '英寸',
  Cargo_Pound: '磅',
  Cargo_CubicFoot: '立方英尺',
  Cargo_Centimeter: '厘米',
  Cargo_Kilogram: '千克',
  Cargo_CubicMeter: '立方米',
  Cargo_measurements2: '尺寸in(长*宽*高*件数)',
  Cargo_GrossProfit: '毛利',
  Cargo_MustEnterComplete: '必须录入完整',
  Cargo_CostVirtualImplementationToConsolidationPlan: '费用虚拟落实到拼装计划上',
  Cargo_EstimatedDeliveryDate: '预计交货时间',
  Cargo_CheckWarehouseInConfig: '请选择仓库',
  Cargo_SelectScales: '请选择地磅',
  Cargo_ReceivablesWriteoffDate: '应收核销日期',
  Cargo_PayablesWriteoffDate: '应付核销日期',
  Cargo_PleaseEnterPieceCount: '请录入件数',
  Cargo_PleaseConfirm: '请确认进仓流水号/送仓单号',
  Cargo_WarehouseInState: '业务入库状态',
  Cargo_LocationConfigurationError: '托盘不能重复或已经被占用，请检查',
  Cargo_KeyNull: 'appKey未配置',
  Cargo_TokenNull: 'token 获取空',
  Cargo_CameraNull: '摄像头配置错误',
  Cargo_Reading: '读数',
  Cargo_FeeInvoiceTitle: '费用发票抬头',
  Cargo_PaymentApplicationTitle: '付款申请抬头',
  Cargo_ReadingTip: '多条尺寸使用逗号\',\'或分号\';\'分隔\n格式：长*宽*高/件数;长×宽×高/件数\n例如：35*40*30/3;35×40×30/3;',
  Cargo_ReadingTip2: '请在仓库中指定地磅配置',
  Cargo_CargoTerminalGrossWeight: '货站毛重(KG)',
  Cargo_FileUpload: '附件上传',
  Cargo_inputMblTip: '请扫描/输入主单号',
  Cargo_OutboundWeight2: '出重操作',
  Cargo_FileInfo: '附件信息',
  Cargo_DeliveryOperation: '交货操作',
  Cargo_MasterAirwayBill: '主运单号',
  Cargo_DeliveryCargoStation: '交货货站',
  Cargo_SplitOrderNumber: '分单数',
  Cargo_TotalPieces: '总件数',
  Cargo_TotalGrossWeight: '总毛重',
  Cargo_TotalChargeableWeight: '总计重',
  Cargo_TotalVolume: '总体积',
  Cargo_PrintCheck1: '打印范围或份数不正确，请检查',
  Cargo_PrintRange: '打印范围',
  Cargo_PrintNumber: '打印份数',
  Cargo_GrossWeight3: '配重重量',
  Cargo_DimensionsEntry: '尺寸录入',
  Cargo_WarehouseTip3: '取消出仓指令完成',
  Cargo_WarehouseTip2: '出仓指令完成',
  Cargo_WarehouseTip1: '未完成配货，请检查',
  Cargo_CancelOutboundOrder: '取消出仓指令',
  Cargo_OutboundOrder: '出仓指令',
  Cargo_GoodsArrived: '货已到齐',
  Cargo_Pallet3: '托',
  Cargo_WeightedInfo: '已磅重信息',
  Cargo_ScaleReading: '地磅读数',
  Cargo_ScalePhoto: '地磅拍照',
  Cargo_Tip: '提示：支持 进仓流水号/送仓单号',
  Cargo_ReadScale: '读磅',
  Cargo_TakePhoto: '拍照',
  Cargo_Weighing: '磅重',
  Cargo_WeightRecord: '磅重记录',
  Cargo_WeightHandling: '磅重处理',
  Cargo_SaveDone: '保存并入仓完成',
  Cargo_DeliverySecurityCheck: '交货',
  Cargo_OutboundWeight: '出重',
  Cargo_CurrentBusinessAlreadyWeighedOut: '当前业务已出重，禁止重复操作',
  Cargo_CurrentBusinessAlreadyDelivered: '当前业务已交货，禁止重复操作',
  Cargo_NetGrossWeight: '净毛重',
  Cargo_VolumeWeight: '体积重量',
  Cargo_BatchEnterDimensions: '批量录入尺寸',
  Cargo_CoveringSizeAndQuantity: '注：点击确认后将全量覆盖原尺寸、件数信息。',
  Cargo_Recognition: '识别',
  Cargo_EstimatedDeliveryDateError: '识别错误',
  Cargo_ScaleWeight: '地磅重量',
  Cargo_OurPallet: '我司托盘',
  Cargo_TareWeight: '皮重',
  Cargo_GrossWeight2: '配重',
  Cargo_Location2: '库位',
  Cargo_FrontEndWarehouseOperation: '前置仓操作',
  Cargo_CargoTerminalOperation: '货站操作',
  Cargo_FileSizeCannotExceed20m2: '文件大小不可超过20M，支持.xls和.xlsx格式',
  Cargo_StateUpdate: '状态更新',
  Cargo_NotData: '没有找到数据',
  Cargo_LclHasMaster: '小票已经关联过主票',
  Cargo_ParamError: '参数错误，请检查',
  Cargo_CheckInventory: '查库存',
  Cargo_ReleaseLocation: '释放库位',
  Cargo_LocationCode: '库位编码',
  Cargo_Warehouse2: '所属仓库',
  Cargo_LocationType: '库位类型',
  Cargo_LocationStatus: '库位状态',
  Cargo_LocationDeleteTip: '库位已占用，不能删除',
  Cargo_ReadFailure: '读取失败',
  Cargo_PalletDeleteTip: '当前托盘已占用，不能删除',
  Cargo_NoLocationSelected: '没有选择库位',
  Cargo_PackingCondition: '包装情况',
  Cargo_SpecialHandling: '特殊处理',
  Cargo_PalletNumber: '板纸号',
  Cargo_InventoryCheck: '库存查看',
  Cargo_ApplyRuleToAllScenarios: '规则设置应用于全部场景',
  Cargo_DocumentsWithCargo: '随货文件',
  Cargo_PalletConfiguration: '托盘管理',
  Cargo_Pallet2: '托盘',
  Cargo_PalletID: '托盘编号',
  Cargo_PalletStatus: '托盘状态',
  Cargo_PalletMaterial: '托盘材质',
  Cargo_RecyclingType: '回收类型',
  Cargo_PalletTareWeight: '托盘皮重',
  Cargo_AirCargoTerminal: '空港货站',
  Cargo_WarehouseType: '仓库类型',
  Cargo_WarehouseCode2: '仓库代码',
  Cargo_WarehouseName: '仓库名称',
  Cargo_WarehouseAddress: '仓库地址',
  Cargo_Terminal: '货站',
  Cargo_TerminalCode: '货站代码',
  Cargo_TerminalName: '货站名称',
  Cargo_AirportCode: '机场代码',
  Cargo_TerminalAddress: '货站地址',
  Cargo_DeliveryMap: '送货地图',
  Cargo_RecipientContact: '接货联系人',
  Cargo_RecipientContactPhone: '接货联系电话',
  Cargo_SecurityCheckMachineWidthLimit: '安检机限宽',
  Cargo_SecurityCheckMachineHeightLimit: '安检机限高',
  Cargo_CustomsCode: '海关编码',
  Cargo_WeighbridgeNumber: '地磅编号',
  Cargo_WeighbridgeBaudRate: '地磅波特率',
  Cargo_Checksum: '校验位',
  Cargo_AutoFinanceAuditLockOrder: '自动财务审核锁单',
  Cargo_UnSubmittedBusinessLockOrder: '未提交的业务，将自动执行锁单操作（业务状态：正操作->已审核）',
  Cargo_PollingFrequency: '轮训频次',
  Cargo_SpecificDateMonthly: '每月指定日期',
  Cargo_DailyOnce: '每天一次',
  Cargo_PhotoTaken: '是否拍照',
  Cargo_CameraConfiguration: '摄像头配置',
  Cargo_WeighbridgeTest: '地磅测试',
  Cargo_Test: '测试',
  Cargo_MonitoringInterface: '监控接口',
  Cargo_DeviceNumber: '设备号',
  Cargo_MonitoringChannel: '监控通道',
  Cargo_MonitoringInterface1: '萤石云',
  Cargo_DeleteTip1: '您将删除【{0}】个{1}信息，请谨慎操作',
  Cargo_GeneralCargoWarehouse: '普货仓库',
  Cargo_WarehouseStorageLocation: '仓库库位',
  Cargo_WoodenPackagingType: '木制包装类型',
  Cargo_ClearSave: '清空并保存',
  Cargo_OrderModificationTimes: '改单次数',
  Cargo_ServiceStatisticalArea: '业务统计区域',
  Cargo_DangerousGoodPackage: '危险品包装',
  Cargo_DangerousGoodPackageCode: '危险品包装代码',
  Cargo_OOGTEU: 'OOG TEU量',
  Cargo_SeaRailTransport: '海铁联运',
  Cargo_BoxOneWay: '用箱(单程/循环)',
  Cargo_OOGTEUTip: '请填写OOG TEU量',
  Cargo_OneWay: '单程',
  Cargo_Circulation: '循环',
  Cargo_Grade: '二级自定义业务类型',
  Cargo_Grade2: '上级自定义业务类型',
  Cargo_LotteryDraw: '票开',
  Cargo_SchoolMonth: '月开',
  Cargo_WithdrawTheEntrustment: '撤销委托',
  Cargo_checkData1: '没有找到委托数据或已经被审核',
  Cargo_ContractTip: '如需要调整合同协议，需先撤销合同',
  Cargo_DetailMakeInvoice: '明细开票',
  Cargo_SplitMakeInvoice: '拆分币种开票',
  Cargo_RemarkAddContent: '开票备注追加内容',
  Cargo_RemarkAddContent3: '开票备注汇率内容',
  Cargo_BillResults: '提单识别字段',
  Cargo_BillResults2: '系统提单数据',
  Cargo_NotUpdate: '不可更改',
  Cargo_UpdateCheck1: '请注意箱型箱量与勾选的装箱信息不一致',
  Cargo_CustomerAssociatedFactory: '客户关联工厂',
  Cargo_FactoryName: '工厂名称',
  Cargo_AddAssociatedFactory: '新增关联工厂',
  Cargo_BatchOperationSameEntrustedUnit: '此批量操作仅支持相同委托单位业务时使用，请重新勾选。',
  Cargo_ImportFailMessage: '导入失败：本次批量导入费用不满足结算对象=委托单位 或 关联工厂的限制，请调整后重试',
  Cargo_SaveAndConfirm: '保存并确认',
  Cargo_ExportUndoHistory: '导出撤销历史',
  Cargo_RevocationBy: '撤销人',
  Cargo_RevocationByDate: '撤销时间',
  Cargo_billingTip: '根据账单开票要求开票',
  Cargo_remarkAddContent2: '追加备注内容',
  Cargo_detailMakeInvoice2: '是否明细开票',
  Cargo_splitMakeInvoice2: '是否拆分币种开票',
  Cargo_rmbGoodsName: 'CNY开票项',
  Cargo_usdGoodsName: 'USD开票项',
  Cargo_CarrierCode: '船舶EDI代码',
  Cargo_identifyTheResult: '识别结果',
  Cargo_identifyTheResult2: '识别提单信息',
  Cargo_SystemResult: '系统提单信息',
  Cargo_ContrastingSystem: '对比系统',
  Cargo_SaveBillData: '保存系统提单信息',
  Cargo_SaveBill2: '识别信息覆盖并保存提单',
  Cargo_InAnalysis: '解析中，请稍等',
  Cargo_UnopenedService: '未开通服务，无法使用',
  Cargo_F17Verify: '发送F17需要保证主单号和分单号一致',
  Cargo_Will: '将',
  Cargo_DFI: '拖到此处进行识别，或',
  Cargo_seaFile: '海出的托书文件',
  Cargo_seaFile2: '海出托书识别',
  Cargo_siFile: '海进的提单文件',
  Cargo_siFile2: '海运进口提单识别',
  Cargo_seBillFile: '海出的提单文件',
  Cargo_seBillFile2: '海运出口提单识别',
  Cargo_aeFile2: '空运出口托书识别',
  Cargo_aiFile2: '空运进口提单识别',
  Cargo_GenerateSiBusiness: '生成海运进口业务',
  Cargo_MaritimeIdentification: '海运识别',
  Cargo_ApplicationIdentificationType: '应用识别类型',
  Cargo_IdentificationType: '识别类型',
  Cargo_IdentificationChannel: '识别渠道',
  Cargo_OriginalMessage: '原始报文',
  Cargo_DataSource: '数据来源',
  Cargo_InvoiceExport: '发票导出',
  Cargo_InvoiceNoImport: '导入发票号',
  Cargo_profitMargin: '利润率',
  Cargo_Payment1: '付款方',
  Cargo_PaymentCode: '付款方代码',
  Cargo_PaymentName1: '付款方联系人名称',
  Cargo_PaymentName: '付款方名称',
  Cargo_SelectPayment: '选择付款方',
  Cargo_ShowTab: '显示补充页签',
  Cargo_MscBookingInfo: 'MSC订舱补充信息',
  Cargo_PaymentInfo: '付款方信息',
  Cargo_PaymentInfo1: '格式化付款方',
  Cargo_PaymentEnterpriseCode: '付款方企业代码',
  Cargo_Payment2: '付款方企业名称',
  Cargo_Payment3: '付款方详细地址',
  Cargo_Payment4: '付款方电话号码',
  Cargo_Payment5: '付款方Email地址',
  Cargo_Payment6: '付款方电传号码',
  Cargo_Province1: '省/州',
  Cargo_GeneralFormat: '通用格式',
  Cargo_DetailFormat: '明细格式',
  Cargo_BringInData: '带入数据',
  Cargo_DefaultInvoiceIssuer: '默认开票员',
  Cargo_checkCabinTip: '存在舱位流水和无舱位流水的数据，不可一并操作',
  Cargo_checkCabinTip2: '您勾选的订单，将执行撤回舱位流程',
  Cargo_RecoverText: '回收舱位并直接登记退舱，是否确认？',
  Cargo_RecoverRemark: '退舱说明',
  Cargo_RecoverTips: '回收并退舱',
  Cargo_LinesArAp: '应收行数/应付行数',
  Cargo_RInPay: '应收包含应付',
  Cargo_market: '销售',
  Cargo_GPExplain: 'GP说明',
  Cargo_ServiceLockSetting1: '自动业务锁定设置',
  Cargo_ServiceLockSettings: '业务自动执行配置',
  Cargo_OnlyServiceDataLocked: '仅锁定业务数据，费用页签可以编辑',
  Cargo_AutomaticallyLocksServiceData: '自动锁定业务单据',
  Cargo_AutomaticallySubmitServiceData: '自动提交业务单据',
  Cargo_SystemAutomaticExecution: '系统自动执行',
  Cargo_ServicesNotSubmittedAutomaticallySubmitted: '未提交的业务，将自动执行提交操作（业务状态：正操作->已提交）',
  Cargo_LockTheNumberOfDeferredDays: '锁定延后天数为3-120之间',
  Cargo_checkBillingGroup: '【{0}】账单状态不是"{1}"',
  Cargo_AutoLock: '自动锁定',
  Cargo_BusinessDate1: '业务日期后',
  Cargo_Days1: '(天)',
  Cargo_SendBookingFail: '发送订舱失败',
  Cargo_OrderTemplateSaveSuccess: '订单模板配置保存成功',
  Cargo_ContinueSave: '模板表头名称未配置将使用实际业务字段名，是否继续？',
  Cargo_OrderTemplateSaveFail: '订单模板配置保存失败',
  Cargo_DownImportTemplate: '下载导入模板',
  Cargo_DownImportTemplate_Simple: '下载导入单个模板',
  Cargo_DownImport_Simport: '单个导入',
  Cargo_ImportingData: '正在导入数据...',
  Cargo_ImportingDataSuccess: '此操作为异步操作，您可在 文件存储->上传日志 查看导入结果',
  Cargo_WriteOffHeader: '销账抬头',
  Cargo_PackageNo: '包装号：',
  Cargo_DeletePackage: '删除包装',
  Cargo_WareHoused: '这些包装已入仓',
  Cargo_NotWareHoused: '这些包装未入仓',
  Cargo_CheckPackage: '是否确定删除对应包装？如确定则实际进仓数据也将被删除。',
  Cargo_SureDeletePackageIn: '这些包装已入仓，是否确定删除对应包装？如确定则实际进仓数据也将被删除。',
  Cargo_SelectPackage: '请选择需要删除的包装数据',
  Cargo_SureDeleteAbovePackage: '是否确认删除以上这些包装？',
  Cargo_BalanceSheetQuarter: '资产负债表季报',
  Cargo_ProfitLossQuarter: '利润表季报',
  Cargo_BalanceSheetYear: '资产负债表年报',
  Cargo_ProfitLossYear: '利润表年报',
  Cargo_ReasonForJudgment: '判责原因',
  Cargo_CheckSavePoInfoItem: '该商品已与包装关联，请先解除关联！',
  Cargo_HasBillingGroup: '此单已生成对账单，不能被编辑！',
  Cargo_HasInvoice: '此单已此单已开票，不能被编辑！',
  Cargo_HasWriteOff: '此单已此单已核销，不能被编辑！',
  Cargo_HasConfirm: '此单已确认，不能被编辑！',
  Cargo_ContinueOperation: '继续操作',
  Cargo_CancelOperation: '取消操作',
  Cargo_BackTopPreviousVersion: '返回旧版',
  Cargo_Combine: '合并',
  Cargo_DataEnableSuccess: '数据启用成功！',
  Cargo_DataDisEnableSuccess: '数据禁用成功！',
  Cargo_CombineChargeItem: '合并收费项目',
  Cargo_ConsolidatedChargeItem: '被合并的收费项目：',
  Cargo_ChargeItemHasUsedForCombine: '{0}已被禁用，请选择其他收费项目合并！',
  Cargo_CombineChargeItemTips: '合并后将刷新所有{1}相关的费用为{0}并设置为禁用状态，是否继续？',
  Cargo_CombineChargeItemTipsOne: '正在合并，请稍等。',
  Cargo_CombineChargeItemTipsTwo: '您可以离开此界面，预计将于10分钟内完成合并，请稍后查看。',
  Cargo_CombineChargeItemTipsThree: '请选择不同的收费项目进行合并！',
  Cargo_PayService: '收费项目：',
  InvoiceTitleCannotBeBlank: '发票抬头不能为空',
  InvoiceTitleCannotBeDuplicate: '发票抬头不能重复',
  TaxControlPanelCannotBeDuplicate: '一个税控盘【{0}】不允许被多个开票抬头关联',
  CheckTaxControlPanelNo: '【{0}】维护了多个税控盘编号，是否继续？',
  TaxControlPanelNoHasInvoiceTitle: '税控信息已关联开票抬头，无法删除，请先取消关联！',
  ChinaAdditionalTaxRateIsEmpty: '【中国附加税率】字段为空，确认是否继续保存？',
  SpecialCharactersExcept: '存在英文、数字、标点符号 以外的其他特殊字符',
  Cargo_ThePreAllocatedManifestHasBeenSentForThisTicketBusiness: '此票业务已发送过预配舱单。导入失败。',
  EstimatedDeliveryDate: '预计送货日期',
  ActualDeliveryDate: '实际送货日期',
  LatestDeliveryDate: '最晚送货日期',
  DischargingWay: '卸货方式',
  Cargo_DownloadSource: '资料下载',
  Cargo_canOnlyBeUppercaseCharactersAndNumbers: '只能是大写字符和数字',
  Cargo_numbersNotLetters: '数字，不能含字母',
  Cargo_pleaseSelectShippingTerms: '请选择运费条款',
  Cargo_pleaseSelectTheTypeOfGoods: '请选择货物类型',
  Cargo_pleaseSelectTheBillOfLadingMethod: '请选择提单方式',
  Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters: '请输入港口大写英文全称',
  Cargo_PortOfDischargeTipText: '中转填中转港，直达填目的港',
  Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers: '只能是字母、数字、“.”、“-”、“空格”',
  Cargo_PortPreRateCode: '港前运价编号',
  Cargo_SideLineType: '支线类型',
  Cargo_EndRouteRateCode: '尾程运价编号',
  Cargo_DeliveryAddressType: '配送地址类型',
  Cargo_DirectHaul: '直拖',
  Cargo_SideLine: '支线',
  Cargo_HuzhouSeaRail: '湖州海铁',
  Cargo_HaiNingBranch: '海宁支线',
  Cargo_ZhapuSideLine: '乍浦支线',
  Cargo_OriginPortInfo: '起运港信息',
  Cargo_ChargeByContainerType: '按箱型计费条目',
  Cargo_ChargeNotByContainerType: '非按箱型计费条目',
  Cargo_SpecialRemark: '特殊备注',
  Cargo_AddEntry: '增加条目',
  Cargo_FreeUseContainer: '免用箱',
  Cargo_FreeStorage: '免堆存',
  Cargo_ThirdPartyAddress: '第三方地址',
  Cargo_AmazonWarehouse: '亚马逊仓库',
  Cargo_WalmartWarehouse: '沃尔玛仓库',
  Cargo_YiCang: '易仓',
  Cargo_DestinationPortInfo: '目的港信息',
  Cargo_Shelving: '上架',
  Cargo_PleaseSelectNonNormalRateForShelving: '请选择非"正常"状态的运价进行上架',
  Cargo_PleaseSelectValidRateForShelving: '请选择有效期生效的运价进行上架',
  Cargo_PleaseSelectNormalRateForUnShelving: '请选择"正常"状态的运价进行下架',
  Cargo_SeaFreightFullContainer: '海运整箱',
  Cargo_SeaFreightLessThanContainer: '海运拼箱',
  Cargo_EnquiryNumber: '询价编号',
  Cargo_EnquirySource: '询价来源',
  Cargo_Enquirer: '询价人',
  Cargo_EnquiryStatus: '询价状态',
  Cargo_FirstLegQuoteStatus: '港前报价状态',
  Cargo_MainlineQuoteStatus: '干线报价状态',
  Cargo_LastLegQuoteStatus: '尾程报价状态',
  Cargo_PalletType: '货盘性质',
  Cargo_DirectOrTransshipment: '直达/中转',
  Cargo_Range: '区间',
  Cargo_Dimensions: '长宽高',
  Cargo_Terms: '服务条款',
  Cargo_DeliveryAddress: '送柜地址',
  Cargo_NameHSCode: '品名（HS Code）',
  Cargo_MainlineRate: '干线运价',
  Cargo_PrePortRate: '港前运价',
  Cargo_EndRouteRate: '尾程运价',
  Cargo_RateCode: '运价编号',
  Cargo_CreatBy: '报价人',
  Cargo_MatchQuote: '匹配报价',
  Cargo_Select_Inquiry_Responsible: '选择询价负责人',
  Cargo_Multiple_Route_Leaders: '匹配到多个航线负责人信息，请选择需要发起询价的人员：',
  Cargo_Pre_Port_Rate_Leader: '港前运价负责人',
  Cargo_Mainline_Rate_Leader: '干线运价负责人',
  Cargo_End_Route_Rate_Leader: '尾程运价负责人',
  Cargo_NoMatchFound: '未匹配到[{0}]',
  Cargo_CombinationPlanQuery: '组合方案查询',
  Cargo_FillQueryConditions: '填写查询条件',
  Cargo_SelectMatchingRate: '选择匹配运价',
  Cargo_GenerateCombinationPlan: '生成组合方案',
  Cargo_ReturnToPreviousStep: '返回上一步',
  Cargo_PrePortPrice: '港前价格',
  Cargo_MainlinePrice: '干线价格',
  Cargo_LastMilePrice: '尾程价格',
  Cargo_AssociatedPrePortQuoteNumber: '关联港前报价单号',
  Cargo_AssociatedLastMileQuoteNumber: '关联尾程报价单号',
  Cargo_20GPQuantity: '20GP数量',
  Cargo_40GPQuantity: '40GP数量',
  Cargo_40HCQuantity: '40HC数量',
  Cargo_45HCQuantity: '45HC数量',
  Cargo_20NORQuantity: '20NOR数量',
  Cargo_40NORQuantity: '40NOR数量',
  Cargo_20FootNORQuantity: '20\'NOR数量',
  Cargo_40FootNORQuantity: '40\'NOR数量',
  Cargo_SubmitQuotation: '提交报价',
  Cargo_WithdrawQuotation: '撤回报价',
  Cargo_RejectQuotation: '拒绝报价',
  Cargo_InquiryManagement: '货物询价管理',
  Cargo_PrePort: '港前',
  Cargo_FinalMile: '尾程',
  Cargo_OriginAreaSelection: '起运地区域选择',
  Cargo_ShippingAddressSelection: '配送地址选择',
  Cargo_AddArea: '+添加区域',
  Cargo_AddAddress: '+添加地址',
  Cargo_AddressDisabledTip: '可添加多个区域，当选择2个及以上街道/村镇时，详细地址将禁用',
  Cargo_PleaseMaintainAtLeastOne: '请至少维护一条',
  Cargo_CannotMatchPleaseFill: '{0}无法进行匹配，请填写[{1}]',
  Cargo_Match: '匹配',
  Cargo_QuoteStatusNotAllowedSave: '已报价状态下不允许保存',
  Cargo_SaveDraft: '保存草稿',
  Cargo_PublishDirectly: '直接上架',
  Cargo_SelectPendingQuoteSubmittedCancel: '请选择待报价且已提交的询价单进行撤销',
  Cargo_LastMileDeliveryAddress: '尾程送货地址',
  Cargo_PackingDoorPoint: '装箱门点',
  Cargo_BoxTypeNotAllowedDuplicate: '箱型不允许重复',
  Cargo_PrePortBusinessLeader: '港前商务负责人',
  Cargo_MainlineBusinessLeader: '干线商务负责人',
  Cargo_LastMileBusinessLeader: '尾程商务负责人',
  Cargo_OverseaTracking: '海外跟单',
  Cargo_OverseaTracker: '海外跟单负责人',
  Cargo_EndCommerceSynced: '已同步',
  Cargo_EndCommerceAudited: '已审核',
  Cargo_EndCommerceNotSynced: '未同步',
  Cargo_EndCommerceFinalStepAudit: '是否尾程审核',
  Cargo_EndCommerceNotAudited: '未审核',
  Cargo_EndCommerceNoAuditRequired: '无需审核',
  Cargo_EndCommerceAuditPassBtn: '审核通过',
  Cargo_EndCommerceAuditSuccessCount: '审核成功{count}条',
  Cargo_EndCommerceSelectedAudited: '选择数据已审核',
  Cargo_EndCommerceSelectedNoAuditRequired: '选择数据无需审核',
  Cargo_EndCommercePleaseSelectAtLeastOne: '请选择至少一条数据',
  Cargo_EndCommerceOnlySelectOne: '当前操作只能选择一条数据',
  Cargo_EndCommerceRecordNotAllowEdit: '当前记录不允许编辑修改',
  CargoMsg_CurrentIdentityNotice: '当前身份将关联后续权限，如您希望以其他身份角色提交询价，请先在界面右上角切换分公司与部门',

  Cargo_enterTheVoyageThereCanBeNoV: '不可以有V.',
  Cargo_ResubscribeBookingReceipt: '重新订阅订舱回执',
  Cargo_BookingReceiptSubscriptionFailed: '订阅订舱回执失败',
  Cargo_inputVoyage: '请输入航次',
  Cargo_pleaseSelectAShippingGeneration: '请选择船代',
  Cargo_pleaseSelectAShippingCompany: '请选择船公司',
  Cargo_pleaseEnterAnAddressWithin140Characters: '请输入地址，140个字符以内',
  Cargo_pleaseEnterTheEnterpriseCode: '请输入企业代码，需含“+”、+号前后不能含空格',
  Cargo_pleaseEnterAPhoneNumber: '请输入电话号码',
  Cargo_pleaseEnterANameWithin140Characters: '请输入名称，140个字符以内',
  Cargo_pleaseEnterANameWithin140Characters2: '请输入名称，70个字符以内',
  Cargo_pleaseSelectACountryCode: '请选择国家代码',
  Cargo_pleaseEnterTheActualContactName: '请输入实际联系人名称',
  Cargo_ViewShipGenerations: '查看船代',
  Cargo_ReferenceShipGenerations: '参考船代',
  Cargo_CopyShipInformation: '复制船信息',
  Cargo_PleaseInquireWithTheBookingHatchOrCustomerService: '请咨询订舱口或客服',
  UnverifiedAmountForCharge: '未销金额（费用）',
  VerifiedAmountForCharge: '已销金额（费用）',
  ReceivableForCharge: '应收（费用）',
  PayableForCharge: '应付（费用）',
  Cargo_PrePlanBookingCheckSoNo: '发送/更正的预配舱单中存在本票业务内未维护过的关单号。是否继续？',
  Cargo_SwitchToTheOldVersion: '切换至老版本',
  Cargo_MaintainChargeItem: '请先维护费用项目！',
  Cargo_UsePeriodRate: '是否使用明细汇率',
  Cargo_initRatePeriod: '初始化历史汇率生效日期',
  Cargo_MonthRate: '月汇率',
  Cargo_PartialImport: '部分导入',
  Cargo_CopyCustomerShippingInformation: '抄录收发通',
  Cargo_NoPermissionForModule: '您没有打开模块的权限！',
  Cargo_OcPayment: '查询线下收款信息',
  Cargo_BatchProcess: '批量处理',
  Cargo_BatchCancelProcess: '批量取消处理',
  Cargo_OcPaymentTime: '支付日期',
  Cargo_ErialNumber: '三方支付流水号',
  Cargo_OcErialNumber: 'OC支付流水号',
  Cargo_BillingAccountId: '账单结算客户名称',
  Cargo_BillingSettlementAgentId: '账单代理结算名称',
  Cargo_Processed: '是否处理',
  Cargo_Project: '项目名称',
  Cargo_PaymentStatus: '支付状态',
  Cargo_UnlockPaymentTimeQuery: '若选的支付日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  Cargo_OnlyUnProcessedRecordsCanBeProcessed: '只能处理未被处理的【线下转账】记录。',
  Cargo_ConfirmAndProcessSelectedRecord: '是否确认处理选择的【线下转账】记录？',
  Cargo_OnlyProcessedRecordsCanBeCancelled: '只能取消已经被处理的【线下转账】记录。',
  Cargo_CancelProcessOfSelectedRecord: '是否确认取消处理选择的【线下转账】记录？',
  Cargo_ProcessedSuccessfully: '标记为已处理',
  Cargo_CancelProcessSuccessfully: '标记为未处理',
  Cargo_LockedOrNot: '是否锁定',
  Cargo_DeleteOCBillTips: '只能删除未锁定的账单！',
  Cargo_DeleteRecheckedBillTips: '只能删除未复核的账单！',
  Cargo_OCCanWriteOff: '只能核销已锁定的【线下转账】账单！',
  Cargo_Adjustment: '调整',
  Cargo_InChangeExpenseReview: '在更改费用审核中',
  Cargo_Verification: '核销',
  Cargo_BeWriteBack: '被红冲',
  Cargo_InquiryAndQuotation: '询报价',
  Cargo_AlertTodoCategoryList: '预警待办分类列表',
  Cargo_ItemDescription: '事项说明',
  Cargo_Alert: '预警',
  Cargo_Todo: '待办',
  Cargo_TodoAlert: '待办/预警',
  Cargo_ChangeFeeApplicationProgress: '更改费用申请进度',
  Cargo_userDefinedRole1: '自定义岗位1',
  Cargo_userDefinedRole2: '自定义岗位2',
  Cargo_userDefinedRole3: '自定义岗位3',
  Cargo_userDefinedRole4: '自定义岗位4',
  Cargo_userDefinedRole5: '自定义岗位5',
  Cargo_userDefinedRole6: '自定义岗位6',
  Cargo_userDefinedRole7: '自定义岗位7',
  Cargo_userDefinedRole8: '自定义岗位8',
  Cargo_DisplaysTheRequestChangeFee: '显示申请更改费用',
  Cargo_UpdateVesselVoyageMsg: '您已修改了船名航次，{0} 已有值，是否需要清空？',
  Cargo_UpdateMblMsg: '您调整了主单号，通过空运出口货踪服务已获取，{0} 是否要清空相关字段？',
  Cargo_CheckUnitRate: '有费用单价为0，继续保存将自动清除单价为0的费用，是否继续保存？',
  Cargo_ZeroUnitPrice: '有费用单价为0，继续保存还是清除单价为0的费用？',
  Cargo_ClearZeroFee: '清除为0的费用',
  Cargo_NoFeesCanBeAdded: '没有费用可新增',
  Cargo_ZeroUnitPriceEntry: '费用单价录入0，请确认是否继续保存',
  Cargo_ZeroAmountWarning: '费用单价或金额录入0，请确认是否继续保存',
  Cargo_Readjust: '重新调整',
  Cargo_Validate_Insure: '总公司下不允许使用保险功能，请切换至分公司。',
  Cargo_ReceivingOperator: '接收操作人',
  Cargo_ReceivingOperationTime: '接收操作时间',
  Cargo_ClaimOperator: '认领操作人',
  Cargo_ClaimOperationTime: '认领操作时间',
  Cargo_OrderChangeOperator: '改单操作人',
  Cargo_ChangeOrderOperationTime: '改单操作时间',
  Cargo_ContinueToReleaseDocuments: '确认是否继续放单？',
  Cargo_ExpectedReturnDate: '预计交回日期',
  Cargo_OcPrePayment: '预收标记',
  Cargo_OcCancelPrePayment: '取消预收标记',
  Cargo_GetKingdeId: '获取金蝶ID',
  Cargo_RefreshData: '操作失败，请刷新后重试！',
  Cargo_ContinueExportTip: '所选记录已导出，是否确定要再次导出？',
  Cargo_WarnRuleConfiguration: '预警规则配置列表',
  Cargo_BPMApprovalProcess: 'BPM审批流程',
  Cargo_DataServiceReminder: '数据服务提醒',
  Cargo_ValueAddedServiceReminder: '增值服务提醒',
  Cargo_DataServiceItems: '数据服务项',
  Cargo_SopTemplate: 'SOP模板',
  Cargo_SopNode: 'SOP节点',
  Cargo_TriggerTypeSelection: '触发类型选择',
  Cargo_TriggerType: '触发类型',
  Cargo_WarningConditions: '预警条件',
  Cargo_NodeUpdate: '节点更新',
  Cargo_EarlyWarning: '预警类型',
  Cargo_WarningContent: '预警内容',
  Cargo_DataServiceConfig: '数据服务配置名',
  Cargo_ConfigureNameNotEmpty: '配置名不能为空',
  Cargo_ConfigureNameRepeat: '{0} 已存在，配置名不可重复',
  Cargo_NotifierRoleRepeat: '岗位 {0} 已经存在配置 {1} 中,请勿重复配置',
  Cargo_NotifierIdRepeat: '人员 {0} 已经存在配置 {1} 中,请勿重复配置',
  Cargo_RemarksInfo: '备注信息',
  Cargo_DesignatedPost: '指定岗位(根据每票业务中设置的操作、销售、客服等岗位发送通知)',
  Cargo_SendSettings: '发送设置',
  Cargo_SetTheNotificationRecipients: '设置通知对象(内部人员)',
  Cargo_ReminderMethod: '提醒方式',
  Cargo_DesignatedPersonnel: '指定人员',
  Cargo_AutoIgnoreMode: '自动忽略方式',
  Cargo_WarningLevel: '预警级别',
  Cargo_ShipPlanReminderMethod: '船舶计划提醒方式',
  Cargo_ShipNameAndVoyage: '按照船名航次提醒',
  Cargo_Job: '按照业务提醒',
  Cargo_AlertOnStatus: '预警开启状态',
  Cargo_EarlyWarningMode: '预警模式',
  Cargo_WarningSwitch: '预警开关',
  Cargo_StartAlert: '开启预警',
  Cargo_CloseAlert: '关闭预警',
  Cargo_EnablePersonalSettings: '开启个人设置',
  Cargo_ClosePersonalSettings: '关闭个人设置',
  Cargo_DataServiceReminderWarning1: '1.【按照“基本配置”设置的推送】是按【基本配置】统一配置的推送节点推送',
  Cargo_DataServiceReminderWarning2: '2.【开启预警】-【保存】后，接收的节点以个人设置为准',
  Cargo_ConfigurationAlert: '按照“基本配置”设置的推送',
  Cargo_PushNodeSettings: '个人推送节点设置',
  Cargo_NodPushSettings: '节点推送设置',
  Cargo_VesselReminderMethodDifferent: '原有效配置的【船舶计划提醒方式】是{按船名航次提醒}将全部替换为最新的{按照业务提醒}',
  Cargo_VesselReminderMethodDifferent2: '原有效配置的【船舶计划提醒方式】是{按照业务提醒}将全部替换为最新的{按船名航次提醒}',
  Cargo_UserConfigOpenDifferent: '原有效配置的【节点推送设置】是{关闭个人设置}将全部替换为最新的{开启个人设置}',
  Cargo_UserConfigOpenDifferent2: '原有效配置的【节点推送设置】是{开启个人设置}将全部替换为最新的{关闭个人设置}',
  Cargo_BringForward: '提前',
  Cargo_Postpone: '延后',
  Cargo_EarlyWarningReminder: '分，预警提醒',
  Cargo_EarlyTimedIgnore: '定时忽略',
  Cargo_TurnOffAutoIgnore: '关闭自动忽略',
  Cargo_SetSOPNodeOfAlert: '预警的SOP节点',
  Cargo_SOPNodeOfAlert: 'SOP节点预警',
  Cargo_ApplicationScope: '应用范围',
  Cargo_DocumentNotification: '单据通知',
  Cargo_ApplyToAllTemplates: '应用到同业务类型模板',
  Cargo_UseOnlyTheCurrentTemplate: '仅当前模板使用',
  Cargo_SetAlertNotificationObject: '设置预警通知对象',
  Cargo_ReminderModes: '提醒方式',
  Cargo_IgnoreTime: '忽略时间',
  Cargo_AutomaticallyIgnoreAfterHours: '小时后自动忽略',
  Cargo_EditNodeAlertRules: '编辑节点预警规则',
  Cargo_CloudPlatformFeeStatus: '云平台费用状态',
  Cargo_CloudPlatformSyncStatus: '云平台同步状态',
  Cargo_CloudPlatformDocumentNumber: '云平台单据号',
  Cargo_SynchronousCloudPlatform: '同步云平台',
  Cargo_SendThirdParty: '发送第三方',
  Cargo_SupplementaryInformation: '补充信息',
  Cargo_InvoiceTypeOfTheOppositePlatform: '对方平台发票种类',
  Cargo_PaymentBranch: '支付分公司',
  Cargo_SyncInvoiceAttachment: '是否同步发票附件',
  Cargo_Send: '发送',
  Cargo_SendSuccess: '发送成功',
  Cargo_SendFail: '发送失败',
  Cargo_Remarks2: '备注内容',
  Cargo_PaymentInstructions: '付款说明',
  Cargo_PaymentReason: '付款事由',
  Cargo_OurHeader: '我方抬头',
  Cargo_DeleteBookingNote: '确定要删除这{0}个托书吗?',
  Cargo_ApplicationDetails: '申请明细',
  Cargo_SubscribeToDataAlerts: '订阅数据提醒',
  Cargo_EnableDataServiceReminder: '启用数据服务提醒',
  Cargo_ClickToLearnMore: '点击了解更多',
  Cargo_DataServiceReminderWarningOne: '1.推送异常提醒是由逻辑判断，仅供参考，具体数据以官方信息为准。',
  Cargo_DataServiceReminderWarning: '2.如果您每天收到的箱货提醒过多，可以关闭该提醒，以上提醒项需开通增值服务模块。',
  Cargo_AskDataServiceReminder: '开通数据服务后,高效准确的自动推送提醒通知给内部工作人员，详情了解：',
  Cargo_AskSopDataService: '开通数据服务后，可高效准确的自动推送通知给内部工作人员及客户（不开通支持人工流转），并可在预警规则配置中设置数据提醒服务，立即联系您公司的管理员，详情了解：',
  Cargo_ContactDataServiceReminder: ',或联系WallTech在线客服或运营021-65143931',
  Cargo_DataServiceRemind: '数据提醒服务',
  Cargo_WhetherToTurnOffAlerts: '是否关闭预警',
  Cargo_DayWarning: '今日预警',
  Cargo_OnlyDataNodesAreDisplayed: '仅显示有预警的节点',
  Cargo_ViewProcessedAlerts: '查看已处理的预警',
  Cargo_ViewIgnoredAlerts: '查看已忽略的预警',
  Cargo_SelectTheSopTemplateToApplyToTheBusiness: '选择SOP模板应用于该业务',
  Cargo_MakeSureToApplyTheSopTemplate: '请确认应用SOP模板【{0}】',
  Cargo_PleaseSelectAnSOPTemplate: '请选择SOP模板',
  Cargo_PleaseSelectSOPTemplateForChange: '请选择要更换的SOP模版',
  Cargo_PleaseSelectOtherSOPTemplate: '您选择的业务已经是您需要的SOP模版，请重新选择',
  Cargo_ReplaceTheSOPTemplate: '更换SOP模板',
  Cargo_Apply: '应用',
  Cargo_MoreFilters: '更多筛选',
  Cargo_Handled: '已处理',
  Cargo_ProcessSelectedData: '所有选择的预警信息将被标记为已处理，该操作仅更新预警消息状态?',
  Cargo_IgnoreSelectedData: '所有选择的预警信息将被忽略?',
  Cargo_Personnel: '人员',
  Cargo_NewSopTemplate: '新建SOP模板',
  Cargo_EditSopTemplate: '编辑SOP模板',
  Cargo_CopySopTemplate: '复制当前SOP模板',
  Cargo_SopTemplateName: 'SOP模板名称',
  Cargo_LookNode: '查看节点',
  Cargo_NewNode: '新建节点',
  Cargo_EditNode: '编辑节点',
  Cargo_NewNodeStatus: '新建节点状态',
  Cargo_NodeSettings: '节点设置',
  Cargo_NodeStatusSettings: '节点状态设置',
  Cargo_NoticeOfEachBill: '每票单据通知（含小票）',
  Cargo_NoNoticeOfTickets: '小票单据不通知',
  Cargo_AlertSettings: '预警设置',
  Cargo_ConfigureSopMessagePush: '配置SOP消息推送',
  Cargo_NodeType: '节点类型',
  Cargo_WhetherToDisclose: '是否公开',
  Cargo_EditTheAlertConfiguration: '编辑预警配置',
  Cargo_AddedAlertConfiguration: '新增预警配置',
  Cargo_EditTheStatusDetails: '编辑状态明细',
  Cargo_NewStatusDetails: '新增状态明细',
  Cargo_StatusDetails: '状态明细',
  Cargo_SetUpSopTemplateApplicationBusinessScenarios: '设置SOP模板应用业务场景',
  Cargo_QuicklySelectBusinessNodes: '快速选择业务节点',
  Cargo_QuicklyConfigureDataServices: '快速配置数据服务',
  Cargo_QuicklyConfigureStatusNotifications: '快速配置状态通知（内部人员）',
  Cargo_ShipPlanningAtThePortOfDeparture: '起运港船舶计划',
  Cargo_ContainerTracking: '箱货跟踪',
  Cargo_ShipDynamicsAtThePortOfDestination: '目的港船舶动态',
  Cargo_CarryEmpty: '提空',
  Cargo_TheActualDischarging: '实际卸船',
  Cargo_ReturnBox: '还空',
  Cargo_TheHomePageIsDisplayed: '首页显示',
  Cargo_QuicklyConfigureSettings: '快速配置设置',
  Cargo_QuickConfigurationIsCheckedByDefault: '快速配置默认勾选',
  Cargo_PleaseEnterAThemeTemplate: '请输入主题模板',
  Cargo_PleaseEnterTheBodyTemplateContent: '请输入正文模板内容',
  Cargo_PleaseEnterTheTemplateContent: '请输入模板内容',
  Cargo_PleaseEnterAnExampleTemplate: '请输入模板示例',
  Cargo_SOPPushObjectChannelRepeats: 'SOP推送对象渠道重复',
  Cargo_DataService: '数据服务',
  Cargo_WarningRuleTips: '更新SOP节点状态后，对应的预警信息将会被标记为已处理',
  Cargo_SopTemplateChangeTips: '已匹配到新的SOP模板【{0}】, 是否保留原有SOP模板?',
  Cargo_ApplyTheSopTemplateAs: '应用SOP模板为：',
  Cargo_TheNodeIsShutDown: '节点已关闭',
  Cargo_CanNotUploadFileOfNewContract: '新增未保存的合同约号不能上传文件！',
  Cargo_OrderReceiving: '接单',
  Cargo_PrintTemplate: '打印模板',
  Cargo_ControlObject: '控制对象',
  Cargo_ControlMode: '控制方式',
  SetDefaultType: '设置默认类型',
  DefaultFileType: '默认文件类型',
  DefaultType: '默认类型',
  Cargo_ActualPaymentAmount: '付款金额',
  Cargo_ReceivedAmount: '到账金额',
  Cargo_OcServiceCharge: 'OC手续费',
  Cargo_ChannelServiceCharge: '支付渠道手续费',
  Cargo_Abnormal: '是否异常',
  Cargo_AbnormalState: '异常说明',
  Cargo_AbnormalRemark: '备注',
  Cargo_ProcessedDate: '处理时间',
  Cargo_UpdateReceivedAmount: '编辑到账金额',
  Cargo_AbnormalComment: '异常批注',
  Cargo_MarkAbnormal: '打标异常',
  Cargo_ValueAddedServices: '增值服务',
  Cargo_CustomsMode: '报关方式',
  Cargo_ServiceType: '服务类型',
  Cargo_PODServices: '目的港服务',
  Cargo_POD: '目的港',
  Cargo_POL: '起运港',
  Cargo_InitData: '初始化数据',
  Cargo_NotInitData: '已有数据，不能初始化',
  Cargo_GeneratedVoucherInvoice: '含已生成凭证的发票号：',
  Cargo_DownLoad_Summary: '下载汇总模板',
  Cargo_DownLoad_Detail: '下载明细模板',
  Cargo_Import_OnOrder: '导入下单',
  Cargo_Not_Submit: '确认暂不提交吗？',
  Cargo_Not_Approved: '只能批量暂不提交【待审核】的订单！',
  Cargo_Not_Submit_Please: '请勾选【暂不提交】的业务！',
  Cargo_Not_Submit_Batch_Success: '暂不提交状态更新成功',
  Cargo_Submit_Batch: '请勾选要【提交】的业务',
  Cargo_Submit_Pre_Qualification: '确认提交预审状态吗？',
  Cargo_Submit_Job: '只能批量提交【暂不提交】的业务',
  Cargo_Submit_Success: '订单已提交',
  Cargo_OnlySelectedOneVoucher: '只能选择一条数据进行导出。',
  Cargo_BatchSetCategory: '批量设置类别',
  Cargo_ExportExcelTemplate: '导出Excel模板？',
  Cargo_Run: '运行',
  Cargo_ExcelTemplateExport: 'Excel报表导出',
  CARGO_OFFICE_EMAIL_ISEMPTY: '当前分公司电子邮箱未维护, 请检查。',
  Cargo_ChangeChargeChanged: '{0}的原费用有修改(开账单/发票/付款申请/销账等)，请检查！',
  Cargo_SecondPolCode: '二程起运港(代码)',
  Cargo_SecondPol: '二程起运港',
  Cargo_SecondPodCode: '二程目的港(代码)',
  Cargo_SecondPod: '二程目的港',
  Cargo_WaybillDestination: '运单目的地',
  Cargo_PolCountry: '出运国家/地区',
  Cargo_IC: '国际卡航',
  Cargo_IC_Master: '国际卡航主票',
  Cargo_IC_Basic: '国际卡航页签',
  Cargo_VehicleModel: '车型',
  Cargo_TypeKh: '卡航',
  Cargo_waybillInvoice: '运单发票信息',
  Cargo_customsMethodPol: '报关方式',
  Cargo_transferAgent: '中转地代理',
  Cargo_destinationAgent: '目的地代理',
  Cargo_dispatchingPlace: '发货地',
  Cargo_dispatchingPlace2: '收/发货地',
  Cargo_dischargingPortCode: '卸货地(POD)',
  Cargo_transferPortCode: '中转地',
  Cargo_loadingPortCode: '起运地(POL)',
  Cargo_actAta: '实际抵运日期(ATA)',
  Cargo_estEta: '预计抵运日期(ETA)',
  Cargo_actAtd: '实际发运日期(ATD)',
  Cargo_estEtd: '预计发运日期(ETD)',
  Cargo_OrderCar: '订舱',
  Cargo_DestinationDelivery: '目的地派送',
  Cargo_trailerNumber: '车挂号',
  Cargo_polInfo: '起运港口岸信息',
  Cargo_estLandingTime: '卡航预计抵岸时间',
  Cargo_actLandingTime: '卡航实际抵岸时间',
  Cargo_estEntryTime: '卡航预计入境时间',
  Cargo_actEntryTime: '卡航实际入境时间',
  Cargo_estExitTime: '卡航预计出境时间',
  Cargo_actExitTime: '卡航实际出境时间',
  Cargo_estReplacementTime: '卡航预计换装时间',
  Cargo_actReplacementTime: '卡航实际换装时间',
  Cargo_declareTime: '卡航报关时间',
  Cargo_transferInfo: '中转地转关信息',
  Cargo_declareCompletedTime: '中转地申报完成时间',
  Cargo_estShippingTime: '中转地预计发运时间',
  Cargo_actShippingTime: '中转地实际发运时间',
  Cargo_estArrivePodTime: '预计到达目的地边境时间',
  Cargo_actArrivePodTime: '实际到达目的地边境时间',
  Cargo_estEnterPodTime: '预计进目的地时间',
  Cargo_actEnterPodTime: '实际进目的地时间',
  Cargo_estArriveClearTime: '预计到达清关地时间',
  Cargo_actArriveClearTime: '实际到达清关地时间',
  Cargo_estDischargeTime: '卡航预计卸货时间',
  Cargo_actDischargeTime: '卡航实际卸货时间',
  Cargo_estArriveTime: '拖车预计到货时间',
  Cargo_actArriveTime: '拖车实际到货时间',
  Cargo_estTakeTime: '拖车预计提货时间',
  Cargo_actTakeTime: '拖车实际提货时间',
  Cargo_estUnloadTime: '拖车预计卸货时间',
  Cargo_actUnloadTime: '拖车实际卸货时间',
  Cargo_podInfo: '目的港派送信息',
  Cargo_estWarehouseDeliveryTime: '预计进仓交货时间',
  Cargo_actWarehouseDeliveryTime: '实际进仓交货时间',
  Cargo_estGoodsDeliveryTime: '预计送货时间',
  Cargo_actGoodsDeliveryTime: '实际送货时间',
  Cargo_estReturnTime: '预计还空时间',
  Cargo_actReturnTime: '实际还空时间',
  Cargo_polPortInfo: '起运地口岸信息',
  Cargo_khLandingTime: '卡航抵岸',
  Cargo_khEntryTime: '卡航入境',
  Cargo_khExitTime: '卡航出境',
  Cargo_khReplacementTime: '卡航换装',
  Cargo_khDeclare: '卡航报关',
  Cargo_transferTransitInfo: '中转地转关信息',
  Cargo_transferDeclareCompleted: '中转地申报完成',
  Cargo_transferShipping: '中转地发运',
  Cargo_arriveDestinationBorder: '到达目的地边境',
  Cargo_podClearInfo: '目的地清关信息',
  Cargo_arrivePod: '到达目的地',
  Cargo_arriveClear: '到达清关地',
  Cargo_khUnloading: '卡航卸货',
  Cargo_polExchangeInfo: '起运地提卸货信息',
  Cargo_trailerLoad: '拖车提货',
  Cargo_trailerArrive: '拖车到货',
  Cargo_trailerUnload: '拖车卸货',
  Cargo_podDeliveryInfo: '目的地派送信息',
  Cargo_warehouseDelivery: '进仓交货',
  Cargo_goodsDelivery: '送货',
  Cargo_podReturn: '还空',
  Cargo_estTime: '预计时间',
  Cargo_actTime: '实际时间',
  Cargo_secondPlateNumber: '二程车牌',
  Cargo_secondTrailerNumber: '二程挂车号',
  Cargo_secondVehicleType: '二程车型',
  Cargo_secondEtd: '发运日期',
  Cargo_secondPol: '起运地',
  Cargo_secondPod: '目的地',
  Cargo_secondLoadingTime: '装货时间',
  Cargo_secondShippingTime: '起运时间',
  Cargo_secondArriveTime: '抵达时间',
  Cargo_secondDischargeTime: '卸货时间',
  Cargo_secondTransportType: '转运方式',
  Cargo_bargeInfo: '驳车信息',
  Cargo_bargeEtd: '驳车发运日期',
  Cargo_bargeAtd: '驳车抵运日期',
  Cargo_bargePlateNumber: '驳车车牌',
  Cargo_bargeTrailerNumber: '驳车挂车号',
  Cargo_bargePol: '驳车起运地(POL)',
  Cargo_bargePod: '驳车目的地(POD)',
  Cargo_ActualEntryTime: '实际进场时间',
  Cargo_ActualLoadingTime: '实际配载时间',
  Cargo_EstimatedDepartureTime: '预计起飞时间',
  Cargo_ActualDepartureTime: '实际起飞时间',
  Cargo_EstimatedArrivalTime: '预计抵达时间',
  Cargo_ActualArrivalTime: '实际抵达时间',
  Cargo_ActualBillingTime: '实际收单时间',
  Cargo_ActualUnloadingTime: '实际卸货时间',
  Cargo_ActualArrivalNotificationTime: '实际到货通知时间',
  Cargo_ActualPickupTime: '实际提货时间',
  Cargo_EstimatedTransitArrivalTime: '预计抵达中转时间',
  Cargo_TransitArrivalTime: '抵达中转时间',
  Cargo_EstimatedTransitDepartureTime: '预计中转起飞时间',
  Cargo_TransitDepartureTime: '中转起飞时间',
  Cargo_bargeLine: '公路航线代码',
  Cargo_bargeCarrierId: '驳车运输公司',
  Cargo_khPlateNumber: '卡航车牌号',
  Cargo_khPlateNum: '卡航车牌',
  Cargo_PlateNums: '国内车牌号',
  Cargo_khTrailerNumber: '卡航挂车号',
  Cargo_TypeTc: '拖车',
  Cargo_SyncTargetDocumentNo: '同步对方凭证号',
  Cargo_PleaseChooseTargetDocumentNo: '请选择有对方凭证号的记录',
  Cargo_WriteOffInputFail: '待核销费用中，有应付费用未做付款申请或付款申请流程没有完成，不允许核销！',
  Cargo_WriteOffInputFail2: '待核销费用中，有应付费用付款申请流程没有完成，不允许核销！',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC_Payment: '操作失败，付款申请正在付款审批流程中，请在流程完成后再操作。',
  Cargo_estimation: '是否暂估',
  Cargo_estimationAmount: '暂估金额',
  Cargo_CooperateBranchId: '协作分公司',
  Cargo_EntrustBranchId: '委托分公司',
  Cargo_CooperateBusinessType: '协作业务类型',
  Cargo_BillingWeightActual: '计费重量(实)',
  Cargo_BillingWeightContract: '计费重量(委)',
  Cargo_NumberOfItemsActual: '件数(实)',
  Cargo_NumberOfItemsContract: '件数(委)',
  Cargo_VolumeActual: '体积(实)',
  Cargo_VolumeContract: '体积(委)',
  Cargo_GrossWeightContract: '毛重(委)',
  Cargo_GrossWeightActual: '毛重(实)',
  Cargo_CooperateStatus: '协作状态',
  Cargo_BusinessStatusRemark: '业务状态备注',
  Cargo_ChargeStatusRemark: '费用状态备注',
  Cargo_CooperateStatusLog: '协作状态变更日志',
  Cargo_BusinessStatusLog: '业务状态变更日志',
  Cargo_ChargeStatusLog: '费用状态变更日志',
  Cargo_AssociatedWithMasterTicket: '是否关联主票',
  Cargo_SelectCooperateBranch: '选择协作分公司',
  Cargo_CooperateBranchCannotBeEmpty: '协作分公司不能为空.',
  Cargo_CooperateBusinessTypeCannotBeEmpty: '协作业务类型不能为空.',
  Cargo_Cooperation: '协作',
  Cargo_CooperationReturn: '退回',
  Cargo_CooperateStatusApprovedCanTBeDeleted: '协作任务状态已审核，不能删除.',
  Cargo_AreYouSureUpdateState: '你确定要更改状态吗？',
  Cargo_CooperateSucceed: '协作成功',
  Cargo_CooperateLogOperation: '操作内容',
  Cargo_CooperateLogState: '操作后状态',
  Cargo_CooperateLogContent: '详情',
  Cargo_AreYouSureReturn: '你确定要退回吗？',
  Cargo_CooperateCreatedDate: '协作任务创建时间',
  Cargo_CooperateReviewSeparately: '选中记录中有协作业务，请分别审核',
  Cargo_CooperateNoPretrialReview: '协作业务没有复核操作',
  Cargo_ShowCooperateAll: '更多协作信息',
  Cargo_SettleBranchId: '结算公司',
  Cargo_ShowInternalCharges: '显示内结',
  Cargo_InternalCharges: '内结',
  Cargo_IsCooperate: '是协作业务，只能是由接单分公司来进行操作',
  Cargo_BranchCooperate: '本公司协助业务',
  Cargo_DownLoad_Template: '下载模板',
  Cargo_EstimatedWarehousingTime: '预计入库时间',
  Cargo_ActualWarehousingTime: '实际入库时间',
  Cargo_EstimatedDeliveryTime: '预计出库时间',
  Cargo_ActualDeliveryTime: '实际出库时间',
  Cargo_SyncWarehouseData: '同步获取仓储数据',
  Cargo_PleaseEnterActualWarehousingTime: '请输入实际入库时间',
  Cargo_LockOrderTip: '会将所有符合条件的业务都更新为【已审核】，是否继续？',
  Cargo_MatchedLockOrderCount: '当前符合条件的业务数：{0} 单',
  Cargo_RefreshTcloudToken: '刷新openToken',
  Cargo_SeaBooking: '海运订舱',
  Cargo_RailwayOperate: '铁路操作',
  Cargo_IntegratedOperate: '综合物流操作',
  Cargo_Timezone: '时区',
  Cargo_HiddenPlatform: '隐藏平台预制模板',
  Cargo_TemplateName: '模板方案名称',
  Cargo_PleaseEnterPlanRemark: '请输入方案描述',
  Cargo_StartLine2: '起始行（含标题）',
  Cargo_PleaseEnterStartLine: '请输入起始行',
  Cargo_ImportTableSet: '导入表格设置',
  Cargo_PleaseQuery: '请搜索',
  Cargo_EnableFilterRowRule: '启用过滤行规则',
  Cargo_ImportColumnsFilterOut: '在导入表格时，会过滤掉表格中有效列中满足此处设置的每行数据。',
  Cargo_SpaceGreaterThan: '空格数量占比大于',
  Cargo_PleaseEnterHeaderName: 'Excel单元格名称：请输入需要导入Excel表格的表头名称。',
  Cargo_PleaseEnterHeaderGridNum: 'Excel单元格列号：请输入需要导入Excel表格的列号，比如：A、B、AA。',
  Cargo_AddNewTemplate: '新建导入模板方案',
  Cargo_SerialNo: '序号',
  Cargo_InternalTableName: '内部表格名称',
  Cargo_ExcelCellName: 'Excel单元格名称',
  Cargo_DocumentEntry: '报关单证录入',
  Cargo_QueryTags: '查询标记',
  Cargo_ChargebackManage: '退单管理',
  Cargo_ReconciliationRule: '对账规则',
  Cargo_ReconciliationRuleName: '对账规则名称',
  Cargo_MatchFieldSettings: '匹配字段设置',
  Cargo_PleaseSelectField: '请选择对比时匹配的字段',
  Cargo_Relationship: '关系',
  Cargo_And: '与',
  Cargo_Or: '或',
  Cargo_MatchingOrder: '匹配顺序',
  Cargo_MatchFieldName: '匹配字段名称',
  Cargo_CompareFieldOperations: '对比字段设置',
  Cargo_SelectFieldToCompare: '选择需要对比的字段名称',
  Cargo_CompareOrder: '对比顺序',
  Cargo_CompareField: '对比字段',
  Cargo_ComparisonOperation: '对比操作',
  Cargo_MultiRowSumMethod: '多行汇总方式',
  Cargo_ComparisonSingleLine: '单行明细对比',
  Cargo_AttachFilePlaneOrNot: '是否附随机文件',
  Cargo_FlightDate: '航班日期',
  Cargo_OtherWarehousingInstructions: '其它进仓说明',
  Cargo_PhotoShootingAwait: '进仓待拍照清单',
  Cargo_PhotoShootingAwaitPallets: '装板待拍照清单',
  Cargo_DeleteSelected: '删除选中',
  Cargo_StartUploading: '开始上传',
  Cargo_Register: '登记',
  Cargo_Void: '作废',
  Cargo_Unbind: '解绑',
  Cargo_OrderPassingAgent: '过单代理',
  Cargo_BusinessBookiingAgent: '业务订舱代理',
  Cargo_RegisteredDate: '领用日期',
  Cargo_EstimatedBackDate: '预计返回日期',
  Cargo_ActualBackDate: '实际返回日期',
  Cargo_FreightRateM: '运价 M',
  Cargo_FreightRateN: '运价 N',
  Cargo_FreightRate45: '运价45',
  Cargo_FreightRate100: '运价100',
  Cargo_FreightRate300: '运价300',
  Cargo_FreightRate500: '运价500',
  Cargo_FreightRate1000: '运价1000',
  Cargo_NewIATAFreightRate: '新建IATA运价',
  Cargo_EditIATAFreightRate: '编辑IATA运价',
  Cargo_DeliveryStation: '交货站',
  Cargo_FlightSchedule: '航班时刻表',
  Cargo_Schedule: '班期',
  Cargo_ArrivaledTime: '到达时间',
  Cargo_Voyage: '航期',
  Cargo_MustBEntered: '必须输入',
  Cargo_NewFlight: '新建航班',
  Cargo_EditFlight: '编辑航班',
  Cargo_OneWayPort: '一程港口',
  Cargo_SecondPort: '二程港口',
  Cargo_ThirdPort: '三程港口',
  Cargo_TransshipmentPort: '转运港',
  Cargo_NewLine: '新建线路',
  Cargo_EditLine: '编辑线路',
  Cargo_NewAirTransportationArea: '新建空运区域',
  Cargo_EditAirTransportationArea: '编辑空运区域',
  Cargo_RegionalPorts: '区域港口',
  Cargo_OriginRegionCode: '起运区域代码',
  Cargo_TargetRegionCode: '目的区域代码',
  Cargo_NewRoute: '新建航线',
  Cargo_ResponsibilityList: '职责列表',
  Cargo_ResponsibilityInformation: '职责信息',
  Cargo_ResponsibilityStep1: '步骤1:录入职责基本信息',
  Cargo_ResponsibilityStep2: '步骤2:选择航线',
  Cargo_ResponsibilityStep3: '步骤3:选择航空公司',
  Cargo_ResponsibilityStep4: '步骤4:选择订舱性质',
  Cargo_ResponsibilityStep5: '步骤5:选择空港',
  Cargo_ResponsibilityStep6: '步骤6:选择销售',
  Cargo_ResponsibilityStep7: '步骤7:确定职责信息',
  Cargo_ResponsibilityNew: '新建操作职责',
  Cargo_ResponsibilityEdit: '编辑操作职责',
  Cargo_QueryType: '查询类型',
  Cargo_NotClearedToday: '前一天未报好关',
  Cargo_ToBeClearedToday: '当天报关当天航班',
  Cargo_DeclarationTheSameDay: '当天报关',
  Cargo_InculdeHistoricalData: '包含历史数据',
  Cargo_DeclarationTracking: '报关跟踪',
  Cargo_FlightTracking: '航班跟踪',
  Cargo_ModifyDeclarationBatches: '批量修改报关状态',
  Cargo_PrintedTag: '已打标签',
  Cargo_PrintTag: '打印标签',
  Cargo_CheckData: '核对数据',
  Cargo_AWBQuantity: '制单件数',
  Cargo_AWBWeight: '制单毛重',
  Cargo_AWBVolume: '制单体积',
  Cargo_GoodsSize: '货物尺寸',
  Cargo_ActualFlight: '实际航班',
  Cargo_OnwardInformation: '续程信息',
  Cargo_AttachmentDescription: '附件说明',
  Cargo_CustomsDeclarationStatus: '报关状态',
  Cargo_NumberDeclaration: '报关件数',
  Cargo_DeclarationGrossWeight: '报关毛重',
  Cargo_CustomsDeclarationRemarks: '报关备注',
  Cargo_DeleteAccountingEntry: '删除分录',
  Cargo_Assets: '资产',
  Cargo_LineNo: '行次',
  Cargo_LiabilitiesOwner: '负债和所有者(或股东)权益',
  Cargo_LineNo2: '行次 ',
  Cargo_OpeningAmountOfTheYear2: '年初数 ',
  Cargo_PeriodEndAmount2: '期末数 ',
  Cargo_AmountOfMonth: '本月发生金额 ',
  Cargo_AmountOfYear: '本年累计金额 ',
  Cargo_TrackingTipOne: '该图标用作于B2B系统使用！',
  Cargo_TrackingTipTwo: '注:建议使用白色png格式，大小不超过500KB的图标进行上传。',
  Cargo_WarehouseMapTip: '注：建议上传仓库地图的图片格式为PNG/JPG。',
  Cargo_UploadDataSizeMore500KB: '文件大小不能大于500KB！',
  Cargo_RuleNotesTip: '可填写备注，以便于用户在使用时查看相关备注提示。',
  Cargo_MainOrderRegistr: '主单登记',
  Cargo_MainOrderStart: '主单起始号',
  Cargo_TotalCopies: '总份数',
  Cargo_LastUpdateTime: '最后更新时间',
  Cargo_AddBranch: '添加分公司',
  Cargo_CopyBranch: '复制分公司',
  Cargo_EORIDetail: 'EORI详情',
  Cargo_DeleteEORITip: 'EORI删除后无法恢复，确认删除？',
  Cargo_EORINotNull: 'EORI不能为空',
  Cargo_EORINotDuplicate: 'EORI不能重复',
  Cargo_AddDept: '添加部门',
  Cargo_BranchCnName: '分公司中文名',
  Cargo_ChineseAddress: '中文地址',
  Cargo_BranchEnName: '分公司英文名',
  Cargo_BranchCode: '分公司代码',
  Cargo_PostalCode: '邮政编码',
  Cargo_Email: '电子邮箱',
  Cargo_LocalCurrency2: '当地币种',
  Cargo_DefaultAirport: '默认空港',
  Cargo_DefaultHarbor: '默认海港',
  Cargo_DefaultTimeZone: '默认时区',
  Cargo_RMBAccount: '付款人民币账号',
  Cargo_USDAccount: '付款美元账号',
  Cargo_ReceiveRMBAccount: '收款人民币账号',
  Cargo_ReceiveUSDAccount: '收款美元账号',
  Cargo_DefaultPaymentAccount: '默认付款账户',
  Cargo_DefaultReceiveAccount: '默认收款账户',
  Cargo_OverseasBillingAddress: '海外账单地址',
  Cargo_DomesticBillingAddress: '国内账单地址',
  Cargo_OverseasEDICode: '海外EDI代码',
  Cargo_ValueAddedTaxRate: '加价税率',
  Cargo_InvoicingTaxRate: '开票税率',
  Cargo_SettleEmail: '结算邮箱',
  Cargo_TaxationSystemAPIAddress: '税务系统接口地址',
  Cargo_TaxControlMachineNo: '税控盘编号',
  Cargo_ElectronicInvoicePlatformCode: '电票平台编码',
  Cargo_ElectronicInvoice: '电票密码',
  Cargo_ElectronicInvoiceTaxpayer: '电票纳税人识别号',
  Cargo_ElectronicInvoiceAuthCode: '电票纳税人授权码',
  Cargo_ElectronicInvoiceRequestAddress: '电票服务请求地址',
  Cargo_InvoiceCancellationRequestAddress: '发票作废请求地址',
  Cargo_EFreighAMSAccount: 'E-Freigh(AMS账户)',
  Cargo_EFreighACIAccount: 'E-Freigh(ACI账户)',
  Cargo_Preview: '预览',
  Cargo_NewBranchInformation: '新的分公司信息',
  Cargo_AssociatePartners: '关联合作伙伴',
  Cargo_AddRole: '增加角色',
  Cargo_DepartmentCode: '部门代码',
  Cargo_JobNumberCodeField: '工作号编码字段',
  Cargo_SettlementCompanyIsOrNot: '是否为结算公司',
  Cargo_Introduction: '简介',
  Cargo_EnableOpen: '开启',
  Cargo_DisableOpen: '关闭',
  Cargo_GeneralSettings: '应用总公司设置',
  Cargo_ControlMode2: '控制模式：',
  Cargo_ReminderMode: '提醒模式',
  Cargo_LockMode: '锁单模式',
  Cargo_Notification: '通知提醒：',
  Cargo_LockingControl: '锁定控制：',
  Cargo_Event: '事件',
  Cargo_NotificationMethod: '通知方式',
  Cargo_NotificationObject: '通知对象',
  Cargo_BLRelease: '提单放单',
  Cargo_NoLock: '不扣单',
  Cargo_NewOrCopyJob: '新增/复制正式业务',
  Cargo_LockAfterSaving: '保存后锁定',
  Cargo_CannotBeSaved: '不可保存',
  Cargo_JobSheetIsLocked: '业务被锁定',
  Cargo_JobSheetIsUnlocked: '业务被解锁',
  Cargo_CreditLimitExceeded2: '信控超出',
  Cargo_CreditLimitChanged: '信控更改',
  Cargo_CreditForewarning: '信控预警',
  Cargo_PaymentPeriodForewarning: '账期预警',
  Cargo_CreditControlManager: '信控主管',
  Cargo_TemplateManagement: '模板管理',
  Cargo_TemplateTypeManagement: '模板类型管理',
  Cargo_ConfigurationManagement: '配置管理',
  Cargo_MappingManagement: '映射管理',
  Cargo_InitializeTemplateManagement: '初始化模板管理',
  Cargo_BusinessStatusManagement: '业务状态管理',
  Cargo_TriggerTypeManagement: '触发类型管理',
  Cargo_FileTypeManagement: '文件类型管理',
  Cargo_DefaultValueManagement: '默认值管理',
  Cargo_ValidationRuleConfiguration: '验证规则配置',
  Cargo_EDITemplateSettings: 'EDI设置',
  Cargo_OnlineShippingOrderSettings: '海运在线对单设置',
  Cargo_RouteAndWarehouseConfiguration: '航线/港口预设配置',
  Cargo_PushServiceConfiguration: '推送服务配置',
  Cargo_CustomInvoiceRemarks: '发票自定义备注',
  Cargo_EmailTemplateManagement: '邮箱模板管理',
  Cargo_BillOfLadingConfiguration: '放单配置',
  Cargo_BranchBankAccount: '分公司银行账号',
  Cargo_SetRMBAccount: '设为默认RMB账号 ',
  Cargo_SetUSDAccount: '设为默认USD账号 ',
  Cargo_SetReceiveRMBAccount: '设为默认收款RMB账号',
  Cargo_SetReceiveUSDAccount: '设为默认收款USD账号',
  Cargo_SetDefaultPaymentAccount: '设置默认付款账号',
  Cargo_SetDefaultReceiveAccount: '设置默认收款账号',
  Cargo_ShortName: '简称',
  Cargo_Instructions: '说明',
  Cargo_BankChineseAddress: '银行中文地址',
  Cargo_BankEnglishAddress: '银行英文地址',
  Cargo_BankCode: '开户行行号',
  Cargo_HeaderTitle: '所属抬头',
  Cargo_ClosingAccountRecord: '关帐记录',
  Cargo_ClosingAccountReview: '关帐审核',
  Cargo_EditConfigurationItem: '编辑配置项',
  Cargo_SelectClosingAccountDate: '选择关账日期',
  Cargo_EditConfigurationDefinition: '编辑配置定义:',
  Cargo_CreditLimitExceededApproval: '信控超出后,锁定工作单，直至自动解锁或人工特批',
  Cargo_CreditOnlyReminder: '信控超出后,只发送提醒,工作单不会锁定',
  Cargo_OperationExecutive: '操作主管',
  Cargo_SalesExecutive: '销售主管',
  Cargo_CreditControlSupervisor: '信控主管',
  Cargo_BusinessCustomerService: '业务客服',
  Cargo_EmailsAndReminders: '邮件和提醒',
  Cargo_Bell2: '站内铃铛',
  Cargo_Email2: '邮件',
  Cargo_BatchAddRolePermissions: '批量添加角色权限',
  Cargo_RoleName: '角色名称',
  Cargo_PermissionName: '权限名',
  Cargo_PermissionCategory: '权限类',
  Cargo_PermissionType: '权限型',
  Cargo_PermissionPoint: '权限点',
  Cargo_UpdatePermissionGroups: '更新权限组',
  Cargo_Personal2: '个人',
  Cargo_DepartmentGroups: '部门分组',
  Cargo_GreaterRemove: '移除>>',
  Cargo_LessAdd: '<<添加',
  Cargo_PleaseEnterNameEtc: '请输入中文名、英文名、邮箱等模糊查询...',
  QuickSearchUser: '快捷检索:登录名、中文名、英文名、邮箱',
  Cargo_Expired: '已到期',
  Cargo_NearExpiration: '临期',
  Cargo_NotVetDueEytended: '未到期/延期',
  Cargo_History: '历史',
  Cargo_QuickSearchContractNumber: '快捷检索:合同编号',
  Cargo_Reminder30Day: '提示：30天内系统设为临期',
  Cargo_PleaseSelectContractRecord: '请选中合同记录.',
  Cargo_ContractAgreement: '合同协议',
  Cargo_WhetherBookingConfirmation: '是否已上传订舱章',
  Cargo_IsContractAgreementUploaded: '是否已上传合同协议',
  Cargo_ContractProhibitedOperated: '该合同已续签，禁止操作',
  Cargo_NeedToUpdateOrNot: '是否需要更新',
  Cargo_ContractCreator: '合同创建人',
  Cargo_ContractCreationTime: '合同创建时间',
  Cargo_PartnerCreation: '合作伙伴创建人',
  Cargo_ContractAuditor: '合同审核人',
  Cargo_ContractAuditTime: '合同审核时间',
  Cargo_TimeLeftUntilExpiry: '距到期日期剩余',
  Cargo_DayRemind: '天提醒',
  Cargo_NoteReminderMethod: '注：提醒方式为"系统提醒"，系统会在到期前2日再提醒',
  Cargo_ProhibitBusinessConfiguration: '禁止创建业务配置：',
  Cargo_SettlementMethodGreaterThan0: '结算方式：每月指定日期，或账期大于0',
  Cargo_ViewContract: '查看合同',
  Cargo_PaymentTermPeriod: '账期区间',
  Cargo_WeekSettlement: '周结',
  Cargo_EveryMonth: '每月',
  Cargo_Day: '日',
  Cargo_CAN_NOT_APPROVED: '选择的数据中包含{0}状态的业务，不允许审核，请检查！',
  Cargo_CAN_NOT_CANCEL_APPROVED: '选择的数据中包含{0}状态的业务，状态的业务，不允许取消审核，请检查！',
  Cargo_HasOneOnly: '请只选择一条记录！',
  Cargo_CloseAndCopySerialNumber: '关闭并复制流水号',
  Cargo_QuickSearchBillPayment: '快捷检索：付款申请号',
  Cargo_AmsNoTooltip: '建议您发送EDI报文时，AMS NO字符数不要超过12位。',
  Cargo_AmsNoEFreightTooltip: '建议您发送EDI报文时，AMS NO字符数不要超过12位，发送时会除去等于Nvocc Scac的前缀。',
  Cargo_AmsNoLengthTooltip: 'AMS NO字符数已超过12位，是否继续发送？',
  Cargo_AmsShipperLine1tip: '提示：NAME名称超长时，可紧接填在ADDRESS1中',
  Cargo_AmsUnitTypeTip: '可在映射配置中维护“反恐包装代码”映射代码',
  Cargo_VoyageFlightLengthTooltip: 'Voyage 不可超过5字符',
  Cargo_VoyageFlightSpecialCharactersTooltip: 'Voyage栏位中有特殊字符，是否继续发送？建议进行更改后继续发送！',
  Cargo_BargeRemarks: '支线驳船备注',
  Cargo_CalcRuleNotes: '计算规则备注',
  Cargo_NotSupportStartOldApprove: '【付款申请】不再支持发起审批，请前往【付款申请（新版）】发起审批。',
  Cargo_Pending: '待处理',
  Cargo_Processing: '处理中',
  Cargo_Completed1: '已完成',
  Cargo_Revoked: '已撤销',
  Cargo_StartTime: '发起时间',
  Cargo_StartDate: '发起日期',
  Cargo_ProcessName: '流程名称',
  Cargo_ApprovalSerialNumber: '审批流水号',
  Cargo_ApprovalDate: '审批日期',
  Cargo_Approver: '审批人',
  Cargo_ApprovalTemplate: '审批模版',
  Cargo_ProcessingStatus: '处理状态',
  Cargo_PleaseFill: '请填写',
  Cargo_PleaseMaintain: '请维护',
  Cargo_MessageNotificationMethod: '消息通知方式',
  Cargo_AreYouSureAboutTheModificationProcess: '确定修改流程么?',
  Cargo_AreYouSureAboutTheModificationProcessTips: '确认修改后，处理中的流程会按照发起时的流程继续执行。后续发起的流程会根据修改后的流程执行。',
  Cargo_SetUpTheProcessTriggerCondition: '请设置流程触发条件。',
  Cargo_CurrentApprover: '当前审批人',
  Cargo_Initiator: '发起人',
  Cargo_ApprovalRecord: '审批记录',
  Cargo_SelectTheApprover: '选择审批人',
  Cargo_RoleSelection: '角色选择',
  Cargo_ReviewTheProcessRecord: '查看流程记录',
  Cargo_BatchApproval: '批量同意',
  Cargo_BatchReject: '批量拒绝',
  Cargo_TerminateTheProcess: '终止流程',
  Cargo_ApprovalComments: '审批意见',
  Cargo_ApprovalTime: '审批时间',
  Cargo_ApprovalCommentsRecord: '审批意见记录',
  Cargo_IInitiated: '我发起的',
  Cargo_IDealWithIt: '我处理的',
  Cargo_SubmitAPaymentRequestForApproval: '提交付款申请审批',
  Cargo_Approving: '审批',
  Cargo_ThereIsDuplicateData: '存在重复数据',
  Cargo_SelectTheApprovalPosition: '选择审批岗位',
  Cargo_FilterDimension: '过滤依据',
  Cargo_FilterValue: '过滤值',
  Cargo_ReviewTheApprovalProcess: '查看审批流程',
  Cargo_Committed: '提交了',
  Cargo_Agreed: '已同意',
  Cargo_Opinion: '意见',
  Cargo_ReviewWithdrawal: '审核撤回',
  Cargo_ProcessRevocation: '流程撤销',
  Cargo_AlreadyWithdraw: '已撤回',
  Cargo_NoHandlingRequired: '无需处理',
  Cargo_MyApprovals: '我的审批事项',
  Cargo_ApprovalsThatIInitiated: '我发起的审批',
  Cargo_ApprovalsThatIHandle: '我处理的审批',
  Cargo_CreateProcess: '创建流程',
  Cargo_EditProcess: '编辑流程',
  Cargo_CopyProcess: '复制流程',
  Cargo_DeleteProcess: '删除流程',
  Cargo_ProcessComment: '流程注释',
  Cargo_RevertProcessStatus: '撤销流程状态',
  Cargo_RevertProcess: '撤销流程',
  Cargo_RejectProcess: '拒绝流程',
  Cargo_NotificationEmailCC: '消息通知邮件抄送人',
  Cargo_Irrevocable: '不可撤销',
  Cargo_BindApprovalTemplate: '绑定审批模板',
  Cargo_ApplicationBusinessDivision: '应用业务分公司',
  Cargo_ProcessTriggerCondition: '流程触发条件',
  Cargo_TriggerConditionConfiguration: '触发条件配置',
  Cargo_ApproverSource: '审批人来源',
  Cargo_ApproverExecutionMode: '审批人执行方式',
  Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor: '第一个节点为发起人的上级主管，后续节点为上一节点审批人的主管',
  Cargo_AnyApproverCanHandle: '审批人中任意一人处理即可',
  Cargo_AllApproversAtCurrentNodeRequired: '需要当前节点所有审批人处理',
  Cargo_TheNumberOfApprovalsInProgress: '进行中的审批数量',
  Cargo_NotNamed: '未命名',
  Cargo_AdministratorSettings: '管理员设置',
  Cargo_FormName: '表单名称',
  Cargo_NumberOfConfigurableBranches: '可配置分支数',
  Cargo_ExistDocumentPlatformConfig: '此分公司已存在此表单状态为启用，请确认后进行操作',
  Cargo_InitiateApproval: '发起审批',
  Cargo_InitiateApprovalSuccessfully: '发起审批成功。',
  Cargo_AreYouSureToInitiateTheApproval: '确认发起审批吗？',
  Cargo_AreYouSureToDo: '确认{0}吗？',
  Cargo_AgreeToTheApproval: '同意审批',
  Cargo_RejectApproval: '拒绝审批',
  Cargo_InitiateBranchCompany: '发起分公司',
  Cargo_ApplicationBranch1: '应用分公司',
  Cargo_InitiateDepartment: '发起部门',
  Cargo_WhetherItIsEnabled: '是否启用',
  Cargo_Deactivate: '停用',
  Cargo_PleaseSelectTenantId: '请选择平台ID',
  Cargo_PleaseSelectOfficeIds: '请选择应用分公司',
  Cargo_PleaseSelectDocumentConfigId: '请选择表单名称',
  Cargo_PleaseSelectBranchCount: '请选择可配置分支数',
  Cargo_PleaseSelectUserIds: '请选择管理员设置',
  Cargo_DocumentPlatformConfigNote: '注：管理员可查看表单相关的所有审批流。',
  Cargo_AddBranchProcess: '+添加分支流程',
  Cargo_Priority: '优先级',
  Cargo_TriggerConditions: '触发条件',
  Cargo_PleaseSelectDocumentConfigId2: '请选择绑定表单',
  Cargo_AddBranchProcessCheck: '当前表单的分支数已达到上限。',
  Cargo_BindForm: '绑定表单',
  Cargo_UnknownProcessProcessing: '未知流程处理',
  Cargo_AutoWriteOffAfterApproval: '审批通过后是否自动核销',
  Cargo_Bell: '铃铛',
  Cargo_NotifierSource: '抄送人来源',
  Cargo_PreconditionsForApproval: '审批前置条件',
  Cargo_RuleConditions: '规则条件',
  Cargo_ConditionalItem: '条件项',
  Cargo_ConditionalRule: '条件规则',
  Cargo_ConditionalValue: '条件取值',
  Cargo_RejectMethod: '拒绝方式',
  Cargo_AllowDirectReturnToInitiator: '允许直接退回发起人',
  Cargo_ReturnToTheInitiatingNode: '退回发起节点',
  Cargo_Returned2: '已退回',
  Cargo_RefuseAndReturnNode: '注：拒绝=退回上一节点、退回=退回发起节点。',
  Cargo_RefuseTitle: '退回上一节点',
  Cargo_ReturnTitle: '退回发起节点',
  Cargo_BillPaymentUpdateFail: '付款申请更新失败。',
  Cargo_OneClickCopy: '一键复制',
  Cargo_OneClickCopyNote: '注：可通过点击“一键复制”按钮进行复制全部审批流水号，以便稍后批量查询。',
  Cargo_OneClickCopyNoteBillPaymentApply: '注：可通过点击“一键复制”按钮进行复制全部申请单号，以便稍后批量查询。',
  Cargo_SubmitException: '提交异常',
  Cargo_ApprovalException: '审批异常',
  Cargo_PriceType: '请选择港前价格/干线价格/尾程价格，询价类型至少选择一个',
  Cargo_AccountPeriodRemainingDays: '账期剩余天数',
  Cargo_WorkflowsBranchCountNotNull: '工作流分支数不能为空',
  Cargo_WorkflowsPlatformConfigRepeat: '此分公司已存在此表单状态为启用,请确认后进行操作',
  Cargo_PleaseSelectUser: '请选择此流程的管理员',
  Cargo_Initiate: '发起',
  Cargo_InitiateForm: '发起表单',
  Cargo_ApprovalMatters: '审批事项',
  Cargo_SelectApprovalWithSameTemplate: '请选择相同"审批模板"的审批事项',
  Cargo_SOPPanelNodeNotDisplayed: 'SOP面板不显示该节点',
  Cargo_SOPPanelNoDataHide: 'SOP面板无数据时，自动隐藏',
  Cargo_TaxInputConfig: '进项税配置',
  Cargo_ReceiptInvoiceTitle: '收票抬头',
  Cargo_ReceiptInvoiceChannel: '收票渠道',
  Cargo_InvoiceAssociation: '收票关联',
  Cargo_BoundInvoiceOrNot: '是否绑定发票',
  Cargo_ManualUpdate: '手动更新',
  Cargo_GetInvoice: '获取发票',
  Cargo_InvoiceTime: '开票时间',
  Cargo_SellerName: '销方名称',
  Cargo_SellerTaxNumber: '销方税号',
  Cargo_BuyerName: '购方名称',
  Cargo_BuyerTaxNumber: '购方税号',
  Cargo_InvoicePool: '发票池',
  Cargo_InvoicePoolReceiving: '发票池收票',
  Cargo_WriteOffBank: '销账银行',
  Cargo_DepartureStation: '始发站',
  Cargo_DestinationStation: '目的站',
  Cargo_TransitStation: '过境站',
  Cargo_TransferStation: '中转站',
  Cargo_QuickApprovalMode: '不同节点相同审批人处理方式',
  Cargo_AutoAgree: '自动同意',
  Cargo_PressToDo: '催办',
  Cargo_CarbonCopy: '抄送',
  Cargo_ApplicationDimension: '申请维度',
  Cargo_ApplicationCode: '申请编码',
  Cargo_TotalReceivable: '总应收',
  Cargo_TotalDues: '总应付',
  Cargo_PackingType: '装箱类型',
  Cargo_ViewChargeDetails: '查看费用明细',
  Cargo_StartingPort: '起始港',
  Cargo_SubmitJobChargeForApproval: '提交业务费用申请审批',
  Cargo_SubmitJobChargeTip: '此票业务需先发起提交审批流程，流程通过后自动提交，失败则提交失败。\n您现在要发起审批吗？',
  Cargo_SubmitJobChargeFailTip: '暂无可匹配的费用审批流程，请联系主管完善审批流程中的触发条件后重新发起提交。',
  Cargo_BillHasBeenInitiatedForApproval: '此账单已发起过审批，可到审批清单页面“我发起”页签下进行查看审批进度与审批详情。',
  Cargo_SubmitInvoiceFailTip: '暂无可匹配的开票审批流程，请联系主管完善审批流程中的触发条件后重新发起提交。',
  Cargo_SubmitInvoiceTip: '开票前先发起开票审批流程，您现在要发起审批吗？',
  Cargo_SubmitCollectionInvoiceTip: '收票前先发起收票审批流程，您现在要发起审批吗？',
  Cargo_SOURCE_CURRENCY_NOT_NULL: '原币币种不能为空！',
  Cargo_SOURCE_AMOUNT_NOT_NULL: '原币金额不能为空！',
  Cargo_imWarning: '当前job没有足够的角色人员来打开沃行通的聊天组。',
  Cargo_ReceiptPaymentOffset: '预付账款冲回',
  Cargo_InvoicePayableOffset: '营运成本冲回',
  Cargo_CheckFreightTermOne: '"{0}" 运输条款时，{1} 和 {2} 不可为空',
  Cargo_CheckFreightTermTwo: '"{0}"  运输条款时，{1} 不可为空',
  Cargo_ThirdTableCheck: '第三方中间表已推送，不可操作',
  Cargo_CheckMergeExport: '应付发票和预付款冲回凭证合并导出，勾选记录中不能其他凭证类型。请检查',
  CargoMsg_QQ: 'QQ',
  CargoMsg_CorporateName: '法人公司名称',
  Cargo_DeleteUnApprovedBillTips: '只能删除未审批的账单！',
  Cargo_EditUnApprovedBillTips: '只能编辑未审批的账单！',
  Cargo_DeleteUnApprovedInvoiceTips: '只能删除未审批的发票！',
  Cargo_InvalidUnApprovedInvoiceTips: '只能作废未审批的发票！',
  Cargo_InvoiceID: '发票ID',
  Cargo_PleaseSelectNeedInvalidBillPaymentTip: '请选择需要作废的付款申请。',
  Cargo_Deleted: '已删除',
  Cargo_EnableSopTemplate: '启用当前sop模板',
  Cargo_UnableSopTemplate: '禁用当前sop模板',
  Cargo_EnableSopTemplateConfirm: '确认启用当前SOP模板么？',
  Cargo_UnableSopTemplateConfirm: '确认禁用当前SOP模板么？禁用后，业务无法应用此模板。但不会影响已使用此模板的业务。',
  Cargo_Disabled2: '(已禁用)',
  Cargo_Got_It: '知道了',
  Cargo_Canceled: '已取消',
  Cargo_RepeatGoldenTaxExport: '请勿重复操作金税导出。',
  Cargo_UpdateCustomerInfo: '更新客商资料',
  Cargo_SyncCustomerData: '同步客商资料',
  Cargo_Synchronizing: '正在同步，请稍后查看',
  Cargo_Prediction: '预报',
  Cargo_PlaceOfDeliveryRegion: '交货地(区域)',
  Cargo_IsTransfer: '是否中转',
  Cargo_TotalAmountTax: '税额合计（发票）',
  Cargo_CustomerNotOwn: '【委托单位】所属分公司与当前公司不一致',
  Cargo_SimilarPartners: '已存在名称相似的【{0}】等{1}家企业',
  Cargo_GoBackSuccess: '取回成功！',
  Cargo_SendBackSuccess: '退单成功！',
  Cargo_AddSignature: '已加签',
  Cargo_Appoint2: '委派',
  Cargo_Appointer: '委派人',
  Cargo_ApproverRepeat: '审批人不允许重复',
  Cargo_ApproverAndAppointerRepeat: '用户不能同时拥有"审批人"和"委派人"身份',
  Cargo_CancelAddSignature: '不可以对自己"取消加签"',
  Cargo_CancelAddSignatureNotSupport: '用户"已审批"或"已委派",不支持"取消加签"',
  Cargo_RuleError: '表单类型变化，流程规则配置错误',
  Cargo_SelectCcTo: '选择抄送人',
  Cargo_SelectSigner: '选择加签人',
  Cargo_SelectTransferor: '选择转签人',
  Cargo_TransferSignature: '已转签',
  Cargo_Appointed: '已委派',
  Cargo_CancelSignature: '取消加签',
  Cargo_AddSignatureSelf: '不可以对自己"加签"',
  Cargo_OnlySupportedFCL: '暂时仅支持整箱业务',
  Cargo_CannotExceedThree: '系统内不同箱型超过3个，本次无法发送相关数据，请及时联系客服人员。',
  Cargo_TransferSignatureSelf: '不允许选择自己作为‘转签人’',
  Cargo_AddSignatureCurrentNode: '不允许对当前节点人"加签"',
  Cargo_ApproverNotEmpty: '审批人不能为空',
  Cargo_AppointerNotEmpty: '委派人不能为空',
  Cargo_NewWarehouseFee: '只允许正操作状态的业务新增仓库费！',
  Cargo_DefaultCurrencyConversion: '默认折合币种',
  Cargo_ChargeGroupCheck: '费用组【{0}】，不支持重复选择，请重新调整后保存。',
  Cargo_RelatedChargeItems: '关联收费项目',
  Cargo_IncludeSoc: '是否含货主箱',
  Cargo_SubsidiaryLedgerDay: '明细账日报表',
  AccountingDate: '会计日期',
  PleaseSelectAccountDate: '请选择会计日期。',
  CurrentDayAmountTo: '本日合计',
  TotalReportingCurrencyOfThisDay: '本日合计本位币',
  Cargo_LastOverseasPort: '卸货港是美国港口时，可直接等于装货港。\n' +
      '卸货港非美国港口时，此处应填挂美国之前的上一个非美国港口。',
  Cargo_FirstPortOfCall: '卸货港是美国港口时，可直接等于卸货港。\n' +
      '卸货港非美国港口时，此处应填途径美国的第一个美国港口。',
  Cargo_PoNoExistTips: '项目编号重复，是否确认保存？',
  Cargo_Assignment: '分配',
  Cargo_SetMarginReminder: '设置余量提醒',
  Cargo_NumberOfCompanyReminders: '提醒的余量数',
  Cargo_CompanyTrackingNumLower: '当前的公司单号余量低于【{0}】',
  Cargo_BatchAdd: '批量新增',
  Cargo_DownloadTemplate: '下载模板',
  Cargo_AssignCompany: '分配公司',
  Cargo_MawbSource: '主单来源',
  CARGO_CAN_NOT_ASSIGNMENT: '仅支持分配新增状态主单',
  CARGO_Confirm_Assignment: '确认分配',
  CARGO_Confirm_Assignment_Success: '分配成功',
  CARGO_Confirm_Assignment_Error: '分配失败',
  CARGO_Only_Invalidated: '仅支持作废非作废状态主单',
  CARGO_Only_Unbind: '仅支持解绑已绑定的主单',
  CARGO_Not_Met_New_Conditions: '以下主单不满足新增条件',
  Cargo_Assign_People: '分配人',
  AERequiredChecksum: '主单起始号、批量新增必填其一',
  Cargo_DeleteCharge: '未选择费用，默认删除所有勾选的业务费用',
  Cargo_BusinessOperationUpdateDynamics: '业务操作更新动态',
  Cargo_UpdateDetails: '更新详情',
  Cargo_UpdateContent: '更新内容',
  Cargo_ChangeLogRecord: '变更日志记录',
  Cargo_BusinessNoChangeLogRecord: '业务编号变更日志',
  Cargo_ResultsDisplayedInRed: '查询结果将以红色显示',
  Cargo_ChangeLocation: '变更位置',
  Cargo_TimeQuery: '时间查询',
  Cargo_BusinessNotExist: '业务不存在！',
  Cargo_UserNoRole: '此用户没有关联任何角色，确认保存吗？',
  Cargo_ResultsDisplayedInYellow: '查询结果将以黄色显示',
  Cargo_CreateBillYesOrNo: '是否生成账单',
  CurrencyReceivable: '{0}应收',
  CurrencyPayable: '{0}应付',
  CurrencyNotReceived: '{0}未收',
  CurrencyUnpaid: '{0}未付',
  CurrencyReceived: '{0}已收',
  CurrencyPaid: '{0}已付',
  Cargo_CheckShippingCompanyCargoTracking: '您已开通船公司货物追踪服务，请选择船公司后保存，确保成功获取到字段信息。',
  Cargo_PodPortInfoPrompt: '如您开通船公司货物追踪服务，基本页签-船公司为必填项，请正确选择船公司后保存业务，确保成功获取到字段信息。',
  Cargo_StatementReviewStatus: '对账单复核状态',
  Cargo_StatementReviewer: '对账单复核人',
  Cargo_StatementReviewTime: '对账单复核时间',
  Cargo_Port_Departure_Sea: '起运港（海运）',
  Cargo_Port_Destination_Sea: '目的港（海运）',
  Cargo_Port_Departure_Air: '起运港（空运）',
  Cargo_Port_Destination_Air: '目的港（空运）',
  Cargo_Port_Departure_Rail: '起运港（铁路）',
  Cargo_Port_Destination_Rail: '目的港（铁路）',
  Cargo_Lob_NEQ_Port: '业务类型与港口类型不符，点击确定清空所选港口',
  Cargo_DuplicateLaneCodePleaseTryItAgain: '航次重复，请重新输入。',
  Need: '需要',
  NoNeed: '不需要',
  Responsible: '有责',
  No_Responsibility: '无责',
  Cargo_VAT_FEI: '电子发票(增值税专用发票)',
  Cargo_NORMAL_FEI: '电子发票(普通发票)',
  Cargo_ViewMoreLogs: '查看更多日志',
  Cargo_ThreeDaysLogs: '近三天操作动态',
  Cargo_CarryForward: '结转',
  Cargo_ReconciliationNewVersion: '对账新版',
  Cargo_NuoNuo: '诺诺',
  Cargo_AISINO_EI: '航信',
  Pigeonhole: '归档',
  Unarchive: '解除归档',
  Confirm_Archiving_Business: '确认对所选业务归档',
  Confirm_Unarchiving_Business: '确认对所选业务解除归档',
  Is_Pigeonhole: '是否归档',
  Financial_Review_Status: '财务审核状态',
  Other_Reminders: '其他提醒',
  Can_Be_Archived: '是否可归档',
  Not_Accrued: '未计提',
  Receivables_Not_Fully_Written_Off: '应收未全部核销',
  Payable_Not_Fully_Written_Off: '应付未全部核销',
  Financial_Archiving_Settings: '财务归档设置',
  Financial_Filing_Preconditions: '财务归档前置条件',
  Financial_Filing_Effective_Effect: '财务归档生效效果',
  WHETHER_FINANCIAL_AUDIT: '是否财务审核:',
  WHETHER_ACCRUED: '是否已计提:',
  CARGO_RECOGNITION_SETTING: 'OCR识别设置',
  AE_IDENTIFY_VENDORS: '新增/编辑识别供应商',
  TENANT_BUSINESS_NAME: '租户企业名称',
  OFFSHORE_CONSIGNMENT_IDENTIFICATION_SUPPLIER: '海出托书识别供应商',
  OCEAN_BILL_OF_LADING_IDENTIFICATION_SUPPLIER: '海运提单识别供应商',
  DTip: '确定要删除此租户的设置吗？删除后会采用平台设置的识别供应商',
  FormEditTip: '请勾选需要编辑的租户识别设置',
  FormDeleteTip: '请勾选需要删除的租户识别设置',
  OCRRecognition: 'OCR识别',
  FINANCIAL_RECEIVABLES_VERIFICATION: '是否应收全部核销:',
  FINANCIAL_DUE_VERIFICATION: '是否应付全部核销:',
  FINANCIAL_CHARGE: '是否有进行中的费用新增/更改/删除:',
  CANCEL_FINANCIAL_AUDIT: '取消财务审核:',
  MODIFY_CHARGE: '修改费用:',
  MODIFY_JOB: '修改业务信息:',
  MODIFY_RATE: '修改汇率:',
  MODIFY_FINANCE_JOB_DATE: '修改财务日期/业务日期:',
  GENERATE_RED_INVOICE: '生成红冲发票:',
  RECEIVABLE_GENERATES_INVOICE: '应收可生成发票:',
  COPE_GENERATES_INVOICE: '应付可生成发票:',
  CANCEL_RECEIVABLE_VERIFICATION: '取消应收核销:',
  COPE_RECEIVABLE_VERIFICATION: '取消应付核销:',
  MODIFY_ACCRUAL: '修改计提:',
  NON_FILEABLE_BUSINESS: '存在不可归档业务',
  NOT_FULLY_COMPLETED: '存在业务未完全完成，请查看提醒',
  BUSINESS_CAN_ARCHIVED: '业务可归档',
  ARCHIVE_DATE: '归档日期',
  NOT_OPERATIONAL: '不可操作，原因：业务已归档。',
  CHANGE_CHARGE_IN_PROGRESS: '存在进行中的“更改费用审核”请先完成',
  ONLY_NOT_ARCHIVED_TRANSACTIONS: '请筛选选择未归档的业务',
  ONLY_ARCHIVED_TRANSACTIONS: '请筛选选择已归档的业务',
  Cargo_Preplan: '预配',
  Cargo_SeaManagerSendPreplan: '海管家（发送预配）',
  Cargo_SeaManagerUpdatePreplan: '海管家（修改预配）',
  Cargo_SeaManagerDeletePreplan: '海管家（删除预配）',
  Cargo_SeaManagerSendingVGM: '海管家 (发送VGM)',
  Cargo_WseSendMPreplanQd: 'CW（青岛港主单发送舱单）',
  Cargo_WseSendPreplanQd: 'CW（青岛港分单发送舱单）',
  Cargo_WseSendUpdatePreplanQd: 'CW（青岛港修改舱单）',
  Cargo_WseDeletePreplanQd: 'CW（青岛港删除舱单）',
  Cargo_WseSendPreplanSh: 'CW（上海港发送舱单）',
  Cargo_WseSendUpdatePreplanSh: 'CW（上海港修改舱单）',
  Cargo_WseDeletePreplanSh: 'CW（上海港删除舱单）',
  Cargo_WseSendingVGM: '发送VGM',
  Cargo_Ams: 'AMS 发送',
  Cargo_Aci: 'ACI 发送',
  Cargo_Afr: 'AFR 发送',
  Cargo_EMainfest: 'eMainfest 发送',
  Cargo_Ens: 'ENS 发送',
  Cargo_Send_error: '发送异常',
  Cargo_Confirm_Delete: '确认要删除选中的数据？',
  Cargo_ApiCallBack: 'api回调',
  Cargo_BWJS: '百旺金穗云',
  Cargo_TaxEasy: '容津',
  Cargo_YGSH: '阳光速航',
  Cargo_BaiHui: '柏辉金壬',
  Cargo_OverseasSettlementCenter: '海外结算中心',
  Cargo_Receivable2: '应收：',
  Cargo_Payable2: '应付：',
  Cargo_From_Import: '进口同步',
  Cargo_From_Export: '出口同步',
  Approval_Approved_Time: '审批通过时间',
  CheckingExportToImport: '该业务不能出口转进口，请检查后重试！',
  OnlySupportOneCustomsInfo: '开启信号旗接口时，只支持有一条报关明细',
  CustomsDeclareTime: '要求报关日期',
  SendContainer: '推送拼箱清单给报关行',
  IsTheLCLListSent: '拼箱清单是否发送',
  LCLList: '拼箱清单',
  iEPort: '出境关别',
  OceanBillOfLadingNumber: '海运提单号',
  NoticeBgh: '等通知报关',
  SelfDeclaration: '客户自报关',
  NotSentCustomsFile: '未发送过报关资料。（如果线下其他途径已发送过，可忽略此提醒）',
  FilledMustFill: '发送报关资料时，[{0}]字段必填',
  NoContainerInfo: '该箱子下面没有装箱信息',
  InformationComparison: '信息比较',
  Diff: '差异',
  PostLCLTask: '推送拼箱任务',
  ForceDeleteCustomsTips: '报关资料已经推送信号旗,确定要强行删除吗？',
  AddCustomerFileFirst: '请先添加报关资料',
  Local: '本地',
  CustomsDocumentPreparation: '报关制单',
  PleaseCreateSplitBillFirst: '请先创建拆单',
  Cargo_DisplaySell: '展示销售方银行账号',
  Cargo_DisplayBuyer: '展示购买方银行账号',
  ItIsRecommendedToFillInWhenTheExitPortIsShanghai: '(注: 出境口岸是上海时建议填写)',
  PleaseFillInTheIEPort: '请填写出境关别',
  CustomsUnFrozen: '报关解冻',
  UnFrozen: '解冻',
  LCLTaskSent: '已发送拼箱任务',
  LCLTaskNotSent: '未发送拼箱任务',
  Unfreeze: '已解冻',
  NotUnfreeze: '未解冻',
  CustomerFileHasBeenSent: '已发送报关资料',
  NotSendingCustomerFile: '未发送报关资料',
  XhqCustomerState: '信号旗报关状态',
  VGMWeighingAddressCannotBeEmpty: 'VGM称重地址不能为空',
  unfrozenOffline: '已解冻(线下解冻)',
  NotifyCustomsUnfreeze: '通知报关解冻',
  CargoOwnerSOC: '货主SOC',
  ForwarderSOC: '货代SOC',
  SOCType: '货主箱类别',
  InvoiceConfig: '开票配置',
  InvoiceChannel: '开票渠道',
  FEI_NuoNuo: '诺诺网全电发票:NUONUO',
  FEI_Bwjsy: '百旺金穗云:BWJSY',
  FEI_Kpzddm: '开票终端代码(kpzddm)',
  FEI_Yhdm: '用户代码(yhdm)',
  FEI_NotUse: '未启用',
  InvoicerConfig: '开票员配置',
  Invoicer: '开票员',
  ExtensionNumber: '分机号',
  OnlyInvoicer: '仅对应开票员开票',
  AllInvoicer: '所有用户共用',
  Cargo_ReceiveAmount: '应收账款金额',
  Cargo_BatchDeleteChargeTips: '未选择费用，默认删除所有勾选的业务费用，是否继续？',
  Cargo_Template_Push: '模板推送',
  Empty: '（空）',
  Cargo_UploadTemplateDataSample: '上传模板数据样例',
  Cargo_SureDeleteTheFile: '确定是否删除该文件？',
  Cargo_DownloadContent: '下载内容',
  Cargo_ImportOrderTemplateFile: '：导入订单模板文件',
  Cargo_ImportOrderTemplateDataSampleFile: '：导入订单模板数据样例文件',
  Cargo_Sample: '样例',
  Cargo_Sample_Tip: '*如HQ已上传数据样例文件，其他分公司未上传时，其他分公司默认使用HQ的数据样例文件',
  OpenXhqChat: '开启信儿',
  OpenXhqChatTips: '该业务未发送过报关资料，请先发送报关资料',
  CustomsBrokerNotEntered: '报关行未录入',
  Cargo_CanNotSplitMasterJob: '整拼类型不等于自拼箱或Buyer Console, 不能进行拆分！',
  RespMsg: '返回信息',
  Cargo_BillPaymentRemarkTip: '* 备注为空时，不会覆盖原有数据备注内容。',
  Cargo_WarehouseCode: '进仓编号代码',
  Cargo_WarehouseCodeLengthLimit: '用于进仓编号生成配置，代码字符最长为10位。',
  Cargo_ValueSetting: '取值设置',
  Cargo_SettingValuePriority: '设置取值优先级',
  Cargo_PleaseToPartnerWarehouseCode: '请参看合作伙伴进仓编号代码',
  Cargo_LineSeaAir: '航线（海运/空运）',
  Cargo_LineRailWay: '航线（铁路）',
  Cargo_BatchDeleteCharge: '批量删除费用',
  Cargo_SetDeleteCondition: '设置删除条件',
  Cargo_ToBeDeletedCharge: '待删除的费用数据',
  Cargo_ToBeDeletedChargeSelected: '已选择删除费用数据: ',
  Cargo_MatchCharge: '匹配费用',
  Cargo_SureDelete: '确定删除已选择{0}条数据项吗？',
  Cargo_ShowChargeDeleteResult: '显示费用删除结果',
  Cargo_DeletedTips: '已删除了{0}条数据',
  Cargo_NotSelectDeletedTips: '未选择需要删除的费用数据！',
  Cargo_PleaseMatchDataFirstTips: '请先匹配数据后，确认需要批量处理的数据。',
  Cargo_NotSelectDeleteConditionTips: '未选择费用删除条件！',
  Cargo_BatchEditCharge: '批量编辑费用',
  Cargo_SetEditCondition: '设置调整条件',
  Cargo_ToBeEditCharge: '待调整的费用数据',
  Cargo_ToBeEditChargeSelected: '已选择调整费用数据: ',
  Cargo_SureEdit: '确定调整已选择{0}条数据项吗？',
  Cargo_ShowChargeEditResult: '显示费用更新结果',
  Cargo_EditTips: '已更新{0}条数据',
  Cargo_NotSelectEditTips: '未选择需要调整的费用数据！',
  Cargo_NotSelectEditConditionTips: '未选择费用调整条件！',
  Cargo_EditAmountNoZero: '调整单价不能为0！',
  Cargo_EditUnitRate: '调整单价',
  Cargo_EditSettleAccountsTo: '调整结算对象',
  Cargo_HandleResult: '处理结果',
  Cargo_LoadMore: '滚动加载更多',
  Cargo_NoMoreData: '无更多数据',
  Cargo_ChargeHasDiffAmount: '费用已做差额处理不允许修改！',
  Cargo_ChargeHasConfirm: '费用已确认不允许修改！',
  Cargo_ChargeHasVerified: '费用已销账不允许修改！',
  Cargo_ChargeHasCommit: '费用已提交不允许修改！',
  Cargo_ChargeHasCreateBillPayment: '费用已创建付款申请不允许修改！',
  Cargo_ChargeHasCreateInvoice: '费用已开票不允许修改！',
  Cargo_JobStateNotAllowModified: '业务已提交/已审核不允许修改!',
  Cargo_InvoiceChargeItemSetup: '费用设置（越南开票）',
  Cargo_InvoiceChargeUnitSetup: '单位设置（越南开票）',
  Cargo_ChargeItemId: '收费项目(Cargoware)',
  Cargo_ChargeItemName: '名称(开票平台)',
  Cargo_ChargeUnitCode: '单位(Cargoware)',
  Cargo_ChargeUnitName: '描述(开票平台)',
  Cargo_InvoicingByTaxRate: '按税点分组开票',
  Cargo_SureToVoidTheInvoiceVietnam: '根据越南税控政策。请确认已联系客户，确保该发票尚未报税。如已保税，请勿作废发票。<br/><br/>确认是否作废此张发票？',
  Cargo_RandomPassword: '随机密码',
  ChargeSchemeCopy: '费用方案复制',
  CompanyCopy: '合作伙伴复制',
  SourceCompany: '来源公司',
  QueryChargeScheme: '查询费用方案',
  CopyChargeScheme: '复制费用方案',
  QueryCompany: '查询合作伙伴',
  CopyCompany: '复制合作伙伴',
  FuzzyQueryOfIdOrName: 'ID或名称模糊查询',
  CopyToCompany: '复制到分公司',
  CopySuccessCount: '复制成功 {0} 条',
  PleaseSelectTargetTenant: '请选择目标租户',
  Cargo_TemplateNodeWorkTaskSetting: '模板的节点工作任务设置',
  Cargo_WorkTaskEnable: '开启节点的工作任务设置',
  Cargo_SetNodeResponsible: '设置该节点负责',
  Cargo_DesignatedPosition: '指定岗位（根据岗位设置节点的工作负责，只可单选）',
  Cargo_SetPreNode: '设置前置节点（节点开始需要的前置节点状态）',
  Cargo_SetPreNodeTips: '设置该节点的前置节点（最多5个前置节点，为与关系）',
  Cargo_HandlingPriorityMarkers: '处理优先级标记',
  Cargo_HandlingPriorityMarkersTips: '设置处理优先级（最多3个，不设置时，默认为低优先级）',
  Cargo_HandlingPriorityMarkersHigh: '设置处理优先级为：高',
  Cargo_HandlingPriorityMarkersMedium: '设置处理优先级为：中',
  Cargo_HandlingPriorityMarkersLow: '设置处理优先级为：低',
  Cargo_SOPWorkTaskBoard: 'SOP工作任务看板',
  Cargo_High: '高：',
  Cargo_Medium: '中：',
  Cargo_Low: '低：',
  Cargo_SopBusinessFlowDashboard: 'SOP业务流看板',
  Cargo_WarnTodoList: '预警待办事项列表',
  Cargo_BpmTodoList: '审批事项列表',
  Cargo_BusinessTime: '业务时间',
  Cargo_HandleLevel: '处理级别',
  Cargo_PreNode: '前置节点',
  Cargo_PriorityHigh: '高优先级',
  Cargo_PriorityMedium: '中优先级',
  Cargo_PriorityLow: '低优先级',
  Cargo_SetDefaultDisplayItem: '设置为默认显示项',
  Cargo_PreNodeRepeat: '前置节点配置重复',
  Cargo_PriorityRepeat: '优先级配置中，【条件项+触发方式+日期】不能重复',
  Cargo_TrackingIconTip: '该图标用作于B2B系统和SOP工作任务看板使用！',
  Cargo_LoadData: '刷新数据',
  Cargo_TemplateNodeMergeShow: '模板节点合并显示',
  Cargo_MblTip: '请输入6-30个大写字符和数字',
  Cargo_VesselTip: '请输入字母、数字、“.”、“-”、“空格”',
  Cargo_VesselTip2: '不能输入中文和全角字符',
  Cargo_VoyageTip: '请输入不带V.航次',
  Cargo_ShippingCompanyTip: '请选择船司',
  Cargo_CarrierAgentTip: '请选择船代',
  Cargo_SailingDateTip: '请选择开航日期',
  Cargo_PortOfLoadingHgjTip: '海管家只支持上海港发送',
  Cargo_PortOfLoadingWsTip: '请选择起运港，支持上海、青岛',
  Cargo_PortOfLoadingTip: '请选择港口大写英文全称',
  Cargo_PortOfDischargeTip: '请选择卸货港',
  Cargo_PortOfDestinationTip: '请选择目的港',
  Cargo_PortOfDestinationTip2: '请选择港口大写英文全称',
  Cargo_BlNumberTip: '请选择提单方式',
  Cargo_DispatchingPlaceCodeTip: '若是南京收货经上海出，发货地填南京',
  Cargo_DispatchingPlaceCodeTip2: '请选择发货地',
  Cargo_DispatchingPlaceCodeTip3: '只能支持发货地是青岛或者日照',
  Cargo_ShipperEnterpriseNameTip: '请输入140以内的字符',
  Cargo_ShipperEnterpriseNameTip2: '请输入70以内的字符',
  Cargo_ShipperContactsTip: '请输入20个字符以内的电话号码',
  Cargo_PortPlaceOfDeparture: '起运港/起运地',
  Cargo_PortPlaceOfDischarge: '卸货港/卸货地',
  Cargo_MsgClassifyManager: '消息分类管理',
  Cargo_BellMsg: '铃铛消息',
  QuickSearchMsgClassify: '请输入名称模糊检索',
  Cargo_GroupingDimensionForRate: '“分组条件“等于“税率”，”值“必须填写为“数字”！',
  Cargo_CheckAccountSetBranchId: '当前账套所属分公司不属于当前分公司或上级分公司，是否继续？',
  Cargo_BillPayment: '付款申请单',
  Cargo_MakeInvoice: '开票申请单',
  Cargo_JobCharge: '业务费用申请单',
  Cargo_CopyNotifier: '复制通知人',
  Cargo_CopyRecipient: '复制收货人',
  Cargo_InputIMO: '请输入IMO号',
  Cargo_InputBLFreightTermTootip: '请选择运输条款',
  Cargo_PureNumbers: '请输入纯数字',
  Cargo_DefaultShanghai: '默认SHANGHAI|CNSHA，不可更改',
  Cargo_IMO: 'IMO号',
  Cargo_DangerousGoodsCheck: '您填写了 {0}，但是货物类型选择的是“普通货物”，请核实后重新发送',
  ChinaPostProductConfiguration: '中邮产品配置',
  AllowSaleProduct: '可售卖产品',
  AllowSaleProductNotNull: '可售卖产品未选择',
  NewChargeGroup: '新一代费用组',
  ChargeMapping: '新一代费用映射',
  ChargeMappingFuzzySearch: '请输入传输费用代码或名称模糊查询',
  RailwayUse: '铁路使用',
  BecameInvalid: '已失效',
  FullOrInside: '全程/国内',
  FullOrInsideNotNull: '全程/国内未选择',
  TransmitChargeName: '传输费用组',
  TransmitChargeNameNotNull: '传输费用组未选择',
  TransmitChargeCode: '传输费用组代码',
  MaintainerRemarks: '维护人员备注',
  PushOrNot: '是否重推',
  Cargo_BusinessLeaderCompanyPrePort: '港前商务负责人公司',
  Cargo_BusinessLeaderDeptPrePort: '港前商务负责人部门',
  Cargo_BusinessLeaderCompanyEndPort: '尾程商务负责人公司',
  Cargo_BusinessLeaderDeptEndPort: '尾程商务负责人部门',
  Cargo_CurrentNode: '当前节点',
  Cargo_WorkNode: '工作节点',
  Cargo_EditStateTip: '确定修改已选择{0}条数据项的节点状态吗？',
  Cargo_BpmSubmitDuplicated: '当前单据已存在审核单, 请勿重复提交',
  Cargo_TempCreditApply: '临时信控申请单',
  Cargo_PartnerName: '合作伙伴名称',
  Cargo_ContractAmount: '合同额度',
  Cargo_ContractAccountingPeriod: '合同账期',
  VerificationSheetRequired: '需要校验单',
  Cargo_TransportSource: '运力来源',
  Cargo_CustomerExpandMode: '拓客方式',
  Cargo_SubmitTempCreditTip: '维护临时信控要发起临时信控审批流程，您现在要发起审批吗？',
  Cargo_CustomFields: '配置字段',
  Cargo_CustomerCode: '凭证系统客商编码',
  Cargo_NoHasFinanceCode: '对应发票抬头没有对应用友的“凭证系统客商编码”。',
  Cargo_MultiCurrency: '勾选的发票存在多币种。',
  Cargo_YongYouDeleteTip: '当前发票已推送用友，如需操作需要前往凭证系统，删除对应记录。确定操作吗？',
  Cargo_SyncVerifyDoc: '同步核销单据',
  Cargo_HasSync: '勾选的数据已同步',
  Cargo_OverseaActualAmount: '国外销账数据，不可同步用友。',
  Cargo_MultiInvoiceTitle: '存在一个销账流水中，包含多个开票抬头。无法推送用友，请调整数据。',
  Cargo_InvoiceTitleMustBeIdentical: '开票抬头必须相同。',
  Cargo_ChargeChangeApply: '费用更改申请单',
  Cargo_CollectInvoiceApply: '收票申请单',
  Cargo_HideUnmodifiedFees: '隐藏未改动费用',
  Cargo_ChargeChangeTip: '注：已存在当下更改内容待审批，待此次改动结束后方可再次进行费用调整。',
  Cargo_UniqueIdentification: '唯一标识',
  Cargo_CostNumber: '费用编号',
  Cargo_OriginalCostUniqueIdentifier: '原费用唯一标识',
  Cargo_OriginalExpenseNumber: '原费用编号',
  Cargo_ChargeChange: '费用更改',
  Cargo_ApprovalProcessForChargeChange: '费用更改申请审批流程',
  Cargo_ChargeChangeTip2: '请问现在就要确认发起费用更改审批吗？',
  Cargo_ChargeChangeTip3: '注：此次审批结束前将无法再对费用进行更改。',
  Cargo_ViewChangeData: '查看变更数据',
  Cargo_GrossProfitMarginBeforeChange: '变更前毛利率',
  Cargo_GrossProfitMarginAfterChange: '变更后毛利率',
  CustomFieldDisplayConfiguration: '自定义字段显示',
  Field: '字段',
  ChineseDisplayName: '中文显示名',
  EnglishDisplayName: '英文显示名',
  FieldNotEmpty: '字段不能为空',
  ChineseDisplayNameNotEmpty: '未填写中文显示名',
  EnglishDisplayNameNotEmpty: '未填写英文显示名',
  Cargo_ContractRule: '合同规则',
  Cargo_ApplicationConditions: '应用条件',
  Cargo_ConditionValue: '条件值',
  Cargo_ContractWarning: '合同预警',
  Cargo_ApplicationRules: '应用规则',
  Cargo_ContractRuleChangeTip: '当前规则已被应用到部分合同中，请先将应用此规则的合同更改新的规则后再进行操作。',
  Cargo_DailySettlement: '天结',
  Cargo_ContractNumber2: '合同编号 ',
  CheckArApDisparity: '已配置过账单的校验，请应收、应付账单分开进行操作',
  VASChannelSetting: '增值服务通道配置',
  ManifestChannel: '预配舱单发送供应商',
  VGMChannel: 'VGM发送供应商',
  VASChannelFormEditTip: '请勾选需要编辑的租户发送通道设置',
  VASChannelFormDeleteTip: '请勾选需要删除的租户发送通道设置',
  VASChannelSelectOneTip: '预配舱单发送供应商/VGM发送供应商至少选择一个',
  VASChannelDeleteTip: '确认要删除此租户的设置吗',
  VASChannelDTip: '删除发送通道设置',
  Cargo_PushAddCustomer: '推送新增客商',
  Cargo_ChooseArea: '请选择地区',
  Cargo_AllocationSuccessful: '分配成功',
  Cargo_CreatedSuccessful: '创建成功',
  Cargo_DuplicateCustomerName: '客商名称重复',
  Cargo_ExistFinanceCode: '已存在客商编码，无需推送',
  Cargo_EntrustedReceiveInfo: '委托接收信息',
  Cargo_ContainerLoadTypeRailWay: '委托类型（铁路）',
  ExclusionOffice: '新一代接口公司设置',
  Cargo_TransportationType: '运输类型',
  Cargo_MultiOrderTip: '若是有多份数据则批量生成订单',
  Cargo_IdentifyTemplateName: '识别模板名称',
  Cargo_IdentifyTemplateName2: '识别模板名称：',
  Cargo_TemplateId: '模板ID',
  Cargo_CodeProcessing: '代码处理',
  Cargo_TestFile: '测试文件',
  Cargo_TemplateIdAutomaticallyGenerated: '模板ID（自动生成）：',
  Cargo_TemplateStatus: '模板状态：',
  Cargo_DocumentTypeDescription: '文件类型说明',
  Cargo_DocumentTypeDescription2: '文件类型说明：',
  Cargo_ReadField: '读取字段',
  Cargo_FieldName: '字段名称',
  Cargo_FieldRuleDescription: '字段规则说明',
  Cargo_PreviewPromptWords: '预览提示词',
  Cargo_Invalid3: '无效',
  Cargo_Sequence: '序列',
  Cargo_FieldAdd: '字段新增',
  Cargo_FieldEdit: '字段编辑',
  Cargo_FieldView: '字段查看',
  Cargo_PlatformEnterpriseName: '平台企业名称',
  Cargo_AccessKey: 'Access Key',
  Cargo_SecretKey: 'Secret Key',
  Cargo_CallBackUrl: '回调地址',
  Cargo_PlatformEnterpriseInterfaceConfiguration: '平台企业接口配置',
  Cargo_OcrTemplateConfig: 'OCR模板设置',
  Cargo_OcrCode: '嵌入代码处理（嵌入代码二次处理最终返回结果作为API输出值）',
  Cargo_originalValue: '原始值',
  Cargo_DebuggingResults: '调试结果',
  Cargo_UsageStatistics: '使用统计',
  Cargo_NumberOfSuccessfulCalls: '调用成功次数',
  Cargo_UsingFlowingWater: '使用流水',
  Cargo_CallTemplateId: '调用模板ID',
  Cargo_CallResult: '调用结果',
  Cargo_Template: '模板',
  Cargo_QueryFlowingWater: '查看流水',
  Cargo_TemplateId2: '模板ID：',
  Cargo_FileName2: '文件名：',
  Cargo_IdentifyReturnResult: '识别返回结果：',
  Cargo_CustomsChannel: '报关单识别供应商',
  Cargo_IdentifyTheSupplier: '识别供应商',
  Cargo_PleaseSet: '请设置',
  Cargo_OnlyOneSupplier: '一个类型只能设置一个供应商',
  Cargo_IdentificationCannotBePerformedTip: '未设置识别类型无法识别，有需求可联系客服；',
  Cargo_TemplateSettings: '模版设置',
  Cargo_IdentificationTip1: '请设置识别类型对应的供应商',
  Cargo_PleaseSelectSpecificFields: '请选择具体的字段进行编辑',
  Cargo_ConfirmToDeleteThisField: '确定要删除该字段？删除后接口将不再返回此字段信息',
  Cargo_ValidThisRecognitionTemplate: '确定要将此识别模板恢复有效吗？',
  Cargo_InValidThisRecognitionTemplate: '确定要失效此配置吗？失效后调用接口将不再返回数据',
  Cargo_ValidThisRecognitionEnterprise: '确定要恢复企业为有效吗？',
  Cargo_InValidThisRecognitionEnterprise: '确定要失效该企业吗？失效后将无法调用接口',
  Cargo_DateErrorTip: '失效日期必须大于生效日期',
  Cargo_ModifyCodeHandle: '修改"代码处理"',
  Cargo_ModifyPromptWords: '修改"提示词"',
  Cargo_CannotEnable: '不在生效期内，无法点击【启用】',
  Cargo_InputTokenCount: '大模型识别input_token数量',
  Cargo_OutputTokenCount: '大模型识别output_token数量',
  Cargo_PlsGenerate: '请生成',
  Cargo_TemplateUsed: '该模版已被客户使用，不可编辑。可解绑后再编辑或者复制模版进行编辑',
  Cargo_SelectOneData: '只允许勾选一条数据进行复制！',
  Cargo_OutputRequirements: '输出要求：',
  Cargo_AnalyticMethod: '解析方式：',
  Cargo_BLNoStatistics: '提单号统计',
  Cargo_RemainingQuantity: '剩余数量',
  Cargo_RegistrationDate: '登记日期',
  AnalyzeChannelSettings: '解析渠道设置',
  EmailParsingSettings: '邮件解析设置',
  EmailPasswordAuthorizationCode: '邮箱密码/授权码',
  SenderServer: '发件服务器',
  Port: '端口',
  AddOrEditEmail: '新增/编辑邮箱',
  EmailPurpose: '邮箱用途',
  EnterCorrectEmail: '请输入正确的邮箱地址',
  SelectDeleteEmail: '请选择要删除的邮箱',
  DeleteEmailConfirm: '确认删除选中的邮箱吗？删除后将不再读取删除的邮箱进行解析',
  ImportMblNo: '导入主单号',
  ApplicableDepartment: '适用部门',
  Cargo_QuoteMethod_ExistingRate: '报价方式为"已有运价"的报价单，无法撤回',
  Cargo_QuoteMethod: '报价方式',
  Cargo_ExistingRate: '已有运价',
  Cargo_CommercialQuote: '商务报价',
  Cargo_PrePortQuoteMethod: '港前报价方式',
  Cargo_MainlineQuoteMethod: '干线报价方式',
  Cargo_EndlineQuoteMethod: '尾程报价方式',
  PleaseSelectApplicableBranch: '请选择适用分公司',
  Cargo_CheckSetting: '校验设置',
  Cargo_BookNoteFieldName: '托书字段名称',
  Cargo_IfRequired: '是否必填',
  Cargo_Channel: '渠道',
  Cargo_IfSame: '对比不一致',
  Cargo_DefaultValue2: '为空默认值',
  Cargo_BookFieldNameRepeat: '托书字段名称重复',
  Cargo_BookNoteFieldAndSort: '托书显示字段以及顺序',
  Cargo_IfAutoBooking: '是否自动订舱',
  Cargo_BookRecognitionResults: '托书识别结果',
  Cargo_ConfirmedBusinessData: '录单信息',
  Cargo_OtherData: '其他数据',
  Cargo_BranchOffice: '分公司(BranchOffice)',
  Cargo_ShippingCompany: '船公司(ShippingCompany)',
  Cargo_IfAutomaticBooking: '是否自动订舱(IfAutomaticBooking)',
  Cargo_Book: '托书',
  Cargo_GoodNameContainSensitiveWord: '品名中包含敏感词<span style="color: red">{0}</span>，是否继续订舱？',
  Cargo_OnlyGenerateJob: '只生成业务',
  Cargo_PleaseReceiveCallback: '请注意接收回执',
  Cargo_JobProcess: '业务进度',
  Cargo_IdentificationMethod: '识别方式',
  Cargo_NoNeedSupplementaryInformationBookNote: '没有需要补充信息的托书',
  Cargo_SupplementaryInformationTip: '请选择【上传进度】为【解析完成】且【识别渠道】为【CW-多模态识别】且【识别类型】为【海出托书】的记录',
  CannotBeLongerThan35: '信息超长，请重新编辑，收发通最大{0}行，每行最大35个字符',
  Cargo_OcrSetTip: '您还未设置任何信息，以下字段以及验证设置均为系统默认，托书中展示平台默认设置<br/><br/>取值优先级：若是勾选应用总公司，则优先级应用总公司>租户设置>平台设置',
  Cargo_AutomaticAllocation: '自动虚拟分摊费用',
  Cargo_ChargeAutomaticAllocationConfig: '费用自动分摊配置',
  Cargo_EditAutomaticAllocationConfig: '编辑主票费用自动分摊配置',
  Cargo_AddAutomaticAllocationConfig: '新建主票费用自动分摊配置',
  Cargo_MatchingCriteriaSelection: '匹配条件选择',
  Cargo_AutomaticAllocationRuleConfig: '自动分摊规则配置',
  Cargo_AllocationNature: '分摊性质',
  Cargo_HblSingleAllocation: 'HBL并单分摊',
  Cargo_OnlyAllocatedToHblSingle: '仅分摊到并单上',
  Cargo_MasterBill: '主单',
  Cargo_AddEditReceivablePayableFees: '新增/编辑应收应付费用',
  Cargo_AddEditReceivableFees: '新增/编辑应收费用',
  Cargo_AddEditPayableFees: '新增/编辑应付费用',
  Cargo_AddEditReceivableSpecialFees: '新增/编辑应收特殊费用',
  Cargo_AddEditPayableSpecialFees: '新增/编辑应付特殊费用',
  Cargo_DeleteReceivablePayableFees: '删除应收应付费用',
  Cargo_DeleteReceivableFees: '删除应收费用',
  Cargo_DeletePayableFees: '删除应付费用',
  Cargo_ImportReceivablePayableFees: '费用导入应付应付',
  Cargo_ImportReceivableFees: '费用导入应收',
  Cargo_ImportPayableFees: '费用导入应付',
  Cargo_BusinessTypeError: '所勾选的单据业务类型不一致，不可修改！',
  Cargo_ReceivableSpecialFee: '应收特殊费用',
  Cargo_PayableSpecialFee: '应付特殊费用',
  Cargo_ReceivablePayableSpecialFee: '应收应付特殊费用',
  Cargo_PleaseSetChargeNameAndAllocationType: '请设置费用名称和分摊类型',
  Cargo_PleaseSetChargeName: '请设置费用名称',
  Cargo_PleaseSetAllocationType: '请设置分摊类型',
  Cargo_HasDuplicateConfigItem: '已有重复配置数据！',
  Cargo_ConfirmDeleteTheConfigItem: '确定是否删除该配置项？',
  Cargo_ConfirmSaveModifiedInfo: '确定是否保存修改信息？',
  Cargo_InvoiceRepeat: '发票号重复',
  Cargo_TurnOffAutomaticAllocation: '将关闭该主票的自动虚拟分摊费用，改为手动分摊！',
  Cargo_RemainingAmountNotEnough: '余额不足，请充值',
  Cargo_RemainingAmountNotEnough2: '余额不足，无法再次生成业务',
  Cargo_ExpandAll: '展开>',
  Cargo_PackUp: '<收起',
  Cargo_OcrTip: '温馨提示：录单信息是指写入业务中的数据，其中标红的字体表示错误无法与平台映射上，需要修改后录单',
  Cargo_OcrTip2: '温馨提示：录单信息是指写入业务中的数据，其中标红的字体表示错误无法与平台映射上',
  Cargo_ClaimSettlement: '理赔',
  Cargo_BillStatusDoesNotMeetPaymentRequestRequirements: '账单状态不符合付款申请要求',
  Cargo_GetReceiptSettings: '获取回执设置',
  Cargo_AddEditReadReceiptMethod: '新增/编辑读取回执方式',
  Cargo_ReadReceiptMethod: '读取回执方式',
  Cargo_DeleteReceiptTip: '确定要删除此配置吗？删除后将不再按此规则读取回执',
  Cargo_PleaseInputTitleOrContentTip: '请输入标题或正文',
  Cargo_BookingState: '订舱状态',
  Cargo_BookingChannelConfig: '订舱渠道配置',
  Cargo_BookingMode: '订舱模式',
  Cargo_RpaSupplier: 'RPA供应商',
  Cargo_BookingChannel: '订舱渠道',
  Cargo_ConfirmRejectQuote: '确定拒绝报价吗？',
  Cargo_MainlineRejectReason: '干线拒绝原因',
  Cargo_PortRejectReason: '港前拒绝原因',
  Cargo_EndlineRejectReason: '尾程拒绝原因',
  Cargo_WebSite: '网址',
  Cargo_CompanyCode: '公司编码',
  Cargo_ReceiptConfig: '回执配置',
  Cargo_EditBookingChannelConfig: '编辑订舱渠道设置',
  Cargo_AddBookingChannelConfig: '新增订舱渠道设置',
  Cargo_ReceiptConfigCannotBeEmpty: '回执配置不能为空',
  Cargo_IndiaLineInfo: '印度线',
  Cargo_CargoAmount: '货值',
  Cargo_CargoCurrency: '货币',
  Cargo_YdShipCode: '壹沓船公司',
  Cargo_SendThisPageEDI: '发送本页EDI',
  Cargo_SendAllEDI: '发送所有EDI',
  Cargo_SendEDI: '是否发送EDI?',
  Cargo_IsSendAllEDI: '是否发送所有的EDI?',
  Cargo_SendEDISucceeded: '发送EDI成功',
  Cargo_FailedToSendEDI: '发送EDI失败',
  Cargo_CheckCanSendEDI: '正在订舱或者已订舱无法再次发送',
  Cargo_OneKeyBooking: '一键订舱',
  Cargo_OneKeyBookingTip1: '满足条件发起订舱的业务：<span style="color: blue">{0}</span>条，点击【确认】后将直接发起订舱，可在EDI或者海运订舱页签中查看订舱状态',
  Cargo_OneKeyBookingTip2: '温馨提示：满足以下条件的订单将一键发起订舱<br/>1）开航日期>当天<br/>2）订舱状态为“已录单，未订舱”<br/>3）货物类型：普货<br/>4）整拼类型：整箱',
  Cargo_CanNotBooking: '没有符合【可订舱条件】的业务',
  Cargo_CurrentlyBooking: '近2个月正在订舱：',
  Cargo_SendSuccess2: '发送成功：',
  Cargo_CallEdiFail: '调用异常：',
  Cargo_ValidFail: '校验错误：',
  Cargo_TemplateMatchFail: '模板匹配失败：',
  Cargo_BookingSendMethod: '订舱发送方式',
  Cargo_BookingSendChannel: '订舱发送渠道',
  Cargo_BookingSendDate: '订舱发送时间',
  Cargo_BookingReceiptDate: '订舱回执时间',
  Cargo_OriginBookingState: '订舱原始状态',
  Cargo_NotBooking: '不订舱',
  Cargo_ContinueBooking: '继续订舱',
  Cargo_ChangeInfo: '修改信息',
  Cargo_BookingTransportMode: '订舱传输方式',
  Cargo_EdiBookingExportState: '导出状态',
  Cargo_OneKeyBookingTip3: '正在发起订舱，可稍后查看具体的订舱状态',
  Cargo_BookingInProgress: '正在订舱',
  Cargo_NewSpaceCarrier: '新增舱位承运人',
  Cargo_AlreadyExistsCheck: '已存在相同数据，无需保存。',
  Cargo_portOfLoadingSeaport: '舱位信息起运港(海港)',
  Cargo_portOfDestinationSeaport: '舱位信息目的港(海港)',
  Cargo_portOfLoadingAirport: '舱位信息起运港(空港)',
  Cargo_portOfDestinationAirport: '舱位信息目的港(空港)',
  Cargo_shippingCarrier: '舱位承运人',
  Cargo_shippingAirline: '舱位信息航线',
  Cargo_newEventRecord: '新增事件记录',
  Cargo_SelectInquiryToCopy: '请选择需要复制的询价',
  Cargo_VerifyStateReceivableDomestic: '国内应收核销状态',
  Cargo_VerifyStateReceivableOversea: '国外应收核销状态',
  Cargo_ReturnActualAmountNo: '关联水单号',
  Cargo_ReturnAmount: '已退金额',
  Cargo_ReturnApplyAmount: '退款中金额',
  Cargo_ReturnApplyState: '退款状态',
  Cargo_ReturnApply: '退款',
  Cargo_ReturnApplyCancel: '撤销退款',
  Cargo_ReturnApplyAudit: '退款同意',
  Cargo_ReturnApplyReject: '退款拒绝',
  Cargo_RemainingClaimedAmount: '剩余认领金额',
  Cargo_RefundAmount: '退款金额',
  Cargo_ReturnApplyCheck: '存在待审批的退款记录，暂无法发起新的退款申请！',
  Cargo_RemainingClaimedAmountZero: '剩余认领金额为0，无法退款！',
  Cargo_ReturnApplyAmountZero: '退款金额为0，无法退款！',
  Cargo_ReturnApplyAuditCheck: '只能对状态为审批中的记录，请重新勾选！',
  Cargo_WaterRefundedNoWriteOff: '水单退款的记录，不支持认领操作！',
  Cargo_WaterRefundingNoWriteOff: '退款状态为审批中的记录，不支持认领操作！',
  Cargo_WaterRefundedNoCancel: '水单退款的记录，不支持撤销认领操作！',
  Cargo_khEntryActTime: '卡航入境（实际时间）',
  Cargo_transferDeclareCompletedActTime: '中转地申报完成（实际时间）',
  Cargo_khExitActTime: '卡航出境（实际时间）',
  Cargo_khDeclareActTime: '卡航报关（实际时间）',
  Cargo_khReplacementActTime: '卡航换装（实际时间）',
  Cargo_arrivePodActTime: '到达目的地（实际时间）',
  Cargo_arriveClearActTime: '到达清关地（实际时间）',
  Cargo_khUnloadingActTime: '卡航卸货（实际时间）',
  Cargo_CustomerReserveVoyage: '客户预定航次',
  Cargo_CustomsDeclarationInformation: '关单信息',
  Cargo_CustomsDeclarationCommissionNumber: '报关委托单号',
  Cargo_CustomsDeclarationNotExist: '请至少维护一条【关单信息】',
  Cargo_QuantityWeightCubageChange: '件毛体信息变更，是否覆盖？',
  Cargo_ReferenceNoRepeat: 'VGM中参考号不能重复',
  Cargo_CustomerDemandClearanceNumber: '客户需求关单数',
  Cargo_Empty2: '(空)',
  Cargo_QuantityWeightCubage: '件毛体',
  Cargo_CustomsDeclarationDeleteTip: '当前关单号已关联报关委托，不可删除',
  Cargo_CustomsDeclarationValidTip: '关单信息的件毛体不可以为0',
  Cargo_CustomsDeclarationSoNoRepeat: '同一票业务中关单信息中的【关单号】不允许重复',
  Cargo_AuditCancel: '确定要取消审核吗！',
  Cargo_AuditCancelReason: '取消审核原因',
  Cargo_NuoNuoTipOne: '当开票渠道=诺诺时，为红冲不自动开具情况下此配置项填1，自动开具时无需配置。',
  Cargo_DestinationVehicleNumberOne: '目的地派送车头号',
  Cargo_DestinationVehicleRegister: '目的地派送车挂号',
  Cargo_ConfirmLockLabelBuyingPrice: '是否确定锁定买价?',
  Cargo_ConfirmLockLabelSellingPrice: '是否确定锁定卖价?',
  Cargo_ConfirmUnlockLabelBuyingPrice: '是否确定解锁买价?',
  Cargo_ConfirmUnlockLabelSellingPrice: '是否确定解锁卖价?',
  Cargo_PurchasePriceLockedStatus: '买价锁定状态',
  Cargo_SellingPriceLockedStatus: '卖价锁定状态',
  Cargo_BatchPurchasePriceLock: '批量锁定买价',
  Cargo_BatchPurchasePriceUnLock: '批量解锁买价',
  Cargo_BatchSellingPriceUnLock: '批量解锁卖价',
  Cargo_BatchSellingPriceLock: '批量锁定卖价',
  Cargo_NotActiveCompanyCleared: '此票业务中包含未活跃合作伙伴：{0} 系统自动将其清空，请重新选择录入。',
  Cargo_FBA_SE: 'FBA海运',
  Cargo_FBA_AE: 'FBA空运',
  Cargo_FBA_RE: 'FBA铁路',
  Cargo_SyncCreditTip: '点击此【同步】按钮后当前页面满足要求的临时信控会即刻生效，额度、账期会进行重新计算可能会存在部分延迟请耐心等待。',
  Cargo_SyncTempCreditTip: '当存在临时信控审批流时不做立刻同步。',
  Cargo_OperationInstructions: '操作指令',
  Cargo_InstructionName: '指令名称',
  Cargo_InstructionType: '指令类型',
  Cargo_RuleCode: '规则代码',
  Cargo_CodeParameterValues: '代码参数值',
  Cargo_InstructionCode: '指令代码',
  Cargo_CommandDisplayName: '指令显示名',
  Cargo_InstructionDescription: '指令说明',
  Cargo_InstructionRuleSetting: '指令规则设置',
  Cargo_IfAllowedSendMultipleTimes: '是否允许多次发送',
  Cargo_CanOnlyBeSentOnce: '仅可发送一次',
  Cargo_CanBeSentMultipleTimes: '可多次发送',
  Cargo_TemplateMatching: '模板匹配',
  Cargo_UnifiedBusinessScenario: '选择推送环节时，不同分公司有独立维护模板时，对应匹配分公司模板',
  Cargo_SelectEmailTemplate: '选择邮件模板',
  Cargo_SelectOperationInstruction: '选择操作指令',
  Cargo_SelectSpecificBusinessRule: '选择特定业务规则',
  Cargo_SelectThePushLink: '选择推送环节',
  Cargo_OperationButtonSettingsAndTip: '操作按钮设置（最多设置5个操作指令）',
  Cargo_SelectInstruction: '选择指令',
  Cargo_SetParameters: '设置参数',
  Cargo_SetParameterValues: '设置参数值',
  Cargo_InstructionChineseName: '指令中文名',
  Cargo_InstructionEnglishName: '指令英文名',
  Cargo_InstructionJapaneseName: '指令日文名',
  Cargo_CheckRuleNameExist: '已存在【{0}】规则名称',
  Cargo_LatestInstructionRecord: '最近操作指令执行情况',
  Cargo_InstructionRecords: '操作指令日志',
  Cargo_QueryInstructionRecords: '查看指令执行日志',
  Cargo_ExecuteResult: '执行结果',
  Cargo_OperationInstructionsManagement: '操作指令管理',
  Cargo_PlatformInstructionDisabled: '该指令已无法使用，请检查配置是否正确！',
  Cargo_NotMatchInstruction: '没有符合该指令条件的业务',
  Cargo_SelectJobCount: '已选中的业务条数',
  Cargo_MatchInstructionTip: '选中{0}条，符合操作指令条件的{1}条',
  Cargo_OperationInstructionSetTip: '操作指令设置时，【选择指令】值不能为空！',
  Cargo_OperationInstructionRepeatTip: '操作指令设置时，所选择的指令不能重复！',
  Cargo_OperationInstructionBatchTip: '每次批量发送邮件时，请不要选择超过30条业务数据。',
  Cargo_CurrentUserRole: '当前用户角色',
  Cargo_DisabledUnableToSave: '“{0}”已被禁用，无法保存，请移除相关费用再保存。',
  Cargo_CompanyDateOfCreation: '委托单位创建时间',
  Cargo_BringInBusinessInformation: '补充订单信息',
  Cargo_LclSendDestinationPortAgentTip: '仅可选择一条主票业务进行发送目的港代理',
  Cargo_LclSendPackageAgentTip: '仅可选择一条主票业务进行发送套单港代理',
  Cargo_SetUploadFileType: '设置上传文件类型',
  Cargo_PillReportData: '人工生成并替换数据源',
  Cargo_CanOnlyPrintOnce: '仅可打印一次',
  Cargo_CanPrintMultipleTimes: '可多次打印',
  Cargo_IfSelectTemplateType: '选择模板文件类型，当不同分公司有独立维护模板时，对应匹配分公司模板',
  Cargo_PrintMode: '打印模式',
  Cargo_SingleJobPrint: '单票业务打印',
  Cargo_BatchJobPrint: '批量业务打印',
  Cargo_SinglePrintFileType: '单票打印文件类型',
  Cargo_BatchPrintFileType: '批量打印文件类型',
  Cargo_SinglePrintFileTemplate: '单票打印文件模板',
  Cargo_BatchPrintFileTemplate: '批量打印文件模板',
  Cargo_SelectPrintFileTemplate: '选择打印文件模板',
  Cargo_SelectPrintFileType: '选择打印文件类型',
  Cargo_SelectPrintFileTypeTip: '所选打印模板未设置文件类型！请先设置打印模板对应的文件类型',
  Cargo_CabinRetrievalSuccessful: '舱位回收成功',
  Cargo_CabinFlowExitAndNo: '存在舱位流水和无舱位流水的数据，不可一并操作',
  Cargo_CabinRetrievalAndReturnSuccessful: '回收并退舱位成功',
  Cargo_revokeCabinSpace: '您勾选的订单，将执行撤回舱位流程',
  Cargo_CancelCabinAtTheSameTime: '同时退舱',
  Cargo_DeleteConfigTip: '确定是否删除？删除后，原有功能设置将无法使用！',
  Cargo_PreviewVoucher: '预览凭证',
  Cargo_InvoiceNotVoucher: '该发票未生成凭证，请重新选择。',
  Cargo_BankSlipNotVoucher: '该水单未生成凭证，请重新选择。',
  Cargo_PleaseChooseDataThatHasVouchered: '请选择已生成过凭证的数据。',
  Cargo_ExportVoucherSuccessfully: '{0}条凭证导出成功。',
  Cargo_ExportVoucherFailedByBankSlip: '水单号{0}导出失败，原因{1}，请重试。',
  Cargo_ExportVoucherFailedByInvoice: '发票{0}导出失败，原因{1}，请重试。',
  Cargo_UpdatePaidOffFlag: '刷新是否已核销',
  Cargo_CheckMblSame: 'MB/L NO与基本页签不一致',
  Cargo_IfExistMblNumberRange: '是否有主单号号段',
  Cargo_UserName_Password_Maintained: '请联系管理员到“基本设置-解析渠道设置”维护',
  Cargo_ShipCompany_Maintained: '请联系管理员到“合作伙伴”维护关联船公司',
  Cargo_ShippingCompanyCode_Maintained: '未维护映射船公司，请联系平台客服维护',
  Cargo_ShippingCompanyCode_MaintainedTip: '请联系平台客服维护',
  Cargo_BookingChannelConfig_Maintained: '未匹配到订舱渠道设置，请联系管理员到“基本配置-订舱渠道配置”维护',
  Cargo_BookingChannelConfig_MaintainedTip: '请联系管理员到“基本配置-订舱渠道配置”维护',
  Cargo_ErrorMsg: '异常原因',
  Cargo_SelectJumpErrorTip: '【{0}】不是可跳转页面，请选择一个页面，如：【基本】',
  Cargo_SelectJumpPage: '选择跳转的页面',
  Cargo_JumpSet: '跳转设置',
  Cargo_ClickJobNoJumpPage: '点击业务编号跳转页面',
  Cargo_JumpPage: '跳转的页面',
  Cargo_TabNotExistTip: '无法访问该页面，请确认是否有访问权限或单据包含该页面。',
  Cargo_CargoValue: '系统值',
  Cargo_YdValue: '回执信息',
  Cargo_ConfirmReplace: '确认覆盖',
  Cargo_NotReplace: '都不覆盖',
  Cargo_ReplaceSystemValue: '覆盖系统信息',
  Cargo_PleaseSelectDataToReplace: '请选择需要覆盖的字段信息',
  Cargo_YdBookingResultTip: '检测到回执中的信息与系统中录入数据存在偏差，请确认',
  Cargo_NoMappingValuesTip: '{0}与系统值匹配不上，若是需要修改请手动选择',
  Cargo_NonReplaceDataTip: '无需要覆盖的数据',
  Cargo_JobNotFound: '未查询到业务【{0}】',
  Cargo_AE_IDENTIFICATION_SUPPLIER: '空出托书识别供应商',
  Cargo_AIR_BILL_SUPPLIER: '空运提单识别供应商',
  Cargo_LoadingDate: '门点服务-提货时间',
  Cargo_DoorAddr: '门点服务-门点地址',
  Cargo_DoorMan: '门点服务-联系人',
  Cargo_DriverTel: '门点服务-联系电话',
  Cargo_aeFile: '空出的托书文件',
  Cargo_aiFile: '空进的提单文件',
  Cargo_carrierType: '舱位承运人类型',
  Cargo_DeclaredValue: '声明价值',
  Cargo_DeclaredValueForCustoms: '海关声明价值',
  Cargo_RateLevel: '费率等级',
  Cargo_PleaseSelectOperateType: '第【{0}】页托书请选择操作模式',
  Cargo_ServiceProductID: '服务产品id',
  Cargo_ServiceProductName: '服务产品名称',
  Cargo_ForceRoutingBooking: '强制航线订舱',
  Cargo_UsedAsRoutingProduct: '是否用做航线产品',
  Cargo_AirServiceProduct: '空运服务产品',
  Cargo_AddBasicAirFreightServiceProduct: '添加基础空运服务产品',
  Cargo_DeleteServiceProductWarning: '您将删除【{0}】个服务产品信息，请谨慎操作。',
  Cargo_RouteProductName: '航线产品名称',
  Cargo_ServiceProduct: '服务产品',
  Cargo_PurchaseMethod: '采购方式',
  Cargo_Airline2: '航司',
  Cargo_PurchaseSource: '采购来源',
  Cargo_OriginPort: '始发港',
  Cargo_RouteOfficer: '航线员',
  Cargo_IsEffective: '是否生效',
  Cargo_BaseWeight: '基重',
  Cargo_LimitWeight: '限重',
  Cargo_SellableSpace: '可售舱位',
  Cargo_LengthLimit: '长度限制',
  Cargo_HeightLimit: '高度限制',
  Cargo_TheoreticalVolume: '理论体积',
  Cargo_SellableVolume: '可售体积',
  Cargo_Box: '板箱',
  Cargo_PayingParty: '付费对象',
  Cargo_UnitPrice_TotalPrice: '单价/总价',
  Cargo_RouteProductCode: '航线产品代码',
  Cargo_BoardCount: '板数',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: '生效日期必须小于等于失效日期',
  Cargo_AirlineProductCode: '航线产品',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: '生效日期必须小于等于失效日期',
  Cargo_DeleteServiceProductWarning: '您将删除【{0}】个服务产品信息，请谨慎操作。',
  Cargo_PleaseSelectOperateType: '第【{0}】页托书请选择操作模式',
  Cargo_BaoDiCreditInfoNote: '注：当系统中配置的日期类型的为空时将采用保底账期进行计算(统一按月结算处理)，当业务中的日期类型有值后会重新计算费用到期日',
  Cargo_BottomLineCreditControl: '保底信控',
  Cargo_ProfitShareConfig: '利润分成配置',
  Cargo_CreateRule: '创建规则',
  Cargo_EditRule: '编辑规则',
  Cargo_CopyRule: '复制规则',
  Cargo_RuleName: '分润规则名称',
  Cargo_RuleConfig: '规则配置',
  Cargo_RuleRole: '角色',
  Cargo_ShareMode: '分润模式',
  Cargo_ShareModeJob: '按整票利润分成',
  Cargo_ShareModeCurrency: '按币种利润分成',
  Cargo_UsdRatio: '分润比例',
  Cargo_NonUsdRatio: '非美金比例',
  Cargo_ShareModeTip: '模式：',
  Cargo_ShareModeJobTip: '整票',
  Cargo_BankSlipDateCreated: '水单创建日期',
  Cargo_ShareRatio: '分润：',
  Cargo_PleaseSelectSalesBranch: '请选择销售分公司',
  Cargo_RuleConfigSubCountNotNull: '规则配置分支数不能为空',
  Cargo_SetUpConfigSubTriggerCondition: '请设置触发条件。',
  Cargo_ConfigSubRuleError: '分润规则条件变化，触发条件配置错误',
  Cargo_AddRuleConfigSub: '+添加分支配置',
  Cargo_AreYouSureModifyRuleConfigTips: '是否确认修改？',
  Cargo_ProfitShare: '是否参与分润',
  Cargo_ProfitShareColumn: '是否分润',
  Cargo_ProfitShareAdjust: '分润调整',
  Cargo_ProfitShareReset: '重新分润',
  Cargo_NonProfitShareBranch: '没有参与分润的分公司',
  Cargo_ProfitShareRatioSumExceed: '当前分润比例超过100%，请重新调整后确认。',
  Cargo_UsdProfit: '美金利润',
  Cargo_NonUsdProfit: '非美金利润',
  Cargo_JobProfit: '整票利润',
  Cargo_ShareBranchId: '分润方',
  Cargo_UsdRatioColumn: '美金分润比例',
  Cargo_UsdProfitColumn: '美金预计获利',
  Cargo_UsdProfitColumn2: '预计获利',
  Cargo_NonUsdRatioColumn: '非美金分润比例',
  Cargo_NonUsdProfitColumn: '非美金预计获利',
  Cargo_CheckProfitShareResetTip: '{0} 分润费用以进行后续财务动作（开票、付款、账单、核销...），暂无法进行重新分润，待取消对应财务动作后重试。',
  Cargo_AdjustColumn: '变动',
  Cargo_UsdProfitAdjustColumn: '美金预计追加获利',
  Cargo_UsdProfitAdjustColumn2: '预计追加获利',
  Cargo_NonUsdProfitAdjustColumn: '非美金预计追加获利',
  Cargo_JobProfitShare: '是否完成分润',
  Cargo_ReceivableFeeLockTime: '应收费用锁定时间',
  Cargo_ReceivableFeeLockTime2: '应收锁定时间',
  Cargo_PayableFeeLockTime: '应付费用锁定时间',
  Cargo_PayableFeeLockTime2: '应付锁定时间',
  Cargo_PayableFeeLockPerson: '应付费用锁定人',
  Cargo_RpaAccount: 'RPA托管账号',
  Cargo_WechatGroupName: '企微群聊名称',
  Cargo_TabEnterpriseWechat: '企微账号托管',
  Cargo_LoginEnterpriseWechat: '登录企微',
  Cargo_LoginEnterpriseWechatTip: '请使用企业微信扫码登录企微',
  Cargo_RpaAccountSummary: 'RPA托管账号信息',
  Cargo_RpaAccountSummaryTip: '如需调整可至[合作伙伴-联系人]页签调整。',
  Cargo_RpaAccountColumn: '企业微信账号',
  Cargo_RpaAccountEnabled: '账号状态',
  Cargo_BatchEditEnterpriseWechat: '批量修改联系人企微群聊',
  Cargo_EditEnterpriseWechatButton: '批量修改企微群聊名称',
  Cargo_RpaAccountColumn2: 'RPA托管账号',
  Cargo_EditEnterpriseWechatTitle: '修改联系人企微群聊',
  Cargo_RpaAccountWechatGroupNameCanTBeEmpty: '请填写 RPA托管账号/企业微信群聊 字段后，进行保存。',
  Cargo_EnterpriseWechat: '企业微信',
  Cargo_MessageContent: '消息内容',
  Cargo_PushFiles: '推送文件',
  Cargo_PushFilesTip: '文件将被压缩为ZIP文件，并通过下载链接地址发送到企业微信群中',
  Cargo_EnterpriseWechat2DataServiceReminder: '（仅对船舶计划变更）',
  Cargo_EnterpriseWechatSopTip: '请准确填写群聊名称，否则无法推送。如有多个请用","隔开填写。',
  Cargo_PleaseInputVerificationCode: '请输入验证码',
  Cargo_InputVerificationCodeTip1: '该设备为首次登录，需要输入验证码，请输入该企微账号手机客户端接收到的验证码',
  Cargo_InputVerificationCodeTip2: '验证失败，验证码无效或已过期，请重新输入',
  Cargo_CaptchaUsing: '验证中，请稍后刷新状态...',
  Cargo_LoginSuccess: '账号：{0}，已登陆成功。',
  Cargo_PushEnterpriseWechat: '是否企微推送',
  Cargo_PushEnterpriseWechatTip: '该联系人未设置企微账号和群聊名称，消息推送会失败',
  Cargo_ServiceProductID: '服务产品id',
  Cargo_ServiceProductName: '服务产品名称',
  Cargo_ForceRoutingBooking: '强制航线订舱',
  Cargo_UsedAsRoutingProduct: '是否用做航线产品',
  Cargo_AirServiceProduct: '空运服务产品',
  Cargo_BusinessManager: '商务负责人',
  Cargo_AirlinePersonSetting: '航线负责人设置',
  Cargo_PrePortFreightRateOfficer: '港前运价负责人',
  Cargo_PersonChargeTrunkLineFreightRates: '干线运价负责人',
  Cargo_PersonChargeLastMileFreightRates: '尾程运价负责人',
  Cargo_NamePersonResponsible: '负责人名称',
  Cargo_ResponsiblePortDeparture: '负责起运港',
  Cargo_OnlyOneFullPerson: '港口为空的全量负责人只能有一条',
  Cargo_OnlyOneFullPersonSameType: '统一类型下相同负责人只能有一条',
  Cargo_AdministrativeDivision: '行政区划',
  Cargo_StreetTownship: '街道/镇乡级',
  Cargo_PostalCodeManagement: '邮编管理',
  Cargo_UsPostalCode: '美国邮编',
  Cargo_preportAudit: '港前审核',
  Cargo_TrunkLineAudit: '干线审核',
  Cargo_TailEndAudit: '尾程审核',
  Cargo_preportAuditStatus: '港前审核状态',
  Cargo_TrunkLineAuditStatus: '干线审核状态',
  Cargo_TailEndAuditStatus: '尾程审核状态',
  Cargo_NoReviewRequired: '无需审批',
  Cargo_HasBeenReviewed: '已经审核过',
  Cargo_NoAuthorityReview: '没有权限审核',
  Cargo_AddBasicAirFreightServiceProduct: '添加基础空运服务产品',
  Cargo_DeleteServiceProductWarning: '您将删除【{0}】个服务产品信息，请谨慎操作。',
  Cargo_RouteProductName: '航线产品名称',
  Cargo_ServiceProduct: '服务产品',
  Cargo_PurchaseMethod: '采购方式',
  Cargo_Airline2: '航司',
  Cargo_PurchaseSource: '采购来源',
  Cargo_OriginPort: '始发港',
  Cargo_RouteOfficer: '航线员',
  Cargo_IsEffective: '是否生效',
  Cargo_BaseWeight: '基重',
  Cargo_LimitWeight: '限重',
  Cargo_SellableSpace: '可售舱位',
  Cargo_LengthLimit: '长度限制',
  Cargo_HeightLimit: '高度限制',
  Cargo_TheoreticalVolume: '理论体积',
  Cargo_SellableVolume: '可售体积',
  Cargo_Box: '板箱',
  Cargo_PayingParty: '付费对象',
  Cargo_UnitPrice_TotalPrice: '单价/总价',
  Cargo_RouteProductCode: '航线产品代码',
  Cargo_BoardCount: '板数',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: '生效日期必须小于等于失效日期',
  Cargo_AirlineProductCode: '航线产品',
  Cargo_NotAssemblyQuantity: '可拼装件数',
  Cargo_NotAssemblyGrossWeight: '可拼装毛重',
  Cargo_NotAssemblyVolume: '可拼装体积',
  Cargo_NotAssemblyChargeableWeight: '可拼装计重',
  Cargo_Density_Weight: '密度/货质',
  Cargo_PreWarehouseStatus: '前置仓状态',
  Cargo_DeliveryStation2: '交货货站',
  Cargo_DeliveryStatus: '交货状态',
  Cargo_PreAssemblyPlanProductionPlan: '预拼装计划-制作计划',
  Cargo_ShipmentOrder: '出仓指令',
  Cargo_GenerateAssemblyPlan: '生成拼装计划',
  Cargo_AssemblyPlanNumber: '拼装计划号',
  Cargo_AssemblyPlanStatus: '拼装计划状态',
  Cargo_AssemblyItemCount: '拼装件数',
  Cargo_AssemblyGrossWeight: '拼装毛重',
  Cargo_AssemblyVolume: '拼装体积',
  Cargo_AssemblyChargeableWeight: '拼装计重',
  Cargo_ContainerGroup: '集装器分组',
  Cargo_LoadingPool: '配载池',
  Cargo_MergeGroup: '合并组',
  Cargo_DeleteGroup: '删除组',
  Cargo_AddToPlan: '加入计划',
  Cargo_AssemblyPlan: '拼装计划',
  Cargo_PlanIssued: '计划下达',
  Cargo_CancelPlanIssued: '取消计划下达',
  Cargo_PlanPrint: '计划打印',
  Cargo_AssemblyCompleted: '拼装完成',
  Cargo_CancelAssemblyCompleted: '取消拼装完成',
  Cargo_ConfirmCompleted: '确认完成',
  Cargo_CancelConfirmCompleted: '取消确认完成',
  Cargo_ImportAssemblyPlan: '导入拼装计划',
  Cargo_UnifiedError: '【{0}】不统一，是否继续？',
  Cargo_JoinExistingAssemblyPlan: '是否并入已存在的拼装计划？',
  Cargo_ExistingPlanIssued: '存在已下达的拼装计划，暂不进行合并，请撤销下达后重试。',
  Cargo_CostAllocated: '已经分摊过成本，请用户自行删除已分摊的成本，是否继续？',
  Cargo_MaintainAtLeastOneGroup: '请至少维护一个集装器分组',
  Cargo_FieldsCannotBeEmpty: '【件/毛/体/计】必须大于0，请检查',
  Cargo_AssemblyPlanExceedsContainerGroup: '【拼装计划-集装器分组】数量大于【航线产品-航次-板箱】数量，是否继续？',
  Cargo_PlanIssuedTip: '拼装计划已下达，不可操作，请撤销下达后重试。',
  Cargo_PieceWeightVolumeUnit: '件毛体计',
  Cargo_EstimatedAmazonArrivalTime: '预计入亚马逊仓时间',
  Cargo_SelectCommonShipper: '选择常用发货人',
  Cargo_SaveAsCommonShipper: '保存为常用发货人',
  Cargo_SelectCommonConsignee: '选择常用收货人',
  Cargo_SaveAsCommonConsignee: '保存为常用收货人',
  Cargo_SelectCommonNotifier: '选择常用通知人',
  Cargo_SaveAsCommonNotifier: '保存为常用通知人',
  Cargo_BoxQuantity: '货箱数量',
  Cargo_OutboundMode: '出库模式',
  Cargo_PalletQuantity: '托盘数',
  Cargo_InventoryAge: '库龄（天/周）',
  Cargo_OutboundOperator: '出库操作人',
  Cargo_RemainingBoxes: '在库剩余箱数',
  Cargo_Goods: '货品',
  Cargo_InventoryInfo: '库存信息',
  Cargo_OutboundByPallet: '按托盘出库',
  Cargo_OutboundByBox: '按箱出库',
  Cargo_Outbound: '已出库',
  Cargo_NotOutbound: '未出库',
  Cargo_OutboundBatch: '出库批次',
  Cargo_BoxesInStock: '在库箱数',
  Cargo_PalletsInStock: '在库托盘数',
  Cargo_PromptWord: '##附件概述：\n' +
    '这是一张消费发票。请根据发票的语言确定其币种。 请识别出下述字段，具体字段有：收费主体（服务主体），消费金额，消费税（税额），税率，币种。\n' +
    '##输出要求：\n' +
    '1、以JSON要求返回，JSON字段名称一律用中文返回。\n' +
    '2、返回json格式举例：\n' +
    '      { \n' +
    '        "data": {\n' +
    '          "收货人": "",\n' +
    '          ……\n' +
    '        }\n' +
    '      }\n' +
    '##每个字段的定义及规则如下：\n' +
    '#1、收费主体（服务主体）\n' +
    '#2、消费金额\n' +
    '#3、消费税（税额）\n' +
    '#4、税率\n' +
    '#5、币种',
  CargoMsg_AIAddressRecognition: 'AI智能识别地址',
  Cargo_ContainerGroupHasOrder: '集装器分组中有订单，禁止删除，请把订单移出去再删除',
  Cargo_HSCode: 'HSCode',
  ChargeHasUpdate: '费用被{0}在{1}修改，请重新查询数据再进行操作！',
  Cargo_QuickSearchCustomPage: '快捷检索:表单名称',
  Cargo_ApplicationScene: '应用场景',
  Cargo_FormId: '表单编号',
  Cargo_FormType: '表单类型',
  Cargo_AddSelectedElements: '添加选中字段',
  Cargo_ElementsAddedSuccessfully: '元素添加成功',
  Cargo_SelectPagePart: '选择信息区域',
  Cargo_AddPagePart: '新增信息区域',
  Cargo_ChatUser: '用户',
  Cargo_ChatAI: 'AI助手',
  Cargo_ChatInputPlaceholder: '发送消息... (Enter 换行, Ctrl+Enter 发送)',
  Cargo_ChatThinking: '思考中...',
  Cargo_ChatCopySuccess: '已复制到剪贴板',
  Cargo_ChatConfirmTitle: '提示',
  Cargo_ChatDeleteConfirm: '确定要删除这条消息吗？',
  Cargo_ChatCopyFailed: '复制失败',
  Cargo_ChatDeleteSuccess: '已删除',
  Cargo_ChatNoResponse: '未获取到回复',
  Cargo_ChatConnectionError: '抱歉，连接出现问题，请重试。',
  Cargo_Debug: '调试',
  Cargo_DebugAndConfig: '调试和设置',
  Cargo_EnterValue: '请输入值',
  Cargo_CreateForm: '新建表单',
  Cargo_ConfigForm: '配置表单',
  Cargo_Branch: '应用公司',
  Cargo_FormNamePlaceholder: '请输入表单名称',
  Cargo_BranchPlaceholder: '请选择应用公司',
  Cargo_ApplicationScenePlaceholder: '请选择应用场景',
  Cargo_BusinessTypePlaceholder: '请选择业务类型',
  Cargo_RemarksPlaceholder: '请输入备注信息',
  Cargo_APIApplication: 'API应用',
  Cargo_BusinessSingleMode: '业务单笔模式',
  Cargo_BusinessBatchMode: '业务批量模式',
  Cargo_ConfirmMessageNotEditableAfterCreate: '在创建后不可修改，是否确认进入下一步？',
  Cargo_Tip2: '提示',
  Cargo_SelectDeleteTip4: '请选择您需要删除的数据',
  Cargo_SelectDeleteTip5: '确定要删除选中的数据吗？该操作不可撤销。',
  Cargo_FormDisableWarning: '被禁用的表单将无法使用，请及时调整使用该表单的模块！',
  Cargo_ElementSettings: '字段设置',
  Cargo_ElementRules: '字段规则',
  Cargo_IsReadOnly: '是否只读',
  Cargo_IsRequired: '是否必填',
  Cargo_MaxPagePartsReached: '已达到最大信息区域个数{0}',
  Cargo_FormInfo: '表单信息',
  Cargo_InputOutputConfig: '输入输出设置',
  Cargo_FormInputConfigDescription: '加载表单（Request Params）：表单加载时，按顺序请求接口，处理表单字段',
  Cargo_FormInputAPI: '输入接口',
  Cargo_FormInputAPIPlaceholder: '请填写输入接口列表',
  Cargo_FormOutputConfigDescription: '提交表单（Function Call）：提交表单时，按顺序请求应用接口',
  Cargo_FormOutputAPI: '输出接口',
  Cargo_FormOutputAPIPlaceholder: '请填写输出接口列表',
  Cargo_SaveDraft: '保存草稿',
  Cargo_PublishForm: '发布表单',
  Cargo_LastOperateTime: '最后操作时间',
  Cargo_Draft: '草稿',
  Cargo_Published: '已发布',
  Cargo_ConfigPagePart: '配置区域',
  Cargo_ConfigName: '配置名称',
  Cargo_PagePartFunction: '区域功能',
  Cargo_PleaseSelectFunction: '请选择功能',
  Cargo_BusinessElements: '业务字段',
  Cargo_ConsigneeShipperAndNotifyInfo: '收发通信息',
  Cargo_AccountsReceivable: '应收费用',
  Cargo_AccountsPayable: '应付费用',
  Cargo_UploadFile: '上传文件',
  Cargo_UploadInstruction: '上传指令',
  Cargo_InstructionParameter: '指令参数',
  Cargo_FormPreviewInListViewIsReadOnly: '如需编辑调试数据，请点击“编辑”进入详情页。',
  Cargo_BPM: 'BPM',
  Cargo_OCR: 'OCR',
  Cargo_PublishSuccess: '发布成功',
  Cargo_PublishFailed: '发布失败',
  Cargo_ValueRequired: '该值不能为空',
  Cargo_FixFormErrors: '请检查表单填写是否正确',
  Cargo_ValidationFailed: '校验结果有误，请检查填写值是否正确',
  Cargo_ToggleStatusFailed: '切换表单启用状态失败',
  Cargo_CopySucceed: '复制成功',
  Cargo_CopyFailed: '复制失败',
  Cargo_CopyFormConfirm: '确定要复制该表单及其包含的所有分块、元素布局和其他配置信息吗？',
  Cargo_CannotDeleteEnabledForm: '无法删除已启用的表单，请先禁用该表单',
  Cargo_GetFormConfigFailed: '获取表单配置失败',
  Cargo_ConfirmChangeBlockType: '变更区域功能，是否清空原有区域的配置内容？',
  Cargo_CopyOne: '请选择一条数据进行复制！',
  Cargo_ConfirmDeleteBlock: '是否确定删除该区域，并取消勾选的字段？',
  Carog_ConfirmSaveBeforeGoBack: '是否需要保存当前的配置内容？',
  Cargo_FormValidation: '表单校验',
  Cargo_Problem: '问题',
  Cargo_Description: '描述',
  Cargo_ValidationSucceed: '校验成功',
  Cargo_NoChanges: '无数据修改',
  Cargo_JobUuidRequired: '业务表单uuid不能为空',
  Cargo_LoadFormDataFailed: '加载表单数据失败',
  Cargo_SyncRuleExecutionFailed: '数据关联编辑规则执行失败',
  Cargo_PreviewRevision: '预览该版本效果',
  Cargo_Current: '当前',
  Cargo_FormPreviewInRevisionViewIsReadOnly: '当前预览为历史版本，仅支持只读模式。',
  Cargo_VisualizationView: '可视化布局',
  Cargo_CodeView: '代码视图',
  Cargo_ChatView: 'AI助手',
  Cargo_RestoreRevision: '还原为此版本',
  Cargo_RestoreSucceed: '还原成功',
  Cargo_RestoreFailed: '还原失败',
  Cargo_ConfirmRestoreRevision: '是否确认还原此版本？',
  Cargo_NeedAtLeastOnePagePart: '信息区域不可全部删除',
  Cargo_DataFill: '数据填写',
  Cargo_CSNInfo_BASIC: '收发通信息（基本页签）',
  Cargo_CSNInfo_MBL: '收发通信息（MBL）',
  Cargo_CSNInfo_HBL: '收发通信息（HBL）',
  Cargo_CSNInfo_HBL2: '收发通信息（形式分单）',
  Cargo_ReadOnly: '只读',
  Cargo_Notify: '通知人',
  Cargo_AlsoNotify: '第二通知人',
  Cargo_AgentParty: '代理信息',
  Cargo_ShippingExchangeRateBatchConfig: '航交所运价批次配置',
  Cargo_DeclarationScope: '申报范围',
  Cargo_DeclarationBusiness: '申报业务',
  Cargo_DeclarationFee: '申报费用',
  Cargo_SetBranch: '设置分公司',
  Cargo_FollowHQ: '跟随HQ',
  Cargo_FreightRate: '运价',
  Cargo_ContainerLock: '箱扣',
  Cargo_OtherAdditionalCharges: '其它附加费',
  Cargo_UpperLimit: '上限',
  Cargo_LowerLimit: '下限',
  Cargo_AlertNotification: '告警通知',
  Cargo_RPASettings: 'RPA设置',
  Cargo_UnregisteredShippingRate: '当创建的业务运价未在航交所申报时',
  Cargo_ExceedMaintainedLimit: '当创建的业务运价超过已维护的界限时',
  Cargo_RPAPaused: '当PRA暂停时',
  Cargo_RPACompleted: '当RPA完成时',
  Cargo_ProhibitSaving: '禁止保存',
  Cargo_RecordOnly: '只记录不提醒',
  Cargo_NoRecordNoAlert: '不记录不提醒',
  Cargo_NotifyRoleByEmail: '邮件通知指定角色',
  Cargo_NotifyPersonByEmail: '邮件通知指定人',
  Cargo_NotifyPositionByEmail: '邮件通知指定岗位',
  Cargo_RPAService: 'RPA服务',
  Cargo_EnableRPAService: '启用RPA服务',
  Cargo_ShippingExchangeAccount: '航交所账号',
  Cargo_ShippingExchangePassword: '航交所密码',
  Cargo_RPASubmission: '由机器人代为在 {0} 上提交数据',
  Cargo_WarningReason: '预警原因',
  Cargo_WarningMessage: '预警信息',
  Cargo_UnregisteredRateSaveError: '本公司已启用航交所公布运价功能，当前业务的运价未在航交所申报，所以无法保存，如需录入业务请联系备案人：<br/>{0}',
  Cargo_UnregisteredRateWarning: '本公司已启用航交所公布运价功能，当前业务的运价未在航交所申报，为避免违规操作，请及时联系备案人：<br/>{0}',
  Cargo_ExceedDeclaredLimitSaveError: '本公司已启用航交所公布运价功能，当前业务的运价超过已申报界限，所以无法保存，如需录入业务请联系备案人：<br/>{0}',
  Cargo_ExceedDeclaredLimitWarning: '本公司已启用航交所公布运价功能，当前业务的运价超过已申报界限，为避免违规操作，请及时联系备案人：<br/>{0}',
  Cargo_GoToProcess: '去处理',
  Cargo_GoToDeclare: '去申报',
  Cargo_CheckWarningToProcess: '请勾选需要处理的预警信息',
  Cargo_SelectedWarningMarkedProcessed: '选中的预警信息已标记为 “已处理”',
  Cargo_SelectInfoToDeclare: '请选择需要申报的信息',
  Cargo_SureSaveUnControlledProduct: '确认保存吗？保存后业务将锁定，无法再操作且不可撤回！',
  Cargo_ScmNeedAllowProduct: '在出口受管制产品时，需事先取得相关许可。详情请联系SCM推进室。',
  Cargo_SureSave: '确认保存',
  Cargo_DataLoadingPleaseWait: '数据加载中，请稍候。',
  Cargo_RuleID: '规则ID',
  Cargo_ValidationRule: '验证规则',
  Cargo_TriggerElement: '触发字段',
  Cargo_RelatedElements: '涉及字段',
  Cargo_TriggerCondition: '触发条件',
  Cargo_FunctionCode: '函数代码',
  Cargo_AddedValidationRules: '已添加以下验证规则',
  Cargo_AddedSyncRules: '已添加以下同步规则',
  Cargo_AddedVisibilityRules: '已添加以下可见性规则',
  Cargo_NoRuleDetected: '不好意思，没有检测到有效的数据校验或数据关联编辑函数，您可以尝试调整查询并再试一次。',
  Cargo_ConnectionError: '抱歉，连接出现问题，请重试。',
  Cargo_OperationArea: '操作区域',
  Cargo_BlDataNotFound: '未找到对应提单数据',
  Cargo_SelectBlDocument: '请选择提单文档',
  Cargo_SelectHblDocument: '请选择HBL提单文档',
  Cargo_SelectHawb2Document: '请选择形式分单文档',
  Cargo_AIChangRulesNumber: '已成功修改 {0} 条规则',
  Cargo_AIDeleteRulesNumber: '已成功删除 {0} 条规则',
  Cargo_AIAddRulesNumber: '已成功添加 {0} 条规则',
  Cargo_UnknownIntent: '您的查询中不包含具体规则',
  Cargo_AIDeleteUnexistRulesNumber: '需要删除的规则不存在',
  CanNotEditCustomer: 'trustFromEditSales参数未开启，交叉委托业务不允许修改委托单位!',
  CustomerRefreshChargeTips: '委托单位已经存在费用,是否刷新费用？',
  BookingAgentRefreshChargeTips: '订舱代理已经存在费用,是否刷新费用？',
  refreshCargoSourceForNc: '是否切换揽货类型为指定货？',
  refreshCargoSourceForSc: '是否切换揽货类型为自揽货？',
  Cargo_FilingBatchNo: '备案批次',
  Cargo_FilingState: '批次状态',
  Cargo_SubmitDate: '提交日期',
  Cargo_DeclareFinal: '申报行数/最终行数',
  Cargo_FiletotalRecordPass: '文件总记录/入库数/校验通过数',
  Cargo_StartRPA: '启动RPA',
  Cargo_SuspendRPA: '暂停RPA',
  Cargo_SuspendRPA2: '暂停',
  Cargo_RpaState: 'RPA状态',
  Cargo_ImportFinalResult: '导入最终结果',
  Cargo_ManuallyExportFile: '手动导出文件',
  Cargo_FilingBatchInfo: '批次信息',
  Cargo_FilingDate: '备案日期',
  Cargo_OpenPriceInfo: '申报运价',
  Cargo_Past6MonthPort: '获取近6个月业务的港口',
  Cargo_Past1MonthPrice: '获取近1个月开船的运价',
  Cargo_CompanyCode2: '公司代码',
  Cargo_Lane: '航线名称',
  Cargo_DepartureDay: '周班',
  Cargo_CargoType2: '货种',
  Cargo_EqSize: '尺码',
  Cargo_Cost2: '运价',
  Cargo_CostRange: '运价区间',
  Cargo_CostMin: '运价下限',
  Cargo_CostMax: '运价上限',
  Cargo_EqDeduct: '箱扣',
  Cargo_BatchReturnPreApproval: '批量退回预审/远程订舱',
  Cargo_ReturnPreApprovalRemoteBooking: '退回预审/远程订舱',
  Cargo_ConfirmReturnResubmit: '确定退回订舱预审/远程订舱重新提交审核吗?',
  Cargo_ReturnModuleSelection: '选择退回的模块',
  Cargo_ReturnModule: '退回模块',
  Cargo_ReturnReason: '退回原因',
  Cargo_MasterTicketRelationError: '存在主小票关系不允许退回',
  Cargo_CostStatusReturnError: '费用已{0}，不允许退回',
  Cargo_RouteManagerEmptyError: '业务编号：{0} 航线负责人为空不允许退回',
  Cargo_FOBReturnRestriction: 'FOB业务只能退回到远程订舱',
  Cargo_SelectedBusiness: '选中的业务',
  Cargo_RemoteBooking: '远程订舱',
  Cargo_RemoteBookingExportOnly: '远程订舱仅支持出口业务退回',
  Cargo_ReturnResult: '已退回成功{0}条，失败{1}条',
  Cargo_MasterTicketRelationAlert: '[{0}]存在主小票关系',
  Cargo_NotFromRemoteBookingError: '[{0}]不是从远程订舱过来的订单，不允许退回',
  Cargo_NotFromPreApprovalError: '[{0}]不是从订舱预审过来的订单，不允许退回',
  Cargo_CostStatusAlert: '[{0}]费用已{1}',
  Cargo_ReturnCurrentOperationOnly: '仅支持退回正操作业务',
  Cargo_MixedBusinessTypeError: '选中的业务自定义业务类型既有FOB又有非FOB的不能一起退回',
  Cargo_CollabBatchRejectError: '包含{0}是协作业务，不支持批量拒绝',
  Cargo_OtherSurcharge: '其他附加费',
  Cargo_MoreDetails: '更多详情',
  Cargo_SureToStartRPA: '【{0}】RPA启动后，系统会自动将数据传输到航交所网站，启动前，请确保数据已填写完整。',
  Cargo_SureToSuspendRPA: '【{0}】RPA暂停后，如再次启动，系统将航交所上的数据状态，如非已确认装填，系统会重新创建排期并上传，如无严重问题，请尽量不要暂停RPA。',
  Cargo_SureToDeleteOpenPrice: '请确认是否删除【{0}】批次的数据？',
  Cargo_SureToImportFinalResult: '手动导入最终结果意味着您确认该批次已完成，RPA将不再执行。',
  Cargo_SureToExportFile: '请确认是否导出【{0}】批次的数据？',
  FileBeLargerThan10MB: '文件大小不能大于10MB',
  FileBeLargerThan5MB: '文件大小不能大于5MB',
  Cargo_DeclareFile: '申报文件',
  Cargo_ImportFinalFile: '最终导入结果',
  Cargo_FinalPriceInfo: '最终运价',
  Cargo_DeclareNumLabel: '运价总数：{0}条',
  Cargo_DeclareFinalLabel: '申报行数/最终行数：{0}',
  Cargo_QuerySuccess: '获取数据成功',
  HasDeletedForDeleteJob: '勾选的业务已被删除！',
  HasSlaveJobForDeleteJob: '[{0}]请先移除小票！',
  HasChargeForDeleteJob: '[{0}]已录入了费用！',
  HasMergeForDeleteJob: '[{0}]已做过并单！',
  Cargo_ArCustomerPaidOff: '委托单位费用核销状态',
  Cargo_ContainsAdvancePayment: '是否含有代垫费用',
  Cargo_JdySendStatus: '简道云发送状态',
  Cargo_JdySendTime: '简道云发送时间',
  Cargo_DetailsLockedStatus: '货物明细锁定状态',
  Cargo_InterestAmountCurrency: '超期利息',
  Cargo_CheckRuleResult: '验证结果',
  BatchProcessingIsNotSupported: '不支持批量业务处理',
  BatchFillingIsNotConfigured: '未配置批量填写表单',
  SingleEntryIsNotSupported: '不支持单票业务填写',
  SingleFormIsNotConfigured: '未配置单票填写表单',
  TheFormDoesNotExist: '表单不存在',
  DataHasModified: '数据被[{0}]于{1}修改，请刷新！',
  Cargo_CheckNeedSynccloud: '请选择需要同步云平台的账单',
  Cargo_CheckJingdiesynccloud: '仅国外账单、代收代付账单可以推送金蝶',
  DisplayReceiptsOnly: '仅显示小票',
  AssignedWorkResponsibleForNode: '指定岗位（根据岗位设置节点的工作负责）',
  Cargo_CheckZySave: '请确认订单内货物是否涉及《中华人民共和国出口管制法》《中华人民共和国两用物项出口管制条例》及《中华人民共和国两用物项出口管制清单》。如是，请客户提供《两用物项出口许可证》作为出口报关随附材料。可通过货物品名和HSCODE对订单内货物进行检索，检索数据库参考以下网页：',
  Cargo_HasVerified: '已核对',
  Cargo_ContainSensitiveWord: '是否包含敏感词',
  Cargo_VoiceRecording: '录音中... 剩余{0}秒',
  Cargo_VoiceRecordingInput: '正在录音识别中，请说话...',
  Cargo_VoiceRecognizing: '识别中...',
  Cargo_VoiceStopRecording: '停止录音',
  Cargo_VoiceStartRecording: '开始录音',
  Cargo_VoiceNotInitialized: '语音识别功能未初始化',
  Cargo_VoiceStartRecordingTip: '开始录音，请说话...（最多60秒）',
  Cargo_VoiceRecordingEnd: '录音结束',
  Cargo_VoiceRecognitionError: '语音识别出错',
  Cargo_VoiceTimeLimitReached: '录音时间已达到60秒上限，已自动停止录音',
  Cargo_VoiceBrowserNotSupported: '当前浏览器不支持语音识别功能',
  Cargo_JobsSavedSuccessfully: '{0}个任务保存成功',
  Cargo_JobsFailedToSave: '{0}个任务保存失败',
  Cargo_BatchSaveFailed: '批量保存失败',
  Cargo_BatchFill: '批量填写',
  Cargo_PleaseAddGoods: '请添加商品明细。',
  confirmLock: '确认锁定 {0} 条订单？',
  confirmUnLock: '确认解锁 {0} 条订单？',
  Cargo_PleaseselectedGoods: '请选择货物明细。',
  Cargo_PleaseAddCheck: '请添加盘点明细。',
  Cargo_Sea_Order: '商品【{0}】 计量单位请保持一致',
  PriorityDisplay: '数据优先级显示',
  WhenTheNodeAllDisplayed: '节点未设定优先级时，将显示全部节点数据！',
  DefaultDisplay: '默认显示：',
  PrioritizationSettings: '优先级设置',
  Cargo_OperationProvince: '操作公司所在省',
  Cargo_SalesProvince: '销售公司所在省',
  Cargo_PushTime: '推送时间',
  CargoMsg_CheckSecondCustomJobType: '自定义业务类型是二级时，上级自定义业务类型不能为空！',
  Cargo_OnlyApprovedAndNotFullyWrittenOffCanProcess: '只有"审批通过"且"未全部核销"的付款申请能执行此操作！',
  Cargo_ConfirmAutoWriteOffSelectedPaymentRequests: '确认对选中的付款申请单进行自动销账？',
  Cargo_ProcessSuccessWrittenOff: '办理成功，已核销{0}条记录',
  Cargo_EnterpriseWechatApprovalPayCompany: '企微审批付款公司',
  Cargo_ProcessFailed: '办理失败',
  Cargo_ReleaseNumberConfigTab: '放号配置',
  Cargo_LimitReleaseWithoutContract: '未上传合同是否限制放号',
  Cargo_TrialOrderDays: '试单天数',
  Cargo_ReleaseNumberNoContract: '未上传合同，无法放号',
  Cargo_ReleaseNumberContractExpired: '合同已失效，无法放号',
  // 海出订舱列表-自定义岗位表头（按业务岗位命名）
  Cargo_UserDefinedRoleHeader1: '支线订舱员',
  Cargo_UserDefinedRoleHeader2: '干线订舱员',
  Cargo_UserDefinedRoleHeader3: '投保员',
  Cargo_UserDefinedRoleHeader4: '海外跟单',
  Cargo_UserDefinedRoleHeader5: '客服助理',

  // 海出订舱列表-自定义岗位表头（按业务岗位命名）
  Cargo_UserDefinedRoleHeader1: '支线订舱员',
  Cargo_UserDefinedRoleHeader2: '干线订舱员',
  Cargo_UserDefinedRoleHeader3: '投保员',
  Cargo_UserDefinedRoleHeader4: '海外跟单',
  Cargo_UserDefinedRoleHeader5: '客服助理',

  Cargo_InternalFeeMarkupRuleConfig: '内部费用加价规则',
  Cargo_FeeName: '费用名称',
  Cargo_AllStatus: '全部状态',
  Cargo_AddRule: '新增规则',
  Cargo_IncomeExpenseType: '收支类型',
  Cargo_MarkupType: '加价类型（单价）',
  Cargo_FixedAmount: '固定金额',
  Cargo_PercentMarkup: '百分比加价',
  Cargo_MarkupValue: '加价数值',
  Cargo_MarkupValueFixedTip: '请输入有效的金额，最多保留两位小数（如: 100.00）',
  Cargo_MarkupValuePercentTip: '请输入有效的百分比，以%结尾（如: 10%）',
  Cargo_ApplicableCompany: '适用公司',
  Cargo_EnabledStatus: '启用状态',
  Cargo_AccountsPayable: '应付',
  Cargo_SellTitleChangeTitle: '销方抬头变更提示',
  Cargo_SellTitleChangeTip: '修改销方抬头将会覆盖当前备注栏内容，是否确认继续修改销方抬头？'
}
